var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __esm = (fn, res) => function __init() {
  return fn && (res = (0, fn[__getOwnPropNames(fn)[0]])(fn = 0)), res;
};
var __commonJS = (cb, mod) => function __require() {
  return mod || (0, cb[__getOwnPropNames(cb)[0]])((mod = { exports: {} }).exports, mod), mod.exports;
};
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target,
  mod
));

// ../../node_modules/lodash/lodash.js
var require_lodash = __commonJS({
  "../../node_modules/lodash/lodash.js"(exports, module) {
    (function() {
      var undefined2;
      var VERSION = "4.18.1";
      var LARGE_ARRAY_SIZE = 200;
      var CORE_ERROR_TEXT = "Unsupported core-js use. Try https://npms.io/search?q=ponyfill.", FUNC_ERROR_TEXT = "Expected a function", INVALID_TEMPL_VAR_ERROR_TEXT = "Invalid `variable` option passed into `_.template`", INVALID_TEMPL_IMPORTS_ERROR_TEXT = "Invalid `imports` option passed into `_.template`";
      var HASH_UNDEFINED = "__lodash_hash_undefined__";
      var MAX_MEMOIZE_SIZE = 500;
      var PLACEHOLDER = "__lodash_placeholder__";
      var CLONE_DEEP_FLAG = 1, CLONE_FLAT_FLAG = 2, CLONE_SYMBOLS_FLAG = 4;
      var COMPARE_PARTIAL_FLAG = 1, COMPARE_UNORDERED_FLAG = 2;
      var WRAP_BIND_FLAG = 1, WRAP_BIND_KEY_FLAG = 2, WRAP_CURRY_BOUND_FLAG = 4, WRAP_CURRY_FLAG = 8, WRAP_CURRY_RIGHT_FLAG = 16, WRAP_PARTIAL_FLAG = 32, WRAP_PARTIAL_RIGHT_FLAG = 64, WRAP_ARY_FLAG = 128, WRAP_REARG_FLAG = 256, WRAP_FLIP_FLAG = 512;
      var DEFAULT_TRUNC_LENGTH = 30, DEFAULT_TRUNC_OMISSION = "...";
      var HOT_COUNT = 800, HOT_SPAN = 16;
      var LAZY_FILTER_FLAG = 1, LAZY_MAP_FLAG = 2, LAZY_WHILE_FLAG = 3;
      var INFINITY = 1 / 0, MAX_SAFE_INTEGER = 9007199254740991, MAX_INTEGER = 17976931348623157e292, NAN = 0 / 0;
      var MAX_ARRAY_LENGTH = 4294967295, MAX_ARRAY_INDEX = MAX_ARRAY_LENGTH - 1, HALF_MAX_ARRAY_LENGTH = MAX_ARRAY_LENGTH >>> 1;
      var wrapFlags = [
        ["ary", WRAP_ARY_FLAG],
        ["bind", WRAP_BIND_FLAG],
        ["bindKey", WRAP_BIND_KEY_FLAG],
        ["curry", WRAP_CURRY_FLAG],
        ["curryRight", WRAP_CURRY_RIGHT_FLAG],
        ["flip", WRAP_FLIP_FLAG],
        ["partial", WRAP_PARTIAL_FLAG],
        ["partialRight", WRAP_PARTIAL_RIGHT_FLAG],
        ["rearg", WRAP_REARG_FLAG]
      ];
      var argsTag = "[object Arguments]", arrayTag = "[object Array]", asyncTag = "[object AsyncFunction]", boolTag = "[object Boolean]", dateTag = "[object Date]", domExcTag = "[object DOMException]", errorTag = "[object Error]", funcTag = "[object Function]", genTag = "[object GeneratorFunction]", mapTag = "[object Map]", numberTag = "[object Number]", nullTag = "[object Null]", objectTag = "[object Object]", promiseTag = "[object Promise]", proxyTag = "[object Proxy]", regexpTag = "[object RegExp]", setTag = "[object Set]", stringTag = "[object String]", symbolTag = "[object Symbol]", undefinedTag = "[object Undefined]", weakMapTag = "[object WeakMap]", weakSetTag = "[object WeakSet]";
      var arrayBufferTag = "[object ArrayBuffer]", dataViewTag = "[object DataView]", float32Tag = "[object Float32Array]", float64Tag = "[object Float64Array]", int8Tag = "[object Int8Array]", int16Tag = "[object Int16Array]", int32Tag = "[object Int32Array]", uint8Tag = "[object Uint8Array]", uint8ClampedTag = "[object Uint8ClampedArray]", uint16Tag = "[object Uint16Array]", uint32Tag = "[object Uint32Array]";
      var reEmptyStringLeading = /\b__p \+= '';/g, reEmptyStringMiddle = /\b(__p \+=) '' \+/g, reEmptyStringTrailing = /(__e\(.*?\)|\b__t\)) \+\n'';/g;
      var reEscapedHtml = /&(?:amp|lt|gt|quot|#39);/g, reUnescapedHtml = /[&<>"']/g, reHasEscapedHtml = RegExp(reEscapedHtml.source), reHasUnescapedHtml = RegExp(reUnescapedHtml.source);
      var reEscape = /<%-([\s\S]+?)%>/g, reEvaluate = /<%([\s\S]+?)%>/g, reInterpolate = /<%=([\s\S]+?)%>/g;
      var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, reIsPlainProp = /^\w*$/, rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;
      var reRegExpChar = /[\\^$.*+?()[\]{}|]/g, reHasRegExpChar = RegExp(reRegExpChar.source);
      var reTrimStart = /^\s+/;
      var reWhitespace = /\s/;
      var reWrapComment = /\{(?:\n\/\* \[wrapped with .+\] \*\/)?\n?/, reWrapDetails = /\{\n\/\* \[wrapped with (.+)\] \*/, reSplitDetails = /,? & /;
      var reAsciiWord = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g;
      var reForbiddenIdentifierChars = /[()=,{}\[\]\/\s]/;
      var reEscapeChar = /\\(\\)?/g;
      var reEsTemplate = /\$\{([^\\}]*(?:\\.[^\\}]*)*)\}/g;
      var reFlags = /\w*$/;
      var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
      var reIsBinary = /^0b[01]+$/i;
      var reIsHostCtor = /^\[object .+?Constructor\]$/;
      var reIsOctal = /^0o[0-7]+$/i;
      var reIsUint = /^(?:0|[1-9]\d*)$/;
      var reLatin = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g;
      var reNoMatch = /($^)/;
      var reUnescapedString = /['\n\r\u2028\u2029\\]/g;
      var rsAstralRange = "\\ud800-\\udfff", rsComboMarksRange = "\\u0300-\\u036f", reComboHalfMarksRange = "\\ufe20-\\ufe2f", rsComboSymbolsRange = "\\u20d0-\\u20ff", rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange, rsDingbatRange = "\\u2700-\\u27bf", rsLowerRange = "a-z\\xdf-\\xf6\\xf8-\\xff", rsMathOpRange = "\\xac\\xb1\\xd7\\xf7", rsNonCharRange = "\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf", rsPunctuationRange = "\\u2000-\\u206f", rsSpaceRange = " \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000", rsUpperRange = "A-Z\\xc0-\\xd6\\xd8-\\xde", rsVarRange = "\\ufe0e\\ufe0f", rsBreakRange = rsMathOpRange + rsNonCharRange + rsPunctuationRange + rsSpaceRange;
      var rsApos = "['\u2019]", rsAstral = "[" + rsAstralRange + "]", rsBreak = "[" + rsBreakRange + "]", rsCombo = "[" + rsComboRange + "]", rsDigits = "\\d+", rsDingbat = "[" + rsDingbatRange + "]", rsLower = "[" + rsLowerRange + "]", rsMisc = "[^" + rsAstralRange + rsBreakRange + rsDigits + rsDingbatRange + rsLowerRange + rsUpperRange + "]", rsFitz = "\\ud83c[\\udffb-\\udfff]", rsModifier = "(?:" + rsCombo + "|" + rsFitz + ")", rsNonAstral = "[^" + rsAstralRange + "]", rsRegional = "(?:\\ud83c[\\udde6-\\uddff]){2}", rsSurrPair = "[\\ud800-\\udbff][\\udc00-\\udfff]", rsUpper = "[" + rsUpperRange + "]", rsZWJ = "\\u200d";
      var rsMiscLower = "(?:" + rsLower + "|" + rsMisc + ")", rsMiscUpper = "(?:" + rsUpper + "|" + rsMisc + ")", rsOptContrLower = "(?:" + rsApos + "(?:d|ll|m|re|s|t|ve))?", rsOptContrUpper = "(?:" + rsApos + "(?:D|LL|M|RE|S|T|VE))?", reOptMod = rsModifier + "?", rsOptVar = "[" + rsVarRange + "]?", rsOptJoin = "(?:" + rsZWJ + "(?:" + [rsNonAstral, rsRegional, rsSurrPair].join("|") + ")" + rsOptVar + reOptMod + ")*", rsOrdLower = "\\d*(?:1st|2nd|3rd|(?![123])\\dth)(?=\\b|[A-Z_])", rsOrdUpper = "\\d*(?:1ST|2ND|3RD|(?![123])\\dTH)(?=\\b|[a-z_])", rsSeq = rsOptVar + reOptMod + rsOptJoin, rsEmoji = "(?:" + [rsDingbat, rsRegional, rsSurrPair].join("|") + ")" + rsSeq, rsSymbol = "(?:" + [rsNonAstral + rsCombo + "?", rsCombo, rsRegional, rsSurrPair, rsAstral].join("|") + ")";
      var reApos = RegExp(rsApos, "g");
      var reComboMark = RegExp(rsCombo, "g");
      var reUnicode = RegExp(rsFitz + "(?=" + rsFitz + ")|" + rsSymbol + rsSeq, "g");
      var reUnicodeWord = RegExp([
        rsUpper + "?" + rsLower + "+" + rsOptContrLower + "(?=" + [rsBreak, rsUpper, "$"].join("|") + ")",
        rsMiscUpper + "+" + rsOptContrUpper + "(?=" + [rsBreak, rsUpper + rsMiscLower, "$"].join("|") + ")",
        rsUpper + "?" + rsMiscLower + "+" + rsOptContrLower,
        rsUpper + "+" + rsOptContrUpper,
        rsOrdUpper,
        rsOrdLower,
        rsDigits,
        rsEmoji
      ].join("|"), "g");
      var reHasUnicode = RegExp("[" + rsZWJ + rsAstralRange + rsComboRange + rsVarRange + "]");
      var reHasUnicodeWord = /[a-z][A-Z]|[A-Z]{2}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/;
      var contextProps = [
        "Array",
        "Buffer",
        "DataView",
        "Date",
        "Error",
        "Float32Array",
        "Float64Array",
        "Function",
        "Int8Array",
        "Int16Array",
        "Int32Array",
        "Map",
        "Math",
        "Object",
        "Promise",
        "RegExp",
        "Set",
        "String",
        "Symbol",
        "TypeError",
        "Uint8Array",
        "Uint8ClampedArray",
        "Uint16Array",
        "Uint32Array",
        "WeakMap",
        "_",
        "clearTimeout",
        "isFinite",
        "parseInt",
        "setTimeout"
      ];
      var templateCounter = -1;
      var typedArrayTags = {};
      typedArrayTags[float32Tag] = typedArrayTags[float64Tag] = typedArrayTags[int8Tag] = typedArrayTags[int16Tag] = typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] = typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] = typedArrayTags[uint32Tag] = true;
      typedArrayTags[argsTag] = typedArrayTags[arrayTag] = typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] = typedArrayTags[dataViewTag] = typedArrayTags[dateTag] = typedArrayTags[errorTag] = typedArrayTags[funcTag] = typedArrayTags[mapTag] = typedArrayTags[numberTag] = typedArrayTags[objectTag] = typedArrayTags[regexpTag] = typedArrayTags[setTag] = typedArrayTags[stringTag] = typedArrayTags[weakMapTag] = false;
      var cloneableTags = {};
      cloneableTags[argsTag] = cloneableTags[arrayTag] = cloneableTags[arrayBufferTag] = cloneableTags[dataViewTag] = cloneableTags[boolTag] = cloneableTags[dateTag] = cloneableTags[float32Tag] = cloneableTags[float64Tag] = cloneableTags[int8Tag] = cloneableTags[int16Tag] = cloneableTags[int32Tag] = cloneableTags[mapTag] = cloneableTags[numberTag] = cloneableTags[objectTag] = cloneableTags[regexpTag] = cloneableTags[setTag] = cloneableTags[stringTag] = cloneableTags[symbolTag] = cloneableTags[uint8Tag] = cloneableTags[uint8ClampedTag] = cloneableTags[uint16Tag] = cloneableTags[uint32Tag] = true;
      cloneableTags[errorTag] = cloneableTags[funcTag] = cloneableTags[weakMapTag] = false;
      var deburredLetters = {
        // Latin-1 Supplement block.
        "\xC0": "A",
        "\xC1": "A",
        "\xC2": "A",
        "\xC3": "A",
        "\xC4": "A",
        "\xC5": "A",
        "\xE0": "a",
        "\xE1": "a",
        "\xE2": "a",
        "\xE3": "a",
        "\xE4": "a",
        "\xE5": "a",
        "\xC7": "C",
        "\xE7": "c",
        "\xD0": "D",
        "\xF0": "d",
        "\xC8": "E",
        "\xC9": "E",
        "\xCA": "E",
        "\xCB": "E",
        "\xE8": "e",
        "\xE9": "e",
        "\xEA": "e",
        "\xEB": "e",
        "\xCC": "I",
        "\xCD": "I",
        "\xCE": "I",
        "\xCF": "I",
        "\xEC": "i",
        "\xED": "i",
        "\xEE": "i",
        "\xEF": "i",
        "\xD1": "N",
        "\xF1": "n",
        "\xD2": "O",
        "\xD3": "O",
        "\xD4": "O",
        "\xD5": "O",
        "\xD6": "O",
        "\xD8": "O",
        "\xF2": "o",
        "\xF3": "o",
        "\xF4": "o",
        "\xF5": "o",
        "\xF6": "o",
        "\xF8": "o",
        "\xD9": "U",
        "\xDA": "U",
        "\xDB": "U",
        "\xDC": "U",
        "\xF9": "u",
        "\xFA": "u",
        "\xFB": "u",
        "\xFC": "u",
        "\xDD": "Y",
        "\xFD": "y",
        "\xFF": "y",
        "\xC6": "Ae",
        "\xE6": "ae",
        "\xDE": "Th",
        "\xFE": "th",
        "\xDF": "ss",
        // Latin Extended-A block.
        "\u0100": "A",
        "\u0102": "A",
        "\u0104": "A",
        "\u0101": "a",
        "\u0103": "a",
        "\u0105": "a",
        "\u0106": "C",
        "\u0108": "C",
        "\u010A": "C",
        "\u010C": "C",
        "\u0107": "c",
        "\u0109": "c",
        "\u010B": "c",
        "\u010D": "c",
        "\u010E": "D",
        "\u0110": "D",
        "\u010F": "d",
        "\u0111": "d",
        "\u0112": "E",
        "\u0114": "E",
        "\u0116": "E",
        "\u0118": "E",
        "\u011A": "E",
        "\u0113": "e",
        "\u0115": "e",
        "\u0117": "e",
        "\u0119": "e",
        "\u011B": "e",
        "\u011C": "G",
        "\u011E": "G",
        "\u0120": "G",
        "\u0122": "G",
        "\u011D": "g",
        "\u011F": "g",
        "\u0121": "g",
        "\u0123": "g",
        "\u0124": "H",
        "\u0126": "H",
        "\u0125": "h",
        "\u0127": "h",
        "\u0128": "I",
        "\u012A": "I",
        "\u012C": "I",
        "\u012E": "I",
        "\u0130": "I",
        "\u0129": "i",
        "\u012B": "i",
        "\u012D": "i",
        "\u012F": "i",
        "\u0131": "i",
        "\u0134": "J",
        "\u0135": "j",
        "\u0136": "K",
        "\u0137": "k",
        "\u0138": "k",
        "\u0139": "L",
        "\u013B": "L",
        "\u013D": "L",
        "\u013F": "L",
        "\u0141": "L",
        "\u013A": "l",
        "\u013C": "l",
        "\u013E": "l",
        "\u0140": "l",
        "\u0142": "l",
        "\u0143": "N",
        "\u0145": "N",
        "\u0147": "N",
        "\u014A": "N",
        "\u0144": "n",
        "\u0146": "n",
        "\u0148": "n",
        "\u014B": "n",
        "\u014C": "O",
        "\u014E": "O",
        "\u0150": "O",
        "\u014D": "o",
        "\u014F": "o",
        "\u0151": "o",
        "\u0154": "R",
        "\u0156": "R",
        "\u0158": "R",
        "\u0155": "r",
        "\u0157": "r",
        "\u0159": "r",
        "\u015A": "S",
        "\u015C": "S",
        "\u015E": "S",
        "\u0160": "S",
        "\u015B": "s",
        "\u015D": "s",
        "\u015F": "s",
        "\u0161": "s",
        "\u0162": "T",
        "\u0164": "T",
        "\u0166": "T",
        "\u0163": "t",
        "\u0165": "t",
        "\u0167": "t",
        "\u0168": "U",
        "\u016A": "U",
        "\u016C": "U",
        "\u016E": "U",
        "\u0170": "U",
        "\u0172": "U",
        "\u0169": "u",
        "\u016B": "u",
        "\u016D": "u",
        "\u016F": "u",
        "\u0171": "u",
        "\u0173": "u",
        "\u0174": "W",
        "\u0175": "w",
        "\u0176": "Y",
        "\u0177": "y",
        "\u0178": "Y",
        "\u0179": "Z",
        "\u017B": "Z",
        "\u017D": "Z",
        "\u017A": "z",
        "\u017C": "z",
        "\u017E": "z",
        "\u0132": "IJ",
        "\u0133": "ij",
        "\u0152": "Oe",
        "\u0153": "oe",
        "\u0149": "'n",
        "\u017F": "s"
      };
      var htmlEscapes = {
        "&": "&amp;",
        "<": "&lt;",
        ">": "&gt;",
        '"': "&quot;",
        "'": "&#39;"
      };
      var htmlUnescapes = {
        "&amp;": "&",
        "&lt;": "<",
        "&gt;": ">",
        "&quot;": '"',
        "&#39;": "'"
      };
      var stringEscapes = {
        "\\": "\\",
        "'": "'",
        "\n": "n",
        "\r": "r",
        "\u2028": "u2028",
        "\u2029": "u2029"
      };
      var freeParseFloat = parseFloat, freeParseInt = parseInt;
      var freeGlobal = typeof global == "object" && global && global.Object === Object && global;
      var freeSelf = typeof self == "object" && self && self.Object === Object && self;
      var root = freeGlobal || freeSelf || Function("return this")();
      var freeExports = typeof exports == "object" && exports && !exports.nodeType && exports;
      var freeModule = freeExports && typeof module == "object" && module && !module.nodeType && module;
      var moduleExports = freeModule && freeModule.exports === freeExports;
      var freeProcess = moduleExports && freeGlobal.process;
      var nodeUtil = function() {
        try {
          var types = freeModule && freeModule.require && freeModule.require("util").types;
          if (types) {
            return types;
          }
          return freeProcess && freeProcess.binding && freeProcess.binding("util");
        } catch (e) {
        }
      }();
      var nodeIsArrayBuffer = nodeUtil && nodeUtil.isArrayBuffer, nodeIsDate = nodeUtil && nodeUtil.isDate, nodeIsMap = nodeUtil && nodeUtil.isMap, nodeIsRegExp = nodeUtil && nodeUtil.isRegExp, nodeIsSet = nodeUtil && nodeUtil.isSet, nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;
      function apply(func, thisArg, args) {
        switch (args.length) {
          case 0:
            return func.call(thisArg);
          case 1:
            return func.call(thisArg, args[0]);
          case 2:
            return func.call(thisArg, args[0], args[1]);
          case 3:
            return func.call(thisArg, args[0], args[1], args[2]);
        }
        return func.apply(thisArg, args);
      }
      function arrayAggregator(array, setter, iteratee, accumulator) {
        var index = -1, length = array == null ? 0 : array.length;
        while (++index < length) {
          var value = array[index];
          setter(accumulator, value, iteratee(value), array);
        }
        return accumulator;
      }
      function arrayEach(array, iteratee) {
        var index = -1, length = array == null ? 0 : array.length;
        while (++index < length) {
          if (iteratee(array[index], index, array) === false) {
            break;
          }
        }
        return array;
      }
      function arrayEachRight(array, iteratee) {
        var length = array == null ? 0 : array.length;
        while (length--) {
          if (iteratee(array[length], length, array) === false) {
            break;
          }
        }
        return array;
      }
      function arrayEvery(array, predicate) {
        var index = -1, length = array == null ? 0 : array.length;
        while (++index < length) {
          if (!predicate(array[index], index, array)) {
            return false;
          }
        }
        return true;
      }
      function arrayFilter(array, predicate) {
        var index = -1, length = array == null ? 0 : array.length, resIndex = 0, result = [];
        while (++index < length) {
          var value = array[index];
          if (predicate(value, index, array)) {
            result[resIndex++] = value;
          }
        }
        return result;
      }
      function arrayIncludes(array, value) {
        var length = array == null ? 0 : array.length;
        return !!length && baseIndexOf(array, value, 0) > -1;
      }
      function arrayIncludesWith(array, value, comparator) {
        var index = -1, length = array == null ? 0 : array.length;
        while (++index < length) {
          if (comparator(value, array[index])) {
            return true;
          }
        }
        return false;
      }
      function arrayMap(array, iteratee) {
        var index = -1, length = array == null ? 0 : array.length, result = Array(length);
        while (++index < length) {
          result[index] = iteratee(array[index], index, array);
        }
        return result;
      }
      function arrayPush(array, values) {
        var index = -1, length = values.length, offset = array.length;
        while (++index < length) {
          array[offset + index] = values[index];
        }
        return array;
      }
      function arrayReduce(array, iteratee, accumulator, initAccum) {
        var index = -1, length = array == null ? 0 : array.length;
        if (initAccum && length) {
          accumulator = array[++index];
        }
        while (++index < length) {
          accumulator = iteratee(accumulator, array[index], index, array);
        }
        return accumulator;
      }
      function arrayReduceRight(array, iteratee, accumulator, initAccum) {
        var length = array == null ? 0 : array.length;
        if (initAccum && length) {
          accumulator = array[--length];
        }
        while (length--) {
          accumulator = iteratee(accumulator, array[length], length, array);
        }
        return accumulator;
      }
      function arraySome(array, predicate) {
        var index = -1, length = array == null ? 0 : array.length;
        while (++index < length) {
          if (predicate(array[index], index, array)) {
            return true;
          }
        }
        return false;
      }
      var asciiSize = baseProperty("length");
      function asciiToArray(string) {
        return string.split("");
      }
      function asciiWords(string) {
        return string.match(reAsciiWord) || [];
      }
      function baseFindKey(collection, predicate, eachFunc) {
        var result;
        eachFunc(collection, function(value, key, collection2) {
          if (predicate(value, key, collection2)) {
            result = key;
            return false;
          }
        });
        return result;
      }
      function baseFindIndex(array, predicate, fromIndex, fromRight) {
        var length = array.length, index = fromIndex + (fromRight ? 1 : -1);
        while (fromRight ? index-- : ++index < length) {
          if (predicate(array[index], index, array)) {
            return index;
          }
        }
        return -1;
      }
      function baseIndexOf(array, value, fromIndex) {
        return value === value ? strictIndexOf(array, value, fromIndex) : baseFindIndex(array, baseIsNaN, fromIndex);
      }
      function baseIndexOfWith(array, value, fromIndex, comparator) {
        var index = fromIndex - 1, length = array.length;
        while (++index < length) {
          if (comparator(array[index], value)) {
            return index;
          }
        }
        return -1;
      }
      function baseIsNaN(value) {
        return value !== value;
      }
      function baseMean(array, iteratee) {
        var length = array == null ? 0 : array.length;
        return length ? baseSum(array, iteratee) / length : NAN;
      }
      function baseProperty(key) {
        return function(object) {
          return object == null ? undefined2 : object[key];
        };
      }
      function basePropertyOf(object) {
        return function(key) {
          return object == null ? undefined2 : object[key];
        };
      }
      function baseReduce(collection, iteratee, accumulator, initAccum, eachFunc) {
        eachFunc(collection, function(value, index, collection2) {
          accumulator = initAccum ? (initAccum = false, value) : iteratee(accumulator, value, index, collection2);
        });
        return accumulator;
      }
      function baseSortBy(array, comparer) {
        var length = array.length;
        array.sort(comparer);
        while (length--) {
          array[length] = array[length].value;
        }
        return array;
      }
      function baseSum(array, iteratee) {
        var result, index = -1, length = array.length;
        while (++index < length) {
          var current2 = iteratee(array[index]);
          if (current2 !== undefined2) {
            result = result === undefined2 ? current2 : result + current2;
          }
        }
        return result;
      }
      function baseTimes(n, iteratee) {
        var index = -1, result = Array(n);
        while (++index < n) {
          result[index] = iteratee(index);
        }
        return result;
      }
      function baseToPairs(object, props) {
        return arrayMap(props, function(key) {
          return [key, object[key]];
        });
      }
      function baseTrim(string) {
        return string ? string.slice(0, trimmedEndIndex(string) + 1).replace(reTrimStart, "") : string;
      }
      function baseUnary(func) {
        return function(value) {
          return func(value);
        };
      }
      function baseValues(object, props) {
        return arrayMap(props, function(key) {
          return object[key];
        });
      }
      function cacheHas(cache, key) {
        return cache.has(key);
      }
      function charsStartIndex(strSymbols, chrSymbols) {
        var index = -1, length = strSymbols.length;
        while (++index < length && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1) {
        }
        return index;
      }
      function charsEndIndex(strSymbols, chrSymbols) {
        var index = strSymbols.length;
        while (index-- && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1) {
        }
        return index;
      }
      function countHolders(array, placeholder) {
        var length = array.length, result = 0;
        while (length--) {
          if (array[length] === placeholder) {
            ++result;
          }
        }
        return result;
      }
      var deburrLetter = basePropertyOf(deburredLetters);
      var escapeHtmlChar = basePropertyOf(htmlEscapes);
      function escapeStringChar(chr) {
        return "\\" + stringEscapes[chr];
      }
      function getValue(object, key) {
        return object == null ? undefined2 : object[key];
      }
      function hasUnicode(string) {
        return reHasUnicode.test(string);
      }
      function hasUnicodeWord(string) {
        return reHasUnicodeWord.test(string);
      }
      function iteratorToArray(iterator) {
        var data, result = [];
        while (!(data = iterator.next()).done) {
          result.push(data.value);
        }
        return result;
      }
      function mapToArray(map) {
        var index = -1, result = Array(map.size);
        map.forEach(function(value, key) {
          result[++index] = [key, value];
        });
        return result;
      }
      function overArg(func, transform) {
        return function(arg) {
          return func(transform(arg));
        };
      }
      function replaceHolders(array, placeholder) {
        var index = -1, length = array.length, resIndex = 0, result = [];
        while (++index < length) {
          var value = array[index];
          if (value === placeholder || value === PLACEHOLDER) {
            array[index] = PLACEHOLDER;
            result[resIndex++] = index;
          }
        }
        return result;
      }
      function setToArray(set2) {
        var index = -1, result = Array(set2.size);
        set2.forEach(function(value) {
          result[++index] = value;
        });
        return result;
      }
      function setToPairs(set2) {
        var index = -1, result = Array(set2.size);
        set2.forEach(function(value) {
          result[++index] = [value, value];
        });
        return result;
      }
      function strictIndexOf(array, value, fromIndex) {
        var index = fromIndex - 1, length = array.length;
        while (++index < length) {
          if (array[index] === value) {
            return index;
          }
        }
        return -1;
      }
      function strictLastIndexOf(array, value, fromIndex) {
        var index = fromIndex + 1;
        while (index--) {
          if (array[index] === value) {
            return index;
          }
        }
        return index;
      }
      function stringSize(string) {
        return hasUnicode(string) ? unicodeSize(string) : asciiSize(string);
      }
      function stringToArray(string) {
        return hasUnicode(string) ? unicodeToArray(string) : asciiToArray(string);
      }
      function trimmedEndIndex(string) {
        var index = string.length;
        while (index-- && reWhitespace.test(string.charAt(index))) {
        }
        return index;
      }
      var unescapeHtmlChar = basePropertyOf(htmlUnescapes);
      function unicodeSize(string) {
        var result = reUnicode.lastIndex = 0;
        while (reUnicode.test(string)) {
          ++result;
        }
        return result;
      }
      function unicodeToArray(string) {
        return string.match(reUnicode) || [];
      }
      function unicodeWords(string) {
        return string.match(reUnicodeWord) || [];
      }
      var runInContext = function runInContext2(context) {
        context = context == null ? root : _.defaults(root.Object(), context, _.pick(root, contextProps));
        var Array2 = context.Array, Date2 = context.Date, Error2 = context.Error, Function2 = context.Function, Math2 = context.Math, Object2 = context.Object, RegExp2 = context.RegExp, String2 = context.String, TypeError2 = context.TypeError;
        var arrayProto = Array2.prototype, funcProto = Function2.prototype, objectProto = Object2.prototype;
        var coreJsData = context["__core-js_shared__"];
        var funcToString = funcProto.toString;
        var hasOwnProperty2 = objectProto.hasOwnProperty;
        var idCounter = 0;
        var maskSrcKey = function() {
          var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || "");
          return uid ? "Symbol(src)_1." + uid : "";
        }();
        var nativeObjectToString = objectProto.toString;
        var objectCtorString2 = funcToString.call(Object2);
        var oldDash = root._;
        var reIsNative = RegExp2(
          "^" + funcToString.call(hasOwnProperty2).replace(reRegExpChar, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"
        );
        var Buffer2 = moduleExports ? context.Buffer : undefined2, Symbol2 = context.Symbol, Uint8Array2 = context.Uint8Array, allocUnsafe = Buffer2 ? Buffer2.allocUnsafe : undefined2, getPrototype = overArg(Object2.getPrototypeOf, Object2), objectCreate = Object2.create, propertyIsEnumerable = objectProto.propertyIsEnumerable, splice = arrayProto.splice, spreadableSymbol = Symbol2 ? Symbol2.isConcatSpreadable : undefined2, symIterator = Symbol2 ? Symbol2.iterator : undefined2, symToStringTag = Symbol2 ? Symbol2.toStringTag : undefined2;
        var defineProperty = function() {
          try {
            var func = getNative(Object2, "defineProperty");
            func({}, "", {});
            return func;
          } catch (e) {
          }
        }();
        var ctxClearTimeout = context.clearTimeout !== root.clearTimeout && context.clearTimeout, ctxNow = Date2 && Date2.now !== root.Date.now && Date2.now, ctxSetTimeout = context.setTimeout !== root.setTimeout && context.setTimeout;
        var nativeCeil = Math2.ceil, nativeFloor = Math2.floor, nativeGetSymbols = Object2.getOwnPropertySymbols, nativeIsBuffer = Buffer2 ? Buffer2.isBuffer : undefined2, nativeIsFinite = context.isFinite, nativeJoin = arrayProto.join, nativeKeys = overArg(Object2.keys, Object2), nativeMax = Math2.max, nativeMin = Math2.min, nativeNow = Date2.now, nativeParseInt = context.parseInt, nativeRandom = Math2.random, nativeReverse = arrayProto.reverse;
        var DataView = getNative(context, "DataView"), Map2 = getNative(context, "Map"), Promise2 = getNative(context, "Promise"), Set2 = getNative(context, "Set"), WeakMap2 = getNative(context, "WeakMap"), nativeCreate = getNative(Object2, "create");
        var metaMap = WeakMap2 && new WeakMap2();
        var realNames = {};
        var dataViewCtorString = toSource(DataView), mapCtorString = toSource(Map2), promiseCtorString = toSource(Promise2), setCtorString = toSource(Set2), weakMapCtorString = toSource(WeakMap2);
        var symbolProto = Symbol2 ? Symbol2.prototype : undefined2, symbolValueOf = symbolProto ? symbolProto.valueOf : undefined2, symbolToString = symbolProto ? symbolProto.toString : undefined2;
        function lodash(value) {
          if (isObjectLike(value) && !isArray(value) && !(value instanceof LazyWrapper)) {
            if (value instanceof LodashWrapper) {
              return value;
            }
            if (hasOwnProperty2.call(value, "__wrapped__")) {
              return wrapperClone(value);
            }
          }
          return new LodashWrapper(value);
        }
        var baseCreate = /* @__PURE__ */ function() {
          function object() {
          }
          return function(proto) {
            if (!isObject2(proto)) {
              return {};
            }
            if (objectCreate) {
              return objectCreate(proto);
            }
            object.prototype = proto;
            var result2 = new object();
            object.prototype = undefined2;
            return result2;
          };
        }();
        function baseLodash() {
        }
        function LodashWrapper(value, chainAll) {
          this.__wrapped__ = value;
          this.__actions__ = [];
          this.__chain__ = !!chainAll;
          this.__index__ = 0;
          this.__values__ = undefined2;
        }
        lodash.templateSettings = {
          /**
           * Used to detect `data` property values to be HTML-escaped.
           *
           * @memberOf _.templateSettings
           * @type {RegExp}
           */
          "escape": reEscape,
          /**
           * Used to detect code to be evaluated.
           *
           * @memberOf _.templateSettings
           * @type {RegExp}
           */
          "evaluate": reEvaluate,
          /**
           * Used to detect `data` property values to inject.
           *
           * @memberOf _.templateSettings
           * @type {RegExp}
           */
          "interpolate": reInterpolate,
          /**
           * Used to reference the data object in the template text.
           *
           * @memberOf _.templateSettings
           * @type {string}
           */
          "variable": "",
          /**
           * Used to import variables into the compiled template.
           *
           * @memberOf _.templateSettings
           * @type {Object}
           */
          "imports": {
            /**
             * A reference to the `lodash` function.
             *
             * @memberOf _.templateSettings.imports
             * @type {Function}
             */
            "_": lodash
          }
        };
        lodash.prototype = baseLodash.prototype;
        lodash.prototype.constructor = lodash;
        LodashWrapper.prototype = baseCreate(baseLodash.prototype);
        LodashWrapper.prototype.constructor = LodashWrapper;
        function LazyWrapper(value) {
          this.__wrapped__ = value;
          this.__actions__ = [];
          this.__dir__ = 1;
          this.__filtered__ = false;
          this.__iteratees__ = [];
          this.__takeCount__ = MAX_ARRAY_LENGTH;
          this.__views__ = [];
        }
        function lazyClone() {
          var result2 = new LazyWrapper(this.__wrapped__);
          result2.__actions__ = copyArray(this.__actions__);
          result2.__dir__ = this.__dir__;
          result2.__filtered__ = this.__filtered__;
          result2.__iteratees__ = copyArray(this.__iteratees__);
          result2.__takeCount__ = this.__takeCount__;
          result2.__views__ = copyArray(this.__views__);
          return result2;
        }
        function lazyReverse() {
          if (this.__filtered__) {
            var result2 = new LazyWrapper(this);
            result2.__dir__ = -1;
            result2.__filtered__ = true;
          } else {
            result2 = this.clone();
            result2.__dir__ *= -1;
          }
          return result2;
        }
        function lazyValue() {
          var array = this.__wrapped__.value(), dir = this.__dir__, isArr = isArray(array), isRight = dir < 0, arrLength = isArr ? array.length : 0, view = getView(0, arrLength, this.__views__), start = view.start, end = view.end, length = end - start, index = isRight ? end : start - 1, iteratees = this.__iteratees__, iterLength = iteratees.length, resIndex = 0, takeCount = nativeMin(length, this.__takeCount__);
          if (!isArr || !isRight && arrLength == length && takeCount == length) {
            return baseWrapperValue(array, this.__actions__);
          }
          var result2 = [];
          outer:
            while (length-- && resIndex < takeCount) {
              index += dir;
              var iterIndex = -1, value = array[index];
              while (++iterIndex < iterLength) {
                var data = iteratees[iterIndex], iteratee2 = data.iteratee, type = data.type, computed = iteratee2(value);
                if (type == LAZY_MAP_FLAG) {
                  value = computed;
                } else if (!computed) {
                  if (type == LAZY_FILTER_FLAG) {
                    continue outer;
                  } else {
                    break outer;
                  }
                }
              }
              result2[resIndex++] = value;
            }
          return result2;
        }
        LazyWrapper.prototype = baseCreate(baseLodash.prototype);
        LazyWrapper.prototype.constructor = LazyWrapper;
        function Hash(entries) {
          var index = -1, length = entries == null ? 0 : entries.length;
          this.clear();
          while (++index < length) {
            var entry = entries[index];
            this.set(entry[0], entry[1]);
          }
        }
        function hashClear() {
          this.__data__ = nativeCreate ? nativeCreate(null) : {};
          this.size = 0;
        }
        function hashDelete(key) {
          var result2 = this.has(key) && delete this.__data__[key];
          this.size -= result2 ? 1 : 0;
          return result2;
        }
        function hashGet(key) {
          var data = this.__data__;
          if (nativeCreate) {
            var result2 = data[key];
            return result2 === HASH_UNDEFINED ? undefined2 : result2;
          }
          return hasOwnProperty2.call(data, key) ? data[key] : undefined2;
        }
        function hashHas(key) {
          var data = this.__data__;
          return nativeCreate ? data[key] !== undefined2 : hasOwnProperty2.call(data, key);
        }
        function hashSet(key, value) {
          var data = this.__data__;
          this.size += this.has(key) ? 0 : 1;
          data[key] = nativeCreate && value === undefined2 ? HASH_UNDEFINED : value;
          return this;
        }
        Hash.prototype.clear = hashClear;
        Hash.prototype["delete"] = hashDelete;
        Hash.prototype.get = hashGet;
        Hash.prototype.has = hashHas;
        Hash.prototype.set = hashSet;
        function ListCache(entries) {
          var index = -1, length = entries == null ? 0 : entries.length;
          this.clear();
          while (++index < length) {
            var entry = entries[index];
            this.set(entry[0], entry[1]);
          }
        }
        function listCacheClear() {
          this.__data__ = [];
          this.size = 0;
        }
        function listCacheDelete(key) {
          var data = this.__data__, index = assocIndexOf(data, key);
          if (index < 0) {
            return false;
          }
          var lastIndex = data.length - 1;
          if (index == lastIndex) {
            data.pop();
          } else {
            splice.call(data, index, 1);
          }
          --this.size;
          return true;
        }
        function listCacheGet(key) {
          var data = this.__data__, index = assocIndexOf(data, key);
          return index < 0 ? undefined2 : data[index][1];
        }
        function listCacheHas(key) {
          return assocIndexOf(this.__data__, key) > -1;
        }
        function listCacheSet(key, value) {
          var data = this.__data__, index = assocIndexOf(data, key);
          if (index < 0) {
            ++this.size;
            data.push([key, value]);
          } else {
            data[index][1] = value;
          }
          return this;
        }
        ListCache.prototype.clear = listCacheClear;
        ListCache.prototype["delete"] = listCacheDelete;
        ListCache.prototype.get = listCacheGet;
        ListCache.prototype.has = listCacheHas;
        ListCache.prototype.set = listCacheSet;
        function MapCache(entries) {
          var index = -1, length = entries == null ? 0 : entries.length;
          this.clear();
          while (++index < length) {
            var entry = entries[index];
            this.set(entry[0], entry[1]);
          }
        }
        function mapCacheClear() {
          this.size = 0;
          this.__data__ = {
            "hash": new Hash(),
            "map": new (Map2 || ListCache)(),
            "string": new Hash()
          };
        }
        function mapCacheDelete(key) {
          var result2 = getMapData(this, key)["delete"](key);
          this.size -= result2 ? 1 : 0;
          return result2;
        }
        function mapCacheGet(key) {
          return getMapData(this, key).get(key);
        }
        function mapCacheHas(key) {
          return getMapData(this, key).has(key);
        }
        function mapCacheSet(key, value) {
          var data = getMapData(this, key), size2 = data.size;
          data.set(key, value);
          this.size += data.size == size2 ? 0 : 1;
          return this;
        }
        MapCache.prototype.clear = mapCacheClear;
        MapCache.prototype["delete"] = mapCacheDelete;
        MapCache.prototype.get = mapCacheGet;
        MapCache.prototype.has = mapCacheHas;
        MapCache.prototype.set = mapCacheSet;
        function SetCache(values2) {
          var index = -1, length = values2 == null ? 0 : values2.length;
          this.__data__ = new MapCache();
          while (++index < length) {
            this.add(values2[index]);
          }
        }
        function setCacheAdd(value) {
          this.__data__.set(value, HASH_UNDEFINED);
          return this;
        }
        function setCacheHas(value) {
          return this.__data__.has(value);
        }
        SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
        SetCache.prototype.has = setCacheHas;
        function Stack(entries) {
          var data = this.__data__ = new ListCache(entries);
          this.size = data.size;
        }
        function stackClear() {
          this.__data__ = new ListCache();
          this.size = 0;
        }
        function stackDelete(key) {
          var data = this.__data__, result2 = data["delete"](key);
          this.size = data.size;
          return result2;
        }
        function stackGet(key) {
          return this.__data__.get(key);
        }
        function stackHas(key) {
          return this.__data__.has(key);
        }
        function stackSet(key, value) {
          var data = this.__data__;
          if (data instanceof ListCache) {
            var pairs = data.__data__;
            if (!Map2 || pairs.length < LARGE_ARRAY_SIZE - 1) {
              pairs.push([key, value]);
              this.size = ++data.size;
              return this;
            }
            data = this.__data__ = new MapCache(pairs);
          }
          data.set(key, value);
          this.size = data.size;
          return this;
        }
        Stack.prototype.clear = stackClear;
        Stack.prototype["delete"] = stackDelete;
        Stack.prototype.get = stackGet;
        Stack.prototype.has = stackHas;
        Stack.prototype.set = stackSet;
        function arrayLikeKeys(value, inherited) {
          var isArr = isArray(value), isArg = !isArr && isArguments(value), isBuff = !isArr && !isArg && isBuffer(value), isType = !isArr && !isArg && !isBuff && isTypedArray(value), skipIndexes = isArr || isArg || isBuff || isType, result2 = skipIndexes ? baseTimes(value.length, String2) : [], length = result2.length;
          for (var key in value) {
            if ((inherited || hasOwnProperty2.call(value, key)) && !(skipIndexes && // Safari 9 has enumerable `arguments.length` in strict mode.
            (key == "length" || // Node.js 0.10 has enumerable non-index properties on buffers.
            isBuff && (key == "offset" || key == "parent") || // PhantomJS 2 has enumerable non-index properties on typed arrays.
            isType && (key == "buffer" || key == "byteLength" || key == "byteOffset") || // Skip index properties.
            isIndex(key, length)))) {
              result2.push(key);
            }
          }
          return result2;
        }
        function arraySample(array) {
          var length = array.length;
          return length ? array[baseRandom(0, length - 1)] : undefined2;
        }
        function arraySampleSize(array, n) {
          return shuffleSelf(copyArray(array), baseClamp(n, 0, array.length));
        }
        function arrayShuffle(array) {
          return shuffleSelf(copyArray(array));
        }
        function assignMergeValue(object, key, value) {
          if (value !== undefined2 && !eq(object[key], value) || value === undefined2 && !(key in object)) {
            baseAssignValue(object, key, value);
          }
        }
        function assignValue(object, key, value) {
          var objValue = object[key];
          if (!(hasOwnProperty2.call(object, key) && eq(objValue, value)) || value === undefined2 && !(key in object)) {
            baseAssignValue(object, key, value);
          }
        }
        function assocIndexOf(array, key) {
          var length = array.length;
          while (length--) {
            if (eq(array[length][0], key)) {
              return length;
            }
          }
          return -1;
        }
        function baseAggregator(collection, setter, iteratee2, accumulator) {
          baseEach(collection, function(value, key, collection2) {
            setter(accumulator, value, iteratee2(value), collection2);
          });
          return accumulator;
        }
        function baseAssign(object, source) {
          return object && copyObject(source, keys(source), object);
        }
        function baseAssignIn(object, source) {
          return object && copyObject(source, keysIn(source), object);
        }
        function baseAssignValue(object, key, value) {
          if (key == "__proto__" && defineProperty) {
            defineProperty(object, key, {
              "configurable": true,
              "enumerable": true,
              "value": value,
              "writable": true
            });
          } else {
            object[key] = value;
          }
        }
        function baseAt(object, paths) {
          var index = -1, length = paths.length, result2 = Array2(length), skip = object == null;
          while (++index < length) {
            result2[index] = skip ? undefined2 : get(object, paths[index]);
          }
          return result2;
        }
        function baseClamp(number, lower, upper) {
          if (number === number) {
            if (upper !== undefined2) {
              number = number <= upper ? number : upper;
            }
            if (lower !== undefined2) {
              number = number >= lower ? number : lower;
            }
          }
          return number;
        }
        function baseClone(value, bitmask, customizer, key, object, stack) {
          var result2, isDeep = bitmask & CLONE_DEEP_FLAG, isFlat = bitmask & CLONE_FLAT_FLAG, isFull = bitmask & CLONE_SYMBOLS_FLAG;
          if (customizer) {
            result2 = object ? customizer(value, key, object, stack) : customizer(value);
          }
          if (result2 !== undefined2) {
            return result2;
          }
          if (!isObject2(value)) {
            return value;
          }
          var isArr = isArray(value);
          if (isArr) {
            result2 = initCloneArray(value);
            if (!isDeep) {
              return copyArray(value, result2);
            }
          } else {
            var tag = getTag(value), isFunc = tag == funcTag || tag == genTag;
            if (isBuffer(value)) {
              return cloneBuffer(value, isDeep);
            }
            if (tag == objectTag || tag == argsTag || isFunc && !object) {
              result2 = isFlat || isFunc ? {} : initCloneObject(value);
              if (!isDeep) {
                return isFlat ? copySymbolsIn(value, baseAssignIn(result2, value)) : copySymbols(value, baseAssign(result2, value));
              }
            } else {
              if (!cloneableTags[tag]) {
                return object ? value : {};
              }
              result2 = initCloneByTag(value, tag, isDeep);
            }
          }
          stack || (stack = new Stack());
          var stacked = stack.get(value);
          if (stacked) {
            return stacked;
          }
          stack.set(value, result2);
          if (isSet2(value)) {
            value.forEach(function(subValue) {
              result2.add(baseClone(subValue, bitmask, customizer, subValue, value, stack));
            });
          } else if (isMap2(value)) {
            value.forEach(function(subValue, key2) {
              result2.set(key2, baseClone(subValue, bitmask, customizer, key2, value, stack));
            });
          }
          var keysFunc = isFull ? isFlat ? getAllKeysIn : getAllKeys : isFlat ? keysIn : keys;
          var props = isArr ? undefined2 : keysFunc(value);
          arrayEach(props || value, function(subValue, key2) {
            if (props) {
              key2 = subValue;
              subValue = value[key2];
            }
            assignValue(result2, key2, baseClone(subValue, bitmask, customizer, key2, value, stack));
          });
          return result2;
        }
        function baseConforms(source) {
          var props = keys(source);
          return function(object) {
            return baseConformsTo(object, source, props);
          };
        }
        function baseConformsTo(object, source, props) {
          var length = props.length;
          if (object == null) {
            return !length;
          }
          object = Object2(object);
          while (length--) {
            var key = props[length], predicate = source[key], value = object[key];
            if (value === undefined2 && !(key in object) || !predicate(value)) {
              return false;
            }
          }
          return true;
        }
        function baseDelay(func, wait, args) {
          if (typeof func != "function") {
            throw new TypeError2(FUNC_ERROR_TEXT);
          }
          return setTimeout2(function() {
            func.apply(undefined2, args);
          }, wait);
        }
        function baseDifference(array, values2, iteratee2, comparator) {
          var index = -1, includes2 = arrayIncludes, isCommon = true, length = array.length, result2 = [], valuesLength = values2.length;
          if (!length) {
            return result2;
          }
          if (iteratee2) {
            values2 = arrayMap(values2, baseUnary(iteratee2));
          }
          if (comparator) {
            includes2 = arrayIncludesWith;
            isCommon = false;
          } else if (values2.length >= LARGE_ARRAY_SIZE) {
            includes2 = cacheHas;
            isCommon = false;
            values2 = new SetCache(values2);
          }
          outer:
            while (++index < length) {
              var value = array[index], computed = iteratee2 == null ? value : iteratee2(value);
              value = comparator || value !== 0 ? value : 0;
              if (isCommon && computed === computed) {
                var valuesIndex = valuesLength;
                while (valuesIndex--) {
                  if (values2[valuesIndex] === computed) {
                    continue outer;
                  }
                }
                result2.push(value);
              } else if (!includes2(values2, computed, comparator)) {
                result2.push(value);
              }
            }
          return result2;
        }
        var baseEach = createBaseEach(baseForOwn);
        var baseEachRight = createBaseEach(baseForOwnRight, true);
        function baseEvery(collection, predicate) {
          var result2 = true;
          baseEach(collection, function(value, index, collection2) {
            result2 = !!predicate(value, index, collection2);
            return result2;
          });
          return result2;
        }
        function baseExtremum(array, iteratee2, comparator) {
          var index = -1, length = array.length;
          while (++index < length) {
            var value = array[index], current2 = iteratee2(value);
            if (current2 != null && (computed === undefined2 ? current2 === current2 && !isSymbol(current2) : comparator(current2, computed))) {
              var computed = current2, result2 = value;
            }
          }
          return result2;
        }
        function baseFill(array, value, start, end) {
          var length = array.length;
          start = toInteger(start);
          if (start < 0) {
            start = -start > length ? 0 : length + start;
          }
          end = end === undefined2 || end > length ? length : toInteger(end);
          if (end < 0) {
            end += length;
          }
          end = start > end ? 0 : toLength(end);
          while (start < end) {
            array[start++] = value;
          }
          return array;
        }
        function baseFilter(collection, predicate) {
          var result2 = [];
          baseEach(collection, function(value, index, collection2) {
            if (predicate(value, index, collection2)) {
              result2.push(value);
            }
          });
          return result2;
        }
        function baseFlatten(array, depth, predicate, isStrict, result2) {
          var index = -1, length = array.length;
          predicate || (predicate = isFlattenable);
          result2 || (result2 = []);
          while (++index < length) {
            var value = array[index];
            if (depth > 0 && predicate(value)) {
              if (depth > 1) {
                baseFlatten(value, depth - 1, predicate, isStrict, result2);
              } else {
                arrayPush(result2, value);
              }
            } else if (!isStrict) {
              result2[result2.length] = value;
            }
          }
          return result2;
        }
        var baseFor = createBaseFor();
        var baseForRight = createBaseFor(true);
        function baseForOwn(object, iteratee2) {
          return object && baseFor(object, iteratee2, keys);
        }
        function baseForOwnRight(object, iteratee2) {
          return object && baseForRight(object, iteratee2, keys);
        }
        function baseFunctions(object, props) {
          return arrayFilter(props, function(key) {
            return isFunction(object[key]);
          });
        }
        function baseGet(object, path) {
          path = castPath(path, object);
          var index = 0, length = path.length;
          while (object != null && index < length) {
            object = object[toKey(path[index++])];
          }
          return index && index == length ? object : undefined2;
        }
        function baseGetAllKeys(object, keysFunc, symbolsFunc) {
          var result2 = keysFunc(object);
          return isArray(object) ? result2 : arrayPush(result2, symbolsFunc(object));
        }
        function baseGetTag(value) {
          if (value == null) {
            return value === undefined2 ? undefinedTag : nullTag;
          }
          return symToStringTag && symToStringTag in Object2(value) ? getRawTag(value) : objectToString2(value);
        }
        function baseGt(value, other) {
          return value > other;
        }
        function baseHas(object, key) {
          return object != null && hasOwnProperty2.call(object, key);
        }
        function baseHasIn(object, key) {
          return object != null && key in Object2(object);
        }
        function baseInRange(number, start, end) {
          return number >= nativeMin(start, end) && number < nativeMax(start, end);
        }
        function baseIntersection(arrays, iteratee2, comparator) {
          var includes2 = comparator ? arrayIncludesWith : arrayIncludes, length = arrays[0].length, othLength = arrays.length, othIndex = othLength, caches = Array2(othLength), maxLength = Infinity, result2 = [];
          while (othIndex--) {
            var array = arrays[othIndex];
            if (othIndex && iteratee2) {
              array = arrayMap(array, baseUnary(iteratee2));
            }
            maxLength = nativeMin(array.length, maxLength);
            caches[othIndex] = !comparator && (iteratee2 || length >= 120 && array.length >= 120) ? new SetCache(othIndex && array) : undefined2;
          }
          array = arrays[0];
          var index = -1, seen = caches[0];
          outer:
            while (++index < length && result2.length < maxLength) {
              var value = array[index], computed = iteratee2 ? iteratee2(value) : value;
              value = comparator || value !== 0 ? value : 0;
              if (!(seen ? cacheHas(seen, computed) : includes2(result2, computed, comparator))) {
                othIndex = othLength;
                while (--othIndex) {
                  var cache = caches[othIndex];
                  if (!(cache ? cacheHas(cache, computed) : includes2(arrays[othIndex], computed, comparator))) {
                    continue outer;
                  }
                }
                if (seen) {
                  seen.push(computed);
                }
                result2.push(value);
              }
            }
          return result2;
        }
        function baseInverter(object, setter, iteratee2, accumulator) {
          baseForOwn(object, function(value, key, object2) {
            setter(accumulator, iteratee2(value), key, object2);
          });
          return accumulator;
        }
        function baseInvoke(object, path, args) {
          path = castPath(path, object);
          object = parent(object, path);
          var func = object == null ? object : object[toKey(last(path))];
          return func == null ? undefined2 : apply(func, object, args);
        }
        function baseIsArguments(value) {
          return isObjectLike(value) && baseGetTag(value) == argsTag;
        }
        function baseIsArrayBuffer(value) {
          return isObjectLike(value) && baseGetTag(value) == arrayBufferTag;
        }
        function baseIsDate(value) {
          return isObjectLike(value) && baseGetTag(value) == dateTag;
        }
        function baseIsEqual(value, other, bitmask, customizer, stack) {
          if (value === other) {
            return true;
          }
          if (value == null || other == null || !isObjectLike(value) && !isObjectLike(other)) {
            return value !== value && other !== other;
          }
          return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
        }
        function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
          var objIsArr = isArray(object), othIsArr = isArray(other), objTag = objIsArr ? arrayTag : getTag(object), othTag = othIsArr ? arrayTag : getTag(other);
          objTag = objTag == argsTag ? objectTag : objTag;
          othTag = othTag == argsTag ? objectTag : othTag;
          var objIsObj = objTag == objectTag, othIsObj = othTag == objectTag, isSameTag = objTag == othTag;
          if (isSameTag && isBuffer(object)) {
            if (!isBuffer(other)) {
              return false;
            }
            objIsArr = true;
            objIsObj = false;
          }
          if (isSameTag && !objIsObj) {
            stack || (stack = new Stack());
            return objIsArr || isTypedArray(object) ? equalArrays(object, other, bitmask, customizer, equalFunc, stack) : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
          }
          if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
            var objIsWrapped = objIsObj && hasOwnProperty2.call(object, "__wrapped__"), othIsWrapped = othIsObj && hasOwnProperty2.call(other, "__wrapped__");
            if (objIsWrapped || othIsWrapped) {
              var objUnwrapped = objIsWrapped ? object.value() : object, othUnwrapped = othIsWrapped ? other.value() : other;
              stack || (stack = new Stack());
              return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
            }
          }
          if (!isSameTag) {
            return false;
          }
          stack || (stack = new Stack());
          return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
        }
        function baseIsMap(value) {
          return isObjectLike(value) && getTag(value) == mapTag;
        }
        function baseIsMatch(object, source, matchData, customizer) {
          var index = matchData.length, length = index, noCustomizer = !customizer;
          if (object == null) {
            return !length;
          }
          object = Object2(object);
          while (index--) {
            var data = matchData[index];
            if (noCustomizer && data[2] ? data[1] !== object[data[0]] : !(data[0] in object)) {
              return false;
            }
          }
          while (++index < length) {
            data = matchData[index];
            var key = data[0], objValue = object[key], srcValue = data[1];
            if (noCustomizer && data[2]) {
              if (objValue === undefined2 && !(key in object)) {
                return false;
              }
            } else {
              var stack = new Stack();
              if (customizer) {
                var result2 = customizer(objValue, srcValue, key, object, source, stack);
              }
              if (!(result2 === undefined2 ? baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG, customizer, stack) : result2)) {
                return false;
              }
            }
          }
          return true;
        }
        function baseIsNative(value) {
          if (!isObject2(value) || isMasked(value)) {
            return false;
          }
          var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
          return pattern.test(toSource(value));
        }
        function baseIsRegExp(value) {
          return isObjectLike(value) && baseGetTag(value) == regexpTag;
        }
        function baseIsSet(value) {
          return isObjectLike(value) && getTag(value) == setTag;
        }
        function baseIsTypedArray(value) {
          return isObjectLike(value) && isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
        }
        function baseIteratee(value) {
          if (typeof value == "function") {
            return value;
          }
          if (value == null) {
            return identity;
          }
          if (typeof value == "object") {
            return isArray(value) ? baseMatchesProperty(value[0], value[1]) : baseMatches(value);
          }
          return property(value);
        }
        function baseKeys(object) {
          if (!isPrototype(object)) {
            return nativeKeys(object);
          }
          var result2 = [];
          for (var key in Object2(object)) {
            if (hasOwnProperty2.call(object, key) && key != "constructor") {
              result2.push(key);
            }
          }
          return result2;
        }
        function baseKeysIn(object) {
          if (!isObject2(object)) {
            return nativeKeysIn(object);
          }
          var isProto = isPrototype(object), result2 = [];
          for (var key in object) {
            if (!(key == "constructor" && (isProto || !hasOwnProperty2.call(object, key)))) {
              result2.push(key);
            }
          }
          return result2;
        }
        function baseLt(value, other) {
          return value < other;
        }
        function baseMap(collection, iteratee2) {
          var index = -1, result2 = isArrayLike(collection) ? Array2(collection.length) : [];
          baseEach(collection, function(value, key, collection2) {
            result2[++index] = iteratee2(value, key, collection2);
          });
          return result2;
        }
        function baseMatches(source) {
          var matchData = getMatchData(source);
          if (matchData.length == 1 && matchData[0][2]) {
            return matchesStrictComparable(matchData[0][0], matchData[0][1]);
          }
          return function(object) {
            return object === source || baseIsMatch(object, source, matchData);
          };
        }
        function baseMatchesProperty(path, srcValue) {
          if (isKey(path) && isStrictComparable(srcValue)) {
            return matchesStrictComparable(toKey(path), srcValue);
          }
          return function(object) {
            var objValue = get(object, path);
            return objValue === undefined2 && objValue === srcValue ? hasIn(object, path) : baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG);
          };
        }
        function baseMerge(object, source, srcIndex, customizer, stack) {
          if (object === source) {
            return;
          }
          baseFor(source, function(srcValue, key) {
            stack || (stack = new Stack());
            if (isObject2(srcValue)) {
              baseMergeDeep(object, source, key, srcIndex, baseMerge, customizer, stack);
            } else {
              var newValue = customizer ? customizer(safeGet(object, key), srcValue, key + "", object, source, stack) : undefined2;
              if (newValue === undefined2) {
                newValue = srcValue;
              }
              assignMergeValue(object, key, newValue);
            }
          }, keysIn);
        }
        function baseMergeDeep(object, source, key, srcIndex, mergeFunc, customizer, stack) {
          var objValue = safeGet(object, key), srcValue = safeGet(source, key), stacked = stack.get(srcValue);
          if (stacked) {
            assignMergeValue(object, key, stacked);
            return;
          }
          var newValue = customizer ? customizer(objValue, srcValue, key + "", object, source, stack) : undefined2;
          var isCommon = newValue === undefined2;
          if (isCommon) {
            var isArr = isArray(srcValue), isBuff = !isArr && isBuffer(srcValue), isTyped = !isArr && !isBuff && isTypedArray(srcValue);
            newValue = srcValue;
            if (isArr || isBuff || isTyped) {
              if (isArray(objValue)) {
                newValue = objValue;
              } else if (isArrayLikeObject(objValue)) {
                newValue = copyArray(objValue);
              } else if (isBuff) {
                isCommon = false;
                newValue = cloneBuffer(srcValue, true);
              } else if (isTyped) {
                isCommon = false;
                newValue = cloneTypedArray(srcValue, true);
              } else {
                newValue = [];
              }
            } else if (isPlainObject2(srcValue) || isArguments(srcValue)) {
              newValue = objValue;
              if (isArguments(objValue)) {
                newValue = toPlainObject(objValue);
              } else if (!isObject2(objValue) || isFunction(objValue)) {
                newValue = initCloneObject(srcValue);
              }
            } else {
              isCommon = false;
            }
          }
          if (isCommon) {
            stack.set(srcValue, newValue);
            mergeFunc(newValue, srcValue, srcIndex, customizer, stack);
            stack["delete"](srcValue);
          }
          assignMergeValue(object, key, newValue);
        }
        function baseNth(array, n) {
          var length = array.length;
          if (!length) {
            return;
          }
          n += n < 0 ? length : 0;
          return isIndex(n, length) ? array[n] : undefined2;
        }
        function baseOrderBy(collection, iteratees, orders) {
          if (iteratees.length) {
            iteratees = arrayMap(iteratees, function(iteratee2) {
              if (isArray(iteratee2)) {
                return function(value) {
                  return baseGet(value, iteratee2.length === 1 ? iteratee2[0] : iteratee2);
                };
              }
              return iteratee2;
            });
          } else {
            iteratees = [identity];
          }
          var index = -1;
          iteratees = arrayMap(iteratees, baseUnary(getIteratee()));
          var result2 = baseMap(collection, function(value, key, collection2) {
            var criteria = arrayMap(iteratees, function(iteratee2) {
              return iteratee2(value);
            });
            return { "criteria": criteria, "index": ++index, "value": value };
          });
          return baseSortBy(result2, function(object, other) {
            return compareMultiple(object, other, orders);
          });
        }
        function basePick(object, paths) {
          return basePickBy(object, paths, function(value, path) {
            return hasIn(object, path);
          });
        }
        function basePickBy(object, paths, predicate) {
          var index = -1, length = paths.length, result2 = {};
          while (++index < length) {
            var path = paths[index], value = baseGet(object, path);
            if (predicate(value, path)) {
              baseSet(result2, castPath(path, object), value);
            }
          }
          return result2;
        }
        function basePropertyDeep(path) {
          return function(object) {
            return baseGet(object, path);
          };
        }
        function basePullAll(array, values2, iteratee2, comparator) {
          var indexOf2 = comparator ? baseIndexOfWith : baseIndexOf, index = -1, length = values2.length, seen = array;
          if (array === values2) {
            values2 = copyArray(values2);
          }
          if (iteratee2) {
            seen = arrayMap(array, baseUnary(iteratee2));
          }
          while (++index < length) {
            var fromIndex = 0, value = values2[index], computed = iteratee2 ? iteratee2(value) : value;
            while ((fromIndex = indexOf2(seen, computed, fromIndex, comparator)) > -1) {
              if (seen !== array) {
                splice.call(seen, fromIndex, 1);
              }
              splice.call(array, fromIndex, 1);
            }
          }
          return array;
        }
        function basePullAt(array, indexes) {
          var length = array ? indexes.length : 0, lastIndex = length - 1;
          while (length--) {
            var index = indexes[length];
            if (length == lastIndex || index !== previous) {
              var previous = index;
              if (isIndex(index)) {
                splice.call(array, index, 1);
              } else {
                baseUnset(array, index);
              }
            }
          }
          return array;
        }
        function baseRandom(lower, upper) {
          return lower + nativeFloor(nativeRandom() * (upper - lower + 1));
        }
        function baseRange(start, end, step, fromRight) {
          var index = -1, length = nativeMax(nativeCeil((end - start) / (step || 1)), 0), result2 = Array2(length);
          while (length--) {
            result2[fromRight ? length : ++index] = start;
            start += step;
          }
          return result2;
        }
        function baseRepeat(string, n) {
          var result2 = "";
          if (!string || n < 1 || n > MAX_SAFE_INTEGER) {
            return result2;
          }
          do {
            if (n % 2) {
              result2 += string;
            }
            n = nativeFloor(n / 2);
            if (n) {
              string += string;
            }
          } while (n);
          return result2;
        }
        function baseRest(func, start) {
          return setToString(overRest(func, start, identity), func + "");
        }
        function baseSample(collection) {
          return arraySample(values(collection));
        }
        function baseSampleSize(collection, n) {
          var array = values(collection);
          return shuffleSelf(array, baseClamp(n, 0, array.length));
        }
        function baseSet(object, path, value, customizer) {
          if (!isObject2(object)) {
            return object;
          }
          path = castPath(path, object);
          var index = -1, length = path.length, lastIndex = length - 1, nested = object;
          while (nested != null && ++index < length) {
            var key = toKey(path[index]), newValue = value;
            if (key === "__proto__" || key === "constructor" || key === "prototype") {
              return object;
            }
            if (index != lastIndex) {
              var objValue = nested[key];
              newValue = customizer ? customizer(objValue, key, nested) : undefined2;
              if (newValue === undefined2) {
                newValue = isObject2(objValue) ? objValue : isIndex(path[index + 1]) ? [] : {};
              }
            }
            assignValue(nested, key, newValue);
            nested = nested[key];
          }
          return object;
        }
        var baseSetData = !metaMap ? identity : function(func, data) {
          metaMap.set(func, data);
          return func;
        };
        var baseSetToString = !defineProperty ? identity : function(func, string) {
          return defineProperty(func, "toString", {
            "configurable": true,
            "enumerable": false,
            "value": constant(string),
            "writable": true
          });
        };
        function baseShuffle(collection) {
          return shuffleSelf(values(collection));
        }
        function baseSlice(array, start, end) {
          var index = -1, length = array.length;
          if (start < 0) {
            start = -start > length ? 0 : length + start;
          }
          end = end > length ? length : end;
          if (end < 0) {
            end += length;
          }
          length = start > end ? 0 : end - start >>> 0;
          start >>>= 0;
          var result2 = Array2(length);
          while (++index < length) {
            result2[index] = array[index + start];
          }
          return result2;
        }
        function baseSome(collection, predicate) {
          var result2;
          baseEach(collection, function(value, index, collection2) {
            result2 = predicate(value, index, collection2);
            return !result2;
          });
          return !!result2;
        }
        function baseSortedIndex(array, value, retHighest) {
          var low = 0, high = array == null ? low : array.length;
          if (typeof value == "number" && value === value && high <= HALF_MAX_ARRAY_LENGTH) {
            while (low < high) {
              var mid = low + high >>> 1, computed = array[mid];
              if (computed !== null && !isSymbol(computed) && (retHighest ? computed <= value : computed < value)) {
                low = mid + 1;
              } else {
                high = mid;
              }
            }
            return high;
          }
          return baseSortedIndexBy(array, value, identity, retHighest);
        }
        function baseSortedIndexBy(array, value, iteratee2, retHighest) {
          var low = 0, high = array == null ? 0 : array.length;
          if (high === 0) {
            return 0;
          }
          value = iteratee2(value);
          var valIsNaN = value !== value, valIsNull = value === null, valIsSymbol = isSymbol(value), valIsUndefined = value === undefined2;
          while (low < high) {
            var mid = nativeFloor((low + high) / 2), computed = iteratee2(array[mid]), othIsDefined = computed !== undefined2, othIsNull = computed === null, othIsReflexive = computed === computed, othIsSymbol = isSymbol(computed);
            if (valIsNaN) {
              var setLow = retHighest || othIsReflexive;
            } else if (valIsUndefined) {
              setLow = othIsReflexive && (retHighest || othIsDefined);
            } else if (valIsNull) {
              setLow = othIsReflexive && othIsDefined && (retHighest || !othIsNull);
            } else if (valIsSymbol) {
              setLow = othIsReflexive && othIsDefined && !othIsNull && (retHighest || !othIsSymbol);
            } else if (othIsNull || othIsSymbol) {
              setLow = false;
            } else {
              setLow = retHighest ? computed <= value : computed < value;
            }
            if (setLow) {
              low = mid + 1;
            } else {
              high = mid;
            }
          }
          return nativeMin(high, MAX_ARRAY_INDEX);
        }
        function baseSortedUniq(array, iteratee2) {
          var index = -1, length = array.length, resIndex = 0, result2 = [];
          while (++index < length) {
            var value = array[index], computed = iteratee2 ? iteratee2(value) : value;
            if (!index || !eq(computed, seen)) {
              var seen = computed;
              result2[resIndex++] = value === 0 ? 0 : value;
            }
          }
          return result2;
        }
        function baseToNumber(value) {
          if (typeof value == "number") {
            return value;
          }
          if (isSymbol(value)) {
            return NAN;
          }
          return +value;
        }
        function baseToString(value) {
          if (typeof value == "string") {
            return value;
          }
          if (isArray(value)) {
            return arrayMap(value, baseToString) + "";
          }
          if (isSymbol(value)) {
            return symbolToString ? symbolToString.call(value) : "";
          }
          var result2 = value + "";
          return result2 == "0" && 1 / value == -INFINITY ? "-0" : result2;
        }
        function baseUniq(array, iteratee2, comparator) {
          var index = -1, includes2 = arrayIncludes, length = array.length, isCommon = true, result2 = [], seen = result2;
          if (comparator) {
            isCommon = false;
            includes2 = arrayIncludesWith;
          } else if (length >= LARGE_ARRAY_SIZE) {
            var set3 = iteratee2 ? null : createSet(array);
            if (set3) {
              return setToArray(set3);
            }
            isCommon = false;
            includes2 = cacheHas;
            seen = new SetCache();
          } else {
            seen = iteratee2 ? [] : result2;
          }
          outer:
            while (++index < length) {
              var value = array[index], computed = iteratee2 ? iteratee2(value) : value;
              value = comparator || value !== 0 ? value : 0;
              if (isCommon && computed === computed) {
                var seenIndex = seen.length;
                while (seenIndex--) {
                  if (seen[seenIndex] === computed) {
                    continue outer;
                  }
                }
                if (iteratee2) {
                  seen.push(computed);
                }
                result2.push(value);
              } else if (!includes2(seen, computed, comparator)) {
                if (seen !== result2) {
                  seen.push(computed);
                }
                result2.push(value);
              }
            }
          return result2;
        }
        function baseUnset(object, path) {
          path = castPath(path, object);
          var index = -1, length = path.length;
          if (!length) {
            return true;
          }
          while (++index < length) {
            var key = toKey(path[index]);
            if (key === "__proto__" && !hasOwnProperty2.call(object, "__proto__")) {
              return false;
            }
            if ((key === "constructor" || key === "prototype") && index < length - 1) {
              return false;
            }
          }
          var obj = parent(object, path);
          return obj == null || delete obj[toKey(last(path))];
        }
        function baseUpdate(object, path, updater, customizer) {
          return baseSet(object, path, updater(baseGet(object, path)), customizer);
        }
        function baseWhile(array, predicate, isDrop, fromRight) {
          var length = array.length, index = fromRight ? length : -1;
          while ((fromRight ? index-- : ++index < length) && predicate(array[index], index, array)) {
          }
          return isDrop ? baseSlice(array, fromRight ? 0 : index, fromRight ? index + 1 : length) : baseSlice(array, fromRight ? index + 1 : 0, fromRight ? length : index);
        }
        function baseWrapperValue(value, actions) {
          var result2 = value;
          if (result2 instanceof LazyWrapper) {
            result2 = result2.value();
          }
          return arrayReduce(actions, function(result3, action) {
            return action.func.apply(action.thisArg, arrayPush([result3], action.args));
          }, result2);
        }
        function baseXor(arrays, iteratee2, comparator) {
          var length = arrays.length;
          if (length < 2) {
            return length ? baseUniq(arrays[0]) : [];
          }
          var index = -1, result2 = Array2(length);
          while (++index < length) {
            var array = arrays[index], othIndex = -1;
            while (++othIndex < length) {
              if (othIndex != index) {
                result2[index] = baseDifference(result2[index] || array, arrays[othIndex], iteratee2, comparator);
              }
            }
          }
          return baseUniq(baseFlatten(result2, 1), iteratee2, comparator);
        }
        function baseZipObject(props, values2, assignFunc) {
          var index = -1, length = props.length, valsLength = values2.length, result2 = {};
          while (++index < length) {
            var value = index < valsLength ? values2[index] : undefined2;
            assignFunc(result2, props[index], value);
          }
          return result2;
        }
        function castArrayLikeObject(value) {
          return isArrayLikeObject(value) ? value : [];
        }
        function castFunction(value) {
          return typeof value == "function" ? value : identity;
        }
        function castPath(value, object) {
          if (isArray(value)) {
            return value;
          }
          return isKey(value, object) ? [value] : stringToPath(toString(value));
        }
        var castRest = baseRest;
        function castSlice(array, start, end) {
          var length = array.length;
          end = end === undefined2 ? length : end;
          return !start && end >= length ? array : baseSlice(array, start, end);
        }
        var clearTimeout2 = ctxClearTimeout || function(id) {
          return root.clearTimeout(id);
        };
        function cloneBuffer(buffer, isDeep) {
          if (isDeep) {
            return buffer.slice();
          }
          var length = buffer.length, result2 = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);
          buffer.copy(result2);
          return result2;
        }
        function cloneArrayBuffer(arrayBuffer) {
          var result2 = new arrayBuffer.constructor(arrayBuffer.byteLength);
          new Uint8Array2(result2).set(new Uint8Array2(arrayBuffer));
          return result2;
        }
        function cloneDataView(dataView, isDeep) {
          var buffer = isDeep ? cloneArrayBuffer(dataView.buffer) : dataView.buffer;
          return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
        }
        function cloneRegExp(regexp) {
          var result2 = new regexp.constructor(regexp.source, reFlags.exec(regexp));
          result2.lastIndex = regexp.lastIndex;
          return result2;
        }
        function cloneSymbol(symbol) {
          return symbolValueOf ? Object2(symbolValueOf.call(symbol)) : {};
        }
        function cloneTypedArray(typedArray, isDeep) {
          var buffer = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
          return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
        }
        function compareAscending(value, other) {
          if (value !== other) {
            var valIsDefined = value !== undefined2, valIsNull = value === null, valIsReflexive = value === value, valIsSymbol = isSymbol(value);
            var othIsDefined = other !== undefined2, othIsNull = other === null, othIsReflexive = other === other, othIsSymbol = isSymbol(other);
            if (!othIsNull && !othIsSymbol && !valIsSymbol && value > other || valIsSymbol && othIsDefined && othIsReflexive && !othIsNull && !othIsSymbol || valIsNull && othIsDefined && othIsReflexive || !valIsDefined && othIsReflexive || !valIsReflexive) {
              return 1;
            }
            if (!valIsNull && !valIsSymbol && !othIsSymbol && value < other || othIsSymbol && valIsDefined && valIsReflexive && !valIsNull && !valIsSymbol || othIsNull && valIsDefined && valIsReflexive || !othIsDefined && valIsReflexive || !othIsReflexive) {
              return -1;
            }
          }
          return 0;
        }
        function compareMultiple(object, other, orders) {
          var index = -1, objCriteria = object.criteria, othCriteria = other.criteria, length = objCriteria.length, ordersLength = orders.length;
          while (++index < length) {
            var result2 = compareAscending(objCriteria[index], othCriteria[index]);
            if (result2) {
              if (index >= ordersLength) {
                return result2;
              }
              var order = orders[index];
              return result2 * (order == "desc" ? -1 : 1);
            }
          }
          return object.index - other.index;
        }
        function composeArgs(args, partials, holders, isCurried) {
          var argsIndex = -1, argsLength = args.length, holdersLength = holders.length, leftIndex = -1, leftLength = partials.length, rangeLength = nativeMax(argsLength - holdersLength, 0), result2 = Array2(leftLength + rangeLength), isUncurried = !isCurried;
          while (++leftIndex < leftLength) {
            result2[leftIndex] = partials[leftIndex];
          }
          while (++argsIndex < holdersLength) {
            if (isUncurried || argsIndex < argsLength) {
              result2[holders[argsIndex]] = args[argsIndex];
            }
          }
          while (rangeLength--) {
            result2[leftIndex++] = args[argsIndex++];
          }
          return result2;
        }
        function composeArgsRight(args, partials, holders, isCurried) {
          var argsIndex = -1, argsLength = args.length, holdersIndex = -1, holdersLength = holders.length, rightIndex = -1, rightLength = partials.length, rangeLength = nativeMax(argsLength - holdersLength, 0), result2 = Array2(rangeLength + rightLength), isUncurried = !isCurried;
          while (++argsIndex < rangeLength) {
            result2[argsIndex] = args[argsIndex];
          }
          var offset = argsIndex;
          while (++rightIndex < rightLength) {
            result2[offset + rightIndex] = partials[rightIndex];
          }
          while (++holdersIndex < holdersLength) {
            if (isUncurried || argsIndex < argsLength) {
              result2[offset + holders[holdersIndex]] = args[argsIndex++];
            }
          }
          return result2;
        }
        function copyArray(source, array) {
          var index = -1, length = source.length;
          array || (array = Array2(length));
          while (++index < length) {
            array[index] = source[index];
          }
          return array;
        }
        function copyObject(source, props, object, customizer) {
          var isNew = !object;
          object || (object = {});
          var index = -1, length = props.length;
          while (++index < length) {
            var key = props[index];
            var newValue = customizer ? customizer(object[key], source[key], key, object, source) : undefined2;
            if (newValue === undefined2) {
              newValue = source[key];
            }
            if (isNew) {
              baseAssignValue(object, key, newValue);
            } else {
              assignValue(object, key, newValue);
            }
          }
          return object;
        }
        function copySymbols(source, object) {
          return copyObject(source, getSymbols(source), object);
        }
        function copySymbolsIn(source, object) {
          return copyObject(source, getSymbolsIn(source), object);
        }
        function createAggregator(setter, initializer) {
          return function(collection, iteratee2) {
            var func = isArray(collection) ? arrayAggregator : baseAggregator, accumulator = initializer ? initializer() : {};
            return func(collection, setter, getIteratee(iteratee2, 2), accumulator);
          };
        }
        function createAssigner(assigner) {
          return baseRest(function(object, sources) {
            var index = -1, length = sources.length, customizer = length > 1 ? sources[length - 1] : undefined2, guard = length > 2 ? sources[2] : undefined2;
            customizer = assigner.length > 3 && typeof customizer == "function" ? (length--, customizer) : undefined2;
            if (guard && isIterateeCall(sources[0], sources[1], guard)) {
              customizer = length < 3 ? undefined2 : customizer;
              length = 1;
            }
            object = Object2(object);
            while (++index < length) {
              var source = sources[index];
              if (source) {
                assigner(object, source, index, customizer);
              }
            }
            return object;
          });
        }
        function createBaseEach(eachFunc, fromRight) {
          return function(collection, iteratee2) {
            if (collection == null) {
              return collection;
            }
            if (!isArrayLike(collection)) {
              return eachFunc(collection, iteratee2);
            }
            var length = collection.length, index = fromRight ? length : -1, iterable = Object2(collection);
            while (fromRight ? index-- : ++index < length) {
              if (iteratee2(iterable[index], index, iterable) === false) {
                break;
              }
            }
            return collection;
          };
        }
        function createBaseFor(fromRight) {
          return function(object, iteratee2, keysFunc) {
            var index = -1, iterable = Object2(object), props = keysFunc(object), length = props.length;
            while (length--) {
              var key = props[fromRight ? length : ++index];
              if (iteratee2(iterable[key], key, iterable) === false) {
                break;
              }
            }
            return object;
          };
        }
        function createBind(func, bitmask, thisArg) {
          var isBind = bitmask & WRAP_BIND_FLAG, Ctor = createCtor(func);
          function wrapper() {
            var fn = this && this !== root && this instanceof wrapper ? Ctor : func;
            return fn.apply(isBind ? thisArg : this, arguments);
          }
          return wrapper;
        }
        function createCaseFirst(methodName) {
          return function(string) {
            string = toString(string);
            var strSymbols = hasUnicode(string) ? stringToArray(string) : undefined2;
            var chr = strSymbols ? strSymbols[0] : string.charAt(0);
            var trailing = strSymbols ? castSlice(strSymbols, 1).join("") : string.slice(1);
            return chr[methodName]() + trailing;
          };
        }
        function createCompounder(callback) {
          return function(string) {
            return arrayReduce(words(deburr(string).replace(reApos, "")), callback, "");
          };
        }
        function createCtor(Ctor) {
          return function() {
            var args = arguments;
            switch (args.length) {
              case 0:
                return new Ctor();
              case 1:
                return new Ctor(args[0]);
              case 2:
                return new Ctor(args[0], args[1]);
              case 3:
                return new Ctor(args[0], args[1], args[2]);
              case 4:
                return new Ctor(args[0], args[1], args[2], args[3]);
              case 5:
                return new Ctor(args[0], args[1], args[2], args[3], args[4]);
              case 6:
                return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5]);
              case 7:
                return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5], args[6]);
            }
            var thisBinding = baseCreate(Ctor.prototype), result2 = Ctor.apply(thisBinding, args);
            return isObject2(result2) ? result2 : thisBinding;
          };
        }
        function createCurry(func, bitmask, arity) {
          var Ctor = createCtor(func);
          function wrapper() {
            var length = arguments.length, args = Array2(length), index = length, placeholder = getHolder(wrapper);
            while (index--) {
              args[index] = arguments[index];
            }
            var holders = length < 3 && args[0] !== placeholder && args[length - 1] !== placeholder ? [] : replaceHolders(args, placeholder);
            length -= holders.length;
            if (length < arity) {
              return createRecurry(
                func,
                bitmask,
                createHybrid,
                wrapper.placeholder,
                undefined2,
                args,
                holders,
                undefined2,
                undefined2,
                arity - length
              );
            }
            var fn = this && this !== root && this instanceof wrapper ? Ctor : func;
            return apply(fn, this, args);
          }
          return wrapper;
        }
        function createFind(findIndexFunc) {
          return function(collection, predicate, fromIndex) {
            var iterable = Object2(collection);
            if (!isArrayLike(collection)) {
              var iteratee2 = getIteratee(predicate, 3);
              collection = keys(collection);
              predicate = function(key) {
                return iteratee2(iterable[key], key, iterable);
              };
            }
            var index = findIndexFunc(collection, predicate, fromIndex);
            return index > -1 ? iterable[iteratee2 ? collection[index] : index] : undefined2;
          };
        }
        function createFlow(fromRight) {
          return flatRest(function(funcs) {
            var length = funcs.length, index = length, prereq = LodashWrapper.prototype.thru;
            if (fromRight) {
              funcs.reverse();
            }
            while (index--) {
              var func = funcs[index];
              if (typeof func != "function") {
                throw new TypeError2(FUNC_ERROR_TEXT);
              }
              if (prereq && !wrapper && getFuncName(func) == "wrapper") {
                var wrapper = new LodashWrapper([], true);
              }
            }
            index = wrapper ? index : length;
            while (++index < length) {
              func = funcs[index];
              var funcName = getFuncName(func), data = funcName == "wrapper" ? getData(func) : undefined2;
              if (data && isLaziable(data[0]) && data[1] == (WRAP_ARY_FLAG | WRAP_CURRY_FLAG | WRAP_PARTIAL_FLAG | WRAP_REARG_FLAG) && !data[4].length && data[9] == 1) {
                wrapper = wrapper[getFuncName(data[0])].apply(wrapper, data[3]);
              } else {
                wrapper = func.length == 1 && isLaziable(func) ? wrapper[funcName]() : wrapper.thru(func);
              }
            }
            return function() {
              var args = arguments, value = args[0];
              if (wrapper && args.length == 1 && isArray(value)) {
                return wrapper.plant(value).value();
              }
              var index2 = 0, result2 = length ? funcs[index2].apply(this, args) : value;
              while (++index2 < length) {
                result2 = funcs[index2].call(this, result2);
              }
              return result2;
            };
          });
        }
        function createHybrid(func, bitmask, thisArg, partials, holders, partialsRight, holdersRight, argPos, ary2, arity) {
          var isAry = bitmask & WRAP_ARY_FLAG, isBind = bitmask & WRAP_BIND_FLAG, isBindKey = bitmask & WRAP_BIND_KEY_FLAG, isCurried = bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG), isFlip = bitmask & WRAP_FLIP_FLAG, Ctor = isBindKey ? undefined2 : createCtor(func);
          function wrapper() {
            var length = arguments.length, args = Array2(length), index = length;
            while (index--) {
              args[index] = arguments[index];
            }
            if (isCurried) {
              var placeholder = getHolder(wrapper), holdersCount = countHolders(args, placeholder);
            }
            if (partials) {
              args = composeArgs(args, partials, holders, isCurried);
            }
            if (partialsRight) {
              args = composeArgsRight(args, partialsRight, holdersRight, isCurried);
            }
            length -= holdersCount;
            if (isCurried && length < arity) {
              var newHolders = replaceHolders(args, placeholder);
              return createRecurry(
                func,
                bitmask,
                createHybrid,
                wrapper.placeholder,
                thisArg,
                args,
                newHolders,
                argPos,
                ary2,
                arity - length
              );
            }
            var thisBinding = isBind ? thisArg : this, fn = isBindKey ? thisBinding[func] : func;
            length = args.length;
            if (argPos) {
              args = reorder(args, argPos);
            } else if (isFlip && length > 1) {
              args.reverse();
            }
            if (isAry && ary2 < length) {
              args.length = ary2;
            }
            if (this && this !== root && this instanceof wrapper) {
              fn = Ctor || createCtor(fn);
            }
            return fn.apply(thisBinding, args);
          }
          return wrapper;
        }
        function createInverter(setter, toIteratee) {
          return function(object, iteratee2) {
            return baseInverter(object, setter, toIteratee(iteratee2), {});
          };
        }
        function createMathOperation(operator, defaultValue) {
          return function(value, other) {
            var result2;
            if (value === undefined2 && other === undefined2) {
              return defaultValue;
            }
            if (value !== undefined2) {
              result2 = value;
            }
            if (other !== undefined2) {
              if (result2 === undefined2) {
                return other;
              }
              if (typeof value == "string" || typeof other == "string") {
                value = baseToString(value);
                other = baseToString(other);
              } else {
                value = baseToNumber(value);
                other = baseToNumber(other);
              }
              result2 = operator(value, other);
            }
            return result2;
          };
        }
        function createOver(arrayFunc) {
          return flatRest(function(iteratees) {
            iteratees = arrayMap(iteratees, baseUnary(getIteratee()));
            return baseRest(function(args) {
              var thisArg = this;
              return arrayFunc(iteratees, function(iteratee2) {
                return apply(iteratee2, thisArg, args);
              });
            });
          });
        }
        function createPadding(length, chars) {
          chars = chars === undefined2 ? " " : baseToString(chars);
          var charsLength = chars.length;
          if (charsLength < 2) {
            return charsLength ? baseRepeat(chars, length) : chars;
          }
          var result2 = baseRepeat(chars, nativeCeil(length / stringSize(chars)));
          return hasUnicode(chars) ? castSlice(stringToArray(result2), 0, length).join("") : result2.slice(0, length);
        }
        function createPartial(func, bitmask, thisArg, partials) {
          var isBind = bitmask & WRAP_BIND_FLAG, Ctor = createCtor(func);
          function wrapper() {
            var argsIndex = -1, argsLength = arguments.length, leftIndex = -1, leftLength = partials.length, args = Array2(leftLength + argsLength), fn = this && this !== root && this instanceof wrapper ? Ctor : func;
            while (++leftIndex < leftLength) {
              args[leftIndex] = partials[leftIndex];
            }
            while (argsLength--) {
              args[leftIndex++] = arguments[++argsIndex];
            }
            return apply(fn, isBind ? thisArg : this, args);
          }
          return wrapper;
        }
        function createRange(fromRight) {
          return function(start, end, step) {
            if (step && typeof step != "number" && isIterateeCall(start, end, step)) {
              end = step = undefined2;
            }
            start = toFinite(start);
            if (end === undefined2) {
              end = start;
              start = 0;
            } else {
              end = toFinite(end);
            }
            step = step === undefined2 ? start < end ? 1 : -1 : toFinite(step);
            return baseRange(start, end, step, fromRight);
          };
        }
        function createRelationalOperation(operator) {
          return function(value, other) {
            if (!(typeof value == "string" && typeof other == "string")) {
              value = toNumber(value);
              other = toNumber(other);
            }
            return operator(value, other);
          };
        }
        function createRecurry(func, bitmask, wrapFunc, placeholder, thisArg, partials, holders, argPos, ary2, arity) {
          var isCurry = bitmask & WRAP_CURRY_FLAG, newHolders = isCurry ? holders : undefined2, newHoldersRight = isCurry ? undefined2 : holders, newPartials = isCurry ? partials : undefined2, newPartialsRight = isCurry ? undefined2 : partials;
          bitmask |= isCurry ? WRAP_PARTIAL_FLAG : WRAP_PARTIAL_RIGHT_FLAG;
          bitmask &= ~(isCurry ? WRAP_PARTIAL_RIGHT_FLAG : WRAP_PARTIAL_FLAG);
          if (!(bitmask & WRAP_CURRY_BOUND_FLAG)) {
            bitmask &= ~(WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG);
          }
          var newData = [
            func,
            bitmask,
            thisArg,
            newPartials,
            newHolders,
            newPartialsRight,
            newHoldersRight,
            argPos,
            ary2,
            arity
          ];
          var result2 = wrapFunc.apply(undefined2, newData);
          if (isLaziable(func)) {
            setData(result2, newData);
          }
          result2.placeholder = placeholder;
          return setWrapToString(result2, func, bitmask);
        }
        function createRound(methodName) {
          var func = Math2[methodName];
          return function(number, precision) {
            number = toNumber(number);
            precision = precision == null ? 0 : nativeMin(toInteger(precision), 292);
            if (precision && nativeIsFinite(number)) {
              var pair = (toString(number) + "e").split("e"), value = func(pair[0] + "e" + (+pair[1] + precision));
              pair = (toString(value) + "e").split("e");
              return +(pair[0] + "e" + (+pair[1] - precision));
            }
            return func(number);
          };
        }
        var createSet = !(Set2 && 1 / setToArray(new Set2([, -0]))[1] == INFINITY) ? noop : function(values2) {
          return new Set2(values2);
        };
        function createToPairs(keysFunc) {
          return function(object) {
            var tag = getTag(object);
            if (tag == mapTag) {
              return mapToArray(object);
            }
            if (tag == setTag) {
              return setToPairs(object);
            }
            return baseToPairs(object, keysFunc(object));
          };
        }
        function createWrap(func, bitmask, thisArg, partials, holders, argPos, ary2, arity) {
          var isBindKey = bitmask & WRAP_BIND_KEY_FLAG;
          if (!isBindKey && typeof func != "function") {
            throw new TypeError2(FUNC_ERROR_TEXT);
          }
          var length = partials ? partials.length : 0;
          if (!length) {
            bitmask &= ~(WRAP_PARTIAL_FLAG | WRAP_PARTIAL_RIGHT_FLAG);
            partials = holders = undefined2;
          }
          ary2 = ary2 === undefined2 ? ary2 : nativeMax(toInteger(ary2), 0);
          arity = arity === undefined2 ? arity : toInteger(arity);
          length -= holders ? holders.length : 0;
          if (bitmask & WRAP_PARTIAL_RIGHT_FLAG) {
            var partialsRight = partials, holdersRight = holders;
            partials = holders = undefined2;
          }
          var data = isBindKey ? undefined2 : getData(func);
          var newData = [
            func,
            bitmask,
            thisArg,
            partials,
            holders,
            partialsRight,
            holdersRight,
            argPos,
            ary2,
            arity
          ];
          if (data) {
            mergeData(newData, data);
          }
          func = newData[0];
          bitmask = newData[1];
          thisArg = newData[2];
          partials = newData[3];
          holders = newData[4];
          arity = newData[9] = newData[9] === undefined2 ? isBindKey ? 0 : func.length : nativeMax(newData[9] - length, 0);
          if (!arity && bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG)) {
            bitmask &= ~(WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG);
          }
          if (!bitmask || bitmask == WRAP_BIND_FLAG) {
            var result2 = createBind(func, bitmask, thisArg);
          } else if (bitmask == WRAP_CURRY_FLAG || bitmask == WRAP_CURRY_RIGHT_FLAG) {
            result2 = createCurry(func, bitmask, arity);
          } else if ((bitmask == WRAP_PARTIAL_FLAG || bitmask == (WRAP_BIND_FLAG | WRAP_PARTIAL_FLAG)) && !holders.length) {
            result2 = createPartial(func, bitmask, thisArg, partials);
          } else {
            result2 = createHybrid.apply(undefined2, newData);
          }
          var setter = data ? baseSetData : setData;
          return setWrapToString(setter(result2, newData), func, bitmask);
        }
        function customDefaultsAssignIn(objValue, srcValue, key, object) {
          if (objValue === undefined2 || eq(objValue, objectProto[key]) && !hasOwnProperty2.call(object, key)) {
            return srcValue;
          }
          return objValue;
        }
        function customDefaultsMerge(objValue, srcValue, key, object, source, stack) {
          if (isObject2(objValue) && isObject2(srcValue)) {
            stack.set(srcValue, objValue);
            baseMerge(objValue, srcValue, undefined2, customDefaultsMerge, stack);
            stack["delete"](srcValue);
          }
          return objValue;
        }
        function customOmitClone(value) {
          return isPlainObject2(value) ? undefined2 : value;
        }
        function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
          var isPartial = bitmask & COMPARE_PARTIAL_FLAG, arrLength = array.length, othLength = other.length;
          if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
            return false;
          }
          var arrStacked = stack.get(array);
          var othStacked = stack.get(other);
          if (arrStacked && othStacked) {
            return arrStacked == other && othStacked == array;
          }
          var index = -1, result2 = true, seen = bitmask & COMPARE_UNORDERED_FLAG ? new SetCache() : undefined2;
          stack.set(array, other);
          stack.set(other, array);
          while (++index < arrLength) {
            var arrValue = array[index], othValue = other[index];
            if (customizer) {
              var compared = isPartial ? customizer(othValue, arrValue, index, other, array, stack) : customizer(arrValue, othValue, index, array, other, stack);
            }
            if (compared !== undefined2) {
              if (compared) {
                continue;
              }
              result2 = false;
              break;
            }
            if (seen) {
              if (!arraySome(other, function(othValue2, othIndex) {
                if (!cacheHas(seen, othIndex) && (arrValue === othValue2 || equalFunc(arrValue, othValue2, bitmask, customizer, stack))) {
                  return seen.push(othIndex);
                }
              })) {
                result2 = false;
                break;
              }
            } else if (!(arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
              result2 = false;
              break;
            }
          }
          stack["delete"](array);
          stack["delete"](other);
          return result2;
        }
        function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
          switch (tag) {
            case dataViewTag:
              if (object.byteLength != other.byteLength || object.byteOffset != other.byteOffset) {
                return false;
              }
              object = object.buffer;
              other = other.buffer;
            case arrayBufferTag:
              if (object.byteLength != other.byteLength || !equalFunc(new Uint8Array2(object), new Uint8Array2(other))) {
                return false;
              }
              return true;
            case boolTag:
            case dateTag:
            case numberTag:
              return eq(+object, +other);
            case errorTag:
              return object.name == other.name && object.message == other.message;
            case regexpTag:
            case stringTag:
              return object == other + "";
            case mapTag:
              var convert = mapToArray;
            case setTag:
              var isPartial = bitmask & COMPARE_PARTIAL_FLAG;
              convert || (convert = setToArray);
              if (object.size != other.size && !isPartial) {
                return false;
              }
              var stacked = stack.get(object);
              if (stacked) {
                return stacked == other;
              }
              bitmask |= COMPARE_UNORDERED_FLAG;
              stack.set(object, other);
              var result2 = equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
              stack["delete"](object);
              return result2;
            case symbolTag:
              if (symbolValueOf) {
                return symbolValueOf.call(object) == symbolValueOf.call(other);
              }
          }
          return false;
        }
        function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
          var isPartial = bitmask & COMPARE_PARTIAL_FLAG, objProps = getAllKeys(object), objLength = objProps.length, othProps = getAllKeys(other), othLength = othProps.length;
          if (objLength != othLength && !isPartial) {
            return false;
          }
          var index = objLength;
          while (index--) {
            var key = objProps[index];
            if (!(isPartial ? key in other : hasOwnProperty2.call(other, key))) {
              return false;
            }
          }
          var objStacked = stack.get(object);
          var othStacked = stack.get(other);
          if (objStacked && othStacked) {
            return objStacked == other && othStacked == object;
          }
          var result2 = true;
          stack.set(object, other);
          stack.set(other, object);
          var skipCtor = isPartial;
          while (++index < objLength) {
            key = objProps[index];
            var objValue = object[key], othValue = other[key];
            if (customizer) {
              var compared = isPartial ? customizer(othValue, objValue, key, other, object, stack) : customizer(objValue, othValue, key, object, other, stack);
            }
            if (!(compared === undefined2 ? objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack) : compared)) {
              result2 = false;
              break;
            }
            skipCtor || (skipCtor = key == "constructor");
          }
          if (result2 && !skipCtor) {
            var objCtor = object.constructor, othCtor = other.constructor;
            if (objCtor != othCtor && ("constructor" in object && "constructor" in other) && !(typeof objCtor == "function" && objCtor instanceof objCtor && typeof othCtor == "function" && othCtor instanceof othCtor)) {
              result2 = false;
            }
          }
          stack["delete"](object);
          stack["delete"](other);
          return result2;
        }
        function flatRest(func) {
          return setToString(overRest(func, undefined2, flatten), func + "");
        }
        function getAllKeys(object) {
          return baseGetAllKeys(object, keys, getSymbols);
        }
        function getAllKeysIn(object) {
          return baseGetAllKeys(object, keysIn, getSymbolsIn);
        }
        var getData = !metaMap ? noop : function(func) {
          return metaMap.get(func);
        };
        function getFuncName(func) {
          var result2 = func.name + "", array = realNames[result2], length = hasOwnProperty2.call(realNames, result2) ? array.length : 0;
          while (length--) {
            var data = array[length], otherFunc = data.func;
            if (otherFunc == null || otherFunc == func) {
              return data.name;
            }
          }
          return result2;
        }
        function getHolder(func) {
          var object = hasOwnProperty2.call(lodash, "placeholder") ? lodash : func;
          return object.placeholder;
        }
        function getIteratee() {
          var result2 = lodash.iteratee || iteratee;
          result2 = result2 === iteratee ? baseIteratee : result2;
          return arguments.length ? result2(arguments[0], arguments[1]) : result2;
        }
        function getMapData(map2, key) {
          var data = map2.__data__;
          return isKeyable(key) ? data[typeof key == "string" ? "string" : "hash"] : data.map;
        }
        function getMatchData(object) {
          var result2 = keys(object), length = result2.length;
          while (length--) {
            var key = result2[length], value = object[key];
            result2[length] = [key, value, isStrictComparable(value)];
          }
          return result2;
        }
        function getNative(object, key) {
          var value = getValue(object, key);
          return baseIsNative(value) ? value : undefined2;
        }
        function getRawTag(value) {
          var isOwn = hasOwnProperty2.call(value, symToStringTag), tag = value[symToStringTag];
          try {
            value[symToStringTag] = undefined2;
            var unmasked = true;
          } catch (e) {
          }
          var result2 = nativeObjectToString.call(value);
          if (unmasked) {
            if (isOwn) {
              value[symToStringTag] = tag;
            } else {
              delete value[symToStringTag];
            }
          }
          return result2;
        }
        var getSymbols = !nativeGetSymbols ? stubArray : function(object) {
          if (object == null) {
            return [];
          }
          object = Object2(object);
          return arrayFilter(nativeGetSymbols(object), function(symbol) {
            return propertyIsEnumerable.call(object, symbol);
          });
        };
        var getSymbolsIn = !nativeGetSymbols ? stubArray : function(object) {
          var result2 = [];
          while (object) {
            arrayPush(result2, getSymbols(object));
            object = getPrototype(object);
          }
          return result2;
        };
        var getTag = baseGetTag;
        if (DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag || Map2 && getTag(new Map2()) != mapTag || Promise2 && getTag(Promise2.resolve()) != promiseTag || Set2 && getTag(new Set2()) != setTag || WeakMap2 && getTag(new WeakMap2()) != weakMapTag) {
          getTag = function(value) {
            var result2 = baseGetTag(value), Ctor = result2 == objectTag ? value.constructor : undefined2, ctorString = Ctor ? toSource(Ctor) : "";
            if (ctorString) {
              switch (ctorString) {
                case dataViewCtorString:
                  return dataViewTag;
                case mapCtorString:
                  return mapTag;
                case promiseCtorString:
                  return promiseTag;
                case setCtorString:
                  return setTag;
                case weakMapCtorString:
                  return weakMapTag;
              }
            }
            return result2;
          };
        }
        function getView(start, end, transforms) {
          var index = -1, length = transforms.length;
          while (++index < length) {
            var data = transforms[index], size2 = data.size;
            switch (data.type) {
              case "drop":
                start += size2;
                break;
              case "dropRight":
                end -= size2;
                break;
              case "take":
                end = nativeMin(end, start + size2);
                break;
              case "takeRight":
                start = nativeMax(start, end - size2);
                break;
            }
          }
          return { "start": start, "end": end };
        }
        function getWrapDetails(source) {
          var match = source.match(reWrapDetails);
          return match ? match[1].split(reSplitDetails) : [];
        }
        function hasPath(object, path, hasFunc) {
          path = castPath(path, object);
          var index = -1, length = path.length, result2 = false;
          while (++index < length) {
            var key = toKey(path[index]);
            if (!(result2 = object != null && hasFunc(object, key))) {
              break;
            }
            object = object[key];
          }
          if (result2 || ++index != length) {
            return result2;
          }
          length = object == null ? 0 : object.length;
          return !!length && isLength(length) && isIndex(key, length) && (isArray(object) || isArguments(object));
        }
        function initCloneArray(array) {
          var length = array.length, result2 = new array.constructor(length);
          if (length && typeof array[0] == "string" && hasOwnProperty2.call(array, "index")) {
            result2.index = array.index;
            result2.input = array.input;
          }
          return result2;
        }
        function initCloneObject(object) {
          return typeof object.constructor == "function" && !isPrototype(object) ? baseCreate(getPrototype(object)) : {};
        }
        function initCloneByTag(object, tag, isDeep) {
          var Ctor = object.constructor;
          switch (tag) {
            case arrayBufferTag:
              return cloneArrayBuffer(object);
            case boolTag:
            case dateTag:
              return new Ctor(+object);
            case dataViewTag:
              return cloneDataView(object, isDeep);
            case float32Tag:
            case float64Tag:
            case int8Tag:
            case int16Tag:
            case int32Tag:
            case uint8Tag:
            case uint8ClampedTag:
            case uint16Tag:
            case uint32Tag:
              return cloneTypedArray(object, isDeep);
            case mapTag:
              return new Ctor();
            case numberTag:
            case stringTag:
              return new Ctor(object);
            case regexpTag:
              return cloneRegExp(object);
            case setTag:
              return new Ctor();
            case symbolTag:
              return cloneSymbol(object);
          }
        }
        function insertWrapDetails(source, details) {
          var length = details.length;
          if (!length) {
            return source;
          }
          var lastIndex = length - 1;
          details[lastIndex] = (length > 1 ? "& " : "") + details[lastIndex];
          details = details.join(length > 2 ? ", " : " ");
          return source.replace(reWrapComment, "{\n/* [wrapped with " + details + "] */\n");
        }
        function isFlattenable(value) {
          return isArray(value) || isArguments(value) || !!(spreadableSymbol && value && value[spreadableSymbol]);
        }
        function isIndex(value, length) {
          var type = typeof value;
          length = length == null ? MAX_SAFE_INTEGER : length;
          return !!length && (type == "number" || type != "symbol" && reIsUint.test(value)) && (value > -1 && value % 1 == 0 && value < length);
        }
        function isIterateeCall(value, index, object) {
          if (!isObject2(object)) {
            return false;
          }
          var type = typeof index;
          if (type == "number" ? isArrayLike(object) && isIndex(index, object.length) : type == "string" && index in object) {
            return eq(object[index], value);
          }
          return false;
        }
        function isKey(value, object) {
          if (isArray(value)) {
            return false;
          }
          var type = typeof value;
          if (type == "number" || type == "symbol" || type == "boolean" || value == null || isSymbol(value)) {
            return true;
          }
          return reIsPlainProp.test(value) || !reIsDeepProp.test(value) || object != null && value in Object2(object);
        }
        function isKeyable(value) {
          var type = typeof value;
          return type == "string" || type == "number" || type == "symbol" || type == "boolean" ? value !== "__proto__" : value === null;
        }
        function isLaziable(func) {
          var funcName = getFuncName(func), other = lodash[funcName];
          if (typeof other != "function" || !(funcName in LazyWrapper.prototype)) {
            return false;
          }
          if (func === other) {
            return true;
          }
          var data = getData(other);
          return !!data && func === data[0];
        }
        function isMasked(func) {
          return !!maskSrcKey && maskSrcKey in func;
        }
        var isMaskable = coreJsData ? isFunction : stubFalse;
        function isPrototype(value) {
          var Ctor = value && value.constructor, proto = typeof Ctor == "function" && Ctor.prototype || objectProto;
          return value === proto;
        }
        function isStrictComparable(value) {
          return value === value && !isObject2(value);
        }
        function matchesStrictComparable(key, srcValue) {
          return function(object) {
            if (object == null) {
              return false;
            }
            return object[key] === srcValue && (srcValue !== undefined2 || key in Object2(object));
          };
        }
        function memoizeCapped(func) {
          var result2 = memoize(func, function(key) {
            if (cache.size === MAX_MEMOIZE_SIZE) {
              cache.clear();
            }
            return key;
          });
          var cache = result2.cache;
          return result2;
        }
        function mergeData(data, source) {
          var bitmask = data[1], srcBitmask = source[1], newBitmask = bitmask | srcBitmask, isCommon = newBitmask < (WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG | WRAP_ARY_FLAG);
          var isCombo = srcBitmask == WRAP_ARY_FLAG && bitmask == WRAP_CURRY_FLAG || srcBitmask == WRAP_ARY_FLAG && bitmask == WRAP_REARG_FLAG && data[7].length <= source[8] || srcBitmask == (WRAP_ARY_FLAG | WRAP_REARG_FLAG) && source[7].length <= source[8] && bitmask == WRAP_CURRY_FLAG;
          if (!(isCommon || isCombo)) {
            return data;
          }
          if (srcBitmask & WRAP_BIND_FLAG) {
            data[2] = source[2];
            newBitmask |= bitmask & WRAP_BIND_FLAG ? 0 : WRAP_CURRY_BOUND_FLAG;
          }
          var value = source[3];
          if (value) {
            var partials = data[3];
            data[3] = partials ? composeArgs(partials, value, source[4]) : value;
            data[4] = partials ? replaceHolders(data[3], PLACEHOLDER) : source[4];
          }
          value = source[5];
          if (value) {
            partials = data[5];
            data[5] = partials ? composeArgsRight(partials, value, source[6]) : value;
            data[6] = partials ? replaceHolders(data[5], PLACEHOLDER) : source[6];
          }
          value = source[7];
          if (value) {
            data[7] = value;
          }
          if (srcBitmask & WRAP_ARY_FLAG) {
            data[8] = data[8] == null ? source[8] : nativeMin(data[8], source[8]);
          }
          if (data[9] == null) {
            data[9] = source[9];
          }
          data[0] = source[0];
          data[1] = newBitmask;
          return data;
        }
        function nativeKeysIn(object) {
          var result2 = [];
          if (object != null) {
            for (var key in Object2(object)) {
              result2.push(key);
            }
          }
          return result2;
        }
        function objectToString2(value) {
          return nativeObjectToString.call(value);
        }
        function overRest(func, start, transform2) {
          start = nativeMax(start === undefined2 ? func.length - 1 : start, 0);
          return function() {
            var args = arguments, index = -1, length = nativeMax(args.length - start, 0), array = Array2(length);
            while (++index < length) {
              array[index] = args[start + index];
            }
            index = -1;
            var otherArgs = Array2(start + 1);
            while (++index < start) {
              otherArgs[index] = args[index];
            }
            otherArgs[start] = transform2(array);
            return apply(func, this, otherArgs);
          };
        }
        function parent(object, path) {
          return path.length < 2 ? object : baseGet(object, baseSlice(path, 0, -1));
        }
        function reorder(array, indexes) {
          var arrLength = array.length, length = nativeMin(indexes.length, arrLength), oldArray = copyArray(array);
          while (length--) {
            var index = indexes[length];
            array[length] = isIndex(index, arrLength) ? oldArray[index] : undefined2;
          }
          return array;
        }
        function safeGet(object, key) {
          if (key === "constructor" && typeof object[key] === "function") {
            return;
          }
          if (key == "__proto__") {
            return;
          }
          return object[key];
        }
        var setData = shortOut(baseSetData);
        var setTimeout2 = ctxSetTimeout || function(func, wait) {
          return root.setTimeout(func, wait);
        };
        var setToString = shortOut(baseSetToString);
        function setWrapToString(wrapper, reference, bitmask) {
          var source = reference + "";
          return setToString(wrapper, insertWrapDetails(source, updateWrapDetails(getWrapDetails(source), bitmask)));
        }
        function shortOut(func) {
          var count = 0, lastCalled = 0;
          return function() {
            var stamp = nativeNow(), remaining = HOT_SPAN - (stamp - lastCalled);
            lastCalled = stamp;
            if (remaining > 0) {
              if (++count >= HOT_COUNT) {
                return arguments[0];
              }
            } else {
              count = 0;
            }
            return func.apply(undefined2, arguments);
          };
        }
        function shuffleSelf(array, size2) {
          var index = -1, length = array.length, lastIndex = length - 1;
          size2 = size2 === undefined2 ? length : size2;
          while (++index < size2) {
            var rand = baseRandom(index, lastIndex), value = array[rand];
            array[rand] = array[index];
            array[index] = value;
          }
          array.length = size2;
          return array;
        }
        var stringToPath = memoizeCapped(function(string) {
          var result2 = [];
          if (string.charCodeAt(0) === 46) {
            result2.push("");
          }
          string.replace(rePropName, function(match, number, quote, subString) {
            result2.push(quote ? subString.replace(reEscapeChar, "$1") : number || match);
          });
          return result2;
        });
        function toKey(value) {
          if (typeof value == "string" || isSymbol(value)) {
            return value;
          }
          var result2 = value + "";
          return result2 == "0" && 1 / value == -INFINITY ? "-0" : result2;
        }
        function toSource(func) {
          if (func != null) {
            try {
              return funcToString.call(func);
            } catch (e) {
            }
            try {
              return func + "";
            } catch (e) {
            }
          }
          return "";
        }
        function updateWrapDetails(details, bitmask) {
          arrayEach(wrapFlags, function(pair) {
            var value = "_." + pair[0];
            if (bitmask & pair[1] && !arrayIncludes(details, value)) {
              details.push(value);
            }
          });
          return details.sort();
        }
        function wrapperClone(wrapper) {
          if (wrapper instanceof LazyWrapper) {
            return wrapper.clone();
          }
          var result2 = new LodashWrapper(wrapper.__wrapped__, wrapper.__chain__);
          result2.__actions__ = copyArray(wrapper.__actions__);
          result2.__index__ = wrapper.__index__;
          result2.__values__ = wrapper.__values__;
          return result2;
        }
        function chunk(array, size2, guard) {
          if (guard ? isIterateeCall(array, size2, guard) : size2 === undefined2) {
            size2 = 1;
          } else {
            size2 = nativeMax(toInteger(size2), 0);
          }
          var length = array == null ? 0 : array.length;
          if (!length || size2 < 1) {
            return [];
          }
          var index = 0, resIndex = 0, result2 = Array2(nativeCeil(length / size2));
          while (index < length) {
            result2[resIndex++] = baseSlice(array, index, index += size2);
          }
          return result2;
        }
        function compact(array) {
          var index = -1, length = array == null ? 0 : array.length, resIndex = 0, result2 = [];
          while (++index < length) {
            var value = array[index];
            if (value) {
              result2[resIndex++] = value;
            }
          }
          return result2;
        }
        function concat() {
          var length = arguments.length;
          if (!length) {
            return [];
          }
          var args = Array2(length - 1), array = arguments[0], index = length;
          while (index--) {
            args[index - 1] = arguments[index];
          }
          return arrayPush(isArray(array) ? copyArray(array) : [array], baseFlatten(args, 1));
        }
        var difference = baseRest(function(array, values2) {
          return isArrayLikeObject(array) ? baseDifference(array, baseFlatten(values2, 1, isArrayLikeObject, true)) : [];
        });
        var differenceBy = baseRest(function(array, values2) {
          var iteratee2 = last(values2);
          if (isArrayLikeObject(iteratee2)) {
            iteratee2 = undefined2;
          }
          return isArrayLikeObject(array) ? baseDifference(array, baseFlatten(values2, 1, isArrayLikeObject, true), getIteratee(iteratee2, 2)) : [];
        });
        var differenceWith = baseRest(function(array, values2) {
          var comparator = last(values2);
          if (isArrayLikeObject(comparator)) {
            comparator = undefined2;
          }
          return isArrayLikeObject(array) ? baseDifference(array, baseFlatten(values2, 1, isArrayLikeObject, true), undefined2, comparator) : [];
        });
        function drop(array, n, guard) {
          var length = array == null ? 0 : array.length;
          if (!length) {
            return [];
          }
          n = guard || n === undefined2 ? 1 : toInteger(n);
          return baseSlice(array, n < 0 ? 0 : n, length);
        }
        function dropRight(array, n, guard) {
          var length = array == null ? 0 : array.length;
          if (!length) {
            return [];
          }
          n = guard || n === undefined2 ? 1 : toInteger(n);
          n = length - n;
          return baseSlice(array, 0, n < 0 ? 0 : n);
        }
        function dropRightWhile(array, predicate) {
          return array && array.length ? baseWhile(array, getIteratee(predicate, 3), true, true) : [];
        }
        function dropWhile(array, predicate) {
          return array && array.length ? baseWhile(array, getIteratee(predicate, 3), true) : [];
        }
        function fill(array, value, start, end) {
          var length = array == null ? 0 : array.length;
          if (!length) {
            return [];
          }
          if (start && typeof start != "number" && isIterateeCall(array, value, start)) {
            start = 0;
            end = length;
          }
          return baseFill(array, value, start, end);
        }
        function findIndex(array, predicate, fromIndex) {
          var length = array == null ? 0 : array.length;
          if (!length) {
            return -1;
          }
          var index = fromIndex == null ? 0 : toInteger(fromIndex);
          if (index < 0) {
            index = nativeMax(length + index, 0);
          }
          return baseFindIndex(array, getIteratee(predicate, 3), index);
        }
        function findLastIndex(array, predicate, fromIndex) {
          var length = array == null ? 0 : array.length;
          if (!length) {
            return -1;
          }
          var index = length - 1;
          if (fromIndex !== undefined2) {
            index = toInteger(fromIndex);
            index = fromIndex < 0 ? nativeMax(length + index, 0) : nativeMin(index, length - 1);
          }
          return baseFindIndex(array, getIteratee(predicate, 3), index, true);
        }
        function flatten(array) {
          var length = array == null ? 0 : array.length;
          return length ? baseFlatten(array, 1) : [];
        }
        function flattenDeep(array) {
          var length = array == null ? 0 : array.length;
          return length ? baseFlatten(array, INFINITY) : [];
        }
        function flattenDepth(array, depth) {
          var length = array == null ? 0 : array.length;
          if (!length) {
            return [];
          }
          depth = depth === undefined2 ? 1 : toInteger(depth);
          return baseFlatten(array, depth);
        }
        function fromPairs(pairs) {
          var index = -1, length = pairs == null ? 0 : pairs.length, result2 = {};
          while (++index < length) {
            var pair = pairs[index];
            baseAssignValue(result2, pair[0], pair[1]);
          }
          return result2;
        }
        function head(array) {
          return array && array.length ? array[0] : undefined2;
        }
        function indexOf(array, value, fromIndex) {
          var length = array == null ? 0 : array.length;
          if (!length) {
            return -1;
          }
          var index = fromIndex == null ? 0 : toInteger(fromIndex);
          if (index < 0) {
            index = nativeMax(length + index, 0);
          }
          return baseIndexOf(array, value, index);
        }
        function initial(array) {
          var length = array == null ? 0 : array.length;
          return length ? baseSlice(array, 0, -1) : [];
        }
        var intersection = baseRest(function(arrays) {
          var mapped = arrayMap(arrays, castArrayLikeObject);
          return mapped.length && mapped[0] === arrays[0] ? baseIntersection(mapped) : [];
        });
        var intersectionBy = baseRest(function(arrays) {
          var iteratee2 = last(arrays), mapped = arrayMap(arrays, castArrayLikeObject);
          if (iteratee2 === last(mapped)) {
            iteratee2 = undefined2;
          } else {
            mapped.pop();
          }
          return mapped.length && mapped[0] === arrays[0] ? baseIntersection(mapped, getIteratee(iteratee2, 2)) : [];
        });
        var intersectionWith = baseRest(function(arrays) {
          var comparator = last(arrays), mapped = arrayMap(arrays, castArrayLikeObject);
          comparator = typeof comparator == "function" ? comparator : undefined2;
          if (comparator) {
            mapped.pop();
          }
          return mapped.length && mapped[0] === arrays[0] ? baseIntersection(mapped, undefined2, comparator) : [];
        });
        function join(array, separator) {
          return array == null ? "" : nativeJoin.call(array, separator);
        }
        function last(array) {
          var length = array == null ? 0 : array.length;
          return length ? array[length - 1] : undefined2;
        }
        function lastIndexOf(array, value, fromIndex) {
          var length = array == null ? 0 : array.length;
          if (!length) {
            return -1;
          }
          var index = length;
          if (fromIndex !== undefined2) {
            index = toInteger(fromIndex);
            index = index < 0 ? nativeMax(length + index, 0) : nativeMin(index, length - 1);
          }
          return value === value ? strictLastIndexOf(array, value, index) : baseFindIndex(array, baseIsNaN, index, true);
        }
        function nth(array, n) {
          return array && array.length ? baseNth(array, toInteger(n)) : undefined2;
        }
        var pull = baseRest(pullAll);
        function pullAll(array, values2) {
          return array && array.length && values2 && values2.length ? basePullAll(array, values2) : array;
        }
        function pullAllBy(array, values2, iteratee2) {
          return array && array.length && values2 && values2.length ? basePullAll(array, values2, getIteratee(iteratee2, 2)) : array;
        }
        function pullAllWith(array, values2, comparator) {
          return array && array.length && values2 && values2.length ? basePullAll(array, values2, undefined2, comparator) : array;
        }
        var pullAt = flatRest(function(array, indexes) {
          var length = array == null ? 0 : array.length, result2 = baseAt(array, indexes);
          basePullAt(array, arrayMap(indexes, function(index) {
            return isIndex(index, length) ? +index : index;
          }).sort(compareAscending));
          return result2;
        });
        function remove(array, predicate) {
          var result2 = [];
          if (!(array && array.length)) {
            return result2;
          }
          var index = -1, indexes = [], length = array.length;
          predicate = getIteratee(predicate, 3);
          while (++index < length) {
            var value = array[index];
            if (predicate(value, index, array)) {
              result2.push(value);
              indexes.push(index);
            }
          }
          basePullAt(array, indexes);
          return result2;
        }
        function reverse(array) {
          return array == null ? array : nativeReverse.call(array);
        }
        function slice(array, start, end) {
          var length = array == null ? 0 : array.length;
          if (!length) {
            return [];
          }
          if (end && typeof end != "number" && isIterateeCall(array, start, end)) {
            start = 0;
            end = length;
          } else {
            start = start == null ? 0 : toInteger(start);
            end = end === undefined2 ? length : toInteger(end);
          }
          return baseSlice(array, start, end);
        }
        function sortedIndex(array, value) {
          return baseSortedIndex(array, value);
        }
        function sortedIndexBy(array, value, iteratee2) {
          return baseSortedIndexBy(array, value, getIteratee(iteratee2, 2));
        }
        function sortedIndexOf(array, value) {
          var length = array == null ? 0 : array.length;
          if (length) {
            var index = baseSortedIndex(array, value);
            if (index < length && eq(array[index], value)) {
              return index;
            }
          }
          return -1;
        }
        function sortedLastIndex(array, value) {
          return baseSortedIndex(array, value, true);
        }
        function sortedLastIndexBy(array, value, iteratee2) {
          return baseSortedIndexBy(array, value, getIteratee(iteratee2, 2), true);
        }
        function sortedLastIndexOf(array, value) {
          var length = array == null ? 0 : array.length;
          if (length) {
            var index = baseSortedIndex(array, value, true) - 1;
            if (eq(array[index], value)) {
              return index;
            }
          }
          return -1;
        }
        function sortedUniq(array) {
          return array && array.length ? baseSortedUniq(array) : [];
        }
        function sortedUniqBy(array, iteratee2) {
          return array && array.length ? baseSortedUniq(array, getIteratee(iteratee2, 2)) : [];
        }
        function tail(array) {
          var length = array == null ? 0 : array.length;
          return length ? baseSlice(array, 1, length) : [];
        }
        function take(array, n, guard) {
          if (!(array && array.length)) {
            return [];
          }
          n = guard || n === undefined2 ? 1 : toInteger(n);
          return baseSlice(array, 0, n < 0 ? 0 : n);
        }
        function takeRight(array, n, guard) {
          var length = array == null ? 0 : array.length;
          if (!length) {
            return [];
          }
          n = guard || n === undefined2 ? 1 : toInteger(n);
          n = length - n;
          return baseSlice(array, n < 0 ? 0 : n, length);
        }
        function takeRightWhile(array, predicate) {
          return array && array.length ? baseWhile(array, getIteratee(predicate, 3), false, true) : [];
        }
        function takeWhile(array, predicate) {
          return array && array.length ? baseWhile(array, getIteratee(predicate, 3)) : [];
        }
        var union = baseRest(function(arrays) {
          return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true));
        });
        var unionBy = baseRest(function(arrays) {
          var iteratee2 = last(arrays);
          if (isArrayLikeObject(iteratee2)) {
            iteratee2 = undefined2;
          }
          return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), getIteratee(iteratee2, 2));
        });
        var unionWith = baseRest(function(arrays) {
          var comparator = last(arrays);
          comparator = typeof comparator == "function" ? comparator : undefined2;
          return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), undefined2, comparator);
        });
        function uniq(array) {
          return array && array.length ? baseUniq(array) : [];
        }
        function uniqBy(array, iteratee2) {
          return array && array.length ? baseUniq(array, getIteratee(iteratee2, 2)) : [];
        }
        function uniqWith(array, comparator) {
          comparator = typeof comparator == "function" ? comparator : undefined2;
          return array && array.length ? baseUniq(array, undefined2, comparator) : [];
        }
        function unzip(array) {
          if (!(array && array.length)) {
            return [];
          }
          var length = 0;
          array = arrayFilter(array, function(group) {
            if (isArrayLikeObject(group)) {
              length = nativeMax(group.length, length);
              return true;
            }
          });
          return baseTimes(length, function(index) {
            return arrayMap(array, baseProperty(index));
          });
        }
        function unzipWith(array, iteratee2) {
          if (!(array && array.length)) {
            return [];
          }
          var result2 = unzip(array);
          if (iteratee2 == null) {
            return result2;
          }
          return arrayMap(result2, function(group) {
            return apply(iteratee2, undefined2, group);
          });
        }
        var without = baseRest(function(array, values2) {
          return isArrayLikeObject(array) ? baseDifference(array, values2) : [];
        });
        var xor = baseRest(function(arrays) {
          return baseXor(arrayFilter(arrays, isArrayLikeObject));
        });
        var xorBy = baseRest(function(arrays) {
          var iteratee2 = last(arrays);
          if (isArrayLikeObject(iteratee2)) {
            iteratee2 = undefined2;
          }
          return baseXor(arrayFilter(arrays, isArrayLikeObject), getIteratee(iteratee2, 2));
        });
        var xorWith = baseRest(function(arrays) {
          var comparator = last(arrays);
          comparator = typeof comparator == "function" ? comparator : undefined2;
          return baseXor(arrayFilter(arrays, isArrayLikeObject), undefined2, comparator);
        });
        var zip = baseRest(unzip);
        function zipObject(props, values2) {
          return baseZipObject(props || [], values2 || [], assignValue);
        }
        function zipObjectDeep(props, values2) {
          return baseZipObject(props || [], values2 || [], baseSet);
        }
        var zipWith = baseRest(function(arrays) {
          var length = arrays.length, iteratee2 = length > 1 ? arrays[length - 1] : undefined2;
          iteratee2 = typeof iteratee2 == "function" ? (arrays.pop(), iteratee2) : undefined2;
          return unzipWith(arrays, iteratee2);
        });
        function chain(value) {
          var result2 = lodash(value);
          result2.__chain__ = true;
          return result2;
        }
        function tap(value, interceptor) {
          interceptor(value);
          return value;
        }
        function thru(value, interceptor) {
          return interceptor(value);
        }
        var wrapperAt = flatRest(function(paths) {
          var length = paths.length, start = length ? paths[0] : 0, value = this.__wrapped__, interceptor = function(object) {
            return baseAt(object, paths);
          };
          if (length > 1 || this.__actions__.length || !(value instanceof LazyWrapper) || !isIndex(start)) {
            return this.thru(interceptor);
          }
          value = value.slice(start, +start + (length ? 1 : 0));
          value.__actions__.push({
            "func": thru,
            "args": [interceptor],
            "thisArg": undefined2
          });
          return new LodashWrapper(value, this.__chain__).thru(function(array) {
            if (length && !array.length) {
              array.push(undefined2);
            }
            return array;
          });
        });
        function wrapperChain() {
          return chain(this);
        }
        function wrapperCommit() {
          return new LodashWrapper(this.value(), this.__chain__);
        }
        function wrapperNext() {
          if (this.__values__ === undefined2) {
            this.__values__ = toArray(this.value());
          }
          var done = this.__index__ >= this.__values__.length, value = done ? undefined2 : this.__values__[this.__index__++];
          return { "done": done, "value": value };
        }
        function wrapperToIterator() {
          return this;
        }
        function wrapperPlant(value) {
          var result2, parent2 = this;
          while (parent2 instanceof baseLodash) {
            var clone2 = wrapperClone(parent2);
            clone2.__index__ = 0;
            clone2.__values__ = undefined2;
            if (result2) {
              previous.__wrapped__ = clone2;
            } else {
              result2 = clone2;
            }
            var previous = clone2;
            parent2 = parent2.__wrapped__;
          }
          previous.__wrapped__ = value;
          return result2;
        }
        function wrapperReverse() {
          var value = this.__wrapped__;
          if (value instanceof LazyWrapper) {
            var wrapped = value;
            if (this.__actions__.length) {
              wrapped = new LazyWrapper(this);
            }
            wrapped = wrapped.reverse();
            wrapped.__actions__.push({
              "func": thru,
              "args": [reverse],
              "thisArg": undefined2
            });
            return new LodashWrapper(wrapped, this.__chain__);
          }
          return this.thru(reverse);
        }
        function wrapperValue() {
          return baseWrapperValue(this.__wrapped__, this.__actions__);
        }
        var countBy = createAggregator(function(result2, value, key) {
          if (hasOwnProperty2.call(result2, key)) {
            ++result2[key];
          } else {
            baseAssignValue(result2, key, 1);
          }
        });
        function every(collection, predicate, guard) {
          var func = isArray(collection) ? arrayEvery : baseEvery;
          if (guard && isIterateeCall(collection, predicate, guard)) {
            predicate = undefined2;
          }
          return func(collection, getIteratee(predicate, 3));
        }
        function filter(collection, predicate) {
          var func = isArray(collection) ? arrayFilter : baseFilter;
          return func(collection, getIteratee(predicate, 3));
        }
        var find = createFind(findIndex);
        var findLast = createFind(findLastIndex);
        function flatMap(collection, iteratee2) {
          return baseFlatten(map(collection, iteratee2), 1);
        }
        function flatMapDeep(collection, iteratee2) {
          return baseFlatten(map(collection, iteratee2), INFINITY);
        }
        function flatMapDepth(collection, iteratee2, depth) {
          depth = depth === undefined2 ? 1 : toInteger(depth);
          return baseFlatten(map(collection, iteratee2), depth);
        }
        function forEach(collection, iteratee2) {
          var func = isArray(collection) ? arrayEach : baseEach;
          return func(collection, getIteratee(iteratee2, 3));
        }
        function forEachRight(collection, iteratee2) {
          var func = isArray(collection) ? arrayEachRight : baseEachRight;
          return func(collection, getIteratee(iteratee2, 3));
        }
        var groupBy = createAggregator(function(result2, value, key) {
          if (hasOwnProperty2.call(result2, key)) {
            result2[key].push(value);
          } else {
            baseAssignValue(result2, key, [value]);
          }
        });
        function includes(collection, value, fromIndex, guard) {
          collection = isArrayLike(collection) ? collection : values(collection);
          fromIndex = fromIndex && !guard ? toInteger(fromIndex) : 0;
          var length = collection.length;
          if (fromIndex < 0) {
            fromIndex = nativeMax(length + fromIndex, 0);
          }
          return isString(collection) ? fromIndex <= length && collection.indexOf(value, fromIndex) > -1 : !!length && baseIndexOf(collection, value, fromIndex) > -1;
        }
        var invokeMap = baseRest(function(collection, path, args) {
          var index = -1, isFunc = typeof path == "function", result2 = isArrayLike(collection) ? Array2(collection.length) : [];
          baseEach(collection, function(value) {
            result2[++index] = isFunc ? apply(path, value, args) : baseInvoke(value, path, args);
          });
          return result2;
        });
        var keyBy = createAggregator(function(result2, value, key) {
          baseAssignValue(result2, key, value);
        });
        function map(collection, iteratee2) {
          var func = isArray(collection) ? arrayMap : baseMap;
          return func(collection, getIteratee(iteratee2, 3));
        }
        function orderBy(collection, iteratees, orders, guard) {
          if (collection == null) {
            return [];
          }
          if (!isArray(iteratees)) {
            iteratees = iteratees == null ? [] : [iteratees];
          }
          orders = guard ? undefined2 : orders;
          if (!isArray(orders)) {
            orders = orders == null ? [] : [orders];
          }
          return baseOrderBy(collection, iteratees, orders);
        }
        var partition = createAggregator(function(result2, value, key) {
          result2[key ? 0 : 1].push(value);
        }, function() {
          return [[], []];
        });
        function reduce(collection, iteratee2, accumulator) {
          var func = isArray(collection) ? arrayReduce : baseReduce, initAccum = arguments.length < 3;
          return func(collection, getIteratee(iteratee2, 4), accumulator, initAccum, baseEach);
        }
        function reduceRight(collection, iteratee2, accumulator) {
          var func = isArray(collection) ? arrayReduceRight : baseReduce, initAccum = arguments.length < 3;
          return func(collection, getIteratee(iteratee2, 4), accumulator, initAccum, baseEachRight);
        }
        function reject(collection, predicate) {
          var func = isArray(collection) ? arrayFilter : baseFilter;
          return func(collection, negate(getIteratee(predicate, 3)));
        }
        function sample(collection) {
          var func = isArray(collection) ? arraySample : baseSample;
          return func(collection);
        }
        function sampleSize(collection, n, guard) {
          if (guard ? isIterateeCall(collection, n, guard) : n === undefined2) {
            n = 1;
          } else {
            n = toInteger(n);
          }
          var func = isArray(collection) ? arraySampleSize : baseSampleSize;
          return func(collection, n);
        }
        function shuffle(collection) {
          var func = isArray(collection) ? arrayShuffle : baseShuffle;
          return func(collection);
        }
        function size(collection) {
          if (collection == null) {
            return 0;
          }
          if (isArrayLike(collection)) {
            return isString(collection) ? stringSize(collection) : collection.length;
          }
          var tag = getTag(collection);
          if (tag == mapTag || tag == setTag) {
            return collection.size;
          }
          return baseKeys(collection).length;
        }
        function some(collection, predicate, guard) {
          var func = isArray(collection) ? arraySome : baseSome;
          if (guard && isIterateeCall(collection, predicate, guard)) {
            predicate = undefined2;
          }
          return func(collection, getIteratee(predicate, 3));
        }
        var sortBy = baseRest(function(collection, iteratees) {
          if (collection == null) {
            return [];
          }
          var length = iteratees.length;
          if (length > 1 && isIterateeCall(collection, iteratees[0], iteratees[1])) {
            iteratees = [];
          } else if (length > 2 && isIterateeCall(iteratees[0], iteratees[1], iteratees[2])) {
            iteratees = [iteratees[0]];
          }
          return baseOrderBy(collection, baseFlatten(iteratees, 1), []);
        });
        var now = ctxNow || function() {
          return root.Date.now();
        };
        function after(n, func) {
          if (typeof func != "function") {
            throw new TypeError2(FUNC_ERROR_TEXT);
          }
          n = toInteger(n);
          return function() {
            if (--n < 1) {
              return func.apply(this, arguments);
            }
          };
        }
        function ary(func, n, guard) {
          n = guard ? undefined2 : n;
          n = func && n == null ? func.length : n;
          return createWrap(func, WRAP_ARY_FLAG, undefined2, undefined2, undefined2, undefined2, n);
        }
        function before(n, func) {
          var result2;
          if (typeof func != "function") {
            throw new TypeError2(FUNC_ERROR_TEXT);
          }
          n = toInteger(n);
          return function() {
            if (--n > 0) {
              result2 = func.apply(this, arguments);
            }
            if (n <= 1) {
              func = undefined2;
            }
            return result2;
          };
        }
        var bind = baseRest(function(func, thisArg, partials) {
          var bitmask = WRAP_BIND_FLAG;
          if (partials.length) {
            var holders = replaceHolders(partials, getHolder(bind));
            bitmask |= WRAP_PARTIAL_FLAG;
          }
          return createWrap(func, bitmask, thisArg, partials, holders);
        });
        var bindKey = baseRest(function(object, key, partials) {
          var bitmask = WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG;
          if (partials.length) {
            var holders = replaceHolders(partials, getHolder(bindKey));
            bitmask |= WRAP_PARTIAL_FLAG;
          }
          return createWrap(key, bitmask, object, partials, holders);
        });
        function curry(func, arity, guard) {
          arity = guard ? undefined2 : arity;
          var result2 = createWrap(func, WRAP_CURRY_FLAG, undefined2, undefined2, undefined2, undefined2, undefined2, arity);
          result2.placeholder = curry.placeholder;
          return result2;
        }
        function curryRight(func, arity, guard) {
          arity = guard ? undefined2 : arity;
          var result2 = createWrap(func, WRAP_CURRY_RIGHT_FLAG, undefined2, undefined2, undefined2, undefined2, undefined2, arity);
          result2.placeholder = curryRight.placeholder;
          return result2;
        }
        function debounce2(func, wait, options) {
          var lastArgs, lastThis, maxWait, result2, timerId, lastCallTime, lastInvokeTime = 0, leading = false, maxing = false, trailing = true;
          if (typeof func != "function") {
            throw new TypeError2(FUNC_ERROR_TEXT);
          }
          wait = toNumber(wait) || 0;
          if (isObject2(options)) {
            leading = !!options.leading;
            maxing = "maxWait" in options;
            maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
            trailing = "trailing" in options ? !!options.trailing : trailing;
          }
          function invokeFunc(time) {
            var args = lastArgs, thisArg = lastThis;
            lastArgs = lastThis = undefined2;
            lastInvokeTime = time;
            result2 = func.apply(thisArg, args);
            return result2;
          }
          function leadingEdge(time) {
            lastInvokeTime = time;
            timerId = setTimeout2(timerExpired, wait);
            return leading ? invokeFunc(time) : result2;
          }
          function remainingWait(time) {
            var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime, timeWaiting = wait - timeSinceLastCall;
            return maxing ? nativeMin(timeWaiting, maxWait - timeSinceLastInvoke) : timeWaiting;
          }
          function shouldInvoke(time) {
            var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime;
            return lastCallTime === undefined2 || timeSinceLastCall >= wait || timeSinceLastCall < 0 || maxing && timeSinceLastInvoke >= maxWait;
          }
          function timerExpired() {
            var time = now();
            if (shouldInvoke(time)) {
              return trailingEdge(time);
            }
            timerId = setTimeout2(timerExpired, remainingWait(time));
          }
          function trailingEdge(time) {
            timerId = undefined2;
            if (trailing && lastArgs) {
              return invokeFunc(time);
            }
            lastArgs = lastThis = undefined2;
            return result2;
          }
          function cancel() {
            if (timerId !== undefined2) {
              clearTimeout2(timerId);
            }
            lastInvokeTime = 0;
            lastArgs = lastCallTime = lastThis = timerId = undefined2;
          }
          function flush() {
            return timerId === undefined2 ? result2 : trailingEdge(now());
          }
          function debounced() {
            var time = now(), isInvoking = shouldInvoke(time);
            lastArgs = arguments;
            lastThis = this;
            lastCallTime = time;
            if (isInvoking) {
              if (timerId === undefined2) {
                return leadingEdge(lastCallTime);
              }
              if (maxing) {
                clearTimeout2(timerId);
                timerId = setTimeout2(timerExpired, wait);
                return invokeFunc(lastCallTime);
              }
            }
            if (timerId === undefined2) {
              timerId = setTimeout2(timerExpired, wait);
            }
            return result2;
          }
          debounced.cancel = cancel;
          debounced.flush = flush;
          return debounced;
        }
        var defer = baseRest(function(func, args) {
          return baseDelay(func, 1, args);
        });
        var delay = baseRest(function(func, wait, args) {
          return baseDelay(func, toNumber(wait) || 0, args);
        });
        function flip(func) {
          return createWrap(func, WRAP_FLIP_FLAG);
        }
        function memoize(func, resolver) {
          if (typeof func != "function" || resolver != null && typeof resolver != "function") {
            throw new TypeError2(FUNC_ERROR_TEXT);
          }
          var memoized = function() {
            var args = arguments, key = resolver ? resolver.apply(this, args) : args[0], cache = memoized.cache;
            if (cache.has(key)) {
              return cache.get(key);
            }
            var result2 = func.apply(this, args);
            memoized.cache = cache.set(key, result2) || cache;
            return result2;
          };
          memoized.cache = new (memoize.Cache || MapCache)();
          return memoized;
        }
        memoize.Cache = MapCache;
        function negate(predicate) {
          if (typeof predicate != "function") {
            throw new TypeError2(FUNC_ERROR_TEXT);
          }
          return function() {
            var args = arguments;
            switch (args.length) {
              case 0:
                return !predicate.call(this);
              case 1:
                return !predicate.call(this, args[0]);
              case 2:
                return !predicate.call(this, args[0], args[1]);
              case 3:
                return !predicate.call(this, args[0], args[1], args[2]);
            }
            return !predicate.apply(this, args);
          };
        }
        function once(func) {
          return before(2, func);
        }
        var overArgs = castRest(function(func, transforms) {
          transforms = transforms.length == 1 && isArray(transforms[0]) ? arrayMap(transforms[0], baseUnary(getIteratee())) : arrayMap(baseFlatten(transforms, 1), baseUnary(getIteratee()));
          var funcsLength = transforms.length;
          return baseRest(function(args) {
            var index = -1, length = nativeMin(args.length, funcsLength);
            while (++index < length) {
              args[index] = transforms[index].call(this, args[index]);
            }
            return apply(func, this, args);
          });
        });
        var partial = baseRest(function(func, partials) {
          var holders = replaceHolders(partials, getHolder(partial));
          return createWrap(func, WRAP_PARTIAL_FLAG, undefined2, partials, holders);
        });
        var partialRight = baseRest(function(func, partials) {
          var holders = replaceHolders(partials, getHolder(partialRight));
          return createWrap(func, WRAP_PARTIAL_RIGHT_FLAG, undefined2, partials, holders);
        });
        var rearg = flatRest(function(func, indexes) {
          return createWrap(func, WRAP_REARG_FLAG, undefined2, undefined2, undefined2, indexes);
        });
        function rest(func, start) {
          if (typeof func != "function") {
            throw new TypeError2(FUNC_ERROR_TEXT);
          }
          start = start === undefined2 ? start : toInteger(start);
          return baseRest(func, start);
        }
        function spread(func, start) {
          if (typeof func != "function") {
            throw new TypeError2(FUNC_ERROR_TEXT);
          }
          start = start == null ? 0 : nativeMax(toInteger(start), 0);
          return baseRest(function(args) {
            var array = args[start], otherArgs = castSlice(args, 0, start);
            if (array) {
              arrayPush(otherArgs, array);
            }
            return apply(func, this, otherArgs);
          });
        }
        function throttle2(func, wait, options) {
          var leading = true, trailing = true;
          if (typeof func != "function") {
            throw new TypeError2(FUNC_ERROR_TEXT);
          }
          if (isObject2(options)) {
            leading = "leading" in options ? !!options.leading : leading;
            trailing = "trailing" in options ? !!options.trailing : trailing;
          }
          return debounce2(func, wait, {
            "leading": leading,
            "maxWait": wait,
            "trailing": trailing
          });
        }
        function unary(func) {
          return ary(func, 1);
        }
        function wrap(value, wrapper) {
          return partial(castFunction(wrapper), value);
        }
        function castArray() {
          if (!arguments.length) {
            return [];
          }
          var value = arguments[0];
          return isArray(value) ? value : [value];
        }
        function clone(value) {
          return baseClone(value, CLONE_SYMBOLS_FLAG);
        }
        function cloneWith(value, customizer) {
          customizer = typeof customizer == "function" ? customizer : undefined2;
          return baseClone(value, CLONE_SYMBOLS_FLAG, customizer);
        }
        function cloneDeep2(value) {
          return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG);
        }
        function cloneDeepWith(value, customizer) {
          customizer = typeof customizer == "function" ? customizer : undefined2;
          return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG, customizer);
        }
        function conformsTo(object, source) {
          return source == null || baseConformsTo(object, source, keys(source));
        }
        function eq(value, other) {
          return value === other || value !== value && other !== other;
        }
        var gt = createRelationalOperation(baseGt);
        var gte = createRelationalOperation(function(value, other) {
          return value >= other;
        });
        var isArguments = baseIsArguments(/* @__PURE__ */ function() {
          return arguments;
        }()) ? baseIsArguments : function(value) {
          return isObjectLike(value) && hasOwnProperty2.call(value, "callee") && !propertyIsEnumerable.call(value, "callee");
        };
        var isArray = Array2.isArray;
        var isArrayBuffer = nodeIsArrayBuffer ? baseUnary(nodeIsArrayBuffer) : baseIsArrayBuffer;
        function isArrayLike(value) {
          return value != null && isLength(value.length) && !isFunction(value);
        }
        function isArrayLikeObject(value) {
          return isObjectLike(value) && isArrayLike(value);
        }
        function isBoolean(value) {
          return value === true || value === false || isObjectLike(value) && baseGetTag(value) == boolTag;
        }
        var isBuffer = nativeIsBuffer || stubFalse;
        var isDate = nodeIsDate ? baseUnary(nodeIsDate) : baseIsDate;
        function isElement(value) {
          return isObjectLike(value) && value.nodeType === 1 && !isPlainObject2(value);
        }
        function isEmpty(value) {
          if (value == null) {
            return true;
          }
          if (isArrayLike(value) && (isArray(value) || typeof value == "string" || typeof value.splice == "function" || isBuffer(value) || isTypedArray(value) || isArguments(value))) {
            return !value.length;
          }
          var tag = getTag(value);
          if (tag == mapTag || tag == setTag) {
            return !value.size;
          }
          if (isPrototype(value)) {
            return !baseKeys(value).length;
          }
          for (var key in value) {
            if (hasOwnProperty2.call(value, key)) {
              return false;
            }
          }
          return true;
        }
        function isEqual(value, other) {
          return baseIsEqual(value, other);
        }
        function isEqualWith(value, other, customizer) {
          customizer = typeof customizer == "function" ? customizer : undefined2;
          var result2 = customizer ? customizer(value, other) : undefined2;
          return result2 === undefined2 ? baseIsEqual(value, other, undefined2, customizer) : !!result2;
        }
        function isError2(value) {
          if (!isObjectLike(value)) {
            return false;
          }
          var tag = baseGetTag(value);
          return tag == errorTag || tag == domExcTag || typeof value.message == "string" && typeof value.name == "string" && !isPlainObject2(value);
        }
        function isFinite(value) {
          return typeof value == "number" && nativeIsFinite(value);
        }
        function isFunction(value) {
          if (!isObject2(value)) {
            return false;
          }
          var tag = baseGetTag(value);
          return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
        }
        function isInteger2(value) {
          return typeof value == "number" && value == toInteger(value);
        }
        function isLength(value) {
          return typeof value == "number" && value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
        }
        function isObject2(value) {
          var type = typeof value;
          return value != null && (type == "object" || type == "function");
        }
        function isObjectLike(value) {
          return value != null && typeof value == "object";
        }
        var isMap2 = nodeIsMap ? baseUnary(nodeIsMap) : baseIsMap;
        function isMatch(object, source) {
          return object === source || baseIsMatch(object, source, getMatchData(source));
        }
        function isMatchWith(object, source, customizer) {
          customizer = typeof customizer == "function" ? customizer : undefined2;
          return baseIsMatch(object, source, getMatchData(source), customizer);
        }
        function isNaN2(value) {
          return isNumber(value) && value != +value;
        }
        function isNative(value) {
          if (isMaskable(value)) {
            throw new Error2(CORE_ERROR_TEXT);
          }
          return baseIsNative(value);
        }
        function isNull(value) {
          return value === null;
        }
        function isNil(value) {
          return value == null;
        }
        function isNumber(value) {
          return typeof value == "number" || isObjectLike(value) && baseGetTag(value) == numberTag;
        }
        function isPlainObject2(value) {
          if (!isObjectLike(value) || baseGetTag(value) != objectTag) {
            return false;
          }
          var proto = getPrototype(value);
          if (proto === null) {
            return true;
          }
          var Ctor = hasOwnProperty2.call(proto, "constructor") && proto.constructor;
          return typeof Ctor == "function" && Ctor instanceof Ctor && funcToString.call(Ctor) == objectCtorString2;
        }
        var isRegExp = nodeIsRegExp ? baseUnary(nodeIsRegExp) : baseIsRegExp;
        function isSafeInteger(value) {
          return isInteger2(value) && value >= -MAX_SAFE_INTEGER && value <= MAX_SAFE_INTEGER;
        }
        var isSet2 = nodeIsSet ? baseUnary(nodeIsSet) : baseIsSet;
        function isString(value) {
          return typeof value == "string" || !isArray(value) && isObjectLike(value) && baseGetTag(value) == stringTag;
        }
        function isSymbol(value) {
          return typeof value == "symbol" || isObjectLike(value) && baseGetTag(value) == symbolTag;
        }
        var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;
        function isUndefined(value) {
          return value === undefined2;
        }
        function isWeakMap(value) {
          return isObjectLike(value) && getTag(value) == weakMapTag;
        }
        function isWeakSet(value) {
          return isObjectLike(value) && baseGetTag(value) == weakSetTag;
        }
        var lt = createRelationalOperation(baseLt);
        var lte = createRelationalOperation(function(value, other) {
          return value <= other;
        });
        function toArray(value) {
          if (!value) {
            return [];
          }
          if (isArrayLike(value)) {
            return isString(value) ? stringToArray(value) : copyArray(value);
          }
          if (symIterator && value[symIterator]) {
            return iteratorToArray(value[symIterator]());
          }
          var tag = getTag(value), func = tag == mapTag ? mapToArray : tag == setTag ? setToArray : values;
          return func(value);
        }
        function toFinite(value) {
          if (!value) {
            return value === 0 ? value : 0;
          }
          value = toNumber(value);
          if (value === INFINITY || value === -INFINITY) {
            var sign = value < 0 ? -1 : 1;
            return sign * MAX_INTEGER;
          }
          return value === value ? value : 0;
        }
        function toInteger(value) {
          var result2 = toFinite(value), remainder = result2 % 1;
          return result2 === result2 ? remainder ? result2 - remainder : result2 : 0;
        }
        function toLength(value) {
          return value ? baseClamp(toInteger(value), 0, MAX_ARRAY_LENGTH) : 0;
        }
        function toNumber(value) {
          if (typeof value == "number") {
            return value;
          }
          if (isSymbol(value)) {
            return NAN;
          }
          if (isObject2(value)) {
            var other = typeof value.valueOf == "function" ? value.valueOf() : value;
            value = isObject2(other) ? other + "" : other;
          }
          if (typeof value != "string") {
            return value === 0 ? value : +value;
          }
          value = baseTrim(value);
          var isBinary = reIsBinary.test(value);
          return isBinary || reIsOctal.test(value) ? freeParseInt(value.slice(2), isBinary ? 2 : 8) : reIsBadHex.test(value) ? NAN : +value;
        }
        function toPlainObject(value) {
          return copyObject(value, keysIn(value));
        }
        function toSafeInteger(value) {
          return value ? baseClamp(toInteger(value), -MAX_SAFE_INTEGER, MAX_SAFE_INTEGER) : value === 0 ? value : 0;
        }
        function toString(value) {
          return value == null ? "" : baseToString(value);
        }
        var assign = createAssigner(function(object, source) {
          if (isPrototype(source) || isArrayLike(source)) {
            copyObject(source, keys(source), object);
            return;
          }
          for (var key in source) {
            if (hasOwnProperty2.call(source, key)) {
              assignValue(object, key, source[key]);
            }
          }
        });
        var assignIn = createAssigner(function(object, source) {
          copyObject(source, keysIn(source), object);
        });
        var assignInWith = createAssigner(function(object, source, srcIndex, customizer) {
          copyObject(source, keysIn(source), object, customizer);
        });
        var assignWith = createAssigner(function(object, source, srcIndex, customizer) {
          copyObject(source, keys(source), object, customizer);
        });
        var at = flatRest(baseAt);
        function create11(prototype, properties) {
          var result2 = baseCreate(prototype);
          return properties == null ? result2 : baseAssign(result2, properties);
        }
        var defaults = baseRest(function(object, sources) {
          object = Object2(object);
          var index = -1;
          var length = sources.length;
          var guard = length > 2 ? sources[2] : undefined2;
          if (guard && isIterateeCall(sources[0], sources[1], guard)) {
            length = 1;
          }
          while (++index < length) {
            var source = sources[index];
            var props = keysIn(source);
            var propsIndex = -1;
            var propsLength = props.length;
            while (++propsIndex < propsLength) {
              var key = props[propsIndex];
              var value = object[key];
              if (value === undefined2 || eq(value, objectProto[key]) && !hasOwnProperty2.call(object, key)) {
                object[key] = source[key];
              }
            }
          }
          return object;
        });
        var defaultsDeep = baseRest(function(args) {
          args.push(undefined2, customDefaultsMerge);
          return apply(mergeWith, undefined2, args);
        });
        function findKey(object, predicate) {
          return baseFindKey(object, getIteratee(predicate, 3), baseForOwn);
        }
        function findLastKey(object, predicate) {
          return baseFindKey(object, getIteratee(predicate, 3), baseForOwnRight);
        }
        function forIn(object, iteratee2) {
          return object == null ? object : baseFor(object, getIteratee(iteratee2, 3), keysIn);
        }
        function forInRight(object, iteratee2) {
          return object == null ? object : baseForRight(object, getIteratee(iteratee2, 3), keysIn);
        }
        function forOwn(object, iteratee2) {
          return object && baseForOwn(object, getIteratee(iteratee2, 3));
        }
        function forOwnRight(object, iteratee2) {
          return object && baseForOwnRight(object, getIteratee(iteratee2, 3));
        }
        function functions(object) {
          return object == null ? [] : baseFunctions(object, keys(object));
        }
        function functionsIn(object) {
          return object == null ? [] : baseFunctions(object, keysIn(object));
        }
        function get(object, path, defaultValue) {
          var result2 = object == null ? undefined2 : baseGet(object, path);
          return result2 === undefined2 ? defaultValue : result2;
        }
        function has2(object, path) {
          return object != null && hasPath(object, path, baseHas);
        }
        function hasIn(object, path) {
          return object != null && hasPath(object, path, baseHasIn);
        }
        var invert = createInverter(function(result2, value, key) {
          if (value != null && typeof value.toString != "function") {
            value = nativeObjectToString.call(value);
          }
          result2[value] = key;
        }, constant(identity));
        var invertBy = createInverter(function(result2, value, key) {
          if (value != null && typeof value.toString != "function") {
            value = nativeObjectToString.call(value);
          }
          if (hasOwnProperty2.call(result2, value)) {
            result2[value].push(key);
          } else {
            result2[value] = [key];
          }
        }, getIteratee);
        var invoke = baseRest(baseInvoke);
        function keys(object) {
          return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
        }
        function keysIn(object) {
          return isArrayLike(object) ? arrayLikeKeys(object, true) : baseKeysIn(object);
        }
        function mapKeys(object, iteratee2) {
          var result2 = {};
          iteratee2 = getIteratee(iteratee2, 3);
          baseForOwn(object, function(value, key, object2) {
            baseAssignValue(result2, iteratee2(value, key, object2), value);
          });
          return result2;
        }
        function mapValues(object, iteratee2) {
          var result2 = {};
          iteratee2 = getIteratee(iteratee2, 3);
          baseForOwn(object, function(value, key, object2) {
            baseAssignValue(result2, key, iteratee2(value, key, object2));
          });
          return result2;
        }
        var merge = createAssigner(function(object, source, srcIndex) {
          baseMerge(object, source, srcIndex);
        });
        var mergeWith = createAssigner(function(object, source, srcIndex, customizer) {
          baseMerge(object, source, srcIndex, customizer);
        });
        var omit = flatRest(function(object, paths) {
          var result2 = {};
          if (object == null) {
            return result2;
          }
          var isDeep = false;
          paths = arrayMap(paths, function(path) {
            path = castPath(path, object);
            isDeep || (isDeep = path.length > 1);
            return path;
          });
          copyObject(object, getAllKeysIn(object), result2);
          if (isDeep) {
            result2 = baseClone(result2, CLONE_DEEP_FLAG | CLONE_FLAT_FLAG | CLONE_SYMBOLS_FLAG, customOmitClone);
          }
          var length = paths.length;
          while (length--) {
            baseUnset(result2, paths[length]);
          }
          return result2;
        });
        function omitBy(object, predicate) {
          return pickBy(object, negate(getIteratee(predicate)));
        }
        var pick = flatRest(function(object, paths) {
          return object == null ? {} : basePick(object, paths);
        });
        function pickBy(object, predicate) {
          if (object == null) {
            return {};
          }
          var props = arrayMap(getAllKeysIn(object), function(prop) {
            return [prop];
          });
          predicate = getIteratee(predicate);
          return basePickBy(object, props, function(value, path) {
            return predicate(value, path[0]);
          });
        }
        function result(object, path, defaultValue) {
          path = castPath(path, object);
          var index = -1, length = path.length;
          if (!length) {
            length = 1;
            object = undefined2;
          }
          while (++index < length) {
            var value = object == null ? undefined2 : object[toKey(path[index])];
            if (value === undefined2) {
              index = length;
              value = defaultValue;
            }
            object = isFunction(value) ? value.call(object) : value;
          }
          return object;
        }
        function set2(object, path, value) {
          return object == null ? object : baseSet(object, path, value);
        }
        function setWith(object, path, value, customizer) {
          customizer = typeof customizer == "function" ? customizer : undefined2;
          return object == null ? object : baseSet(object, path, value, customizer);
        }
        var toPairs = createToPairs(keys);
        var toPairsIn = createToPairs(keysIn);
        function transform(object, iteratee2, accumulator) {
          var isArr = isArray(object), isArrLike = isArr || isBuffer(object) || isTypedArray(object);
          iteratee2 = getIteratee(iteratee2, 4);
          if (accumulator == null) {
            var Ctor = object && object.constructor;
            if (isArrLike) {
              accumulator = isArr ? new Ctor() : [];
            } else if (isObject2(object)) {
              accumulator = isFunction(Ctor) ? baseCreate(getPrototype(object)) : {};
            } else {
              accumulator = {};
            }
          }
          (isArrLike ? arrayEach : baseForOwn)(object, function(value, index, object2) {
            return iteratee2(accumulator, value, index, object2);
          });
          return accumulator;
        }
        function unset(object, path) {
          return object == null ? true : baseUnset(object, path);
        }
        function update(object, path, updater) {
          return object == null ? object : baseUpdate(object, path, castFunction(updater));
        }
        function updateWith(object, path, updater, customizer) {
          customizer = typeof customizer == "function" ? customizer : undefined2;
          return object == null ? object : baseUpdate(object, path, castFunction(updater), customizer);
        }
        function values(object) {
          return object == null ? [] : baseValues(object, keys(object));
        }
        function valuesIn(object) {
          return object == null ? [] : baseValues(object, keysIn(object));
        }
        function clamp(number, lower, upper) {
          if (upper === undefined2) {
            upper = lower;
            lower = undefined2;
          }
          if (upper !== undefined2) {
            upper = toNumber(upper);
            upper = upper === upper ? upper : 0;
          }
          if (lower !== undefined2) {
            lower = toNumber(lower);
            lower = lower === lower ? lower : 0;
          }
          return baseClamp(toNumber(number), lower, upper);
        }
        function inRange(number, start, end) {
          start = toFinite(start);
          if (end === undefined2) {
            end = start;
            start = 0;
          } else {
            end = toFinite(end);
          }
          number = toNumber(number);
          return baseInRange(number, start, end);
        }
        function random(lower, upper, floating) {
          if (floating && typeof floating != "boolean" && isIterateeCall(lower, upper, floating)) {
            upper = floating = undefined2;
          }
          if (floating === undefined2) {
            if (typeof upper == "boolean") {
              floating = upper;
              upper = undefined2;
            } else if (typeof lower == "boolean") {
              floating = lower;
              lower = undefined2;
            }
          }
          if (lower === undefined2 && upper === undefined2) {
            lower = 0;
            upper = 1;
          } else {
            lower = toFinite(lower);
            if (upper === undefined2) {
              upper = lower;
              lower = 0;
            } else {
              upper = toFinite(upper);
            }
          }
          if (lower > upper) {
            var temp = lower;
            lower = upper;
            upper = temp;
          }
          if (floating || lower % 1 || upper % 1) {
            var rand = nativeRandom();
            return nativeMin(lower + rand * (upper - lower + freeParseFloat("1e-" + ((rand + "").length - 1))), upper);
          }
          return baseRandom(lower, upper);
        }
        var camelCase = createCompounder(function(result2, word, index) {
          word = word.toLowerCase();
          return result2 + (index ? capitalize(word) : word);
        });
        function capitalize(string) {
          return upperFirst(toString(string).toLowerCase());
        }
        function deburr(string) {
          string = toString(string);
          return string && string.replace(reLatin, deburrLetter).replace(reComboMark, "");
        }
        function endsWith(string, target, position) {
          string = toString(string);
          target = baseToString(target);
          var length = string.length;
          position = position === undefined2 ? length : baseClamp(toInteger(position), 0, length);
          var end = position;
          position -= target.length;
          return position >= 0 && string.slice(position, end) == target;
        }
        function escape(string) {
          string = toString(string);
          return string && reHasUnescapedHtml.test(string) ? string.replace(reUnescapedHtml, escapeHtmlChar) : string;
        }
        function escapeRegExp(string) {
          string = toString(string);
          return string && reHasRegExpChar.test(string) ? string.replace(reRegExpChar, "\\$&") : string;
        }
        var kebabCase = createCompounder(function(result2, word, index) {
          return result2 + (index ? "-" : "") + word.toLowerCase();
        });
        var lowerCase = createCompounder(function(result2, word, index) {
          return result2 + (index ? " " : "") + word.toLowerCase();
        });
        var lowerFirst = createCaseFirst("toLowerCase");
        function pad(string, length, chars) {
          string = toString(string);
          length = toInteger(length);
          var strLength = length ? stringSize(string) : 0;
          if (!length || strLength >= length) {
            return string;
          }
          var mid = (length - strLength) / 2;
          return createPadding(nativeFloor(mid), chars) + string + createPadding(nativeCeil(mid), chars);
        }
        function padEnd(string, length, chars) {
          string = toString(string);
          length = toInteger(length);
          var strLength = length ? stringSize(string) : 0;
          return length && strLength < length ? string + createPadding(length - strLength, chars) : string;
        }
        function padStart(string, length, chars) {
          string = toString(string);
          length = toInteger(length);
          var strLength = length ? stringSize(string) : 0;
          return length && strLength < length ? createPadding(length - strLength, chars) + string : string;
        }
        function parseInt2(string, radix, guard) {
          if (guard || radix == null) {
            radix = 0;
          } else if (radix) {
            radix = +radix;
          }
          return nativeParseInt(toString(string).replace(reTrimStart, ""), radix || 0);
        }
        function repeat(string, n, guard) {
          if (guard ? isIterateeCall(string, n, guard) : n === undefined2) {
            n = 1;
          } else {
            n = toInteger(n);
          }
          return baseRepeat(toString(string), n);
        }
        function replace() {
          var args = arguments, string = toString(args[0]);
          return args.length < 3 ? string : string.replace(args[1], args[2]);
        }
        var snakeCase = createCompounder(function(result2, word, index) {
          return result2 + (index ? "_" : "") + word.toLowerCase();
        });
        function split(string, separator, limit) {
          if (limit && typeof limit != "number" && isIterateeCall(string, separator, limit)) {
            separator = limit = undefined2;
          }
          limit = limit === undefined2 ? MAX_ARRAY_LENGTH : limit >>> 0;
          if (!limit) {
            return [];
          }
          string = toString(string);
          if (string && (typeof separator == "string" || separator != null && !isRegExp(separator))) {
            separator = baseToString(separator);
            if (!separator && hasUnicode(string)) {
              return castSlice(stringToArray(string), 0, limit);
            }
          }
          return string.split(separator, limit);
        }
        var startCase = createCompounder(function(result2, word, index) {
          return result2 + (index ? " " : "") + upperFirst(word);
        });
        function startsWith(string, target, position) {
          string = toString(string);
          position = position == null ? 0 : baseClamp(toInteger(position), 0, string.length);
          target = baseToString(target);
          return string.slice(position, position + target.length) == target;
        }
        function template(string, options, guard) {
          var settings = lodash.templateSettings;
          if (guard && isIterateeCall(string, options, guard)) {
            options = undefined2;
          }
          string = toString(string);
          options = assignWith({}, options, settings, customDefaultsAssignIn);
          var imports = assignWith({}, options.imports, settings.imports, customDefaultsAssignIn), importsKeys = keys(imports), importsValues = baseValues(imports, importsKeys);
          arrayEach(importsKeys, function(key) {
            if (reForbiddenIdentifierChars.test(key)) {
              throw new Error2(INVALID_TEMPL_IMPORTS_ERROR_TEXT);
            }
          });
          var isEscaping, isEvaluating, index = 0, interpolate = options.interpolate || reNoMatch, source = "__p += '";
          var reDelimiters = RegExp2(
            (options.escape || reNoMatch).source + "|" + interpolate.source + "|" + (interpolate === reInterpolate ? reEsTemplate : reNoMatch).source + "|" + (options.evaluate || reNoMatch).source + "|$",
            "g"
          );
          var sourceURL = "//# sourceURL=" + (hasOwnProperty2.call(options, "sourceURL") ? (options.sourceURL + "").replace(/\s/g, " ") : "lodash.templateSources[" + ++templateCounter + "]") + "\n";
          string.replace(reDelimiters, function(match, escapeValue, interpolateValue, esTemplateValue, evaluateValue, offset) {
            interpolateValue || (interpolateValue = esTemplateValue);
            source += string.slice(index, offset).replace(reUnescapedString, escapeStringChar);
            if (escapeValue) {
              isEscaping = true;
              source += "' +\n__e(" + escapeValue + ") +\n'";
            }
            if (evaluateValue) {
              isEvaluating = true;
              source += "';\n" + evaluateValue + ";\n__p += '";
            }
            if (interpolateValue) {
              source += "' +\n((__t = (" + interpolateValue + ")) == null ? '' : __t) +\n'";
            }
            index = offset + match.length;
            return match;
          });
          source += "';\n";
          var variable = hasOwnProperty2.call(options, "variable") && options.variable;
          if (!variable) {
            source = "with (obj) {\n" + source + "\n}\n";
          } else if (reForbiddenIdentifierChars.test(variable)) {
            throw new Error2(INVALID_TEMPL_VAR_ERROR_TEXT);
          }
          source = (isEvaluating ? source.replace(reEmptyStringLeading, "") : source).replace(reEmptyStringMiddle, "$1").replace(reEmptyStringTrailing, "$1;");
          source = "function(" + (variable || "obj") + ") {\n" + (variable ? "" : "obj || (obj = {});\n") + "var __t, __p = ''" + (isEscaping ? ", __e = _.escape" : "") + (isEvaluating ? ", __j = Array.prototype.join;\nfunction print() { __p += __j.call(arguments, '') }\n" : ";\n") + source + "return __p\n}";
          var result2 = attempt(function() {
            return Function2(importsKeys, sourceURL + "return " + source).apply(undefined2, importsValues);
          });
          result2.source = source;
          if (isError2(result2)) {
            throw result2;
          }
          return result2;
        }
        function toLower(value) {
          return toString(value).toLowerCase();
        }
        function toUpper(value) {
          return toString(value).toUpperCase();
        }
        function trim(string, chars, guard) {
          string = toString(string);
          if (string && (guard || chars === undefined2)) {
            return baseTrim(string);
          }
          if (!string || !(chars = baseToString(chars))) {
            return string;
          }
          var strSymbols = stringToArray(string), chrSymbols = stringToArray(chars), start = charsStartIndex(strSymbols, chrSymbols), end = charsEndIndex(strSymbols, chrSymbols) + 1;
          return castSlice(strSymbols, start, end).join("");
        }
        function trimEnd(string, chars, guard) {
          string = toString(string);
          if (string && (guard || chars === undefined2)) {
            return string.slice(0, trimmedEndIndex(string) + 1);
          }
          if (!string || !(chars = baseToString(chars))) {
            return string;
          }
          var strSymbols = stringToArray(string), end = charsEndIndex(strSymbols, stringToArray(chars)) + 1;
          return castSlice(strSymbols, 0, end).join("");
        }
        function trimStart(string, chars, guard) {
          string = toString(string);
          if (string && (guard || chars === undefined2)) {
            return string.replace(reTrimStart, "");
          }
          if (!string || !(chars = baseToString(chars))) {
            return string;
          }
          var strSymbols = stringToArray(string), start = charsStartIndex(strSymbols, stringToArray(chars));
          return castSlice(strSymbols, start).join("");
        }
        function truncate(string, options) {
          var length = DEFAULT_TRUNC_LENGTH, omission = DEFAULT_TRUNC_OMISSION;
          if (isObject2(options)) {
            var separator = "separator" in options ? options.separator : separator;
            length = "length" in options ? toInteger(options.length) : length;
            omission = "omission" in options ? baseToString(options.omission) : omission;
          }
          string = toString(string);
          var strLength = string.length;
          if (hasUnicode(string)) {
            var strSymbols = stringToArray(string);
            strLength = strSymbols.length;
          }
          if (length >= strLength) {
            return string;
          }
          var end = length - stringSize(omission);
          if (end < 1) {
            return omission;
          }
          var result2 = strSymbols ? castSlice(strSymbols, 0, end).join("") : string.slice(0, end);
          if (separator === undefined2) {
            return result2 + omission;
          }
          if (strSymbols) {
            end += result2.length - end;
          }
          if (isRegExp(separator)) {
            if (string.slice(end).search(separator)) {
              var match, substring = result2;
              if (!separator.global) {
                separator = RegExp2(separator.source, toString(reFlags.exec(separator)) + "g");
              }
              separator.lastIndex = 0;
              while (match = separator.exec(substring)) {
                var newEnd = match.index;
              }
              result2 = result2.slice(0, newEnd === undefined2 ? end : newEnd);
            }
          } else if (string.indexOf(baseToString(separator), end) != end) {
            var index = result2.lastIndexOf(separator);
            if (index > -1) {
              result2 = result2.slice(0, index);
            }
          }
          return result2 + omission;
        }
        function unescape(string) {
          string = toString(string);
          return string && reHasEscapedHtml.test(string) ? string.replace(reEscapedHtml, unescapeHtmlChar) : string;
        }
        var upperCase = createCompounder(function(result2, word, index) {
          return result2 + (index ? " " : "") + word.toUpperCase();
        });
        var upperFirst = createCaseFirst("toUpperCase");
        function words(string, pattern, guard) {
          string = toString(string);
          pattern = guard ? undefined2 : pattern;
          if (pattern === undefined2) {
            return hasUnicodeWord(string) ? unicodeWords(string) : asciiWords(string);
          }
          return string.match(pattern) || [];
        }
        var attempt = baseRest(function(func, args) {
          try {
            return apply(func, undefined2, args);
          } catch (e) {
            return isError2(e) ? e : new Error2(e);
          }
        });
        var bindAll = flatRest(function(object, methodNames) {
          arrayEach(methodNames, function(key) {
            key = toKey(key);
            baseAssignValue(object, key, bind(object[key], object));
          });
          return object;
        });
        function cond(pairs) {
          var length = pairs == null ? 0 : pairs.length, toIteratee = getIteratee();
          pairs = !length ? [] : arrayMap(pairs, function(pair) {
            if (typeof pair[1] != "function") {
              throw new TypeError2(FUNC_ERROR_TEXT);
            }
            return [toIteratee(pair[0]), pair[1]];
          });
          return baseRest(function(args) {
            var index = -1;
            while (++index < length) {
              var pair = pairs[index];
              if (apply(pair[0], this, args)) {
                return apply(pair[1], this, args);
              }
            }
          });
        }
        function conforms(source) {
          return baseConforms(baseClone(source, CLONE_DEEP_FLAG));
        }
        function constant(value) {
          return function() {
            return value;
          };
        }
        function defaultTo(value, defaultValue) {
          return value == null || value !== value ? defaultValue : value;
        }
        var flow = createFlow();
        var flowRight = createFlow(true);
        function identity(value) {
          return value;
        }
        function iteratee(func) {
          return baseIteratee(typeof func == "function" ? func : baseClone(func, CLONE_DEEP_FLAG));
        }
        function matches(source) {
          return baseMatches(baseClone(source, CLONE_DEEP_FLAG));
        }
        function matchesProperty(path, srcValue) {
          return baseMatchesProperty(path, baseClone(srcValue, CLONE_DEEP_FLAG));
        }
        var method = baseRest(function(path, args) {
          return function(object) {
            return baseInvoke(object, path, args);
          };
        });
        var methodOf = baseRest(function(object, args) {
          return function(path) {
            return baseInvoke(object, path, args);
          };
        });
        function mixin(object, source, options) {
          var props = keys(source), methodNames = baseFunctions(source, props);
          if (options == null && !(isObject2(source) && (methodNames.length || !props.length))) {
            options = source;
            source = object;
            object = this;
            methodNames = baseFunctions(source, keys(source));
          }
          var chain2 = !(isObject2(options) && "chain" in options) || !!options.chain, isFunc = isFunction(object);
          arrayEach(methodNames, function(methodName) {
            var func = source[methodName];
            object[methodName] = func;
            if (isFunc) {
              object.prototype[methodName] = function() {
                var chainAll = this.__chain__;
                if (chain2 || chainAll) {
                  var result2 = object(this.__wrapped__), actions = result2.__actions__ = copyArray(this.__actions__);
                  actions.push({ "func": func, "args": arguments, "thisArg": object });
                  result2.__chain__ = chainAll;
                  return result2;
                }
                return func.apply(object, arrayPush([this.value()], arguments));
              };
            }
          });
          return object;
        }
        function noConflict() {
          if (root._ === this) {
            root._ = oldDash;
          }
          return this;
        }
        function noop() {
        }
        function nthArg(n) {
          n = toInteger(n);
          return baseRest(function(args) {
            return baseNth(args, n);
          });
        }
        var over = createOver(arrayMap);
        var overEvery = createOver(arrayEvery);
        var overSome = createOver(arraySome);
        function property(path) {
          return isKey(path) ? baseProperty(toKey(path)) : basePropertyDeep(path);
        }
        function propertyOf(object) {
          return function(path) {
            return object == null ? undefined2 : baseGet(object, path);
          };
        }
        var range = createRange();
        var rangeRight = createRange(true);
        function stubArray() {
          return [];
        }
        function stubFalse() {
          return false;
        }
        function stubObject() {
          return {};
        }
        function stubString() {
          return "";
        }
        function stubTrue() {
          return true;
        }
        function times(n, iteratee2) {
          n = toInteger(n);
          if (n < 1 || n > MAX_SAFE_INTEGER) {
            return [];
          }
          var index = MAX_ARRAY_LENGTH, length = nativeMin(n, MAX_ARRAY_LENGTH);
          iteratee2 = getIteratee(iteratee2);
          n -= MAX_ARRAY_LENGTH;
          var result2 = baseTimes(length, iteratee2);
          while (++index < n) {
            iteratee2(index);
          }
          return result2;
        }
        function toPath(value) {
          if (isArray(value)) {
            return arrayMap(value, toKey);
          }
          return isSymbol(value) ? [value] : copyArray(stringToPath(toString(value)));
        }
        function uniqueId(prefix) {
          var id = ++idCounter;
          return toString(prefix) + id;
        }
        var add = createMathOperation(function(augend, addend) {
          return augend + addend;
        }, 0);
        var ceil = createRound("ceil");
        var divide = createMathOperation(function(dividend, divisor) {
          return dividend / divisor;
        }, 1);
        var floor = createRound("floor");
        function max(array) {
          return array && array.length ? baseExtremum(array, identity, baseGt) : undefined2;
        }
        function maxBy(array, iteratee2) {
          return array && array.length ? baseExtremum(array, getIteratee(iteratee2, 2), baseGt) : undefined2;
        }
        function mean(array) {
          return baseMean(array, identity);
        }
        function meanBy(array, iteratee2) {
          return baseMean(array, getIteratee(iteratee2, 2));
        }
        function min(array) {
          return array && array.length ? baseExtremum(array, identity, baseLt) : undefined2;
        }
        function minBy(array, iteratee2) {
          return array && array.length ? baseExtremum(array, getIteratee(iteratee2, 2), baseLt) : undefined2;
        }
        var multiply = createMathOperation(function(multiplier, multiplicand) {
          return multiplier * multiplicand;
        }, 1);
        var round = createRound("round");
        var subtract = createMathOperation(function(minuend, subtrahend) {
          return minuend - subtrahend;
        }, 0);
        function sum(array) {
          return array && array.length ? baseSum(array, identity) : 0;
        }
        function sumBy(array, iteratee2) {
          return array && array.length ? baseSum(array, getIteratee(iteratee2, 2)) : 0;
        }
        lodash.after = after;
        lodash.ary = ary;
        lodash.assign = assign;
        lodash.assignIn = assignIn;
        lodash.assignInWith = assignInWith;
        lodash.assignWith = assignWith;
        lodash.at = at;
        lodash.before = before;
        lodash.bind = bind;
        lodash.bindAll = bindAll;
        lodash.bindKey = bindKey;
        lodash.castArray = castArray;
        lodash.chain = chain;
        lodash.chunk = chunk;
        lodash.compact = compact;
        lodash.concat = concat;
        lodash.cond = cond;
        lodash.conforms = conforms;
        lodash.constant = constant;
        lodash.countBy = countBy;
        lodash.create = create11;
        lodash.curry = curry;
        lodash.curryRight = curryRight;
        lodash.debounce = debounce2;
        lodash.defaults = defaults;
        lodash.defaultsDeep = defaultsDeep;
        lodash.defer = defer;
        lodash.delay = delay;
        lodash.difference = difference;
        lodash.differenceBy = differenceBy;
        lodash.differenceWith = differenceWith;
        lodash.drop = drop;
        lodash.dropRight = dropRight;
        lodash.dropRightWhile = dropRightWhile;
        lodash.dropWhile = dropWhile;
        lodash.fill = fill;
        lodash.filter = filter;
        lodash.flatMap = flatMap;
        lodash.flatMapDeep = flatMapDeep;
        lodash.flatMapDepth = flatMapDepth;
        lodash.flatten = flatten;
        lodash.flattenDeep = flattenDeep;
        lodash.flattenDepth = flattenDepth;
        lodash.flip = flip;
        lodash.flow = flow;
        lodash.flowRight = flowRight;
        lodash.fromPairs = fromPairs;
        lodash.functions = functions;
        lodash.functionsIn = functionsIn;
        lodash.groupBy = groupBy;
        lodash.initial = initial;
        lodash.intersection = intersection;
        lodash.intersectionBy = intersectionBy;
        lodash.intersectionWith = intersectionWith;
        lodash.invert = invert;
        lodash.invertBy = invertBy;
        lodash.invokeMap = invokeMap;
        lodash.iteratee = iteratee;
        lodash.keyBy = keyBy;
        lodash.keys = keys;
        lodash.keysIn = keysIn;
        lodash.map = map;
        lodash.mapKeys = mapKeys;
        lodash.mapValues = mapValues;
        lodash.matches = matches;
        lodash.matchesProperty = matchesProperty;
        lodash.memoize = memoize;
        lodash.merge = merge;
        lodash.mergeWith = mergeWith;
        lodash.method = method;
        lodash.methodOf = methodOf;
        lodash.mixin = mixin;
        lodash.negate = negate;
        lodash.nthArg = nthArg;
        lodash.omit = omit;
        lodash.omitBy = omitBy;
        lodash.once = once;
        lodash.orderBy = orderBy;
        lodash.over = over;
        lodash.overArgs = overArgs;
        lodash.overEvery = overEvery;
        lodash.overSome = overSome;
        lodash.partial = partial;
        lodash.partialRight = partialRight;
        lodash.partition = partition;
        lodash.pick = pick;
        lodash.pickBy = pickBy;
        lodash.property = property;
        lodash.propertyOf = propertyOf;
        lodash.pull = pull;
        lodash.pullAll = pullAll;
        lodash.pullAllBy = pullAllBy;
        lodash.pullAllWith = pullAllWith;
        lodash.pullAt = pullAt;
        lodash.range = range;
        lodash.rangeRight = rangeRight;
        lodash.rearg = rearg;
        lodash.reject = reject;
        lodash.remove = remove;
        lodash.rest = rest;
        lodash.reverse = reverse;
        lodash.sampleSize = sampleSize;
        lodash.set = set2;
        lodash.setWith = setWith;
        lodash.shuffle = shuffle;
        lodash.slice = slice;
        lodash.sortBy = sortBy;
        lodash.sortedUniq = sortedUniq;
        lodash.sortedUniqBy = sortedUniqBy;
        lodash.split = split;
        lodash.spread = spread;
        lodash.tail = tail;
        lodash.take = take;
        lodash.takeRight = takeRight;
        lodash.takeRightWhile = takeRightWhile;
        lodash.takeWhile = takeWhile;
        lodash.tap = tap;
        lodash.throttle = throttle2;
        lodash.thru = thru;
        lodash.toArray = toArray;
        lodash.toPairs = toPairs;
        lodash.toPairsIn = toPairsIn;
        lodash.toPath = toPath;
        lodash.toPlainObject = toPlainObject;
        lodash.transform = transform;
        lodash.unary = unary;
        lodash.union = union;
        lodash.unionBy = unionBy;
        lodash.unionWith = unionWith;
        lodash.uniq = uniq;
        lodash.uniqBy = uniqBy;
        lodash.uniqWith = uniqWith;
        lodash.unset = unset;
        lodash.unzip = unzip;
        lodash.unzipWith = unzipWith;
        lodash.update = update;
        lodash.updateWith = updateWith;
        lodash.values = values;
        lodash.valuesIn = valuesIn;
        lodash.without = without;
        lodash.words = words;
        lodash.wrap = wrap;
        lodash.xor = xor;
        lodash.xorBy = xorBy;
        lodash.xorWith = xorWith;
        lodash.zip = zip;
        lodash.zipObject = zipObject;
        lodash.zipObjectDeep = zipObjectDeep;
        lodash.zipWith = zipWith;
        lodash.entries = toPairs;
        lodash.entriesIn = toPairsIn;
        lodash.extend = assignIn;
        lodash.extendWith = assignInWith;
        mixin(lodash, lodash);
        lodash.add = add;
        lodash.attempt = attempt;
        lodash.camelCase = camelCase;
        lodash.capitalize = capitalize;
        lodash.ceil = ceil;
        lodash.clamp = clamp;
        lodash.clone = clone;
        lodash.cloneDeep = cloneDeep2;
        lodash.cloneDeepWith = cloneDeepWith;
        lodash.cloneWith = cloneWith;
        lodash.conformsTo = conformsTo;
        lodash.deburr = deburr;
        lodash.defaultTo = defaultTo;
        lodash.divide = divide;
        lodash.endsWith = endsWith;
        lodash.eq = eq;
        lodash.escape = escape;
        lodash.escapeRegExp = escapeRegExp;
        lodash.every = every;
        lodash.find = find;
        lodash.findIndex = findIndex;
        lodash.findKey = findKey;
        lodash.findLast = findLast;
        lodash.findLastIndex = findLastIndex;
        lodash.findLastKey = findLastKey;
        lodash.floor = floor;
        lodash.forEach = forEach;
        lodash.forEachRight = forEachRight;
        lodash.forIn = forIn;
        lodash.forInRight = forInRight;
        lodash.forOwn = forOwn;
        lodash.forOwnRight = forOwnRight;
        lodash.get = get;
        lodash.gt = gt;
        lodash.gte = gte;
        lodash.has = has2;
        lodash.hasIn = hasIn;
        lodash.head = head;
        lodash.identity = identity;
        lodash.includes = includes;
        lodash.indexOf = indexOf;
        lodash.inRange = inRange;
        lodash.invoke = invoke;
        lodash.isArguments = isArguments;
        lodash.isArray = isArray;
        lodash.isArrayBuffer = isArrayBuffer;
        lodash.isArrayLike = isArrayLike;
        lodash.isArrayLikeObject = isArrayLikeObject;
        lodash.isBoolean = isBoolean;
        lodash.isBuffer = isBuffer;
        lodash.isDate = isDate;
        lodash.isElement = isElement;
        lodash.isEmpty = isEmpty;
        lodash.isEqual = isEqual;
        lodash.isEqualWith = isEqualWith;
        lodash.isError = isError2;
        lodash.isFinite = isFinite;
        lodash.isFunction = isFunction;
        lodash.isInteger = isInteger2;
        lodash.isLength = isLength;
        lodash.isMap = isMap2;
        lodash.isMatch = isMatch;
        lodash.isMatchWith = isMatchWith;
        lodash.isNaN = isNaN2;
        lodash.isNative = isNative;
        lodash.isNil = isNil;
        lodash.isNull = isNull;
        lodash.isNumber = isNumber;
        lodash.isObject = isObject2;
        lodash.isObjectLike = isObjectLike;
        lodash.isPlainObject = isPlainObject2;
        lodash.isRegExp = isRegExp;
        lodash.isSafeInteger = isSafeInteger;
        lodash.isSet = isSet2;
        lodash.isString = isString;
        lodash.isSymbol = isSymbol;
        lodash.isTypedArray = isTypedArray;
        lodash.isUndefined = isUndefined;
        lodash.isWeakMap = isWeakMap;
        lodash.isWeakSet = isWeakSet;
        lodash.join = join;
        lodash.kebabCase = kebabCase;
        lodash.last = last;
        lodash.lastIndexOf = lastIndexOf;
        lodash.lowerCase = lowerCase;
        lodash.lowerFirst = lowerFirst;
        lodash.lt = lt;
        lodash.lte = lte;
        lodash.max = max;
        lodash.maxBy = maxBy;
        lodash.mean = mean;
        lodash.meanBy = meanBy;
        lodash.min = min;
        lodash.minBy = minBy;
        lodash.stubArray = stubArray;
        lodash.stubFalse = stubFalse;
        lodash.stubObject = stubObject;
        lodash.stubString = stubString;
        lodash.stubTrue = stubTrue;
        lodash.multiply = multiply;
        lodash.nth = nth;
        lodash.noConflict = noConflict;
        lodash.noop = noop;
        lodash.now = now;
        lodash.pad = pad;
        lodash.padEnd = padEnd;
        lodash.padStart = padStart;
        lodash.parseInt = parseInt2;
        lodash.random = random;
        lodash.reduce = reduce;
        lodash.reduceRight = reduceRight;
        lodash.repeat = repeat;
        lodash.replace = replace;
        lodash.result = result;
        lodash.round = round;
        lodash.runInContext = runInContext2;
        lodash.sample = sample;
        lodash.size = size;
        lodash.snakeCase = snakeCase;
        lodash.some = some;
        lodash.sortedIndex = sortedIndex;
        lodash.sortedIndexBy = sortedIndexBy;
        lodash.sortedIndexOf = sortedIndexOf;
        lodash.sortedLastIndex = sortedLastIndex;
        lodash.sortedLastIndexBy = sortedLastIndexBy;
        lodash.sortedLastIndexOf = sortedLastIndexOf;
        lodash.startCase = startCase;
        lodash.startsWith = startsWith;
        lodash.subtract = subtract;
        lodash.sum = sum;
        lodash.sumBy = sumBy;
        lodash.template = template;
        lodash.times = times;
        lodash.toFinite = toFinite;
        lodash.toInteger = toInteger;
        lodash.toLength = toLength;
        lodash.toLower = toLower;
        lodash.toNumber = toNumber;
        lodash.toSafeInteger = toSafeInteger;
        lodash.toString = toString;
        lodash.toUpper = toUpper;
        lodash.trim = trim;
        lodash.trimEnd = trimEnd;
        lodash.trimStart = trimStart;
        lodash.truncate = truncate;
        lodash.unescape = unescape;
        lodash.uniqueId = uniqueId;
        lodash.upperCase = upperCase;
        lodash.upperFirst = upperFirst;
        lodash.each = forEach;
        lodash.eachRight = forEachRight;
        lodash.first = head;
        mixin(lodash, function() {
          var source = {};
          baseForOwn(lodash, function(func, methodName) {
            if (!hasOwnProperty2.call(lodash.prototype, methodName)) {
              source[methodName] = func;
            }
          });
          return source;
        }(), { "chain": false });
        lodash.VERSION = VERSION;
        arrayEach(["bind", "bindKey", "curry", "curryRight", "partial", "partialRight"], function(methodName) {
          lodash[methodName].placeholder = lodash;
        });
        arrayEach(["drop", "take"], function(methodName, index) {
          LazyWrapper.prototype[methodName] = function(n) {
            n = n === undefined2 ? 1 : nativeMax(toInteger(n), 0);
            var result2 = this.__filtered__ && !index ? new LazyWrapper(this) : this.clone();
            if (result2.__filtered__) {
              result2.__takeCount__ = nativeMin(n, result2.__takeCount__);
            } else {
              result2.__views__.push({
                "size": nativeMin(n, MAX_ARRAY_LENGTH),
                "type": methodName + (result2.__dir__ < 0 ? "Right" : "")
              });
            }
            return result2;
          };
          LazyWrapper.prototype[methodName + "Right"] = function(n) {
            return this.reverse()[methodName](n).reverse();
          };
        });
        arrayEach(["filter", "map", "takeWhile"], function(methodName, index) {
          var type = index + 1, isFilter = type == LAZY_FILTER_FLAG || type == LAZY_WHILE_FLAG;
          LazyWrapper.prototype[methodName] = function(iteratee2) {
            var result2 = this.clone();
            result2.__iteratees__.push({
              "iteratee": getIteratee(iteratee2, 3),
              "type": type
            });
            result2.__filtered__ = result2.__filtered__ || isFilter;
            return result2;
          };
        });
        arrayEach(["head", "last"], function(methodName, index) {
          var takeName = "take" + (index ? "Right" : "");
          LazyWrapper.prototype[methodName] = function() {
            return this[takeName](1).value()[0];
          };
        });
        arrayEach(["initial", "tail"], function(methodName, index) {
          var dropName = "drop" + (index ? "" : "Right");
          LazyWrapper.prototype[methodName] = function() {
            return this.__filtered__ ? new LazyWrapper(this) : this[dropName](1);
          };
        });
        LazyWrapper.prototype.compact = function() {
          return this.filter(identity);
        };
        LazyWrapper.prototype.find = function(predicate) {
          return this.filter(predicate).head();
        };
        LazyWrapper.prototype.findLast = function(predicate) {
          return this.reverse().find(predicate);
        };
        LazyWrapper.prototype.invokeMap = baseRest(function(path, args) {
          if (typeof path == "function") {
            return new LazyWrapper(this);
          }
          return this.map(function(value) {
            return baseInvoke(value, path, args);
          });
        });
        LazyWrapper.prototype.reject = function(predicate) {
          return this.filter(negate(getIteratee(predicate)));
        };
        LazyWrapper.prototype.slice = function(start, end) {
          start = toInteger(start);
          var result2 = this;
          if (result2.__filtered__ && (start > 0 || end < 0)) {
            return new LazyWrapper(result2);
          }
          if (start < 0) {
            result2 = result2.takeRight(-start);
          } else if (start) {
            result2 = result2.drop(start);
          }
          if (end !== undefined2) {
            end = toInteger(end);
            result2 = end < 0 ? result2.dropRight(-end) : result2.take(end - start);
          }
          return result2;
        };
        LazyWrapper.prototype.takeRightWhile = function(predicate) {
          return this.reverse().takeWhile(predicate).reverse();
        };
        LazyWrapper.prototype.toArray = function() {
          return this.take(MAX_ARRAY_LENGTH);
        };
        baseForOwn(LazyWrapper.prototype, function(func, methodName) {
          var checkIteratee = /^(?:filter|find|map|reject)|While$/.test(methodName), isTaker = /^(?:head|last)$/.test(methodName), lodashFunc = lodash[isTaker ? "take" + (methodName == "last" ? "Right" : "") : methodName], retUnwrapped = isTaker || /^find/.test(methodName);
          if (!lodashFunc) {
            return;
          }
          lodash.prototype[methodName] = function() {
            var value = this.__wrapped__, args = isTaker ? [1] : arguments, isLazy = value instanceof LazyWrapper, iteratee2 = args[0], useLazy = isLazy || isArray(value);
            var interceptor = function(value2) {
              var result3 = lodashFunc.apply(lodash, arrayPush([value2], args));
              return isTaker && chainAll ? result3[0] : result3;
            };
            if (useLazy && checkIteratee && typeof iteratee2 == "function" && iteratee2.length != 1) {
              isLazy = useLazy = false;
            }
            var chainAll = this.__chain__, isHybrid = !!this.__actions__.length, isUnwrapped = retUnwrapped && !chainAll, onlyLazy = isLazy && !isHybrid;
            if (!retUnwrapped && useLazy) {
              value = onlyLazy ? value : new LazyWrapper(this);
              var result2 = func.apply(value, args);
              result2.__actions__.push({ "func": thru, "args": [interceptor], "thisArg": undefined2 });
              return new LodashWrapper(result2, chainAll);
            }
            if (isUnwrapped && onlyLazy) {
              return func.apply(this, args);
            }
            result2 = this.thru(interceptor);
            return isUnwrapped ? isTaker ? result2.value()[0] : result2.value() : result2;
          };
        });
        arrayEach(["pop", "push", "shift", "sort", "splice", "unshift"], function(methodName) {
          var func = arrayProto[methodName], chainName = /^(?:push|sort|unshift)$/.test(methodName) ? "tap" : "thru", retUnwrapped = /^(?:pop|shift)$/.test(methodName);
          lodash.prototype[methodName] = function() {
            var args = arguments;
            if (retUnwrapped && !this.__chain__) {
              var value = this.value();
              return func.apply(isArray(value) ? value : [], args);
            }
            return this[chainName](function(value2) {
              return func.apply(isArray(value2) ? value2 : [], args);
            });
          };
        });
        baseForOwn(LazyWrapper.prototype, function(func, methodName) {
          var lodashFunc = lodash[methodName];
          if (lodashFunc) {
            var key = lodashFunc.name + "";
            if (!hasOwnProperty2.call(realNames, key)) {
              realNames[key] = [];
            }
            realNames[key].push({ "name": methodName, "func": lodashFunc });
          }
        });
        realNames[createHybrid(undefined2, WRAP_BIND_KEY_FLAG).name] = [{
          "name": "wrapper",
          "func": undefined2
        }];
        LazyWrapper.prototype.clone = lazyClone;
        LazyWrapper.prototype.reverse = lazyReverse;
        LazyWrapper.prototype.value = lazyValue;
        lodash.prototype.at = wrapperAt;
        lodash.prototype.chain = wrapperChain;
        lodash.prototype.commit = wrapperCommit;
        lodash.prototype.next = wrapperNext;
        lodash.prototype.plant = wrapperPlant;
        lodash.prototype.reverse = wrapperReverse;
        lodash.prototype.toJSON = lodash.prototype.valueOf = lodash.prototype.value = wrapperValue;
        lodash.prototype.first = lodash.prototype.head;
        if (symIterator) {
          lodash.prototype[symIterator] = wrapperToIterator;
        }
        return lodash;
      };
      var _ = runInContext();
      if (typeof define == "function" && typeof define.amd == "object" && define.amd) {
        root._ = _;
        define(function() {
          return _;
        });
      } else if (freeModule) {
        (freeModule.exports = _)._ = _;
        freeExports._ = _;
      } else {
        root._ = _;
      }
    }).call(exports);
  }
});

// ../../node_modules/@smithy/core/dist-es/submodules/transport/httpResponse.js
var HttpResponse;
var init_httpResponse = __esm({
  "../../node_modules/@smithy/core/dist-es/submodules/transport/httpResponse.js"() {
    HttpResponse = class {
      statusCode;
      reason;
      headers;
      body;
      constructor(options) {
        this.statusCode = options.statusCode;
        this.reason = options.reason;
        this.headers = options.headers || {};
        this.body = options.body;
      }
      static isInstance(response) {
        if (!response)
          return false;
        const resp = response;
        return typeof resp.statusCode === "number" && typeof resp.headers === "object";
      }
    };
  }
});

// ../../node_modules/@smithy/core/dist-es/submodules/transport/index.js
var init_transport = __esm({
  "../../node_modules/@smithy/core/dist-es/submodules/transport/index.js"() {
    init_httpResponse();
  }
});

// src/capabilities/services/MaxServiceContext.tsx
import * as React9 from "react";

// src/capabilities/services/MaxServiceClient.ts
import { Client as McpClient } from "@modelcontextprotocol/sdk/client/index.js";
import { StreamableHTTPClientTransport } from "@modelcontextprotocol/sdk/client/streamableHttp.js";
import { McpError, ErrorCode } from "@modelcontextprotocol/sdk/types.js";
import {
  AGENT_PREVIEW_COOKIE,
  AGENT_PREVIEW_HEADER,
  CONTROL_PLANE_ELICITATION_NAMESPACE,
  MAX_REQUEST_ID_META_KEY,
  ToolAuthorizationBehavior
} from "@amzn/awsmp-max-model";
import { getArtifactSchemas } from "@amzn/awsmp-max-data";

// ../../node_modules/@amzn/awsmp-contessa-signer/dist/signer.js
var import_lodash = __toESM(require_lodash());

// ../../node_modules/@amzn/awsmp-contessa-signer/dist/authentication-error.js
var AuthenticationError = class extends Error {
  constructor(message) {
    super(message);
    this.name = "AuthenticationError";
  }
};

// ../../node_modules/@amzn/awsmp-contessa-signer/dist/util/client-utils.js
var getService = (client, headers) => {
  return client.config.defaultSigningName ? client.config.defaultSigningName : getServiceFromAuthorizationHeader(headers);
};
var getRegion = async (client, headers) => {
  try {
    return await client.config.region();
  } catch (error) {
    return getRegionFromAuthorizationHeader(headers);
  }
};
var getServiceFromAuthorizationHeader = (headers) => {
  const credential = getCredentialFromAuthorizationHeader(headers);
  return credential.split("/")[3];
};
var getRegionFromAuthorizationHeader = (headers) => {
  const credential = getCredentialFromAuthorizationHeader(headers);
  return credential.split("/")[2];
};
var getCredentialFromAuthorizationHeader = (headers) => {
  const authHeader = headers.authorization;
  let credential;
  if (authHeader != null && authHeader.indexOf(",") > 0 && authHeader.indexOf("SignedHeaders=") > 0 && authHeader.indexOf("Credential=") > 0) {
    credential = authHeader.split(",").find((name) => name.indexOf("Credential=") >= 0);
  }
  if (credential === void 0) {
    throw new Error(`Missing or malformed authorization header in ${JSON.stringify(headers)}`);
  }
  return credential;
};

// ../../node_modules/@amzn/awsmp-contessa-signer/dist/util/contessa-utils.js
var getPathPrefix = () => window.location.hostname.endsWith(".aws.com") ? "" : "/marketplace";
var getSignerEndpoint = () => `${getPathPrefix()}/api/request-signer`;
var getLoginPath = () => `${getPathPrefix()}/login`;
var getSignedHeaders = async (client, request, options) => {
  const ajaxHeaders = { "Content-Type": "application/json" };
  addCsrfToken(ajaxHeaders, options);
  const queryString = buildQueryString(request.query);
  const fullPath = `${request.path}${queryString}`;
  return await fetch(getSignerEndpoint(), {
    method: "post",
    redirect: "manual",
    headers: ajaxHeaders,
    body: JSON.stringify({
      endpoint: request.hostname,
      method: request.method,
      path: fullPath,
      headers: request.headers,
      body: ArrayBuffer.isView(request.body) ? new TextDecoder().decode(request.body) : request.body,
      service: getService(client, request.headers),
      region: await getRegion(client, request.headers)
    })
  }).then(async (response) => {
    if (response.type === "opaqueredirect") {
      throw new AuthenticationError(`User is not authenticated`);
    } else if (!response.ok) {
      const error = await response.text();
      throw new Error(error);
    }
    return response.json();
  }).catch((error) => {
    console.log(`GetSignedHeaders failed with error: ${error}`);
    throw error;
  });
};
var getCookieValue = (name) => {
  const match = document.cookie.match(new RegExp(`(?:^|; )${name}=([^;]*)`));
  return match === null || match === void 0 ? void 0 : match[1];
};
var isAwsComDomain = () => window.location.hostname.endsWith(".aws.com");
var addCsrfToken = (headers, options) => {
  var _a;
  if (!isCsrfCheckEnabled(options))
    return;
  const cdnCsrfToken = getCookieValue("__Host-csrf");
  if (cdnCsrfToken) {
    headers["x-csrf-token"] = cdnCsrfToken;
  }
  if (isAwsComDomain()) {
    if (!cdnCsrfToken)
      throw new Error("CSRF token not found: __Host-csrf cookie is missing on aws.com domain");
    return;
  }
  const csrfToken = (_a = document.querySelector('meta[name="AWSMP-CsrfToken"]')) === null || _a === void 0 ? void 0 : _a.getAttribute("content");
  if (typeof csrfToken === "string") {
    headers["AWSMP-CsrfToken"] = csrfToken;
  } else if (!cdnCsrfToken) {
    throw new Error("AWSMP-CsrfToken token not found in meta tag");
  }
};
var isCsrfCheckEnabled = (options) => (options === null || options === void 0 ? void 0 : options.csrfEnabled) === void 0 || (options === null || options === void 0 ? void 0 : options.csrfEnabled);
var buildQueryString = (query) => {
  if (!query || Object.keys(query).length === 0) {
    return "";
  }
  const params = new URLSearchParams();
  Object.entries(query).forEach(([key, value]) => {
    if (value !== null && value !== void 0) {
      params.append(key, value);
    } else {
      console.log(`Skipping invalid key: ${key} and value: ${value}`);
    }
  });
  return `?${params.toString()}`;
};

// ../../node_modules/@amzn/awsmp-contessa-signer/dist/signer.js
var Signer = class {
  constructor(options) {
    this.getSignedClient = (client) => {
      const serviceClient = (0, import_lodash.cloneDeep)(client);
      serviceClient.middlewareStack.add(this.requestSignerMiddleware(client), {
        step: "finalizeRequest",
        name: "ContessaRequestSigner"
      });
      return serviceClient;
    };
    this.requestSignerMiddleware = (client) => (next) => async (args) => {
      await this.sign(client, args.request);
      return await next(args);
    };
    this.sign = async (client, request) => {
      try {
        const signedHeaders = await getSignedHeaders(client, request, this.options);
        this.updateRequestWithSignedHeaders(request, signedHeaders);
        return request;
      } catch (error) {
        if (error instanceof AuthenticationError && this.isRedirectionEnabled()) {
          window.location.href = getLoginPath();
          await new Promise((resolve) => setTimeout(resolve, 5e3));
          return request;
        }
        throw error;
      }
    };
    this.updateRequestWithSignedHeaders = (originalRequest, signedHeaders) => {
      for (const [header, value] of Object.entries(signedHeaders)) {
        const matchedHeader = this.getPropertyIgnoreCase(originalRequest.headers, header);
        originalRequest.headers[matchedHeader] = value;
      }
    };
    this.isRedirectionEnabled = () => {
      var _a, _b;
      return ((_a = this.options) === null || _a === void 0 ? void 0 : _a.followRedirects) === void 0 || ((_b = this.options) === null || _b === void 0 ? void 0 : _b.followRedirects);
    };
    this.getPropertyIgnoreCase = (object, property) => {
      return Object.keys(object).find((key) => key.toLowerCase() === property.toLowerCase()) || property;
    };
    this.options = options;
  }
};

// src/capabilities/services/uploadFileToS3.ts
async function uploadFileToS3(file, uploadUrl, onProgress) {
  const SIMULATE_ERROR = false;
  if (SIMULATE_ERROR) {
    return Promise.reject(new Error("Simulated upload failure for testing"));
  }
  if (!uploadUrl) {
    throw new Error("Upload URL is required but was not provided");
  }
  return new Promise((resolve, reject) => {
    const xhr = new XMLHttpRequest();
    xhr.upload.addEventListener("progress", (event) => {
      if (event.lengthComputable && onProgress) {
        const percent = event.loaded / event.total * 100;
        onProgress(percent);
      }
    });
    xhr.addEventListener("load", () => {
      if (xhr.status === 200) {
        resolve();
      } else {
        const errorMsg = `Upload failed with status ${xhr.status}: ${xhr.statusText}`;
        reject(new Error(errorMsg));
      }
    });
    xhr.addEventListener("error", () => {
      reject(new Error("Network error during upload"));
    });
    xhr.addEventListener("abort", () => {
      reject(new Error("Upload aborted"));
    });
    xhr.addEventListener("timeout", () => {
      reject(new Error("Upload timed out"));
    });
    xhr.open("PUT", uploadUrl);
    xhr.timeout = 3e5;
    xhr.send(file);
  });
}

// src/capabilities/services/constants.ts
var CLIENT_TYPE_HEADER_NAME = "X-AMZN-Client-Type";
var CLIENT_TYPE_INTERNAL = "AMZN-INTERNAL";

// src/capabilities/services/TokenManager.ts
import { AccessDeniedException, OAuth2ErrorCode } from "@amzn/awsmp-max-signin-client";
import { SessionResetOutcome } from "@amzn/awsmp-max-agentic-renderer-interface";
import { isAgentPreviewCookiePresent } from "@amzn/awsmp-max-data";
import { detectStageFromHostname, ROLLOUT_STAGES } from "@amzn/awsmp-max-model";

// ../../tool-configs/awsmp-max-monitoring-frontend/lib/metrics-constants.js
var CustomOpsMetricName;
(function(CustomOpsMetricName2) {
  CustomOpsMetricName2["ClientSide404"] = "ClientSide404";
  CustomOpsMetricName2["ClientSide500"] = "ClientSide500";
  CustomOpsMetricName2["ClientSide500Ignored"] = "ClientSide500Ignored";
  CustomOpsMetricName2["ClientSideNonFatalToolCallError"] = "ClientSideNonFatalToolCallError";
  CustomOpsMetricName2["ClientSideThrottled"] = "ClientSideThrottled";
  CustomOpsMetricName2["ClientSideReconnectionRateLimited"] = "ClientSideReconnectionRateLimited";
  CustomOpsMetricName2["ClientSidePatchDropped"] = "ClientSidePatchDropped";
  CustomOpsMetricName2["ClientSideConversationMismatch"] = "ClientSideConversationMismatch";
  CustomOpsMetricName2["ClientSidePatchRecoveryAttempt"] = "ClientSidePatchRecoveryAttempt";
  CustomOpsMetricName2["ClientSidePatchRecoverySuccess"] = "ClientSidePatchRecoverySuccess";
  CustomOpsMetricName2["ClientSidePatchRecoveryFailure"] = "ClientSidePatchRecoveryFailure";
  CustomOpsMetricName2["MintRefused"] = "MintRefused";
  CustomOpsMetricName2["SessionResetUnavailable"] = "SessionResetUnavailable";
  CustomOpsMetricName2["OriginGrantRecoveryNavigated"] = "OriginGrantRecoveryNavigated";
  CustomOpsMetricName2["OriginGrantRecoveryExhausted"] = "OriginGrantRecoveryExhausted";
  CustomOpsMetricName2["ArtifactFallbackRender"] = "ArtifactFallbackRender";
  CustomOpsMetricName2["FederatedArtifactRenderSuccess"] = "FederatedArtifactRenderSuccess";
  CustomOpsMetricName2["FederatedArtifactRenderError"] = "FederatedArtifactRenderError";
  CustomOpsMetricName2["FederatedArtifactRenderLatency"] = "FederatedArtifactRenderLatency";
  CustomOpsMetricName2["FederatedWidgetLoadFailure"] = "FederatedWidgetLoadFailure";
  CustomOpsMetricName2["EPOBuyerUnonboardedPageRender"] = "EPOBuyerUnonboardedPageRender";
  CustomOpsMetricName2["EPOBuyerLeadReferralValueInvalid"] = "EPOBuyerLeadReferralValueInvalid";
  CustomOpsMetricName2["EPOBuyerLeadFormLoadFailure"] = "EPOBuyerLeadFormLoadFailure";
  CustomOpsMetricName2["EPOBuyerLeadFormLoadSuccess"] = "EPOBuyerLeadFormLoadSuccess";
  CustomOpsMetricName2["EPOBuyerLeadSubmitFailure"] = "EPOBuyerLeadSubmitFailure";
  CustomOpsMetricName2["EPOBuyerLeadSubmitSuccess"] = "EPOBuyerLeadSubmitSuccess";
  CustomOpsMetricName2["EPOBuyerLeadValidationFailure"] = "EPOBuyerLeadValidationFailure";
  CustomOpsMetricName2["EPOBuyerLeadSubmitNotReady"] = "EPOBuyerLeadSubmitNotReady";
  CustomOpsMetricName2["EPOBuyerLeadTerminalSubmitFailure"] = "EPOBuyerLeadTerminalSubmitFailure";
  CustomOpsMetricName2["EPOBuyerRenewalPreviewDerivationFailure"] = "EPOBuyerRenewalPreviewDerivationFailure";
  CustomOpsMetricName2["RecommendUnitsError"] = "RecommendUnitsError";
  CustomOpsMetricName2["EPOSellerMultiplePublicOffers"] = "EPOSellerMultiplePublicOffers";
  CustomOpsMetricName2["EPOSellerUnexpectedEulaType"] = "EPOSellerUnexpectedEulaType";
  CustomOpsMetricName2["EPOSellerBatchDescribePartialFailure"] = "EPOSellerBatchDescribePartialFailure";
  CustomOpsMetricName2["EPOSellerBatchDescribeFailure"] = "EPOSellerBatchDescribeFailure";
  CustomOpsMetricName2["EPOSellerNoPublicOfferFound"] = "EPOSellerNoPublicOfferFound";
  CustomOpsMetricName2["EPOSellerNoPublicOfferFreeTrialOnly"] = "EPOSellerNoPublicOfferFreeTrialOnly";
  CustomOpsMetricName2["EPOSellerCreateChangeSetRejected"] = "EPOSellerCreateChangeSetRejected";
  CustomOpsMetricName2["EPOSellerCreateStatusCheckUnavailable"] = "EPOSellerCreateStatusCheckUnavailable";
  CustomOpsMetricName2["CapiThrottleRetry"] = "CapiThrottleRetry";
  CustomOpsMetricName2["CapiThrottleExhausted"] = "CapiThrottleExhausted";
  CustomOpsMetricName2["CapiTransientRetry"] = "CapiTransientRetry";
  CustomOpsMetricName2["CapiTransientExhausted"] = "CapiTransientExhausted";
})(CustomOpsMetricName || (CustomOpsMetricName = {}));
var CustomOpsSdkServiceName;
(function(CustomOpsSdkServiceName2) {
  CustomOpsSdkServiceName2["MARKETPLACE_DISCOVERY"] = "MarketplaceDiscovery";
  CustomOpsSdkServiceName2["MARKETPLACE_AGREEMENT"] = "MarketplaceAgreement";
  CustomOpsSdkServiceName2["MARKETPLACE_CATALOG"] = "MarketplaceCatalog";
})(CustomOpsSdkServiceName || (CustomOpsSdkServiceName = {}));

// ../../node_modules/@smithy/core/dist-es/submodules/protocols/index.js
init_transport();

// ../../node_modules/@smithy/core/dist-es/submodules/protocols/util-uri-escape/escape-uri.js
var escapeUri = (uri) => encodeURIComponent(uri).replace(/[!'()*]/g, hexEncode);
var hexEncode = (c) => `%${c.charCodeAt(0).toString(16).toUpperCase()}`;

// ../../node_modules/@smithy/core/dist-es/submodules/protocols/querystring-builder/buildQueryString.js
function buildQueryString2(query) {
  const parts = [];
  for (let key of Object.keys(query).sort()) {
    const value = query[key];
    key = escapeUri(key);
    if (Array.isArray(value)) {
      for (let i = 0, iLen = value.length; i < iLen; i++) {
        parts.push(`${key}=${escapeUri(value[i])}`);
      }
    } else {
      let qsEntry = key;
      if (value || typeof value === "string") {
        qsEntry += `=${escapeUri(value)}`;
      }
      parts.push(qsEntry);
    }
  }
  return parts.join("&");
}

// ../../tool-configs/awsmp-max-monitoring-frontend/lib/sdk-metrics/types.js
var STATUS_CODE_CLASS;
(function(STATUS_CODE_CLASS2) {
  STATUS_CODE_CLASS2["TWO_HUNDRED"] = "200";
  STATUS_CODE_CLASS2["FOUR_HUNDRED"] = "400";
  STATUS_CODE_CLASS2["FIVE_HUNDRED"] = "500";
})(STATUS_CODE_CLASS || (STATUS_CODE_CLASS = {}));

// ../../node_modules/is-network-error/index.js
var objectToString = Object.prototype.toString;
var isError = (value) => objectToString.call(value) === "[object Error]";
var errorMessages = /* @__PURE__ */ new Set([
  "network error",
  // Chrome
  "Failed to fetch",
  // Chrome
  "NetworkError when attempting to fetch resource.",
  // Firefox
  "The Internet connection appears to be offline.",
  // Safari 16
  "Network request failed",
  // `cross-fetch`
  "fetch failed",
  // Undici (Node.js)
  "terminated",
  // Undici (Node.js)
  " A network error occurred.",
  // Bun (WebKit)
  "Network connection lost"
  // Cloudflare Workers (fetch)
]);
function isNetworkError(error) {
  const isValid = error && isError(error) && error.name === "TypeError" && typeof error.message === "string";
  if (!isValid) {
    return false;
  }
  const { message, stack } = error;
  if (message === "Load failed") {
    return stack === void 0 || "__sentry_captured__" in error;
  }
  if (message.startsWith("error sending request for url")) {
    return true;
  }
  return errorMessages.has(message);
}

// src/capabilities/services/SignedIAMSigninClient.ts
import { SigninClient, CreateOAuth2TokenWithIAMCommand } from "@amzn/awsmp-max-signin-client";

// ../../node_modules/@smithy/fetch-http-handler/dist-es/create-request.js
function createRequest(url, requestOptions) {
  return new Request(url, requestOptions);
}

// ../../node_modules/@smithy/fetch-http-handler/dist-es/request-timeout.js
function requestTimeout(timeoutInMs = 0) {
  return new Promise((resolve, reject) => {
    if (timeoutInMs) {
      setTimeout(() => {
        const timeoutError = new Error(`Request did not complete within ${timeoutInMs} ms`);
        timeoutError.name = "TimeoutError";
        reject(timeoutError);
      }, timeoutInMs);
    }
  });
}

// ../../node_modules/@smithy/fetch-http-handler/dist-es/fetch-http-handler.js
var keepAliveSupport = {
  supported: void 0
};
var FetchHttpHandler = class _FetchHttpHandler {
  config;
  configProvider;
  static create(instanceOrOptions) {
    if (typeof instanceOrOptions?.handle === "function") {
      return instanceOrOptions;
    }
    return new _FetchHttpHandler(instanceOrOptions);
  }
  constructor(options) {
    if (typeof options === "function") {
      this.configProvider = options().then((opts) => opts || {});
    } else {
      this.config = options ?? {};
      this.configProvider = Promise.resolve(this.config);
    }
    if (keepAliveSupport.supported === void 0) {
      keepAliveSupport.supported = Boolean(typeof Request !== "undefined" && "keepalive" in createRequest("https://[::1]"));
    }
  }
  destroy() {
  }
  async handle(request, { abortSignal, requestTimeout: requestTimeout2 } = {}) {
    if (!this.config) {
      this.config = await this.configProvider;
    }
    const requestTimeoutInMs = requestTimeout2 ?? this.config.requestTimeout;
    const keepAlive = this.config.keepAlive === true;
    const credentials = this.config.credentials;
    const fetchFn = this.config.customFetch ?? fetch;
    if (abortSignal?.aborted) {
      const abortError = buildAbortError(abortSignal);
      return Promise.reject(abortError);
    }
    let path = request.path;
    const queryString = buildQueryString2(request.query || {});
    if (queryString) {
      path += `?${queryString}`;
    }
    if (request.fragment) {
      path += `#${request.fragment}`;
    }
    let auth = "";
    if (request.username != null || request.password != null) {
      const username = request.username ?? "";
      const password = request.password ?? "";
      auth = `${username}:${password}@`;
    }
    const { port, method } = request;
    const url = `${request.protocol}//${auth}${request.hostname}${port ? `:${port}` : ""}${path}`;
    const body = method === "GET" || method === "HEAD" ? void 0 : request.body;
    const requestOptions = {
      body,
      headers: new Headers(request.headers),
      method,
      credentials
    };
    if (this.config?.cache) {
      requestOptions.cache = this.config.cache;
    }
    if (body) {
      requestOptions.duplex = "half";
    }
    if (typeof AbortController !== "undefined") {
      requestOptions.signal = abortSignal;
    }
    if (keepAliveSupport.supported) {
      requestOptions.keepalive = keepAlive;
    }
    if (typeof this.config.requestInit === "function") {
      Object.assign(requestOptions, this.config.requestInit(request));
    }
    let removeSignalEventListener = () => {
    };
    const fetchRequest = createRequest(url, requestOptions);
    const raceOfPromises = [
      fetchFn(fetchRequest).then((response) => {
        const fetchHeaders = response.headers;
        const transformedHeaders = {};
        for (const pair of fetchHeaders.entries()) {
          transformedHeaders[pair[0]] = pair[1];
        }
        const hasReadableStream = response.body != void 0;
        if (!hasReadableStream) {
          return response.blob().then((body2) => ({
            response: new HttpResponse({
              headers: transformedHeaders,
              reason: response.statusText,
              statusCode: response.status,
              body: body2
            })
          }));
        }
        return {
          response: new HttpResponse({
            headers: transformedHeaders,
            reason: response.statusText,
            statusCode: response.status,
            body: response.body
          })
        };
      }),
      requestTimeout(requestTimeoutInMs)
    ];
    if (abortSignal) {
      raceOfPromises.push(new Promise((resolve, reject) => {
        const onAbort = () => {
          const abortError = buildAbortError(abortSignal);
          reject(abortError);
        };
        if (typeof abortSignal.addEventListener === "function") {
          const signal = abortSignal;
          signal.addEventListener("abort", onAbort, { once: true });
          removeSignalEventListener = () => signal.removeEventListener("abort", onAbort);
        } else {
          abortSignal.onabort = onAbort;
        }
      }));
    }
    return Promise.race(raceOfPromises).finally(removeSignalEventListener);
  }
  updateHttpClientConfig(key, value) {
    this.config = void 0;
    this.configProvider = this.configProvider.then((config) => {
      config[key] = value;
      return config;
    });
  }
  httpHandlerConfigs() {
    return this.config ?? {};
  }
};
function buildAbortError(abortSignal) {
  const reason = abortSignal && typeof abortSignal === "object" && "reason" in abortSignal ? abortSignal.reason : void 0;
  if (reason) {
    if (reason instanceof Error) {
      const abortError3 = new Error("Request aborted");
      abortError3.name = "AbortError";
      abortError3.cause = reason;
      return abortError3;
    }
    const abortError2 = new Error(String(reason));
    abortError2.name = "AbortError";
    return abortError2;
  }
  const abortError = new Error("Request aborted");
  abortError.name = "AbortError";
  return abortError;
}

// src/capabilities/services/AwsRelayHandler.ts
var AwsRelayHandler = class {
  inner = new FetchHttpHandler();
  prefix;
  constructor(prefix) {
    this.prefix = prefix;
  }
  handle(request, options) {
    request.headers["x-aws-target-host"] = request.hostname;
    request.protocol = window.location.protocol;
    request.hostname = window.location.hostname;
    request.port = window.location.port ? Number(window.location.port) : void 0;
    request.path = `${this.prefix}${request.path}`;
    return this.inner.handle(request, options);
  }
  updateHttpClientConfig(key, value) {
    this.inner.updateHttpClientConfig(key, value);
  }
  httpHandlerConfigs() {
    return this.inner.httpHandlerConfigs();
  }
  destroy() {
    this.inner.destroy();
  }
};

// src/capabilities/services/SignedIAMSigninClient.ts
var SIGNIN_REGION = "us-east-1";
var PLACEHOLDER_CREDENTIAL = "replaced_by_contessa_signer";
var AWS_PROXY_PATH_META_ID = "aws-proxy-path";
var AWS_PROXY_PATH_PLACEHOLDER = "{{aws-proxy-path}}";
var DEFAULT_AWS_PROXY_PATH = "/aws-proxy";
var SIGNIN_ENDPOINT_META_ID = "signin-endpoint";
var SIGNIN_ENDPOINT_PLACEHOLDER = "{{signin-endpoint}}";
function resolveAwsProxyPath() {
  const meta = document.getElementById(AWS_PROXY_PATH_META_ID);
  const content = meta?.getAttribute("content");
  if (content == null || content === AWS_PROXY_PATH_PLACEHOLDER) {
    return DEFAULT_AWS_PROXY_PATH;
  }
  if (content === "") {
    return null;
  }
  return content;
}
function resolveSigninEndpoint() {
  const meta = document.getElementById(SIGNIN_ENDPOINT_META_ID);
  const content = meta?.getAttribute("content");
  if (!content || content === SIGNIN_ENDPOINT_PLACEHOLDER) {
    return null;
  }
  return content;
}
var SignedIAMSigninClient = class _SignedIAMSigninClient {
  constructor(client) {
    this.client = client;
  }
  /**
   * Assembles the SigV4-signed client. Reads aws-proxy-path to pick transport:
   * relay handler for lower envs, plain FetchHttpHandler for prod.
   */
  static of() {
    const proxyPath = resolveAwsProxyPath();
    const requestHandler = proxyPath ? new AwsRelayHandler(proxyPath) : new FetchHttpHandler({ requestTimeout: 5e3 });
    const signinEndpoint = resolveSigninEndpoint();
    const client = new SigninClient({
      region: SIGNIN_REGION,
      retryMode: "adaptive",
      credentials: {
        accessKeyId: PLACEHOLDER_CREDENTIAL,
        secretAccessKey: PLACEHOLDER_CREDENTIAL,
        sessionToken: PLACEHOLDER_CREDENTIAL
      },
      requestHandler,
      ...signinEndpoint ? { endpoint: signinEndpoint } : {}
    });
    const signedClient = new Signer({ csrfEnabled: false, followRedirects: false }).getSignedClient(client);
    return new _SignedIAMSigninClient(signedClient);
  }
  /** Mints a Sign-In OAuth Bearer token (client_credentials grant) for the given resource. */
  async createOAuth2Token(resource) {
    const response = await this.client.send(
      new CreateOAuth2TokenWithIAMCommand({
        grantType: "client_credentials",
        resource
      })
    );
    if (!response.accessToken || response.expiresIn === void 0) {
      throw new Error("Sign-In token response is missing accessToken or expiresIn");
    }
    return { accessToken: response.accessToken, expiresIn: response.expiresIn };
  }
};

// src/capabilities/services/oauthTokenStore.ts
import { create } from "zustand";
import { persist } from "zustand/middleware";
var useOAuthTokenStore = create()(
  persist(
    (set2) => ({
      token: null,
      expiresAt: null,
      boundSessionHash: null,
      setToken: (token, expiresAt, boundSessionHash) => set2({ token, expiresAt, boundSessionHash }),
      clearToken: () => set2({ token: null, expiresAt: null, boundSessionHash: null })
    }),
    {
      name: "awsmp-max-oauth-token",
      partialize: (state) => ({
        token: state.token,
        expiresAt: state.expiresAt,
        boundSessionHash: state.boundSessionHash
      })
    }
  )
);

// src/capabilities/services/TokenManager.ts
var SIGNIN_PENDING_STORAGE_KEY = "max-signin-pending";
var EXPIRY_SKEW_MS = 5 * 60 * 1e3;
var SIGNIN_RESOURCE_META_ID = "signin-resource";
var SIGNIN_RESOURCE_PLACEHOLDER = "{{signin-resource}}";
function isOAuthMintEnabled() {
  const hostname = typeof window !== "undefined" ? window.location.hostname : void 0;
  if (hostname) {
    const stage = detectStageFromHostname(hostname);
    if (!ROLLOUT_STAGES.includes(stage))
      return true;
  }
  return isAgentPreviewCookiePresent();
}
var CONSOLE_SESSION_COOKIE = "aws-userInfo=";
function readCookieValue(prefix) {
  for (const cookie of (document.cookie ?? "").split(";")) {
    const trimmed = cookie.trim();
    if (trimmed.startsWith(prefix))
      return trimmed.slice(prefix.length);
  }
  return null;
}
function sessionFingerprint() {
  const value = readCookieValue(CONSOLE_SESSION_COOKIE) ?? "";
  let hash = 2166136261;
  for (let i = 0; i < value.length; i++) {
    hash ^= value.charCodeAt(i);
    hash = Math.imul(hash, 16777619);
  }
  return (hash >>> 0).toString(16);
}
function hasCookie(prefix) {
  return (document.cookie ?? "").split(";").some((cookie) => cookie.trim().startsWith(prefix));
}
var CONSOLE_SESSION_COOKIE_NAME = "aws-userInfo";
function cookieDomainCandidates() {
  const labels = window.location.hostname.split(".");
  const domains = [];
  for (let i = 0; i <= labels.length - 2; i++) {
    domains.push(labels.slice(i).join("."));
  }
  return [void 0, ...domains];
}
function deleteConsoleSessionCookie() {
  for (const domain of cookieDomainCandidates()) {
    const domainAttribute = domain === void 0 ? "" : `domain=${domain};`;
    document.cookie = `${CONSOLE_SESSION_COOKIE_NAME}=;expires=Thu, 01 Jan 1970 00:00:01 GMT;path=/;${domainAttribute}`;
  }
  return !hasCookie(CONSOLE_SESSION_COOKIE);
}
var MAX_FRAGMENT_OVERRIDE_QUERY_PARAM = "awsmpMaxFragmentOverride";
function resolveSigninResource() {
  const meta = document.getElementById(SIGNIN_RESOURCE_META_ID);
  const content = meta?.getAttribute("content");
  if (!content || content === SIGNIN_RESOURCE_PLACEHOLDER) {
    throw new Error(
      `signin-resource meta tag is ${meta ? "unsubstituted" : "missing"} \u2014 the deploy pipeline (renderBaseHtml) or the inject-signin-config vite plugin must substitute it before mint`
    );
  }
  return content;
}
var INVALID_CREDENTIALS_CODES = /* @__PURE__ */ new Set([
  OAuth2ErrorCode.TOKEN_EXPIRED,
  OAuth2ErrorCode.AUTHCODE_EXPIRED,
  OAuth2ErrorCode.USER_CREDENTIALS_CHANGED
]);
var MINT_DENIAL_STATUS_CODES = /* @__PURE__ */ new Set([401, 403]);
var GRANT_REFUSAL_STATUS_CODE = 400;
var STALE_GRANT_CODES = /* @__PURE__ */ new Set(["invalid_grant"]);
function classifyDenialCode(code) {
  return code && (INVALID_CREDENTIALS_CODES.has(code) || STALE_GRANT_CODES.has(code)) ? { type: "sign-in-required" } : { type: "permission-required" };
}
function classifyAccessDenied(error) {
  return classifyDenialCode(error.error);
}
function mintFailureStatus(error) {
  if (typeof error !== "object" || error === null || !("$metadata" in error))
    return void 0;
  const metadata = error.$metadata;
  if (typeof metadata !== "object" || metadata === null || !("httpStatusCode" in metadata))
    return void 0;
  return typeof metadata.httpStatusCode === "number" ? metadata.httpStatusCode : void 0;
}
function isOAuthMintDenial(error) {
  const status = mintFailureStatus(error);
  return status !== void 0 && MINT_DENIAL_STATUS_CODES.has(status);
}
function mintFailureCode(error) {
  if (typeof error !== "object" || error === null || !("error" in error))
    return void 0;
  return typeof error.error === "string" ? error.error : void 0;
}
function isLifetimeRefusal(error) {
  const code = mintFailureCode(error);
  return mintFailureStatus(error) === GRANT_REFUSAL_STATUS_CODE && code !== void 0 && STALE_GRANT_CODES.has(code);
}
var TokenManager = class {
  constructor(minter, logger) {
    this.minter = minter;
    this.logger = logger;
  }
  /** Single-flight guard: concurrent callers share one in-flight mint. */
  mintInFlight = null;
  /**
   * The session fingerprint the in-flight mint was STARTED under, so a refusal can be attributed to the
   * session it was actually about rather than to whichever session is current when it lands.
   *
   * Captured where the in-flight promise is created, not per caller, because the single-flight guard
   * shares one mint (and one rejection) with every caller that joins it: a caller that joined after a
   * renewal would otherwise attribute the refusal to the new session. `""` is never a real fingerprint,
   * so before any mint the memo it would stamp releases on the next read, which is the safe direction.
   */
  mintStartedUnder = "";
  /**
   * The last lifetime refusal, so it is not re-attempted while it is certain to be refused again.
   * Without this, every call inside the window fires a doomed mint: latency on each request and a
   * stream of failures in the logs, in place of the single failure this retention removes.
   *
   * Held in MEMORY, never persisted, and that is what reduces the release conditions to two.
   * `startSignIn` ends in `window.location.assign`, so the sign-in round trip unloads the page and
   * destroys this for free — there is nothing left to release when the customer returns. The remaining
   * recovery path is a session renewed without MAX unloading (the customer signing into the console in
   * another tab), and that changes `aws-userInfo` and therefore the fingerprint.
   *
   * `error` is retained so a suppressed caller can be answered with the real refusal rather than a
   * manufactured one.
   */
  lifetimeRefusal = null;
  /**
   * Supplies the logger the refusal signal is emitted through. Set after construction because the
   * module-level singleton is built by a zero-argument factory, while the callers that own a logger
   * reach it later. Absent, the refusal still behaves identically and simply emits nothing.
   */
  setLogger(logger) {
    this.logger = logger;
  }
  /**
   * The bearer if it may be attached to a request, else null. Deliberately does NOT answer "is a
   * re-mint preferred?" — that is `fresh`, and the two disagree for the final 300 seconds of every
   * bearer's life. Callers wanting the other question ask through `ensureToken` or `onAuthRequired`.
   *
   * There is NO safety margin on the expiry, and none is wanted. A margin refuses the bearer for its
   * whole width while the straddle risk it guards against occupies only the final round trip, so at a
   * 5-second margin roughly 4.7 of those seconds would have completed successfully. It was never needed
   * for clock inaccuracy either: `expiresAt` is derived from `Date.now()` and compared against
   * `Date.now()`, so an absolute offset cancels. The residual — a request whose bearer dies before ARS
   * checks it — is carried by the 401 clear on the transport paths instead.
   *
   * Never logs or exposes the token anywhere else.
   */
  getToken() {
    return this.readToken().usable;
  }
  /**
   * The token to use, minting one if a better one is worth reaching for (single-flight).
   *
   * Reads `fresh`, not `usable`: returning early on a merely-usable token would suppress the invisible
   * re-mint entirely, which is the behaviour healthy sessions depend on.
   */
  async ensureToken() {
    const read = this.readToken();
    if (read.fresh && read.usable) {
      return read.usable;
    }
    const suppressed = this.suppressedRefusal();
    if (suppressed) {
      if (read.usable) {
        return read.usable;
      }
      throw suppressed.error;
    }
    try {
      return await this.mint();
    } catch (error) {
      if (isLifetimeRefusal(error)) {
        const current2 = this.readToken();
        this.recordLifetimeRefusal(error, current2);
        if (current2.usable) {
          return current2.usable;
        }
      }
      throw error;
    }
  }
  /**
   * Resolves the customer-authentication demand behind a sign-in askUser block. The client owns its
   * own token lifecycle and does NOT infer anything about the server here — it resolves purely from
   * local state, so it is safe to call speculatively (e.g. once on prompt mount to decide the button
   * copy):
   * - a FRESH token in hand → use it as-is (the transport attaches it to the resumed request);
   * - otherwise a console session → mint one, falling back to a merely-usable token when Sign-In
   * refuses for the lifetime reason, rather than falling back to failure;
   * - otherwise → sign in.
   * A mint that fails for any other reason maps to sign-in (invalid credentials) or
   * permission-required (403), exactly as before.
   */
  async onAuthRequired() {
    const read = this.readToken();
    if (read.fresh && read.usable) {
      return { type: "token", token: read.usable };
    }
    if (!this.hasAwsSession()) {
      return { type: "sign-in-required" };
    }
    const suppressed = this.suppressedRefusal();
    if (suppressed) {
      return read.usable ? { type: "token", token: read.usable } : this.classifyMintFailure(suppressed.error);
    }
    try {
      return { type: "token", token: await this.mint() };
    } catch (error) {
      if (isLifetimeRefusal(error)) {
        const current2 = this.readToken();
        this.recordLifetimeRefusal(error, current2);
        if (current2.usable) {
          return { type: "token", token: current2.usable };
        }
      }
      return this.classifyMintFailure(error);
    }
  }
  /**
   * Redirects to console sign-in with route restoration (same mechanism as the
   * Screens clientSideSignIn helper: the fragment-override param is double-encoded
   * and the website bootstrap decodes it twice). Persists the pending-sign-in flag
   * first so the resumed page knows a mint was the goal. The same-origin login path
   * is the real console login in deployed stages and a mockauth redirect stub in
   * local dev. It comes from the signer library, so it always carries the same host
   * prefix as `/api/request-signer`: `/login` on the new `.aws.com` hosts, which serve
   * the app at the root, and `/marketplace/login` everywhere else.
   */
  startSignIn() {
    setPendingSignIn({ reason: "sign-in-block" });
    const hashPath = window.location.hash.replace(/^#\/?/, "");
    if (hashPath && !hashPath.includes("#") && !hashPath.includes("%")) {
      const currentUrl = new URL(window.location.href);
      currentUrl.searchParams.set(MAX_FRAGMENT_OVERRIDE_QUERY_PARAM, encodeURIComponent(hashPath));
      window.history.replaceState({}, "", currentUrl.toString());
    }
    window.location.assign(`${window.location.origin}${getLoginPath()}`);
  }
  /**
   * Signs in, ending the console session first WHERE THAT IS WARRANTED. The one refusal `startSignIn`
   * alone cannot clear: the session has too little life left to back a token, yet is still valid enough
   * that Sign-In's authorize issues a code silently and the customer lands straight back where they
   * started. Removing the keybase is what makes `!empty(kbase)` fail, so the login becomes a real
   * authentication.
   *
   * Always safe to call from a sign-in control. Whether to reset is decided HERE, from the refusal memo,
   * rather than by the caller: see the gate below for why `sign-in-required` is too broad a signal to
   * end a session on.
   *
   * A SEPARATE method rather than a flag on `startSignIn`, so the call sites that redirect without
   * asking the customer cannot reach this. Ending every console session in every tab off a click that
   * asked for something else is the failure this shape rules out by construction.
   *
   * A failed delete still signs in. That is byte for byte today's behaviour, so the worst case of a
   * branch that should be unreachable is the status quo rather than a new dead end, and declining to
   * navigate would leave the customer holding a button that visibly does nothing. The metric is the
   * detector: it may be lost to the unload, but a systematic cause would be hit by many customers, so
   * one sighting is enough to show the reasoning below is wrong somewhere.
   *
   * Why unreachable: reaching a lifetime refusal at all requires MAX to have MINTED, which requires
   * `hasAwsSession()` to have READ this cookie. Readability and writability share one domain rule, so
   * a cookie MAX can see is a cookie `cookieDomainCandidates` can address.
   */
  resetSessionAndSignIn() {
    if (!this.suppressedRefusal()) {
      this.startSignIn();
      return SessionResetOutcome.NoRefusalOnRecord;
    }
    const removed = deleteConsoleSessionCookie();
    if (!removed) {
      this.logger?.opsMetric({ metricName: CustomOpsMetricName.SessionResetUnavailable, unit: "Count", value: 1 });
      this.logger?.warn("Console session cookie survived a reset; signing in without having ended the session");
    }
    this.startSignIn();
    return removed ? SessionResetOutcome.SigningIn : SessionResetOutcome.CookieUnreachable;
  }
  /** Drops the stored token (AuthenticationError / sign-out). */
  clear() {
    useOAuthTokenStore.getState().clearToken();
  }
  /**
   * Whether MAX holds a bearer it can attach for the customer. This is the "Continue" state: MAX can
   * already act, so no authentication ask is needed. It knows only local expiry, not whether the server
   * has since rejected the token.
   *
   * Reads USABLE, deliberately, and not `fresh` — the distinction this docstring used to blur by calling
   * the same thing "a usable token" and "a fresh, unexpired mint". Inside the refresh lead MAX can still
   * act, because the transport will attach the retained bearer. Reading `fresh` here would open the card
   * on an authenticate step for work MAX can already perform, which is the card disagreeing with the
   * transport, exactly the defect `c1029eacc` set out to remove.
   */
  isAuthenticatedWithMAX() {
    return this.getToken() !== null;
  }
  /**
   * Whether the customer has an AWS console session to authenticate MAX from — the JS-readable
   * `aws-userInfo` cookie, and the SAME signal the mint (onAuthRequired) uses. The card keys its
   * "sign in to AWS" vs "authenticate with MAX" step on this, so the step it shows always matches
   * what the mint will actually do.
   *
   * `aws-userInfo-signed` is deliberately NOT used: it is not reliably readable from JS on this page
   * (it is path/domain-scoped, so it is absent from `document.cookie` here even though devtools shows
   * it for the domain). A JS check of it reads false even when the customer is signed in, which sent
   * the card to "Sign in" while the mint would have authenticated from the `aws-userInfo` session it
   * can see. The mint never relied on it, so neither does the card.
   *
   * Fails closed where minting is disabled — a rollout stage (Prod/Pre-Prod) without the
   * max-agent-preview cookie: short-circuit on isOAuthMintEnabled() BEFORE reading the cookie, so no
   * mint is attempted even if a console-session cookie is present (e.g. set by the global chrome
   * header). In non-rollout stages (Local/Personal/Beta/Gamma) minting is enabled unconditionally.
   */
  hasAwsSession() {
    if (!isOAuthMintEnabled()) {
      return false;
    }
    return hasCookie(CONSOLE_SESSION_COOKIE);
  }
  /**
   * The customer's IAM principal ARN from the JS-readable `aws-userInfo` cookie, or `undefined` when
   * there is no session or the value carries no ARN. Used to populate the User field of a mint-denial
   * Access Denied popover — the server has no principal at the mint gate. Best-effort display
   * enrichment: it never throws; a missing/unrecognized cookie yields `undefined` (a blank User),
   * mirroring ARCParse's degrade-to-blank.
   *
   * The cookie carries the ARN in one of two shapes, both handled: a real AWS console session stores a
   * JSON blob with an `arn` field; MAX's sign-in simulation (server `login-handler.ts`, used in dev/test
   * stages) stores the bare role ARN.
   */
  getPrincipalArn() {
    const raw = readCookieValue(CONSOLE_SESSION_COOKIE);
    if (!raw) {
      return void 0;
    }
    let decoded;
    try {
      decoded = decodeURIComponent(raw);
    } catch {
      return void 0;
    }
    try {
      const parsed = JSON.parse(decoded);
      if (typeof parsed?.arn === "string") {
        return parsed.arn;
      }
    } catch {
    }
    return decoded.startsWith("arn:aws:") ? decoded : void 0;
  }
  /**
   * Whether `aws-userInfo` carries a `keybase`, i.e. the console session is signed in. Sign-In's logout
   * removes the keybase but leaves the cookie, so `hasAwsSession()` stays true after a logout and this is
   * the signal that tells the two apart. Never throws; an absent or unparseable cookie reads as signed out.
   */
  hasSignedInConsoleSession() {
    const raw = readCookieValue(CONSOLE_SESSION_COOKIE);
    if (!raw) {
      return false;
    }
    try {
      const parsed = JSON.parse(decodeURIComponent(raw));
      return typeof parsed?.keybase === "string" && parsed.keybase.length > 0;
    } catch {
      return false;
    }
  }
  /**
   * One read of the store, and the ONLY place a token is cleared on a read path. Two clears live here,
   * both deliberate, and neither of them is the refresh lead.
   *
   * The BINDING clear: a bearer bound to a different fingerprint represents a DIFFERENT customer or a
   * RENEWED session, not a stale copy of the current one, so retaining it would let MAX act as whoever
   * held the previous session. Destructive on every path, including the retention fallback. This is the
   * consent invariant, and separating it from the expiry arm without separating their consequences is
   * the likeliest way to introduce a security defect here.
   *
   * The EXPIRY clear: a bearer past its ACTUAL expiry is cleared rather than merely reported unusable,
   * because the store is persisted (zustand `persist` / `partialize` writes all three fields to
   * `awsmp-max-oauth-token`). Without it, a same-session reload inside the refresh lead would rehydrate
   * a dead token, which the old early-discard masked.
   *
   * Being inside the refresh lead clears NOTHING. That is the whole change: the discard is what
   * converted a doomed mint into a hard failure, because by the time the refusal arrived the token that
   * would have served was gone.
   */
  readToken() {
    const { token, expiresAt, boundSessionHash } = useOAuthTokenStore.getState();
    if (!token || expiresAt == null) {
      return { usable: null, fresh: false, expiresAt: null };
    }
    if (boundSessionHash !== sessionFingerprint()) {
      useOAuthTokenStore.getState().clearToken();
      return { usable: null, fresh: false, expiresAt: null };
    }
    const now = Date.now();
    if (expiresAt <= now) {
      useOAuthTokenStore.getState().clearToken();
      return { usable: null, fresh: false, expiresAt: null };
    }
    return { usable: token, fresh: expiresAt - EXPIRY_SKEW_MS > now, expiresAt };
  }
  /**
   * The recorded refusal if a mint would still be pointless, else null, releasing the memo once either
   * condition has come true.
   *
   * The fingerprint condition is the subtle one. A memo keyed on time alone would suppress the mint on
   * the one path that recovers: the customer re-authenticates, gets a new session, and MAX must mint
   * again at once. `sessionFingerprint` changes on renewal (see its docstring), so it is sound.
   */
  suppressedRefusal() {
    const memo3 = this.lifetimeRefusal;
    if (!memo3) {
      return null;
    }
    if (Date.now() >= memo3.releaseAt || sessionFingerprint() !== memo3.sessionHash) {
      this.lifetimeRefusal = null;
      return null;
    }
    return { error: memo3.error };
  }
  /**
   * Records the refusal and emits its signal, once per refusal.
   *
   * Not on a memo hit, which would count UI chattiness rather than customers affected, and not on the
   * successful re-mint inside the lead, which is ordinary operation and would be high volume. Before
   * this retention the window produced a visible error and so was measurable by its failures; after it
   * the window produces silent success, so without this the condition would be unobservable. The
   * existing `Authentication mint failed` line cannot serve: it is emitted from
   * `AuthenticationRequestPrompt`, and the whole point here is that the prompt never mounts.
   */
  recordLifetimeRefusal(error, read) {
    if (this.lifetimeRefusal?.error === error) {
      return;
    }
    const outcome = read.usable ? "BearerRetained" /* BearerRetained */ : "NoUsableBearer" /* NoUsableBearer */;
    this.lifetimeRefusal = {
      // With a bearer held the memo releases at its expiry. With none held there is no expiry to key
      // on, so the horizon is the refusal plus the lead: Sign-In only refuses when the session has less
      // than that left, and a session cannot gain life, so by then it is certainly gone.
      releaseAt: read.expiresAt ?? Date.now() + EXPIRY_SKEW_MS,
      // The session the refused mint was SIGNED under, not the one current now. Reading the fingerprint
      // here would stamp the memo with a session renewed while the mint was in flight, which was never
      // refused, and `suppressedRefusal` would then match it and block the one session that could mint
      // immediately. That inverts R2, whose whole purpose is that a session change RELEASES the memo.
      // Note this is the opposite direction to `read` above, which must be the post-mint snapshot: the
      // two answer different questions, "which session was refused" and "is a usable bearer still held".
      sessionHash: this.mintStartedUnder,
      error
    };
    this.logger?.opsMetric({
      metricName: CustomOpsMetricName.MintRefused,
      unit: "Count",
      value: 1,
      dimensions: { Reason: "InsufficientLifetime" /* InsufficientLifetime */, Outcome: outcome }
    });
    this.logger?.warn("OAuth mint refused for insufficient credential lifetime", {
      outcome,
      bearerRemainingMs: read.expiresAt === null ? void 0 : read.expiresAt - Date.now()
    });
  }
  /**
   * Sorts a mint failure into the outcome its caller renders, or rethrows one that is neither a denial
   * nor a refusal.
   *
   * Every branch here behaves exactly as it did before the retention fallback existed:
   * `permission-required` for a denial, `sign-in-required` for a stale credential, a rethrow for a
   * transport failure. The fallback is applied by the caller BEFORE reaching this, and only for the
   * lifetime refusal, so widening it can never happen by accident here.
   *
   * The 400 branch at the end still answers `sign-in-required` and must: it is reached only when no
   * usable bearer was held, which is the case where the session really has expired and signing in works.
   */
  classifyMintFailure(error) {
    if (error instanceof AuthenticationError) {
      return { type: "sign-in-required" };
    }
    if (error instanceof AccessDeniedException) {
      return classifyAccessDenied(error);
    }
    const status = mintFailureStatus(error);
    const code = mintFailureCode(error);
    if (status !== void 0 && MINT_DENIAL_STATUS_CODES.has(status)) {
      return classifyDenialCode(code);
    }
    if (status === GRANT_REFUSAL_STATUS_CODE && code !== void 0 && STALE_GRANT_CODES.has(code)) {
      return { type: "sign-in-required" };
    }
    throw error;
  }
  mint() {
    if (!this.mintInFlight) {
      this.mintStartedUnder = sessionFingerprint();
      this.mintInFlight = this.executeMint().finally(() => {
        this.mintInFlight = null;
      });
    }
    return this.mintInFlight;
  }
  async executeMint() {
    try {
      const { accessToken, expiresIn } = await this.minter.createOAuth2Token(resolveSigninResource());
      useOAuthTokenStore.getState().setToken(accessToken, Date.now() + expiresIn * 1e3, sessionFingerprint());
      return accessToken;
    } catch (error) {
      if (error instanceof AuthenticationError) {
        this.clear();
      }
      throw error;
    }
  }
};
function setPendingSignIn(pending) {
  sessionStorage.setItem(SIGNIN_PENDING_STORAGE_KEY, JSON.stringify(pending));
}
function consumePendingSignIn() {
  const raw = sessionStorage.getItem(SIGNIN_PENDING_STORAGE_KEY);
  if (!raw) {
    return null;
  }
  sessionStorage.removeItem(SIGNIN_PENDING_STORAGE_KEY);
  try {
    const parsed = JSON.parse(raw);
    if (typeof parsed === "object" && parsed !== null && typeof parsed.reason === "string") {
      return parsed;
    }
  } catch {
  }
  return null;
}
var defaultTokenManager;
function getTokenManager(logger) {
  if (!defaultTokenManager) {
    defaultTokenManager = new TokenManager(SignedIAMSigninClient.of());
  }
  if (logger) {
    defaultTokenManager.setLogger(logger);
  }
  return defaultTokenManager;
}

// src/capabilities/debug/debugStore.ts
import { create as create2 } from "zustand";
import { persist as persist2 } from "zustand/middleware";
var useDebugStore = create2()(
  persist2(
    (set2) => ({
      gateEnabled: false,
      debugFeaturesActivated: false,
      settings: {
        messages: false,
        darkMode: false,
        limitPatches: true,
        epoHelpPanels: false,
        epoRenewalEnabledSeller: false,
        epoLeadsCaptureBuyerDisabled: false,
        epoForwardRedirect: false,
        testTrafficMode: false
      },
      panelOpen: false,
      trackedProjectId: null,
      patches: [],
      recording: false,
      tail: false,
      setGateEnabled: (enabled) => set2({ gateEnabled: enabled }),
      toggleEnabled: () => set2((state) => ({ debugFeaturesActivated: !state.debugFeaturesActivated })),
      toggleSetting: (key) => set2((state) => ({
        settings: { ...state.settings, [key]: !state.settings[key] }
      })),
      setTrackedProjectId: (projectId) => set2({ trackedProjectId: projectId }),
      togglePanel: () => set2((state) => ({ panelOpen: !state.panelOpen })),
      addPatch: (patch) => set2((state) => {
        const newPatches = [...state.patches, patch];
        return {
          patches: !state.tail && newPatches.length > 100 ? newPatches.slice(-100) : newPatches
        };
      }),
      clearPatches: () => set2({ patches: [] }),
      toggleRecording: () => set2((state) => ({ recording: !state.recording })),
      toggleTail: () => set2((state) => ({ tail: !state.tail }))
    }),
    {
      name: "max-debug-storage",
      partialize: (state) => ({
        gateEnabled: state.gateEnabled,
        debugFeaturesActivated: state.debugFeaturesActivated,
        settings: state.settings,
        recording: state.recording,
        tail: state.tail
      })
    }
  )
);
var getDebugSettings = () => useDebugStore.getState().settings;
if (typeof window !== "undefined") {
  const api = {
    setTestTrafficMode(enabled) {
      useDebugStore.setState((state) => ({
        settings: { ...state.settings, testTrafficMode: enabled }
      }));
    },
    getSettings() {
      return useDebugStore.getState().settings;
    },
    setSetting(key, value) {
      useDebugStore.setState((state) => ({
        settings: { ...state.settings, [key]: value }
      }));
    }
  };
  window.__MAX_DEBUG__ = api;
}

// src/capabilities/debug/useDebug.ts
function useDebug() {
  const debugFeaturesActivated = useDebugStore((state) => state.debugFeaturesActivated);
  const settings = useDebugStore((state) => state.settings);
  const toggleEnabled = useDebugStore((state) => state.toggleEnabled);
  const toggleSetting = useDebugStore((state) => state.toggleSetting);
  return {
    debug: debugFeaturesActivated,
    settings,
    toggleDebug: toggleEnabled,
    isToggled: (key) => settings[key],
    toggleSetting
  };
}

// src/capabilities/debug/useDebugPanel.ts
import { useCallback as useCallback3 } from "react";

// src/capabilities/services/useProjectStoreInternal.ts
import { create as create7 } from "zustand";
import { subscribeWithSelector } from "zustand/middleware";
import { unstable_batchedUpdates as unstable_batchedUpdates2 } from "react-dom";

// src/capabilities/services/non-empty-string.ts
function nonEmptyString(value) {
  return typeof value === "string" && value.length > 0 ? value : void 0;
}

// src/capabilities/services/stream-message-call-ids.ts
function streamMessageCallIds(message) {
  const maxRequestId = nonEmptyString(message.requestId);
  const projectId = nonEmptyString(message.projectId);
  const projectTurnId = nonEmptyString(message.projectTurnId);
  return {
    ...maxRequestId ? { maxRequestId } : {},
    ...projectId ? { projectId } : {},
    ...projectTurnId ? { projectTurnId } : {}
  };
}

// src/capabilities/logging/max-project-context.ts
var shown = [];
function showMaxProjectContext(context) {
  const entry = { ...context };
  shown.push(entry);
  return () => {
    const index = shown.lastIndexOf(entry);
    if (index !== -1)
      shown.splice(index, 1);
  };
}
function getMaxProjectContext() {
  return shown[shown.length - 1];
}

// src/capabilities/logging/max-request-context.ts
var callScope;
function withCallIds(ids, write) {
  const previous = callScope;
  callScope = ids;
  try {
    write();
  } finally {
    callScope = previous;
  }
}
function getMaxRequestContext() {
  const shown2 = getMaxProjectContext();
  const projectId = callScope?.projectId ?? shown2?.projectId;
  const projectTurnId = callScope?.projectTurnId ?? (projectId === shown2?.projectId ? shown2?.projectTurnId : void 0);
  const maxRequestId = callScope?.maxRequestId;
  return {
    ...projectId ? { projectId } : {},
    ...projectTurnId ? { projectTurnId } : {},
    ...maxRequestId ? { maxRequestId } : {}
  };
}

// src/capabilities/services/useProjectStoreInternal.ts
import { NotFoundError } from "@amzn/awsmp-max-agentic-renderer-interface";

// src/capabilities/services/streamed-patch-failure-reporter.ts
import { TurnStatus } from "@amzn/awsmp-max-model";

// src/capabilities/logging/browserUtils.ts
function getBrowserInfo() {
  if (typeof window === "undefined" || typeof navigator === "undefined") {
    return {
      isSupported: false,
      userAgent: "SSR"
    };
  }
  const userAgent = navigator.userAgent;
  const isChrome = /Chrome/.test(userAgent) && /Google Inc/.test(navigator.vendor);
  const isFirefox = /Firefox/.test(userAgent);
  const isSafari = /Safari/.test(userAgent) && /Apple Computer/.test(navigator.vendor);
  const isEdge = /Edg/.test(userAgent);
  const isSupported = isChrome || isFirefox || isSafari || isEdge;
  let version;
  if (isChrome) {
    const match = userAgent.match(/Chrome\/(\d+)/);
    version = match ? match[1] : void 0;
  } else if (isFirefox) {
    const match = userAgent.match(/Firefox\/(\d+)/);
    version = match ? match[1] : void 0;
  } else if (isSafari) {
    const match = userAgent.match(/Version\/(\d+)/);
    version = match ? match[1] : void 0;
  } else if (isEdge) {
    const match = userAgent.match(/Edg\/(\d+)/);
    version = match ? match[1] : void 0;
  }
  return {
    isSupported,
    userAgent,
    version
  };
}
function isSupportedBrowser() {
  return getBrowserInfo().isSupported;
}
function extractVersionFromUserAgent(userAgent) {
  if (!userAgent)
    return void 0;
  try {
    const match = userAgent.match(/Edg\/(\d+)/) ?? userAgent.match(/Chrome\/(\d+)/) ?? userAgent.match(/Firefox\/(\d+)/) ?? userAgent.match(/Version\/(\d+)/);
    return match?.[1];
  } catch {
    return void 0;
  }
}

// src/capabilities/logging/active-agent-metrics-config.ts
import { loadedArtifactWidgets } from "@amzn/awsmp-max-data";
function getActiveAgentMetricsConfig() {
  const agentId = useProjectStoreInternal.getState().currentProject?.renderContext?.agent?.agentId;
  if (!agentId)
    return void 0;
  return loadedArtifactWidgets().find((w) => w.agentId === agentId)?.metricsConfig;
}

// src/capabilities/logging/clientLogger.ts
function buildBrowserInfoRecord(externalBrowserInfo) {
  const browserInfo = externalBrowserInfo ?? getBrowserInfo();
  const version = browserInfo.version || extractVersionFromUserAgent(browserInfo.userAgent);
  const record = {
    IsSupportedBrowser: browserInfo.isSupported.toString(),
    UserAgent: browserInfo.userAgent
  };
  if (version) {
    record.BrowserVersion = version;
  }
  return record;
}
function getClientLoggerInstance(externalBrowserInfo) {
  const clientLoggerInstance = window.awsmpue;
  if (!clientLoggerInstance) {
    return void 0;
  }
  const logInfo = Object.entries(buildBrowserInfoRecord(externalBrowserInfo)).map(([name, value]) => ({ name, value }));
  return clientLoggerInstance.setInfo(logInfo);
}
function createSafeLogger(debugMode = false, accumulatedDimensions = {}, browserInfo) {
  const logger = getClientLoggerInstance(browserInfo);
  const browserInfoRecord = buildBrowserInfoRecord(browserInfo);
  const shouldLogToConsole = debugMode || true;
  const logPrefix = debugMode ? "[DEBUG Logger]" : "[Logger]";
  const withAgentRouting = (target) => {
    const metricsConfig = getActiveAgentMetricsConfig();
    return metricsConfig?.clientLoggerTenantId ? target.addTenants([metricsConfig.clientLoggerTenantId]) : target;
  };
  const withMaxContext = (payload) => {
    const callerContext = payload.maxContext;
    const callerKeys = typeof callerContext === "object" && callerContext !== null && !Array.isArray(callerContext) ? callerContext : {};
    const maxContext = { ...getMaxRequestContext(), ...callerKeys };
    return Object.keys(maxContext).length > 0 ? { ...payload, maxContext } : payload;
  };
  const emitPageHitMetric = (dimensions = {}) => {
    if (!logger)
      return;
    const dimArr = Object.entries(dimensions).map(([name, value]) => ({ name, value }));
    const withDims = dimArr.length > 0 ? logger.setDimensions(dimArr) : logger;
    withDims.biMetric("PageHit", "Count", 1);
  };
  return {
    /**
     * Log a message - uses official logger or falls back to console
     */
    log: (message, data) => {
      if (logger) {
        withAgentRouting(logger).json(withMaxContext({ logLevel: "INFO", message, ...data }));
      } else if (shouldLogToConsole) {
        console.log(`${logPrefix} ${message}`, data);
      }
    },
    /**
     * Log an error - uses official logger or falls back to console
     */
    error: (message, error, data) => {
      if (logger) {
        const errorData = { logLevel: "ERROR", message };
        if (error) {
          errorData.error = error.message;
          errorData.stack = error.stack;
        }
        if (data) {
          Object.assign(errorData, data);
        }
        withAgentRouting(logger).json(withMaxContext(errorData));
      }
      const errorPrefix = debugMode ? "[DEBUG Logger]" : "[Logger]";
      console.error(`${errorPrefix} ${message}`, error, data);
    },
    /**
     * Log a warning - uses official logger or falls back to console in dev/debug mode
     */
    warn: (message, data) => {
      if (logger) {
        withAgentRouting(logger).json(withMaxContext({ logLevel: "WARN", message, ...data }));
      } else if (shouldLogToConsole) {
        console.warn(`${logPrefix} ${message}`, data);
      }
    },
    /**
     * Log debug information - uses official logger or falls back to console in dev/debug mode
     */
    debug: (message, data) => {
      if (logger) {
        withAgentRouting(logger).json(withMaxContext({ logLevel: "DEBUG", message, ...data }));
      } else if (shouldLogToConsole) {
        console.debug(`${logPrefix} ${message}`, data);
      }
    },
    /**
     * Log a business intelligence metric - uses official logger or falls back to console
     * Restricted to 4 specific dimension keys: ClickAct, ClickSelect, ClickObj, ClickFeat
     */
    biMetric: ({ metricName, unit, value, dimensions }) => {
      const allDimensions = { ...accumulatedDimensions, ...dimensions };
      let handled = false;
      if (logger) {
        const routedLogger = withAgentRouting(logger);
        const loggerWithDimensions = Object.keys(allDimensions).length > 0 ? routedLogger.setDimensions(Object.entries(allDimensions).map((dimension) => ({ name: dimension[0], value: dimension[1] }))) : routedLogger;
        loggerWithDimensions.biMetric(metricName, unit, value);
        handled = true;
      }
      if (allDimensions.EventContext || allDimensions.EventDetail) {
        const panorama = window.panorama;
        if (typeof panorama === "function") {
          panorama("trackCustomEvent", {
            eventType: metricName,
            eventContext: allDimensions.EventContext ?? "",
            eventDetail: allDimensions.EventDetail ?? "",
            eventValue: String(value),
            timestamp: Date.now()
          });
          handled = true;
        }
      }
      if (!handled && shouldLogToConsole) {
        console.info(
          `${logPrefix} [biMetric] ${metricName}: ${value} ${unit}`,
          Object.keys(allDimensions).length > 0 ? { dimensions: allDimensions } : void 0
        );
      }
    },
    /**
     * Log an operational metric - uses official logger or falls back to console
     */
    opsMetric: ({ metricName, unit, value, dimensions, additionalInfo: callerInfo }) => {
      const additionalInfo = { ...getMaxRequestContext(), ...callerInfo };
      if (logger) {
        const allDimensions = { ...accumulatedDimensions, ...dimensions };
        const routedLogger = withAgentRouting(logger);
        const loggerWithDimensions = Object.keys(allDimensions).length > 0 ? routedLogger.setDimensions(Object.entries(allDimensions).map((dimension) => ({ name: dimension[0], value: dimension[1] }))) : routedLogger;
        const loggerWithInfo = additionalInfo && Object.keys(additionalInfo).length > 0 ? loggerWithDimensions.setInfo(Object.entries({ ...browserInfoRecord, ...additionalInfo }).map(([name, value2]) => ({ name, value: value2 }))) : loggerWithDimensions;
        loggerWithInfo.metric(metricName, unit, value);
      } else if (shouldLogToConsole) {
        const allDimensions = { ...accumulatedDimensions, ...dimensions };
        const hasDimensions = Object.keys(allDimensions).length > 0;
        const hasAdditionalInfo = additionalInfo && Object.keys(additionalInfo).length > 0;
        console.info(
          `${logPrefix} [opsMetric] ${metricName}: ${value} ${unit}`,
          hasDimensions || hasAdditionalInfo ? { ...hasDimensions ? { dimensions: allDimensions } : {}, ...hasAdditionalInfo ? { additionalInfo } : {} } : void 0
        );
      }
    },
    /**
     * Update ClientLogger context - uses official logger or falls back to console.
     * Keys are restricted by the `AllowedContextKey` type. Pass `undefined` to
     * clear a key.
     */
    updateContext: (contextUpdates) => {
      if (logger && typeof logger.updateContext === "function") {
        logger.updateContext(contextUpdates);
      } else if (shouldLogToConsole) {
        console.info(`${logPrefix} [updateContext]`, contextUpdates);
      }
    },
    /**
     * Record a page hit from a page's root component. Sets `PageType` context,
     * clears any stale `SubPageType` and emits
     * a bare `PageHit` biMetric.
     */
    pageHit: ({ pageType }) => {
      if (logger) {
        logger.updateContext({ PageType: pageType, SubPageType: void 0 });
        emitPageHitMetric();
      } else if (shouldLogToConsole) {
        console.info(`${logPrefix} [pageHit]`, { PageType: pageType });
      }
    },
    /**
     * Record a sub-page hit: updates the `SubPageType` context AND emits a
     * `PageHit` biMetric with `{ SubPageType }` as a per-call dimension.
     */
    subPageHit: ({ subPageType }) => {
      const dims = { ...accumulatedDimensions, SubPageType: subPageType };
      if (logger) {
        logger.updateContext({ SubPageType: subPageType });
        emitPageHitMetric(dims);
      } else if (shouldLogToConsole) {
        console.info(`${logPrefix} [subPageHit]`, { dimensions: dims });
      }
    },
    /**
     * Set dimensions on the logger and return a new SafeLogger with accumulated dimensions
     * This enables method chaining while maintaining immutability
     */
    setDimensions: (dimensions) => {
      const newAccumulatedDimensions = { ...accumulatedDimensions, ...dimensions };
      return createSafeLogger(debugMode, newAccumulatedDimensions);
    }
  };
}

// src/capabilities/services/streamed-patch-failure-reporter.ts
var RESYNC_DEBOUNCE_MS = 5e3;
var RECOVERY_TIMEOUT_MS = 3e4;
var moduleLogger;
function getLogger() {
  if (!moduleLogger) {
    moduleLogger = createSafeLogger();
  }
  return moduleLogger;
}
var lastResyncAtByProject = /* @__PURE__ */ new Map();
var pendingRecoveryProjects = /* @__PURE__ */ new Set();
function errorMessageOf(error) {
  return error instanceof Error ? error.message : String(error);
}
function emitPatchDropped(stage) {
  getLogger().opsMetric({
    metricName: CustomOpsMetricName.ClientSidePatchDropped,
    unit: "Count",
    value: 1,
    dimensions: { Stage: stage }
  });
}
function reportStreamedPatchParseFailure(projectId, error) {
  getLogger().error("Failed to parse streaming message", error instanceof Error ? error : void 0, {
    projectId,
    errorMessage: errorMessageOf(error)
  });
  emitPatchDropped("parse");
}
function reportStreamedPatchApplyFailure(projectId, error, operation) {
  getLogger().error("Failed to apply streamed patch", error instanceof Error ? error : void 0, {
    projectId,
    op: operation?.op,
    path: operation?.path,
    errorMessage: errorMessageOf(error)
  });
  emitPatchDropped("apply");
}
function reportStreamFailure(context, error, data) {
  getLogger().error("Streaming failure", error instanceof Error ? error : void 0, {
    context,
    errorMessage: errorMessageOf(error),
    ...data
  });
}
async function reconcileConversationOnTurnComplete(client, projectId, engine, finalResult, resetEngine) {
  const rendered = engine.getProjectState();
  if (!rendered || rendered.turnStatus === TurnStatus.Processing) {
    return;
  }
  let committedCount;
  if (typeof finalResult?.conversationLength === "number") {
    committedCount = finalResult.conversationLength;
  } else {
    try {
      const committed = await client.getProject(projectId);
      committedCount = committed?.conversation?.length ?? 0;
    } catch (error) {
      getLogger().warn("Turn-complete reconciliation skipped", {
        projectId,
        errorMessage: errorMessageOf(error)
      });
      return;
    }
  }
  const renderedCount = rendered.conversation?.length ?? 0;
  if (renderedCount >= committedCount) {
    return;
  }
  getLogger().opsMetric({
    metricName: CustomOpsMetricName.ClientSideConversationMismatch,
    unit: "Count",
    value: 1,
    dimensions: { Stage: "turn-complete" }
  });
  getLogger().warn("Rendered conversation behind committed state", {
    projectId,
    renderedCount,
    committedCount
  });
  resyncAfterPatchLoss(client, projectId, "turn-complete", resetEngine);
}
function resyncAfterPatchLoss(client, projectId, trigger, resetEngine) {
  const now = Date.now();
  const lastResyncAt = lastResyncAtByProject.get(projectId) ?? 0;
  if (now - lastResyncAt < RESYNC_DEBOUNCE_MS) {
    return;
  }
  if (pendingRecoveryProjects.has(projectId)) {
    return;
  }
  lastResyncAtByProject.set(projectId, now);
  getLogger().opsMetric({
    metricName: CustomOpsMetricName.ClientSidePatchRecoveryAttempt,
    unit: "Count",
    value: 1,
    dimensions: { Trigger: trigger }
  });
  resetEngine();
  trackRecoveryOutcome(projectId, trigger);
  useProjectStoreInternal.getState().getProject(client, projectId, true);
}
function trackRecoveryOutcome(projectId, trigger) {
  pendingRecoveryProjects.add(projectId);
  let settled = false;
  let sawOwnProject = false;
  const settle = (outcome) => {
    if (settled) {
      return;
    }
    settled = true;
    pendingRecoveryProjects.delete(projectId);
    const elapsed = Date.now() - (lastResyncAtByProject.get(projectId) ?? 0);
    if (elapsed >= RESYNC_DEBOUNCE_MS) {
      lastResyncAtByProject.delete(projectId);
    } else {
      setTimeout(() => lastResyncAtByProject.delete(projectId), RESYNC_DEBOUNCE_MS - elapsed);
    }
    unsubscribe();
    clearTimeout(timeoutId);
    if (outcome === "success") {
      getLogger().opsMetric({
        metricName: CustomOpsMetricName.ClientSidePatchRecoverySuccess,
        unit: "Count",
        value: 1,
        dimensions: { Trigger: trigger }
      });
      return;
    }
    getLogger().opsMetric({
      metricName: CustomOpsMetricName.ClientSidePatchRecoveryFailure,
      unit: "Count",
      value: 1,
      dimensions: { Trigger: trigger, Reason: outcome }
    });
    if (outcome === "abandoned") {
      return;
    }
    getLogger().error("Streamed-patch recovery failed", void 0, {
      projectId,
      trigger,
      reason: outcome
    });
  };
  const unsubscribe = useProjectStoreInternal.subscribe((state) => {
    if (state.currentProjectId !== projectId) {
      if (state.currentProjectId !== null || sawOwnProject) {
        settle("abandoned");
      }
      return;
    }
    sawOwnProject = true;
    const project = state.currentProject;
    if (!project || project.isLoading) {
      return;
    }
    settle(project.error ? "error" : "success");
  });
  const timeoutId = setTimeout(() => settle("timeout"), RECOVERY_TIMEOUT_MS);
}

// src/capabilities/layout/LayoutStateProvider.tsx
var import_lodash2 = __toESM(require_lodash(), 1);
import * as React2 from "react";

// src/capabilities/layout/layoutStore.ts
import { create as create5 } from "zustand";
import * as React from "react";

// src/capabilities/layout/showHideStore.ts
import { create as create3 } from "zustand";
function createShowHideLayout(initialMetadata) {
  return create3((set2) => ({
    mode: "show-hide",
    shown: false,
    header: void 0,
    content: void 0,
    metadata: initialMetadata,
    show: () => set2({ shown: true }),
    hide: () => set2({ shown: false, content: void 0 }),
    setShown: (shown2) => set2({ shown: shown2 }),
    setContent: ({ header, content }) => set2(() => ({
      ...header !== void 0 && { header },
      ...content !== void 0 && { content },
      shown: true
    })),
    updateMetadata: (data) => set2((state) => ({
      metadata: { ...state.metadata, ...data }
    }))
  }));
}

// src/capabilities/layout/listStore.ts
import { create as create4 } from "zustand";
var dismissTimers = /* @__PURE__ */ new Map();
function createListLayout() {
  return create4((set2, get) => ({
    mode: "list",
    items: [],
    addItem: (item) => {
      const id = item.id || crypto.randomUUID();
      const newItem = { ...item, id };
      set2((state) => {
        const existingIndex = state.items.findIndex((existing) => existing.id === id);
        if (existingIndex === -1) {
          return { items: [newItem, ...state.items] };
        }
        const items = [...state.items];
        items[existingIndex] = newItem;
        return { items };
      });
      const supersededTimer = dismissTimers.get(id);
      if (supersededTimer) {
        clearTimeout(supersededTimer);
        dismissTimers.delete(id);
      }
      if ("autoDismiss" in newItem && "dismissTimeout" in newItem && "type" in newItem) {
        const itemWithAutoDismiss = newItem;
        const shouldAutoDismiss = itemWithAutoDismiss.autoDismiss !== false;
        const isErrorOrWarning = itemWithAutoDismiss.type === "error" || itemWithAutoDismiss.type === "warning";
        if (shouldAutoDismiss && !isErrorOrWarning) {
          const timeout = itemWithAutoDismiss.dismissTimeout || 5e3;
          const timer = setTimeout(() => {
            get().removeItem(id);
            dismissTimers.delete(id);
          }, timeout);
          dismissTimers.set(id, timer);
        }
      }
    },
    removeItem: (id) => {
      const timer = dismissTimers.get(id);
      if (timer) {
        clearTimeout(timer);
        dismissTimers.delete(id);
      }
      set2((state) => ({
        items: state.items.filter((item) => item.id !== id)
      }));
    },
    clearAll: () => {
      dismissTimers.forEach((timer) => clearTimeout(timer));
      dismissTimers.clear();
      set2({ items: [] });
    }
  }));
}

// src/capabilities/layout/layoutStore.ts
var useSplitPanel = createShowHideLayout({
  size: 900,
  position: "side"
});
var useModal = createShowHideLayout({
  size: "medium"
});
var useHelpPanel = createShowHideLayout({});
var useFlashbar = createListLayout();
var useLayoutStore = create5((set2, get) => ({
  windowSize: "l",
  stickyElements: /* @__PURE__ */ new Map(),
  nextStickyId: 0,
  _setWindowSize: (windowSize) => set2({ windowSize }),
  _updateStickyHeight: (id, height) => set2((state) => {
    const entry = state.stickyElements.get(id);
    if (!entry)
      return state;
    const newElements = new Map(state.stickyElements);
    newElements.set(id, { ...entry, height });
    return { stickyElements: newElements };
  }),
  registerSticky: (ref, debugLabel) => {
    const id = get().nextStickyId;
    const resizeObserver = new ResizeObserver(() => {
      const height = ref.current?.offsetHeight ?? 0;
      get()._updateStickyHeight(id, height);
    });
    if (ref.current) {
      const initialHeight = ref.current.offsetHeight;
      set2((state) => ({
        stickyElements: new Map(state.stickyElements).set(id, {
          height: initialHeight,
          resizeObserver,
          debugLabel,
          ref
        }),
        nextStickyId: state.nextStickyId + 1
      }));
      resizeObserver.observe(ref.current);
    } else {
      set2((state) => ({
        stickyElements: new Map(state.stickyElements).set(id, {
          height: 0,
          resizeObserver,
          debugLabel,
          ref
        }),
        nextStickyId: state.nextStickyId + 1
      }));
    }
    return () => {
      const entry = get().stickyElements.get(id);
      if (entry) {
        entry.resizeObserver.disconnect();
      }
      set2((state) => {
        const newElements = new Map(state.stickyElements);
        newElements.delete(id);
        return { stickyElements: newElements };
      });
    };
  }
}));
function useLayoutManager() {
  const splitPanel = useSplitPanel();
  const modal = useModal();
  const flashbar = useFlashbar();
  const helpPanel = useHelpPanel();
  const windowSize = useLayoutStore((state) => state.windowSize);
  const registerSticky = React.useCallback((ref, debugLabel) => {
    return useLayoutStore.getState().registerSticky(ref, debugLabel);
  }, []);
  const [viewportYOffset, setViewportYOffset] = React.useState(0);
  React.useEffect(() => {
    const calculateOffset = () => {
      const state = useLayoutStore.getState();
      let totalOffset = 0;
      for (const entry of state.stickyElements.values()) {
        totalOffset += entry.height;
      }
      setViewportYOffset(totalOffset);
    };
    calculateOffset();
    window.addEventListener("scroll", calculateOffset, { passive: true });
    window.addEventListener("resize", calculateOffset, { passive: true });
    const unsubscribe = useLayoutStore.subscribe(calculateOffset);
    return () => {
      window.removeEventListener("scroll", calculateOffset);
      window.removeEventListener("resize", calculateOffset);
      unsubscribe();
    };
  }, []);
  const scrollToElement = React.useCallback(
    (element, options) => {
      const rect = element.getBoundingClientRect();
      const targetScroll = rect.top + window.scrollY - viewportYOffset;
      window.scrollTo({
        top: Math.max(0, targetScroll),
        behavior: options?.behavior ?? "smooth"
      });
    },
    [viewportYOffset]
  );
  return {
    splitPanel,
    modal,
    flashbar,
    helpPanel,
    windowSize,
    viewportYOffset,
    registerSticky,
    scrollToElement
  };
}
var useLayoutStoreInternal = () => useLayoutStore((state) => state._setWindowSize);

// src/capabilities/layout/LayoutStateProvider.tsx
import { Fragment, jsx } from "react/jsx-runtime";
function LayoutStateProvider({ children }) {
  const setWindowSize = useLayoutStoreInternal();
  React2.useEffect(() => {
    const getWindowSize = () => {
      const width = window.innerWidth;
      if (width < 768)
        return "s";
      if (width < 1024)
        return "m";
      return "l";
    };
    setWindowSize(getWindowSize());
    const handleResize = (0, import_lodash2.debounce)(() => {
      setWindowSize(getWindowSize());
    }, 250);
    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
      handleResize.cancel();
    };
  }, [setWindowSize]);
  return /* @__PURE__ */ jsx(Fragment, { children });
}

// src/capabilities/layout/LayoutSplitPanel.tsx
import * as React4 from "react";
import { createPortal } from "react-dom";
import SplitPanel from "@cloudscape-design/components/split-panel";

// src/capabilities/layout/directRenderingStore.ts
import { create as create6 } from "zustand";
var useDirectRenderingStore = create6((set2, get) => ({
  // Initial state
  splitPanel: void 0,
  helpPanel: void 0,
  // Split panel actions
  splitPanelActions: {
    register: (registration) => {
      const current2 = get().splitPanel;
      if (current2 && current2.id !== registration.id) {
        throw new Error(
          `Split panel collision: Cannot register split panel "${registration.id}" because split panel "${current2.id}" is already registered. Only one split panel can be active at a time.`
        );
      }
      set2({ splitPanel: registration });
    },
    unregister: (id) => {
      const current2 = get().splitPanel;
      if (current2?.id === id) {
        set2({ splitPanel: void 0 });
      }
    },
    updateOpen: (id, open) => {
      const current2 = get().splitPanel;
      if (current2?.id === id) {
        set2({ splitPanel: { ...current2, open } });
      }
    },
    updateSize: (id, size) => {
      const current2 = get().splitPanel;
      if (current2?.id === id) {
        set2({ splitPanel: { ...current2, size } });
      }
    }
  },
  // Help panel actions
  helpPanelActions: {
    register: (registration) => {
      const current2 = get().helpPanel;
      if (current2 && current2.id !== registration.id) {
        throw new Error(
          `Help panel collision: Cannot register help panel "${registration.id}" because help panel "${current2.id}" is already registered. Only one help panel can be active at a time.`
        );
      }
      set2({ helpPanel: registration });
    },
    unregister: (id) => {
      const current2 = get().helpPanel;
      if (current2?.id === id) {
        set2({ helpPanel: void 0 });
      }
    },
    updateOpen: (id, open) => {
      const current2 = get().helpPanel;
      if (current2?.id === id) {
        set2({ helpPanel: { ...current2, open } });
      }
    }
  }
}));

// src/capabilities/layout/useDirectRenderingContainers.tsx
import * as React3 from "react";
import { jsx as jsx2 } from "react/jsx-runtime";
var DirectRenderingContainersContext = React3.createContext(null);
var DirectRenderingContainersProvider = ({ splitPanelContainer, children }) => {
  const containers = React3.useMemo(
    () => ({
      splitPanelContainer
    }),
    [splitPanelContainer]
  );
  return /* @__PURE__ */ jsx2(DirectRenderingContainersContext.Provider, { value: containers, children });
};
var useDirectRenderingContainers = () => {
  const containers = React3.useContext(DirectRenderingContainersContext);
  if (!containers) {
    throw new Error("useDirectRenderingContainers must be used within a DirectRenderingContainersProvider");
  }
  return containers;
};

// src/capabilities/layout/LayoutSplitPanel.tsx
import { jsx as jsx3 } from "react/jsx-runtime";
var InternalSplitPanelWrapper = ({ i18nStrings, ...props }) => {
  const defaultI18nStrings = {
    preferencesTitle: "Split panel preferences",
    preferencesPositionLabel: "Split panel position",
    preferencesPositionDescription: "Choose the default split panel position for the service.",
    preferencesPositionSide: "Side",
    preferencesPositionBottom: "Bottom",
    preferencesConfirm: "Confirm",
    preferencesCancel: "Cancel"
  };
  return /* @__PURE__ */ jsx3(SplitPanel, { i18nStrings: { ...defaultI18nStrings, ...i18nStrings }, ...props });
};
var LayoutSplitPanel = ({
  open = true,
  onToggle,
  onResize,
  onDismiss,
  size,
  children,
  ...splitPanelProps
}) => {
  const portalId = React4.useId();
  const { splitPanelActions } = useDirectRenderingStore();
  const { splitPanelContainer } = useDirectRenderingContainers();
  React4.useEffect(() => {
    splitPanelActions.register({ id: portalId, open, size, onToggle, onResize });
    return () => splitPanelActions.unregister(portalId);
  }, [portalId, splitPanelActions, open, size, onToggle, onResize]);
  React4.useEffect(() => {
    splitPanelActions.updateOpen(portalId, open);
  }, [portalId, open, splitPanelActions]);
  React4.useEffect(() => {
    splitPanelActions.updateSize(portalId, size);
  }, [portalId, size, splitPanelActions]);
  if (!splitPanelContainer) {
    return null;
  }
  return createPortal(/* @__PURE__ */ jsx3(InternalSplitPanelWrapper, { ...splitPanelProps, children }), splitPanelContainer);
};

// src/capabilities/layout/LayoutHelpPanel.tsx
import * as React5 from "react";
var LayoutHelpPanel = ({ open = true, pathslug, onToggle }) => {
  const portalId = React5.useId();
  const { helpPanelActions } = useDirectRenderingStore();
  React5.useEffect(() => {
    helpPanelActions.register({ id: portalId, open, pathslug, onToggle });
    return () => helpPanelActions.unregister(portalId);
  }, [portalId, helpPanelActions, open, pathslug, onToggle]);
  React5.useEffect(() => {
    helpPanelActions.updateOpen(portalId, open);
  }, [portalId, open, helpPanelActions]);
  return null;
};

// src/capabilities/services/useMaxService.ts
import * as React6 from "react";

// ../../node_modules/immer/dist/immer.mjs
var NOTHING = Symbol.for("immer-nothing");
var DRAFTABLE = Symbol.for("immer-draftable");
var DRAFT_STATE = Symbol.for("immer-state");
var errors = true ? [
  // All error codes, starting by 0:
  function(plugin) {
    return `The plugin for '${plugin}' has not been loaded into Immer. To enable the plugin, import and call \`enable${plugin}()\` when initializing your application.`;
  },
  function(thing) {
    return `produce can only be called on things that are draftable: plain objects, arrays, Map, Set or classes that are marked with '[immerable]: true'. Got '${thing}'`;
  },
  "This object has been frozen and should not be mutated",
  function(data) {
    return "Cannot use a proxy that has been revoked. Did you pass an object from inside an immer function to an async process? " + data;
  },
  "An immer producer returned a new value *and* modified its draft. Either return a new value *or* modify the draft.",
  "Immer forbids circular references",
  "The first or second argument to `produce` must be a function",
  "The third argument to `produce` must be a function or undefined",
  "First argument to `createDraft` must be a plain object, an array, or an immerable object",
  "First argument to `finishDraft` must be a draft returned by `createDraft`",
  function(thing) {
    return `'current' expects a draft, got: ${thing}`;
  },
  "Object.defineProperty() cannot be used on an Immer draft",
  "Object.setPrototypeOf() cannot be used on an Immer draft",
  "Immer only supports deleting array indices",
  "Immer only supports setting array indices and the 'length' property",
  function(thing) {
    return `'original' expects a draft, got: ${thing}`;
  }
  // Note: if more errors are added, the errorOffset in Patches.ts should be increased
  // See Patches.ts for additional errors
] : [];
function die(error, ...args) {
  if (true) {
    const e = errors[error];
    const msg = typeof e === "function" ? e.apply(null, args) : e;
    throw new Error(`[Immer] ${msg}`);
  }
  throw new Error(
    `[Immer] minified error nr: ${error}. Full error at: https://bit.ly/3cXEKWf`
  );
}
var getPrototypeOf = Object.getPrototypeOf;
function isDraft(value) {
  return !!value && !!value[DRAFT_STATE];
}
function isDraftable(value) {
  if (!value)
    return false;
  return isPlainObject(value) || Array.isArray(value) || !!value[DRAFTABLE] || !!value.constructor?.[DRAFTABLE] || isMap(value) || isSet(value);
}
var objectCtorString = Object.prototype.constructor.toString();
var cachedCtorStrings = /* @__PURE__ */ new WeakMap();
function isPlainObject(value) {
  if (!value || typeof value !== "object")
    return false;
  const proto = Object.getPrototypeOf(value);
  if (proto === null || proto === Object.prototype)
    return true;
  const Ctor = Object.hasOwnProperty.call(proto, "constructor") && proto.constructor;
  if (Ctor === Object)
    return true;
  if (typeof Ctor !== "function")
    return false;
  let ctorString = cachedCtorStrings.get(Ctor);
  if (ctorString === void 0) {
    ctorString = Function.toString.call(Ctor);
    cachedCtorStrings.set(Ctor, ctorString);
  }
  return ctorString === objectCtorString;
}
function each(obj, iter, strict = true) {
  if (getArchtype(obj) === 0) {
    const keys = strict ? Reflect.ownKeys(obj) : Object.keys(obj);
    keys.forEach((key) => {
      iter(key, obj[key], obj);
    });
  } else {
    obj.forEach((entry, index) => iter(index, entry, obj));
  }
}
function getArchtype(thing) {
  const state = thing[DRAFT_STATE];
  return state ? state.type_ : Array.isArray(thing) ? 1 : isMap(thing) ? 2 : isSet(thing) ? 3 : 0;
}
function has(thing, prop) {
  return getArchtype(thing) === 2 ? thing.has(prop) : Object.prototype.hasOwnProperty.call(thing, prop);
}
function set(thing, propOrOldValue, value) {
  const t = getArchtype(thing);
  if (t === 2)
    thing.set(propOrOldValue, value);
  else if (t === 3) {
    thing.add(value);
  } else
    thing[propOrOldValue] = value;
}
function is(x, y) {
  if (x === y) {
    return x !== 0 || 1 / x === 1 / y;
  } else {
    return x !== x && y !== y;
  }
}
function isMap(target) {
  return target instanceof Map;
}
function isSet(target) {
  return target instanceof Set;
}
function latest(state) {
  return state.copy_ || state.base_;
}
function shallowCopy(base, strict) {
  if (isMap(base)) {
    return new Map(base);
  }
  if (isSet(base)) {
    return new Set(base);
  }
  if (Array.isArray(base))
    return Array.prototype.slice.call(base);
  const isPlain = isPlainObject(base);
  if (strict === true || strict === "class_only" && !isPlain) {
    const descriptors = Object.getOwnPropertyDescriptors(base);
    delete descriptors[DRAFT_STATE];
    let keys = Reflect.ownKeys(descriptors);
    for (let i = 0; i < keys.length; i++) {
      const key = keys[i];
      const desc = descriptors[key];
      if (desc.writable === false) {
        desc.writable = true;
        desc.configurable = true;
      }
      if (desc.get || desc.set)
        descriptors[key] = {
          configurable: true,
          writable: true,
          // could live with !!desc.set as well here...
          enumerable: desc.enumerable,
          value: base[key]
        };
    }
    return Object.create(getPrototypeOf(base), descriptors);
  } else {
    const proto = getPrototypeOf(base);
    if (proto !== null && isPlain) {
      return { ...base };
    }
    const obj = Object.create(proto);
    return Object.assign(obj, base);
  }
}
function freeze(obj, deep = false) {
  if (isFrozen(obj) || isDraft(obj) || !isDraftable(obj))
    return obj;
  if (getArchtype(obj) > 1) {
    Object.defineProperties(obj, {
      set: dontMutateMethodOverride,
      add: dontMutateMethodOverride,
      clear: dontMutateMethodOverride,
      delete: dontMutateMethodOverride
    });
  }
  Object.freeze(obj);
  if (deep)
    Object.values(obj).forEach((value) => freeze(value, true));
  return obj;
}
function dontMutateFrozenCollections() {
  die(2);
}
var dontMutateMethodOverride = {
  value: dontMutateFrozenCollections
};
function isFrozen(obj) {
  if (obj === null || typeof obj !== "object")
    return true;
  return Object.isFrozen(obj);
}
var plugins = {};
function getPlugin(pluginKey) {
  const plugin = plugins[pluginKey];
  if (!plugin) {
    die(0, pluginKey);
  }
  return plugin;
}
function loadPlugin(pluginKey, implementation) {
  if (!plugins[pluginKey])
    plugins[pluginKey] = implementation;
}
var currentScope;
function getCurrentScope() {
  return currentScope;
}
function createScope(parent_, immer_) {
  return {
    drafts_: [],
    parent_,
    immer_,
    // Whenever the modified draft contains a draft from another scope, we
    // need to prevent auto-freezing so the unowned draft can be finalized.
    canAutoFreeze_: true,
    unfinalizedDrafts_: 0
  };
}
function usePatchesInScope(scope, patchListener) {
  if (patchListener) {
    getPlugin("Patches");
    scope.patches_ = [];
    scope.inversePatches_ = [];
    scope.patchListener_ = patchListener;
  }
}
function revokeScope(scope) {
  leaveScope(scope);
  scope.drafts_.forEach(revokeDraft);
  scope.drafts_ = null;
}
function leaveScope(scope) {
  if (scope === currentScope) {
    currentScope = scope.parent_;
  }
}
function enterScope(immer2) {
  return currentScope = createScope(currentScope, immer2);
}
function revokeDraft(draft) {
  const state = draft[DRAFT_STATE];
  if (state.type_ === 0 || state.type_ === 1)
    state.revoke_();
  else
    state.revoked_ = true;
}
function processResult(result, scope) {
  scope.unfinalizedDrafts_ = scope.drafts_.length;
  const baseDraft = scope.drafts_[0];
  const isReplaced = result !== void 0 && result !== baseDraft;
  if (isReplaced) {
    if (baseDraft[DRAFT_STATE].modified_) {
      revokeScope(scope);
      die(4);
    }
    if (isDraftable(result)) {
      result = finalize(scope, result);
      if (!scope.parent_)
        maybeFreeze(scope, result);
    }
    if (scope.patches_) {
      getPlugin("Patches").generateReplacementPatches_(
        baseDraft[DRAFT_STATE].base_,
        result,
        scope.patches_,
        scope.inversePatches_
      );
    }
  } else {
    result = finalize(scope, baseDraft, []);
  }
  revokeScope(scope);
  if (scope.patches_) {
    scope.patchListener_(scope.patches_, scope.inversePatches_);
  }
  return result !== NOTHING ? result : void 0;
}
function finalize(rootScope, value, path) {
  if (isFrozen(value))
    return value;
  const useStrictIteration = rootScope.immer_.shouldUseStrictIteration();
  const state = value[DRAFT_STATE];
  if (!state) {
    each(
      value,
      (key, childValue) => finalizeProperty(rootScope, state, value, key, childValue, path),
      useStrictIteration
    );
    return value;
  }
  if (state.scope_ !== rootScope)
    return value;
  if (!state.modified_) {
    maybeFreeze(rootScope, state.base_, true);
    return state.base_;
  }
  if (!state.finalized_) {
    state.finalized_ = true;
    state.scope_.unfinalizedDrafts_--;
    const result = state.copy_;
    let resultEach = result;
    let isSet2 = false;
    if (state.type_ === 3) {
      resultEach = new Set(result);
      result.clear();
      isSet2 = true;
    }
    each(
      resultEach,
      (key, childValue) => finalizeProperty(
        rootScope,
        state,
        result,
        key,
        childValue,
        path,
        isSet2
      ),
      useStrictIteration
    );
    maybeFreeze(rootScope, result, false);
    if (path && rootScope.patches_) {
      getPlugin("Patches").generatePatches_(
        state,
        path,
        rootScope.patches_,
        rootScope.inversePatches_
      );
    }
  }
  return state.copy_;
}
function finalizeProperty(rootScope, parentState, targetObject, prop, childValue, rootPath, targetIsSet) {
  if (childValue == null) {
    return;
  }
  if (typeof childValue !== "object" && !targetIsSet) {
    return;
  }
  const childIsFrozen = isFrozen(childValue);
  if (childIsFrozen && !targetIsSet) {
    return;
  }
  if (childValue === targetObject)
    die(5);
  if (isDraft(childValue)) {
    const path = rootPath && parentState && parentState.type_ !== 3 && // Set objects are atomic since they have no keys.
    !has(parentState.assigned_, prop) ? rootPath.concat(prop) : void 0;
    const res = finalize(rootScope, childValue, path);
    set(targetObject, prop, res);
    if (isDraft(res)) {
      rootScope.canAutoFreeze_ = false;
    } else
      return;
  } else if (targetIsSet) {
    targetObject.add(childValue);
  }
  if (isDraftable(childValue) && !childIsFrozen) {
    if (!rootScope.immer_.autoFreeze_ && rootScope.unfinalizedDrafts_ < 1) {
      return;
    }
    if (parentState && parentState.base_ && parentState.base_[prop] === childValue && childIsFrozen) {
      return;
    }
    finalize(rootScope, childValue);
    if ((!parentState || !parentState.scope_.parent_) && typeof prop !== "symbol" && (isMap(targetObject) ? targetObject.has(prop) : Object.prototype.propertyIsEnumerable.call(targetObject, prop)))
      maybeFreeze(rootScope, childValue);
  }
}
function maybeFreeze(scope, value, deep = false) {
  if (!scope.parent_ && scope.immer_.autoFreeze_ && scope.canAutoFreeze_) {
    freeze(value, deep);
  }
}
function createProxyProxy(base, parent) {
  const isArray = Array.isArray(base);
  const state = {
    type_: isArray ? 1 : 0,
    // Track which produce call this is associated with.
    scope_: parent ? parent.scope_ : getCurrentScope(),
    // True for both shallow and deep changes.
    modified_: false,
    // Used during finalization.
    finalized_: false,
    // Track which properties have been assigned (true) or deleted (false).
    assigned_: {},
    // The parent draft state.
    parent_: parent,
    // The base state.
    base_: base,
    // The base proxy.
    draft_: null,
    // set below
    // The base copy with any updated values.
    copy_: null,
    // Called by the `produce` function.
    revoke_: null,
    isManual_: false
  };
  let target = state;
  let traps = objectTraps;
  if (isArray) {
    target = [state];
    traps = arrayTraps;
  }
  const { revoke, proxy } = Proxy.revocable(target, traps);
  state.draft_ = proxy;
  state.revoke_ = revoke;
  return proxy;
}
var objectTraps = {
  get(state, prop) {
    if (prop === DRAFT_STATE)
      return state;
    const source = latest(state);
    if (!has(source, prop)) {
      return readPropFromProto(state, source, prop);
    }
    const value = source[prop];
    if (state.finalized_ || !isDraftable(value)) {
      return value;
    }
    if (value === peek(state.base_, prop)) {
      prepareCopy(state);
      return state.copy_[prop] = createProxy(value, state);
    }
    return value;
  },
  has(state, prop) {
    return prop in latest(state);
  },
  ownKeys(state) {
    return Reflect.ownKeys(latest(state));
  },
  set(state, prop, value) {
    const desc = getDescriptorFromProto(latest(state), prop);
    if (desc?.set) {
      desc.set.call(state.draft_, value);
      return true;
    }
    if (!state.modified_) {
      const current2 = peek(latest(state), prop);
      const currentState = current2?.[DRAFT_STATE];
      if (currentState && currentState.base_ === value) {
        state.copy_[prop] = value;
        state.assigned_[prop] = false;
        return true;
      }
      if (is(value, current2) && (value !== void 0 || has(state.base_, prop)))
        return true;
      prepareCopy(state);
      markChanged(state);
    }
    if (state.copy_[prop] === value && // special case: handle new props with value 'undefined'
    (value !== void 0 || prop in state.copy_) || // special case: NaN
    Number.isNaN(value) && Number.isNaN(state.copy_[prop]))
      return true;
    state.copy_[prop] = value;
    state.assigned_[prop] = true;
    return true;
  },
  deleteProperty(state, prop) {
    if (peek(state.base_, prop) !== void 0 || prop in state.base_) {
      state.assigned_[prop] = false;
      prepareCopy(state);
      markChanged(state);
    } else {
      delete state.assigned_[prop];
    }
    if (state.copy_) {
      delete state.copy_[prop];
    }
    return true;
  },
  // Note: We never coerce `desc.value` into an Immer draft, because we can't make
  // the same guarantee in ES5 mode.
  getOwnPropertyDescriptor(state, prop) {
    const owner = latest(state);
    const desc = Reflect.getOwnPropertyDescriptor(owner, prop);
    if (!desc)
      return desc;
    return {
      writable: true,
      configurable: state.type_ !== 1 || prop !== "length",
      enumerable: desc.enumerable,
      value: owner[prop]
    };
  },
  defineProperty() {
    die(11);
  },
  getPrototypeOf(state) {
    return getPrototypeOf(state.base_);
  },
  setPrototypeOf() {
    die(12);
  }
};
var arrayTraps = {};
each(objectTraps, (key, fn) => {
  arrayTraps[key] = function() {
    arguments[0] = arguments[0][0];
    return fn.apply(this, arguments);
  };
});
arrayTraps.deleteProperty = function(state, prop) {
  if (isNaN(parseInt(prop)))
    die(13);
  return arrayTraps.set.call(this, state, prop, void 0);
};
arrayTraps.set = function(state, prop, value) {
  if (prop !== "length" && isNaN(parseInt(prop)))
    die(14);
  return objectTraps.set.call(this, state[0], prop, value, state[0]);
};
function peek(draft, prop) {
  const state = draft[DRAFT_STATE];
  const source = state ? latest(state) : draft;
  return source[prop];
}
function readPropFromProto(state, source, prop) {
  const desc = getDescriptorFromProto(source, prop);
  return desc ? `value` in desc ? desc.value : (
    // This is a very special case, if the prop is a getter defined by the
    // prototype, we should invoke it with the draft as context!
    desc.get?.call(state.draft_)
  ) : void 0;
}
function getDescriptorFromProto(source, prop) {
  if (!(prop in source))
    return void 0;
  let proto = getPrototypeOf(source);
  while (proto) {
    const desc = Object.getOwnPropertyDescriptor(proto, prop);
    if (desc)
      return desc;
    proto = getPrototypeOf(proto);
  }
  return void 0;
}
function markChanged(state) {
  if (!state.modified_) {
    state.modified_ = true;
    if (state.parent_) {
      markChanged(state.parent_);
    }
  }
}
function prepareCopy(state) {
  if (!state.copy_) {
    state.copy_ = shallowCopy(
      state.base_,
      state.scope_.immer_.useStrictShallowCopy_
    );
  }
}
var Immer2 = class {
  constructor(config) {
    this.autoFreeze_ = true;
    this.useStrictShallowCopy_ = false;
    this.useStrictIteration_ = true;
    this.produce = (base, recipe, patchListener) => {
      if (typeof base === "function" && typeof recipe !== "function") {
        const defaultBase = recipe;
        recipe = base;
        const self2 = this;
        return function curriedProduce(base2 = defaultBase, ...args) {
          return self2.produce(base2, (draft) => recipe.call(this, draft, ...args));
        };
      }
      if (typeof recipe !== "function")
        die(6);
      if (patchListener !== void 0 && typeof patchListener !== "function")
        die(7);
      let result;
      if (isDraftable(base)) {
        const scope = enterScope(this);
        const proxy = createProxy(base, void 0);
        let hasError = true;
        try {
          result = recipe(proxy);
          hasError = false;
        } finally {
          if (hasError)
            revokeScope(scope);
          else
            leaveScope(scope);
        }
        usePatchesInScope(scope, patchListener);
        return processResult(result, scope);
      } else if (!base || typeof base !== "object") {
        result = recipe(base);
        if (result === void 0)
          result = base;
        if (result === NOTHING)
          result = void 0;
        if (this.autoFreeze_)
          freeze(result, true);
        if (patchListener) {
          const p = [];
          const ip = [];
          getPlugin("Patches").generateReplacementPatches_(base, result, p, ip);
          patchListener(p, ip);
        }
        return result;
      } else
        die(1, base);
    };
    this.produceWithPatches = (base, recipe) => {
      if (typeof base === "function") {
        return (state, ...args) => this.produceWithPatches(state, (draft) => base(draft, ...args));
      }
      let patches, inversePatches;
      const result = this.produce(base, recipe, (p, ip) => {
        patches = p;
        inversePatches = ip;
      });
      return [result, patches, inversePatches];
    };
    if (typeof config?.autoFreeze === "boolean")
      this.setAutoFreeze(config.autoFreeze);
    if (typeof config?.useStrictShallowCopy === "boolean")
      this.setUseStrictShallowCopy(config.useStrictShallowCopy);
    if (typeof config?.useStrictIteration === "boolean")
      this.setUseStrictIteration(config.useStrictIteration);
  }
  createDraft(base) {
    if (!isDraftable(base))
      die(8);
    if (isDraft(base))
      base = current(base);
    const scope = enterScope(this);
    const proxy = createProxy(base, void 0);
    proxy[DRAFT_STATE].isManual_ = true;
    leaveScope(scope);
    return proxy;
  }
  finishDraft(draft, patchListener) {
    const state = draft && draft[DRAFT_STATE];
    if (!state || !state.isManual_)
      die(9);
    const { scope_: scope } = state;
    usePatchesInScope(scope, patchListener);
    return processResult(void 0, scope);
  }
  /**
   * Pass true to automatically freeze all copies created by Immer.
   *
   * By default, auto-freezing is enabled.
   */
  setAutoFreeze(value) {
    this.autoFreeze_ = value;
  }
  /**
   * Pass true to enable strict shallow copy.
   *
   * By default, immer does not copy the object descriptors such as getter, setter and non-enumrable properties.
   */
  setUseStrictShallowCopy(value) {
    this.useStrictShallowCopy_ = value;
  }
  /**
   * Pass false to use faster iteration that skips non-enumerable properties
   * but still handles symbols for compatibility.
   *
   * By default, strict iteration is enabled (includes all own properties).
   */
  setUseStrictIteration(value) {
    this.useStrictIteration_ = value;
  }
  shouldUseStrictIteration() {
    return this.useStrictIteration_;
  }
  applyPatches(base, patches) {
    let i;
    for (i = patches.length - 1; i >= 0; i--) {
      const patch = patches[i];
      if (patch.path.length === 0 && patch.op === "replace") {
        base = patch.value;
        break;
      }
    }
    if (i > -1) {
      patches = patches.slice(i + 1);
    }
    const applyPatchesImpl = getPlugin("Patches").applyPatches_;
    if (isDraft(base)) {
      return applyPatchesImpl(base, patches);
    }
    return this.produce(
      base,
      (draft) => applyPatchesImpl(draft, patches)
    );
  }
};
function createProxy(value, parent) {
  const draft = isMap(value) ? getPlugin("MapSet").proxyMap_(value, parent) : isSet(value) ? getPlugin("MapSet").proxySet_(value, parent) : createProxyProxy(value, parent);
  const scope = parent ? parent.scope_ : getCurrentScope();
  scope.drafts_.push(draft);
  return draft;
}
function current(value) {
  if (!isDraft(value))
    die(10, value);
  return currentImpl(value);
}
function currentImpl(value) {
  if (!isDraftable(value) || isFrozen(value))
    return value;
  const state = value[DRAFT_STATE];
  let copy;
  let strict = true;
  if (state) {
    if (!state.modified_)
      return state.base_;
    state.finalized_ = true;
    copy = shallowCopy(value, state.scope_.immer_.useStrictShallowCopy_);
    strict = state.scope_.immer_.shouldUseStrictIteration();
  } else {
    copy = shallowCopy(value, true);
  }
  each(
    copy,
    (key, childValue) => {
      set(copy, key, currentImpl(childValue));
    },
    strict
  );
  if (state) {
    state.finalized_ = false;
  }
  return copy;
}
function enableMapSet() {
  class DraftMap extends Map {
    constructor(target, parent) {
      super();
      this[DRAFT_STATE] = {
        type_: 2,
        parent_: parent,
        scope_: parent ? parent.scope_ : getCurrentScope(),
        modified_: false,
        finalized_: false,
        copy_: void 0,
        assigned_: void 0,
        base_: target,
        draft_: this,
        isManual_: false,
        revoked_: false
      };
    }
    get size() {
      return latest(this[DRAFT_STATE]).size;
    }
    has(key) {
      return latest(this[DRAFT_STATE]).has(key);
    }
    set(key, value) {
      const state = this[DRAFT_STATE];
      assertUnrevoked(state);
      if (!latest(state).has(key) || latest(state).get(key) !== value) {
        prepareMapCopy(state);
        markChanged(state);
        state.assigned_.set(key, true);
        state.copy_.set(key, value);
        state.assigned_.set(key, true);
      }
      return this;
    }
    delete(key) {
      if (!this.has(key)) {
        return false;
      }
      const state = this[DRAFT_STATE];
      assertUnrevoked(state);
      prepareMapCopy(state);
      markChanged(state);
      if (state.base_.has(key)) {
        state.assigned_.set(key, false);
      } else {
        state.assigned_.delete(key);
      }
      state.copy_.delete(key);
      return true;
    }
    clear() {
      const state = this[DRAFT_STATE];
      assertUnrevoked(state);
      if (latest(state).size) {
        prepareMapCopy(state);
        markChanged(state);
        state.assigned_ = /* @__PURE__ */ new Map();
        each(state.base_, (key) => {
          state.assigned_.set(key, false);
        });
        state.copy_.clear();
      }
    }
    forEach(cb, thisArg) {
      const state = this[DRAFT_STATE];
      latest(state).forEach((_value, key, _map) => {
        cb.call(thisArg, this.get(key), key, this);
      });
    }
    get(key) {
      const state = this[DRAFT_STATE];
      assertUnrevoked(state);
      const value = latest(state).get(key);
      if (state.finalized_ || !isDraftable(value)) {
        return value;
      }
      if (value !== state.base_.get(key)) {
        return value;
      }
      const draft = createProxy(value, state);
      prepareMapCopy(state);
      state.copy_.set(key, draft);
      return draft;
    }
    keys() {
      return latest(this[DRAFT_STATE]).keys();
    }
    values() {
      const iterator = this.keys();
      return {
        [Symbol.iterator]: () => this.values(),
        next: () => {
          const r = iterator.next();
          if (r.done)
            return r;
          const value = this.get(r.value);
          return {
            done: false,
            value
          };
        }
      };
    }
    entries() {
      const iterator = this.keys();
      return {
        [Symbol.iterator]: () => this.entries(),
        next: () => {
          const r = iterator.next();
          if (r.done)
            return r;
          const value = this.get(r.value);
          return {
            done: false,
            value: [r.value, value]
          };
        }
      };
    }
    [(DRAFT_STATE, Symbol.iterator)]() {
      return this.entries();
    }
  }
  function proxyMap_(target, parent) {
    return new DraftMap(target, parent);
  }
  function prepareMapCopy(state) {
    if (!state.copy_) {
      state.assigned_ = /* @__PURE__ */ new Map();
      state.copy_ = new Map(state.base_);
    }
  }
  class DraftSet extends Set {
    constructor(target, parent) {
      super();
      this[DRAFT_STATE] = {
        type_: 3,
        parent_: parent,
        scope_: parent ? parent.scope_ : getCurrentScope(),
        modified_: false,
        finalized_: false,
        copy_: void 0,
        base_: target,
        draft_: this,
        drafts_: /* @__PURE__ */ new Map(),
        revoked_: false,
        isManual_: false
      };
    }
    get size() {
      return latest(this[DRAFT_STATE]).size;
    }
    has(value) {
      const state = this[DRAFT_STATE];
      assertUnrevoked(state);
      if (!state.copy_) {
        return state.base_.has(value);
      }
      if (state.copy_.has(value))
        return true;
      if (state.drafts_.has(value) && state.copy_.has(state.drafts_.get(value)))
        return true;
      return false;
    }
    add(value) {
      const state = this[DRAFT_STATE];
      assertUnrevoked(state);
      if (!this.has(value)) {
        prepareSetCopy(state);
        markChanged(state);
        state.copy_.add(value);
      }
      return this;
    }
    delete(value) {
      if (!this.has(value)) {
        return false;
      }
      const state = this[DRAFT_STATE];
      assertUnrevoked(state);
      prepareSetCopy(state);
      markChanged(state);
      return state.copy_.delete(value) || (state.drafts_.has(value) ? state.copy_.delete(state.drafts_.get(value)) : (
        /* istanbul ignore next */
        false
      ));
    }
    clear() {
      const state = this[DRAFT_STATE];
      assertUnrevoked(state);
      if (latest(state).size) {
        prepareSetCopy(state);
        markChanged(state);
        state.copy_.clear();
      }
    }
    values() {
      const state = this[DRAFT_STATE];
      assertUnrevoked(state);
      prepareSetCopy(state);
      return state.copy_.values();
    }
    entries() {
      const state = this[DRAFT_STATE];
      assertUnrevoked(state);
      prepareSetCopy(state);
      return state.copy_.entries();
    }
    keys() {
      return this.values();
    }
    [(DRAFT_STATE, Symbol.iterator)]() {
      return this.values();
    }
    forEach(cb, thisArg) {
      const iterator = this.values();
      let result = iterator.next();
      while (!result.done) {
        cb.call(thisArg, result.value, result.value, this);
        result = iterator.next();
      }
    }
  }
  function proxySet_(target, parent) {
    return new DraftSet(target, parent);
  }
  function prepareSetCopy(state) {
    if (!state.copy_) {
      state.copy_ = /* @__PURE__ */ new Set();
      state.base_.forEach((value) => {
        if (isDraftable(value)) {
          const draft = createProxy(value, state);
          state.drafts_.set(value, draft);
          state.copy_.add(draft);
        } else {
          state.copy_.add(value);
        }
      });
    }
  }
  function assertUnrevoked(state) {
    if (state.revoked_)
      die(3, JSON.stringify(latest(state)));
  }
  loadPlugin("MapSet", { proxyMap_, proxySet_ });
}
var immer = new Immer2();
var produce = immer.produce;

// src/capabilities/services/useMaxService.ts
import { unstable_batchedUpdates } from "react-dom";

// src/capabilities/services/ThrottleError.ts
var ThrottleError = class extends Error {
  constructor(cause) {
    super("Request throttled", { cause });
    this.name = "ThrottleError";
  }
};

// src/capabilities/services/useMaxService.ts
import {
  TurnStatus as TurnStatus2,
  ContentBlockVisibility
} from "@amzn/awsmp-max-model";

// ../../node_modules/fast-json-patch/module/core.mjs
var core_exports = {};
__export(core_exports, {
  JsonPatchError: () => JsonPatchError,
  _areEquals: () => _areEquals,
  applyOperation: () => applyOperation,
  applyPatch: () => applyPatch,
  applyReducer: () => applyReducer,
  deepClone: () => deepClone,
  getValueByPointer: () => getValueByPointer,
  validate: () => validate,
  validator: () => validator
});

// ../../node_modules/fast-json-patch/module/helpers.mjs
var __extends = /* @__PURE__ */ function() {
  var extendStatics = function(d, b) {
    extendStatics = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(d2, b2) {
      d2.__proto__ = b2;
    } || function(d2, b2) {
      for (var p in b2)
        if (b2.hasOwnProperty(p))
          d2[p] = b2[p];
    };
    return extendStatics(d, b);
  };
  return function(d, b) {
    extendStatics(d, b);
    function __() {
      this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();
var _hasOwnProperty = Object.prototype.hasOwnProperty;
function hasOwnProperty(obj, key) {
  return _hasOwnProperty.call(obj, key);
}
function _objectKeys(obj) {
  if (Array.isArray(obj)) {
    var keys_1 = new Array(obj.length);
    for (var k = 0; k < keys_1.length; k++) {
      keys_1[k] = "" + k;
    }
    return keys_1;
  }
  if (Object.keys) {
    return Object.keys(obj);
  }
  var keys = [];
  for (var i in obj) {
    if (hasOwnProperty(obj, i)) {
      keys.push(i);
    }
  }
  return keys;
}
function _deepClone(obj) {
  switch (typeof obj) {
    case "object":
      return JSON.parse(JSON.stringify(obj));
    case "undefined":
      return null;
    default:
      return obj;
  }
}
function isInteger(str) {
  var i = 0;
  var len = str.length;
  var charCode;
  while (i < len) {
    charCode = str.charCodeAt(i);
    if (charCode >= 48 && charCode <= 57) {
      i++;
      continue;
    }
    return false;
  }
  return true;
}
function escapePathComponent(path) {
  if (path.indexOf("/") === -1 && path.indexOf("~") === -1)
    return path;
  return path.replace(/~/g, "~0").replace(/\//g, "~1");
}
function unescapePathComponent(path) {
  return path.replace(/~1/g, "/").replace(/~0/g, "~");
}
function hasUndefined(obj) {
  if (obj === void 0) {
    return true;
  }
  if (obj) {
    if (Array.isArray(obj)) {
      for (var i_1 = 0, len = obj.length; i_1 < len; i_1++) {
        if (hasUndefined(obj[i_1])) {
          return true;
        }
      }
    } else if (typeof obj === "object") {
      var objKeys = _objectKeys(obj);
      var objKeysLength = objKeys.length;
      for (var i = 0; i < objKeysLength; i++) {
        if (hasUndefined(obj[objKeys[i]])) {
          return true;
        }
      }
    }
  }
  return false;
}
function patchErrorMessageFormatter(message, args) {
  var messageParts = [message];
  for (var key in args) {
    var value = typeof args[key] === "object" ? JSON.stringify(args[key], null, 2) : args[key];
    if (typeof value !== "undefined") {
      messageParts.push(key + ": " + value);
    }
  }
  return messageParts.join("\n");
}
var PatchError = (
  /** @class */
  function(_super) {
    __extends(PatchError2, _super);
    function PatchError2(message, name, index, operation, tree) {
      var _newTarget = this.constructor;
      var _this = _super.call(this, patchErrorMessageFormatter(message, { name, index, operation, tree })) || this;
      _this.name = name;
      _this.index = index;
      _this.operation = operation;
      _this.tree = tree;
      Object.setPrototypeOf(_this, _newTarget.prototype);
      _this.message = patchErrorMessageFormatter(message, { name, index, operation, tree });
      return _this;
    }
    return PatchError2;
  }(Error)
);

// ../../node_modules/fast-json-patch/module/core.mjs
var JsonPatchError = PatchError;
var deepClone = _deepClone;
var objOps = {
  add: function(obj, key, document2) {
    obj[key] = this.value;
    return { newDocument: document2 };
  },
  remove: function(obj, key, document2) {
    var removed = obj[key];
    delete obj[key];
    return { newDocument: document2, removed };
  },
  replace: function(obj, key, document2) {
    var removed = obj[key];
    obj[key] = this.value;
    return { newDocument: document2, removed };
  },
  move: function(obj, key, document2) {
    var removed = getValueByPointer(document2, this.path);
    if (removed) {
      removed = _deepClone(removed);
    }
    var originalValue = applyOperation(document2, { op: "remove", path: this.from }).removed;
    applyOperation(document2, { op: "add", path: this.path, value: originalValue });
    return { newDocument: document2, removed };
  },
  copy: function(obj, key, document2) {
    var valueToCopy = getValueByPointer(document2, this.from);
    applyOperation(document2, { op: "add", path: this.path, value: _deepClone(valueToCopy) });
    return { newDocument: document2 };
  },
  test: function(obj, key, document2) {
    return { newDocument: document2, test: _areEquals(obj[key], this.value) };
  },
  _get: function(obj, key, document2) {
    this.value = obj[key];
    return { newDocument: document2 };
  }
};
var arrOps = {
  add: function(arr, i, document2) {
    if (isInteger(i)) {
      arr.splice(i, 0, this.value);
    } else {
      arr[i] = this.value;
    }
    return { newDocument: document2, index: i };
  },
  remove: function(arr, i, document2) {
    var removedList = arr.splice(i, 1);
    return { newDocument: document2, removed: removedList[0] };
  },
  replace: function(arr, i, document2) {
    var removed = arr[i];
    arr[i] = this.value;
    return { newDocument: document2, removed };
  },
  move: objOps.move,
  copy: objOps.copy,
  test: objOps.test,
  _get: objOps._get
};
function getValueByPointer(document2, pointer) {
  if (pointer == "") {
    return document2;
  }
  var getOriginalDestination = { op: "_get", path: pointer };
  applyOperation(document2, getOriginalDestination);
  return getOriginalDestination.value;
}
function applyOperation(document2, operation, validateOperation, mutateDocument, banPrototypeModifications, index) {
  if (validateOperation === void 0) {
    validateOperation = false;
  }
  if (mutateDocument === void 0) {
    mutateDocument = true;
  }
  if (banPrototypeModifications === void 0) {
    banPrototypeModifications = true;
  }
  if (index === void 0) {
    index = 0;
  }
  if (validateOperation) {
    if (typeof validateOperation == "function") {
      validateOperation(operation, 0, document2, operation.path);
    } else {
      validator(operation, 0);
    }
  }
  if (operation.path === "") {
    var returnValue = { newDocument: document2 };
    if (operation.op === "add") {
      returnValue.newDocument = operation.value;
      return returnValue;
    } else if (operation.op === "replace") {
      returnValue.newDocument = operation.value;
      returnValue.removed = document2;
      return returnValue;
    } else if (operation.op === "move" || operation.op === "copy") {
      returnValue.newDocument = getValueByPointer(document2, operation.from);
      if (operation.op === "move") {
        returnValue.removed = document2;
      }
      return returnValue;
    } else if (operation.op === "test") {
      returnValue.test = _areEquals(document2, operation.value);
      if (returnValue.test === false) {
        throw new JsonPatchError("Test operation failed", "TEST_OPERATION_FAILED", index, operation, document2);
      }
      returnValue.newDocument = document2;
      return returnValue;
    } else if (operation.op === "remove") {
      returnValue.removed = document2;
      returnValue.newDocument = null;
      return returnValue;
    } else if (operation.op === "_get") {
      operation.value = document2;
      return returnValue;
    } else {
      if (validateOperation) {
        throw new JsonPatchError("Operation `op` property is not one of operations defined in RFC-6902", "OPERATION_OP_INVALID", index, operation, document2);
      } else {
        return returnValue;
      }
    }
  } else {
    if (!mutateDocument) {
      document2 = _deepClone(document2);
    }
    var path = operation.path || "";
    var keys = path.split("/");
    var obj = document2;
    var t = 1;
    var len = keys.length;
    var existingPathFragment = void 0;
    var key = void 0;
    var validateFunction = void 0;
    if (typeof validateOperation == "function") {
      validateFunction = validateOperation;
    } else {
      validateFunction = validator;
    }
    while (true) {
      key = keys[t];
      if (key && key.indexOf("~") != -1) {
        key = unescapePathComponent(key);
      }
      if (banPrototypeModifications && (key == "__proto__" || key == "prototype" && t > 0 && keys[t - 1] == "constructor")) {
        throw new TypeError("JSON-Patch: modifying `__proto__` or `constructor/prototype` prop is banned for security reasons, if this was on purpose, please set `banPrototypeModifications` flag false and pass it to this function. More info in fast-json-patch README");
      }
      if (validateOperation) {
        if (existingPathFragment === void 0) {
          if (obj[key] === void 0) {
            existingPathFragment = keys.slice(0, t).join("/");
          } else if (t == len - 1) {
            existingPathFragment = operation.path;
          }
          if (existingPathFragment !== void 0) {
            validateFunction(operation, 0, document2, existingPathFragment);
          }
        }
      }
      t++;
      if (Array.isArray(obj)) {
        if (key === "-") {
          key = obj.length;
        } else {
          if (validateOperation && !isInteger(key)) {
            throw new JsonPatchError("Expected an unsigned base-10 integer value, making the new referenced value the array element with the zero-based index", "OPERATION_PATH_ILLEGAL_ARRAY_INDEX", index, operation, document2);
          } else if (isInteger(key)) {
            key = ~~key;
          }
        }
        if (t >= len) {
          if (validateOperation && operation.op === "add" && key > obj.length) {
            throw new JsonPatchError("The specified index MUST NOT be greater than the number of elements in the array", "OPERATION_VALUE_OUT_OF_BOUNDS", index, operation, document2);
          }
          var returnValue = arrOps[operation.op].call(operation, obj, key, document2);
          if (returnValue.test === false) {
            throw new JsonPatchError("Test operation failed", "TEST_OPERATION_FAILED", index, operation, document2);
          }
          return returnValue;
        }
      } else {
        if (t >= len) {
          var returnValue = objOps[operation.op].call(operation, obj, key, document2);
          if (returnValue.test === false) {
            throw new JsonPatchError("Test operation failed", "TEST_OPERATION_FAILED", index, operation, document2);
          }
          return returnValue;
        }
      }
      obj = obj[key];
      if (validateOperation && t < len && (!obj || typeof obj !== "object")) {
        throw new JsonPatchError("Cannot perform operation at the desired path", "OPERATION_PATH_UNRESOLVABLE", index, operation, document2);
      }
    }
  }
}
function applyPatch(document2, patch, validateOperation, mutateDocument, banPrototypeModifications) {
  if (mutateDocument === void 0) {
    mutateDocument = true;
  }
  if (banPrototypeModifications === void 0) {
    banPrototypeModifications = true;
  }
  if (validateOperation) {
    if (!Array.isArray(patch)) {
      throw new JsonPatchError("Patch sequence must be an array", "SEQUENCE_NOT_AN_ARRAY");
    }
  }
  if (!mutateDocument) {
    document2 = _deepClone(document2);
  }
  var results = new Array(patch.length);
  for (var i = 0, length_1 = patch.length; i < length_1; i++) {
    results[i] = applyOperation(document2, patch[i], validateOperation, true, banPrototypeModifications, i);
    document2 = results[i].newDocument;
  }
  results.newDocument = document2;
  return results;
}
function applyReducer(document2, operation, index) {
  var operationResult = applyOperation(document2, operation);
  if (operationResult.test === false) {
    throw new JsonPatchError("Test operation failed", "TEST_OPERATION_FAILED", index, operation, document2);
  }
  return operationResult.newDocument;
}
function validator(operation, index, document2, existingPathFragment) {
  if (typeof operation !== "object" || operation === null || Array.isArray(operation)) {
    throw new JsonPatchError("Operation is not an object", "OPERATION_NOT_AN_OBJECT", index, operation, document2);
  } else if (!objOps[operation.op]) {
    throw new JsonPatchError("Operation `op` property is not one of operations defined in RFC-6902", "OPERATION_OP_INVALID", index, operation, document2);
  } else if (typeof operation.path !== "string") {
    throw new JsonPatchError("Operation `path` property is not a string", "OPERATION_PATH_INVALID", index, operation, document2);
  } else if (operation.path.indexOf("/") !== 0 && operation.path.length > 0) {
    throw new JsonPatchError('Operation `path` property must start with "/"', "OPERATION_PATH_INVALID", index, operation, document2);
  } else if ((operation.op === "move" || operation.op === "copy") && typeof operation.from !== "string") {
    throw new JsonPatchError("Operation `from` property is not present (applicable in `move` and `copy` operations)", "OPERATION_FROM_REQUIRED", index, operation, document2);
  } else if ((operation.op === "add" || operation.op === "replace" || operation.op === "test") && operation.value === void 0) {
    throw new JsonPatchError("Operation `value` property is not present (applicable in `add`, `replace` and `test` operations)", "OPERATION_VALUE_REQUIRED", index, operation, document2);
  } else if ((operation.op === "add" || operation.op === "replace" || operation.op === "test") && hasUndefined(operation.value)) {
    throw new JsonPatchError("Operation `value` property is not present (applicable in `add`, `replace` and `test` operations)", "OPERATION_VALUE_CANNOT_CONTAIN_UNDEFINED", index, operation, document2);
  } else if (document2) {
    if (operation.op == "add") {
      var pathLen = operation.path.split("/").length;
      var existingPathLen = existingPathFragment.split("/").length;
      if (pathLen !== existingPathLen + 1 && pathLen !== existingPathLen) {
        throw new JsonPatchError("Cannot perform an `add` operation at the desired path", "OPERATION_PATH_CANNOT_ADD", index, operation, document2);
      }
    } else if (operation.op === "replace" || operation.op === "remove" || operation.op === "_get") {
      if (operation.path !== existingPathFragment) {
        throw new JsonPatchError("Cannot perform the operation at a path that does not exist", "OPERATION_PATH_UNRESOLVABLE", index, operation, document2);
      }
    } else if (operation.op === "move" || operation.op === "copy") {
      var existingValue = { op: "_get", path: operation.from, value: void 0 };
      var error = validate([existingValue], document2);
      if (error && error.name === "OPERATION_PATH_UNRESOLVABLE") {
        throw new JsonPatchError("Cannot perform the operation from a path that does not exist", "OPERATION_FROM_UNRESOLVABLE", index, operation, document2);
      }
    }
  }
}
function validate(sequence, document2, externalValidator) {
  try {
    if (!Array.isArray(sequence)) {
      throw new JsonPatchError("Patch sequence must be an array", "SEQUENCE_NOT_AN_ARRAY");
    }
    if (document2) {
      applyPatch(_deepClone(document2), _deepClone(sequence), externalValidator || true);
    } else {
      externalValidator = externalValidator || validator;
      for (var i = 0; i < sequence.length; i++) {
        externalValidator(sequence[i], i, document2, void 0);
      }
    }
  } catch (e) {
    if (e instanceof JsonPatchError) {
      return e;
    } else {
      throw e;
    }
  }
}
function _areEquals(a, b) {
  if (a === b)
    return true;
  if (a && b && typeof a == "object" && typeof b == "object") {
    var arrA = Array.isArray(a), arrB = Array.isArray(b), i, length, key;
    if (arrA && arrB) {
      length = a.length;
      if (length != b.length)
        return false;
      for (i = length; i-- !== 0; )
        if (!_areEquals(a[i], b[i]))
          return false;
      return true;
    }
    if (arrA != arrB)
      return false;
    var keys = Object.keys(a);
    length = keys.length;
    if (length !== Object.keys(b).length)
      return false;
    for (i = length; i-- !== 0; )
      if (!b.hasOwnProperty(keys[i]))
        return false;
    for (i = length; i-- !== 0; ) {
      key = keys[i];
      if (!_areEquals(a[key], b[key]))
        return false;
    }
    return true;
  }
  return a !== a && b !== b;
}

// ../../node_modules/fast-json-patch/module/duplex.mjs
var duplex_exports = {};
__export(duplex_exports, {
  compare: () => compare,
  generate: () => generate,
  observe: () => observe,
  unobserve: () => unobserve
});
var beforeDict = /* @__PURE__ */ new WeakMap();
var Mirror = (
  /** @class */
  /* @__PURE__ */ function() {
    function Mirror2(obj) {
      this.observers = /* @__PURE__ */ new Map();
      this.obj = obj;
    }
    return Mirror2;
  }()
);
var ObserverInfo = (
  /** @class */
  /* @__PURE__ */ function() {
    function ObserverInfo2(callback, observer) {
      this.callback = callback;
      this.observer = observer;
    }
    return ObserverInfo2;
  }()
);
function getMirror(obj) {
  return beforeDict.get(obj);
}
function getObserverFromMirror(mirror, callback) {
  return mirror.observers.get(callback);
}
function removeObserverFromMirror(mirror, observer) {
  mirror.observers.delete(observer.callback);
}
function unobserve(root, observer) {
  observer.unobserve();
}
function observe(obj, callback) {
  var patches = [];
  var observer;
  var mirror = getMirror(obj);
  if (!mirror) {
    mirror = new Mirror(obj);
    beforeDict.set(obj, mirror);
  } else {
    var observerInfo = getObserverFromMirror(mirror, callback);
    observer = observerInfo && observerInfo.observer;
  }
  if (observer) {
    return observer;
  }
  observer = {};
  mirror.value = _deepClone(obj);
  if (callback) {
    observer.callback = callback;
    observer.next = null;
    var dirtyCheck = function() {
      generate(observer);
    };
    var fastCheck = function() {
      clearTimeout(observer.next);
      observer.next = setTimeout(dirtyCheck);
    };
    if (typeof window !== "undefined") {
      window.addEventListener("mouseup", fastCheck);
      window.addEventListener("keyup", fastCheck);
      window.addEventListener("mousedown", fastCheck);
      window.addEventListener("keydown", fastCheck);
      window.addEventListener("change", fastCheck);
    }
  }
  observer.patches = patches;
  observer.object = obj;
  observer.unobserve = function() {
    generate(observer);
    clearTimeout(observer.next);
    removeObserverFromMirror(mirror, observer);
    if (typeof window !== "undefined") {
      window.removeEventListener("mouseup", fastCheck);
      window.removeEventListener("keyup", fastCheck);
      window.removeEventListener("mousedown", fastCheck);
      window.removeEventListener("keydown", fastCheck);
      window.removeEventListener("change", fastCheck);
    }
  };
  mirror.observers.set(callback, new ObserverInfo(callback, observer));
  return observer;
}
function generate(observer, invertible) {
  if (invertible === void 0) {
    invertible = false;
  }
  var mirror = beforeDict.get(observer.object);
  _generate(mirror.value, observer.object, observer.patches, "", invertible);
  if (observer.patches.length) {
    applyPatch(mirror.value, observer.patches);
  }
  var temp = observer.patches;
  if (temp.length > 0) {
    observer.patches = [];
    if (observer.callback) {
      observer.callback(temp);
    }
  }
  return temp;
}
function _generate(mirror, obj, patches, path, invertible) {
  if (obj === mirror) {
    return;
  }
  if (typeof obj.toJSON === "function") {
    obj = obj.toJSON();
  }
  var newKeys = _objectKeys(obj);
  var oldKeys = _objectKeys(mirror);
  var changed = false;
  var deleted = false;
  for (var t = oldKeys.length - 1; t >= 0; t--) {
    var key = oldKeys[t];
    var oldVal = mirror[key];
    if (hasOwnProperty(obj, key) && !(obj[key] === void 0 && oldVal !== void 0 && Array.isArray(obj) === false)) {
      var newVal = obj[key];
      if (typeof oldVal == "object" && oldVal != null && typeof newVal == "object" && newVal != null && Array.isArray(oldVal) === Array.isArray(newVal)) {
        _generate(oldVal, newVal, patches, path + "/" + escapePathComponent(key), invertible);
      } else {
        if (oldVal !== newVal) {
          changed = true;
          if (invertible) {
            patches.push({ op: "test", path: path + "/" + escapePathComponent(key), value: _deepClone(oldVal) });
          }
          patches.push({ op: "replace", path: path + "/" + escapePathComponent(key), value: _deepClone(newVal) });
        }
      }
    } else if (Array.isArray(mirror) === Array.isArray(obj)) {
      if (invertible) {
        patches.push({ op: "test", path: path + "/" + escapePathComponent(key), value: _deepClone(oldVal) });
      }
      patches.push({ op: "remove", path: path + "/" + escapePathComponent(key) });
      deleted = true;
    } else {
      if (invertible) {
        patches.push({ op: "test", path, value: mirror });
      }
      patches.push({ op: "replace", path, value: obj });
      changed = true;
    }
  }
  if (!deleted && newKeys.length == oldKeys.length) {
    return;
  }
  for (var t = 0; t < newKeys.length; t++) {
    var key = newKeys[t];
    if (!hasOwnProperty(mirror, key) && obj[key] !== void 0) {
      patches.push({ op: "add", path: path + "/" + escapePathComponent(key), value: _deepClone(obj[key]) });
    }
  }
}
function compare(tree1, tree2, invertible) {
  if (invertible === void 0) {
    invertible = false;
  }
  var patches = [];
  _generate(tree1, tree2, patches, "", invertible);
  return patches;
}

// ../../node_modules/fast-json-patch/index.mjs
var fast_json_patch_default = Object.assign({}, core_exports, duplex_exports, {
  JsonPatchError: PatchError,
  deepClone: _deepClone,
  escapePathComponent,
  unescapePathComponent
});

// src/capabilities/services/SimplePatchEngine.ts
var SimplePatchEngine = class {
  projectId;
  state;
  onStateChange;
  patchCollector;
  onPatchApplyFailure;
  constructor(config) {
    this.projectId = config.projectId;
    this.onStateChange = config.onStateChange;
    this.patchCollector = config.patchCollector;
    this.onPatchApplyFailure = config.onPatchApplyFailure;
    this.state = {
      projects: {
        [config.projectId]: config.initialState
      }
    };
  }
  /**
   * Apply a streaming event to the state
   */
  applyEvent(event) {
    const patchEvent = this.normalizeToPatchEvent(event);
    const operation = this.extractPatchFromEvent(patchEvent);
    let patchApplied = false;
    let applyError;
    this.state = produce(this.state, (draft) => {
      try {
        applyPatch(draft, [operation], true, true);
        patchApplied = true;
      } catch (error) {
        applyError = error;
      }
    });
    if (patchApplied) {
      const patchData = {
        operations: [operation],
        timestamp: patchEvent.timestamp || (/* @__PURE__ */ new Date()).toISOString(),
        eventId: event.eventId,
        projectTurnId: event.projectTurnId
      };
      this.patchCollector.collectPatch(patchData);
    }
    this.onStateChange?.();
    if (!patchApplied) {
      this.onPatchApplyFailure?.(applyError, operation, event);
    }
  }
  /**
   * Get the project state
   */
  getProjectState() {
    return this.state.projects[this.projectId];
  }
  /**
   * Set state change callback
   */
  setOnStateChange(callback) {
    this.onStateChange = callback;
  }
  /**
   * Set patch-apply-failure callback (engines are cached per project)
   */
  setOnPatchApplyFailure(callback) {
    this.onPatchApplyFailure = callback;
  }
  // ============ Private Methods ============
  /**
   * Extract patch from PatchEvent
   */
  extractPatchFromEvent(event) {
    if ("data" in event && event.data) {
      return event.data;
    }
    if ("patch" in event) {
      return event.patch;
    }
    throw new Error("Cannot extract patch from event");
  }
  /**
   * Normalize event to PatchEvent format
   */
  normalizeToPatchEvent(event) {
    if (this.isMCPPatchNotification(event)) {
      const patch = event.patch;
      const jsonPatch = {
        ...patch,
        isMetadata: patch.isMetadata ?? false
      };
      return {
        type: "patch",
        projectId: event.projectId,
        timestamp: event.timestamp,
        data: jsonPatch
      };
    }
    return event;
  }
  /**
   * Type guard for MCP notification
   */
  isMCPPatchNotification(event) {
    return typeof event === "object" && event !== null && "patch" in event && "projectId" in event;
  }
};

// src/capabilities/debug/DebugPatchCollector.ts
var DebugPatchCollector = class {
  collectPatch(patch) {
    const { debugFeaturesActivated, recording } = useDebugStore.getState();
    if (debugFeaturesActivated && recording) {
      useDebugStore.getState().addPatch(patch);
    }
  }
};
function createPatchCollector() {
  return new DebugPatchCollector();
}

// src/capabilities/services/throttle.ts
function throttle(func, delay, options = {}) {
  const { leading = true, trailing = true } = options;
  let timeoutId = null;
  let lastArgs = null;
  let lastCallTime = 0;
  const throttled = function(...args) {
    const now = Date.now();
    const timeSinceLastCall = now - lastCallTime;
    if (leading && timeSinceLastCall >= delay) {
      lastCallTime = now;
      return func.apply(this, args);
    }
    lastArgs = args;
    if (trailing && !timeoutId) {
      timeoutId = setTimeout(() => {
        lastCallTime = Date.now();
        timeoutId = null;
        if (lastArgs) {
          func.apply(this, lastArgs);
          lastArgs = null;
        }
      }, delay - timeSinceLastCall);
    }
  };
  throttled.cancel = () => {
    if (timeoutId) {
      clearTimeout(timeoutId);
      timeoutId = null;
    }
    lastArgs = null;
  };
  return throttled;
}

// src/capabilities/services/useMaxService.ts
import { useAppTranslation } from "@amzn/awsmp-max-translations";

// src/capabilities/services/maxSessionStore.ts
var STORAGE_KEY = "web-identity-token";
var useMaxSessionStore = {
  setSessionId: (sessionId) => {
    if (sessionId) {
      localStorage.setItem(STORAGE_KEY, sessionId);
    } else {
      localStorage.removeItem(STORAGE_KEY);
    }
  },
  getSessionId: () => {
    return localStorage.getItem(STORAGE_KEY) ?? void 0;
  }
};

// src/capabilities/services/useMaxService.ts
enableMapSet();
var activeStreams = /* @__PURE__ */ new Map();
var projectPatchingEngines = /* @__PURE__ */ new Map();
var throttledUpdateFunctions = /* @__PURE__ */ new Map();
var THROTTLE_DELAY_MS = 1e3;
function extractProjectIdFromPath(path) {
  if (path && path.startsWith("/projects/")) {
    const pathParts = path.split("/");
    return pathParts[2] || null;
  }
  return null;
}
function getOrCreateEngine(projectId, onStateChange, onPatchApplyFailure) {
  let engine = projectPatchingEngines.get(projectId);
  if (!engine) {
    const storeState = useProjectStoreInternal.getState();
    const state = storeState.currentProjectId === projectId ? storeState.currentProject : null;
    engine = new SimplePatchEngine({
      projectId,
      initialState: state?.renderContext || {},
      onStateChange,
      patchCollector: createPatchCollector(),
      onPatchApplyFailure
    });
    projectPatchingEngines.set(projectId, engine);
  } else {
    if (onStateChange) {
      engine.setOnStateChange(onStateChange);
    }
    if (onPatchApplyFailure) {
      engine.setOnPatchApplyFailure(onPatchApplyFailure);
    }
  }
  return engine;
}
function getOrCreateThrottledUpdate(projectId) {
  let throttledUpdate = throttledUpdateFunctions.get(projectId);
  if (!throttledUpdate) {
    throttledUpdate = throttle(
      (projId, engine) => {
        updateProjectStore(projId, engine);
      },
      THROTTLE_DELAY_MS,
      { leading: true, trailing: true }
    );
    throttledUpdateFunctions.set(projectId, throttledUpdate);
  }
  return throttledUpdate;
}
function cleanupThrottledUpdate(projectId) {
  const throttledUpdate = throttledUpdateFunctions.get(projectId);
  if (throttledUpdate) {
    throttledUpdate.cancel();
    throttledUpdateFunctions.delete(projectId);
  }
}
function cleanupEngine(projectId) {
  projectPatchingEngines.delete(projectId);
  cleanupThrottledUpdate(projectId);
}
function updateProjectStore(projectId, engine) {
  const projectState = engine.getProjectState();
  useProjectStoreInternal.setState(
    (prevState) => produce(prevState, (draft) => {
      if (draft.currentProjectId === projectId && draft.currentProject) {
        draft.currentProject.renderContext = projectState;
      } else {
        draft.currentProjectId = projectId;
        draft.currentProject = {
          renderContext: projectState,
          isLoading: false,
          error: null
        };
      }
    })
  );
}
function useMaxService() {
  const client = useMaxServiceClient();
  const { t } = useAppTranslation();
  const createProject = React6.useCallback(
    async (params) => {
      const project = await client.createProject(params);
      if (!project.projectId) {
        throw new Error(t("failedToCreateProjectNoId"));
      }
      return project.projectId;
    },
    [client, t]
  );
  const listProjects = React6.useCallback(
    async (options) => {
      let nextToken;
      do {
        const response = await client.listProjects(nextToken, options.suppressBearer);
        options.onPageLoaded(response.projects);
        nextToken = response.nextToken;
      } while (nextToken);
    },
    [client]
  );
  const deleteProject = React6.useCallback(
    async (projectId, options) => {
      const force = options?.force ?? false;
      const onForceDeleteRequired = options?.onForceDeleteRequired;
      try {
        const result = await client.deleteProject(projectId, force);
        cleanupEngine(projectId);
        return result;
      } catch (err) {
        const errorMessage = err instanceof Error ? err.message : "Failed to delete project";
        if (errorMessage.includes("Use force=true to override") && onForceDeleteRequired) {
          onForceDeleteRequired(async () => {
            await client.deleteProject(projectId, true);
            cleanupEngine(projectId);
          });
          return {
            success: false,
            message: t("forceDeleteRequired")
          };
        }
        throw err;
      }
    },
    [client, t]
  );
  const uploadDocument = React6.useCallback(
    async (projectId, fileName) => {
      return client.uploadDocument(projectId, fileName);
    },
    [client]
  );
  const listDocuments = React6.useCallback(
    async (projectId) => {
      return client.listDocuments(projectId);
    },
    [client]
  );
  const uploadFilesToProject = React6.useCallback(
    async (projectId, files, callbacks) => {
      return client.uploadFilesToProject(projectId, files, callbacks);
    },
    [client]
  );
  const searchListings = React6.useCallback(
    async (searchParams) => {
      return client.searchListings(searchParams);
    },
    [client]
  );
  const getListingOverview = React6.useCallback(
    async (listingIds) => {
      return client.getListingOverview(listingIds);
    },
    [client]
  );
  const getFullReview = React6.useCallback(
    async (listingId, reviewId) => {
      return client.getFullReview(listingId, reviewId);
    },
    [client]
  );
  const sendMessage = React6.useCallback(
    async (projectId, content) => {
      return client.sendMessage(projectId, content);
    },
    [client]
  );
  const createProjectWithStreaming = React6.useCallback(
    (options, onProjectId, onClose) => {
      const operationId = crypto.randomUUID();
      let projectId = null;
      let patchLost = false;
      let hasNavigated = false;
      const _abortController = client.createProjectWithStreaming(options, {
        onMessage: (event) => {
          try {
            const eventData = JSON.parse(event.data);
            const extractedProjectId = extractProjectIdFromPath(eventData.patch.path);
            if (extractedProjectId && !projectPatchingEngines.has(extractedProjectId)) {
              const newEngine = new SimplePatchEngine({
                projectId: extractedProjectId,
                initialState: {},
                // Empty initial state for new project
                patchCollector: createPatchCollector(),
                // The report names the stream message the patch came from: its request, project and turn.
                onPatchApplyFailure: (error, operation, event2) => {
                  withCallIds(streamMessageCallIds(event2), () => reportStreamedPatchApplyFailure(extractedProjectId, error, operation));
                  patchLost = true;
                }
              });
              projectPatchingEngines.set(extractedProjectId, newEngine);
              projectId = extractedProjectId;
              if (!hasNavigated) {
                hasNavigated = true;
                onProjectId?.(extractedProjectId);
              }
            }
            if (projectId) {
              const engine = projectPatchingEngines.get(projectId);
              if (engine) {
                engine.applyEvent(eventData);
                updateProjectStore(projectId, engine);
              }
            }
          } catch (err) {
            reportStreamedPatchParseFailure(projectId ?? "unknown", err);
          }
        },
        onClose: (finalResult) => {
          if (projectId) {
            const engine = projectPatchingEngines.get(projectId);
            if (engine) {
              updateProjectStore(projectId, engine);
              const createdProjectId = projectId;
              const resetEngine = () => cleanupEngine(createdProjectId);
              if (patchLost) {
                resyncAfterPatchLoss(client, createdProjectId, "apply", resetEngine);
              } else {
                void reconcileConversationOnTurnComplete(client, createdProjectId, engine, finalResult, resetEngine);
              }
            }
            onClose?.(projectId);
          }
        },
        onError: (errorEvent) => {
          const errorMessage = errorEvent instanceof ErrorEvent && errorEvent.error instanceof Error ? errorEvent.error.message : "Failed to create project with streaming";
          useFlashbar.getState().addItem({
            type: "error",
            header: "Failed to create project",
            content: errorMessage,
            dismissible: true
          });
          if (projectId) {
            cleanupEngine(projectId);
            useProjectStoreInternal.setState(
              (prevState) => produce(prevState, (draft) => {
                if (draft.currentProjectId === projectId) {
                  draft.currentProjectId = null;
                  draft.currentProject = null;
                }
              })
            );
          }
        }
      });
      return operationId;
    },
    [client]
  );
  const sendMessageWithStreaming = React6.useCallback(
    (projectId, contentOrBlocks, callbacks, agent, webIdentityTokenOverride) => {
      let actualContentBlocks;
      let metadata;
      if (typeof contentOrBlocks === "object" && contentOrBlocks !== null && "contentBlocks" in contentOrBlocks) {
        actualContentBlocks = contentOrBlocks.contentBlocks;
        const { projectName, projectDescription, tags } = contentOrBlocks;
        if (projectName !== void 0 || projectDescription !== void 0 || tags !== void 0) {
          metadata = { projectName, projectDescription, tags };
        }
      } else {
        actualContentBlocks = contentOrBlocks;
      }
      const storeState = useProjectStoreInternal.getState();
      const currentState = storeState.currentProjectId === projectId ? storeState.currentProject : null;
      const projectTurnId = currentState?.renderContext?.projectTurnId;
      if (!projectTurnId) {
        return { status: "rejected" };
      }
      if (currentState?.renderContext?.turnStatus === TurnStatus2.Processing) {
        return { status: "rejected" };
      }
      let patchLost = false;
      const engine = getOrCreateEngine(
        projectId,
        () => {
          updateProjectStore(projectId, engine);
        },
        // The report names the stream message the patch came from: its request, project and turn.
        (error, operation, event) => {
          withCallIds(streamMessageCallIds(event), () => reportStreamedPatchApplyFailure(projectId, error, operation));
          patchLost = true;
        }
      );
      const now = (/* @__PURE__ */ new Date()).toISOString();
      engine.applyEvent({
        type: "patch",
        projectId,
        timestamp: now,
        data: {
          op: "replace",
          path: `/projects/${projectId}/turnStatus`,
          value: TurnStatus2.Processing,
          isMetadata: false,
          timestamp: now
        }
      });
      const throttledUpdate = getOrCreateThrottledUpdate(projectId);
      let settleCompletion;
      const completion = new Promise((resolve) => {
        settleCompletion = resolve;
      });
      let abortController;
      try {
        abortController = client.sendMessageWithStreaming(
          projectTurnId,
          actualContentBlocks,
          {
            onMessage: (event) => {
              callbacks?.onMessage?.(event);
              try {
                const parsedEvent = JSON.parse(event.data);
                const patchEvent = {
                  type: "patch",
                  projectId: parsedEvent.projectId,
                  projectTurnId: parsedEvent.projectTurnId,
                  requestId: parsedEvent.requestId,
                  timestamp: parsedEvent.timestamp,
                  data: parsedEvent.patch
                };
                unstable_batchedUpdates(() => {
                  engine.applyEvent(patchEvent);
                });
                throttledUpdate(projectId, engine);
              } catch (error) {
                reportStreamedPatchParseFailure(projectId, error);
              }
            },
            onClose: (finalResult) => {
              activeStreams.delete(projectId);
              throttledUpdate.cancel();
              updateProjectStore(projectId, engine);
              callbacks?.onClose?.();
              if (engine.getProjectState()?.turnStatus === TurnStatus2.Processing) {
                cleanupEngine(projectId);
                useProjectStoreInternal.getState().getProject(client, projectId, true);
              } else if (patchLost) {
                resyncAfterPatchLoss(client, projectId, "apply", () => cleanupEngine(projectId));
              } else {
                void reconcileConversationOnTurnComplete(client, projectId, engine, finalResult, () => cleanupEngine(projectId));
              }
              settleCompletion();
            },
            onError: (error) => {
              activeStreams.delete(projectId);
              const errorObj = new Error("Streaming failed");
              callbacks?.onError?.(errorObj);
              reportStreamFailure("send", error, { projectId });
              const errorEvent = error;
              const isThrottle = errorEvent?.error instanceof ThrottleError;
              if (isThrottle) {
                useFlashbar.getState().addItem({
                  type: "error",
                  header: "Request throttled",
                  content: "Please wait a moment and try again.",
                  dismissible: true
                });
              } else {
                useFlashbar.getState().addItem({
                  type: "error",
                  header: "Streaming failed",
                  content: "The message stream was interrupted. Please try sending your message again.",
                  dismissible: true
                });
              }
              cleanupEngine(projectId);
              useProjectStoreInternal.getState().getProject(client, projectId, true);
              settleCompletion();
            }
          },
          agent,
          webIdentityTokenOverride,
          metadata
        );
      } catch (error) {
        cleanupEngine(projectId);
        useProjectStoreInternal.getState().getProject(client, projectId, true);
        throw error;
      }
      activeStreams.set(projectId, abortController);
      return { status: "accepted", completion };
    },
    [client]
  );
  const getProject = React6.useCallback(
    async (projectId) => {
      return client.getProject(projectId);
    },
    [client]
  );
  const interruptProject = React6.useCallback(
    async (projectId) => {
      return client.interruptProject(projectId);
    },
    [client]
  );
  const rollbackProject = React6.useCallback(
    async (projectId, turnId) => {
      const result = await client.rollbackProject(projectId, turnId);
      cleanupEngine(projectId);
      useProjectStoreInternal.getState().getProject(client, projectId, true);
      return result;
    },
    [client]
  );
  const shareProject = React6.useCallback(
    async (projectId, targetWebIdentityToken, webIdentityToken) => {
      return client.shareProject(projectId, targetWebIdentityToken, webIdentityToken);
    },
    [client]
  );
  const moveProject = React6.useCallback(
    async (projectId) => {
      return client.moveProject(projectId);
    },
    [client]
  );
  const updateProjectTags = React6.useCallback(
    async (projectId, tags) => {
      const projectState = await client.getProject(projectId);
      client.sendMessageWithStreaming(projectState.projectTurnId, [], {}, void 0, void 0, { tags });
    },
    [client]
  );
  const directToolCallWithStreaming = React6.useCallback(
    async ({
      projectId,
      toolName,
      toolInput,
      agent,
      webIdentityTokenOverride,
      visibility: visibilityOverride
    }) => {
      return new Promise((resolve, reject) => {
        let toolResult = null;
        const result = sendMessageWithStreaming(
          projectId,
          [
            {
              // NOTE: "Non-Display" inference type means the frontend code won't see responses at all.
              // To control display in the chat panel, we need to use other mechanisms such as hardcoded filtering or tags.
              visibility: visibilityOverride ?? ContentBlockVisibility.DISPLAY_ONLY,
              [toolName]: toolInput
            }
          ],
          {
            onMessage: (event) => {
              try {
                const parsedEvent = JSON.parse(event.data);
                if (parsedEvent.patch?.value?.contentBlocks) {
                  const contentBlocks = parsedEvent.patch.value.contentBlocks;
                  for (const block of contentBlocks) {
                    if (block.type === "toolOutput" && toolName in block.content) {
                      if (block.status === "ERROR") {
                        toolResult = { error: block.content[toolName] };
                      } else if (block.status === "COMPLETE") {
                        toolResult = { success: block.content[toolName] };
                      }
                    }
                  }
                }
              } catch (err) {
                reject(err);
              }
            },
            onClose: () => {
              if (toolResult?.error) {
                reject(toolResult.error);
              } else if (toolResult?.success) {
                resolve(toolResult.success);
              } else {
                const epoError = {
                  statusCode: 500,
                  exceptionName: "InternalServiceException",
                  message: `No tool result found for ${toolName}`
                };
                reject(epoError);
              }
            },
            onError: (error) => {
              reject(error);
            }
          },
          agent,
          webIdentityTokenOverride
        );
        if (result.status === "rejected") {
          const epoError = {
            statusCode: 409,
            exceptionName: "ConflictException",
            message: `Tool call ${toolName} rejected: a turn is already in progress (or there is no active turn) for project ${projectId}.`
          };
          reject(epoError);
        }
      });
    },
    [sendMessageWithStreaming]
  );
  const extractToolResult = (response, toolName) => {
    const toolOutputContentBlock = response.response?.contentBlocks?.[0] || response.contentBlocks?.[0];
    if (toolOutputContentBlock?.status === "ERROR") {
      const blockOutput = toolOutputContentBlock.content[toolName];
      throw blockOutput;
    } else {
      const blockOutput = toolOutputContentBlock.content[toolName];
      return blockOutput;
    }
  };
  const directToolCallWithoutStreaming = React6.useCallback(
    async ({
      toolName,
      toolInput,
      projectId,
      agent,
      webIdentityTokenOverride
    }) => {
      const response = await client.sendToolsRequest(
        [
          {
            // NOTE: "Non-Display" inference type means the frontend code won't see responses at all.
            // To control display in the chat panel, we need to use other mechanisms such as hardcoded filtering or tags.
            visibility: ContentBlockVisibility.DISPLAY_ONLY,
            [toolName]: toolInput
          }
        ],
        projectId,
        agent,
        webIdentityTokenOverride
      );
      return extractToolResult(response, toolName);
    },
    [client]
  );
  const submitFeedback = React6.useCallback(
    async (projectId, messageId, payload) => {
      const result = payload.sentiment === "positive" ? await client.submitFeedback(projectId, messageId, payload.sentiment) : await client.submitFeedback(projectId, messageId, payload.sentiment, payload.categories, payload.feedbackText);
      if (result.feedbackMarker) {
        useProjectStoreInternal.setState(
          (prevState) => produce(prevState, (draft) => {
            if (draft.currentProject?.renderContext) {
              if (!draft.currentProject.renderContext.feedbackMap) {
                draft.currentProject.renderContext.feedbackMap = {};
              }
              draft.currentProject.renderContext.feedbackMap[messageId] = result.feedbackMarker;
            }
          })
        );
      }
    },
    [client]
  );
  const setToolAuthorizationBehavior = React6.useCallback(
    async (projectId, enabled) => {
      try {
        const result = await client.setToolAuthorizationBehavior(projectId, enabled);
        if (result.settings) {
          const engine = getOrCreateEngine(projectId);
          const now = (/* @__PURE__ */ new Date()).toISOString();
          const patchEvent = {
            type: "patch",
            projectId,
            timestamp: now,
            data: { op: "add", path: `/projects/${projectId}/settings`, value: result.settings, isMetadata: false, timestamp: now }
          };
          engine.applyEvent(patchEvent);
          updateProjectStore(projectId, engine);
        }
      } catch (error) {
        useFlashbar.getState().addItem({
          type: "error",
          header: "Failed to update tool approvals",
          content: error instanceof Error ? error.message : "The tool-approval setting could not be updated. Please try again.",
          dismissible: true
        });
      }
    },
    [client]
  );
  const getWebIdentityToken = React6.useCallback(() => {
    return useMaxSessionStore.getSessionId() || window.SESSION_ID_AGENTMODE;
  }, []);
  return React6.useMemo(
    () => ({
      setToolAuthorizationBehavior,
      createProject,
      createProjectWithStreaming,
      listProjects,
      deleteProject,
      getProject,
      interruptProject,
      rollbackProject,
      shareProject,
      moveProject,
      updateProjectTags,
      sendMessage,
      sendMessageWithStreaming,
      submitFeedback,
      directToolCallWithStreaming,
      directToolCallWithoutStreaming,
      uploadDocument,
      listDocuments,
      uploadFilesToProject,
      searchListings,
      getListingOverview,
      getFullReview,
      getWebIdentityToken
    }),
    [
      setToolAuthorizationBehavior,
      createProject,
      createProjectWithStreaming,
      listProjects,
      deleteProject,
      getProject,
      interruptProject,
      rollbackProject,
      shareProject,
      moveProject,
      updateProjectTags,
      sendMessage,
      sendMessageWithStreaming,
      submitFeedback,
      directToolCallWithStreaming,
      directToolCallWithoutStreaming,
      uploadDocument,
      listDocuments,
      uploadFilesToProject,
      searchListings,
      getListingOverview,
      getFullReview,
      getWebIdentityToken
    ]
  );
}

// src/capabilities/services/useProjectStoreInternal.ts
var useProjectStoreInternal = create7()(
  subscribeWithSelector((set2, get) => ({
    currentProjectId: null,
    currentProject: null,
    getProject: (client, projectId, forceRefresh = false) => {
      const state = get();
      if (state.currentProjectId === projectId && state.currentProject && !forceRefresh) {
        return state.currentProject;
      }
      const loadingProject = {
        renderContext: state.currentProjectId === projectId ? state.currentProject?.renderContext || null : null,
        isLoading: true,
        error: null
      };
      set2({
        currentProjectId: projectId,
        currentProject: loadingProject
      });
      let patchLost = false;
      const engine = getOrCreateEngine(projectId, void 0, (error, operation, event) => {
        withCallIds(streamMessageCallIds(event), () => reportStreamedPatchApplyFailure(projectId, error, operation));
        patchLost = true;
      });
      const throttledUpdate = getOrCreateThrottledUpdate(projectId);
      const markId = `max-getProject-${projectId}`;
      performance.mark(`${markId}-start`);
      client.getProjectWithStreaming(projectId, {
        onMessage: (event) => {
          try {
            const parsedEvent = JSON.parse(event.data);
            const patchEvent = {
              type: "patch",
              projectId: parsedEvent.projectId,
              projectTurnId: parsedEvent.projectTurnId,
              requestId: parsedEvent.requestId,
              timestamp: parsedEvent.timestamp,
              data: parsedEvent.patch
              // The patch object is in the 'patch' field
            };
            unstable_batchedUpdates2(() => {
              engine.applyEvent(patchEvent);
            });
            throttledUpdate(projectId, engine);
          } catch (error) {
            reportStreamedPatchParseFailure(projectId, error);
          }
        },
        onClose: () => {
          throttledUpdate.cancel();
          updateProjectStore(projectId, engine);
          try {
            performance.mark(`${markId}-end`);
            const measure = performance.measure("GetProjectStreamingDuration", `${markId}-start`, `${markId}-end`);
            const awsmpue = window.awsmpue;
            if (awsmpue?.platformMetric) {
              awsmpue.platformMetric("GetProjectStreamingDuration", "Milliseconds", Math.round(measure.duration));
            }
          } catch {
          }
          const currentState = get();
          if (currentState.currentProjectId === projectId && currentState.currentProject) {
            set2({
              currentProject: {
                ...currentState.currentProject,
                isLoading: false
              }
            });
          }
          if (patchLost) {
            resyncAfterPatchLoss(client, projectId, "apply", () => cleanupEngine(projectId));
          }
        },
        onError: (error) => {
          const errorEvent = error;
          const errorMessage = errorEvent.error?.message || "";
          const isAccessDenied = errorMessage.includes("INSUFFICIENT_PERMISSIONS") || errorMessage.includes("RESOURCE_NOT_FOUND");
          if (!isAccessDenied) {
            reportStreamFailure("project-load", error, { projectId });
            useFlashbar.getState().addItem({
              type: "error",
              header: "Failed to load project",
              content: "Unable to load project data. Please try refreshing the page.",
              dismissible: true
            });
          }
          throttledUpdate.cancel();
          updateProjectStore(projectId, engine);
          const currentState = get();
          if (currentState.currentProjectId === projectId) {
            set2({
              currentProject: {
                renderContext: state.currentProject?.renderContext || null,
                isLoading: false,
                error: isAccessDenied ? new NotFoundError(errorEvent.error) : new Error("Failed to load project")
              }
            });
          }
        }
      });
      return loadingProject;
    },
    cleanup: () => {
      set2({ currentProjectId: null, currentProject: null });
    }
  }))
);
function cleanupProjectStore() {
  useProjectStoreInternal.getState().cleanup();
}

// src/capabilities/debug/useDebugPanel.ts
var EMPTY_PATCHES = [];
function useDebugPanel() {
  const debugFeaturesActivated = useDebugStore((state) => state.debugFeaturesActivated);
  const isOpen = useDebugStore((state) => state.panelOpen);
  const trackedProjectId = useDebugStore((state) => state.trackedProjectId);
  const patchCount = useDebugStore((state) => state.patches.length);
  const patches = useDebugStore((state) => state.panelOpen ? state.patches : EMPTY_PATCHES);
  const recording = useDebugStore((state) => state.recording);
  const tail = useDebugStore((state) => state.tail);
  const settings = useDebugStore((state) => state.settings);
  const togglePanel = useDebugStore((state) => state.togglePanel);
  const clearPatches = useDebugStore((state) => state.clearPatches);
  const toggleRecording = useDebugStore((state) => state.toggleRecording);
  const toggleTail = useDebugStore((state) => state.toggleTail);
  const toggleSetting = useDebugStore((state) => state.toggleSetting);
  const projectData = useProjectStoreInternal(
    (state) => trackedProjectId && state.currentProjectId === trackedProjectId ? state.currentProject : null
  );
  const exportPatches = useCallback3(() => {
    const dataStr = JSON.stringify(patches, null, 2);
    const dataBlob = new Blob([dataStr], { type: "application/json" });
    const url = URL.createObjectURL(dataBlob);
    const link = document.createElement("a");
    link.href = url;
    link.download = `patches-${trackedProjectId || "unknown"}-${Date.now()}.json`;
    link.click();
    URL.revokeObjectURL(url);
  }, [patches, trackedProjectId]);
  return {
    enabled: debugFeaturesActivated,
    isOpen,
    trackedProjectId,
    currentState: projectData?.renderContext || null,
    patches,
    patchCount,
    recording,
    tail,
    settings,
    togglePanel,
    clearPatches,
    toggleRecording,
    toggleTail,
    exportPatches,
    toggleSetting
  };
}

// src/capabilities/debug/useTrackDebugProject.ts
import { useEffect as useEffect5 } from "react";
function useTrackDebugProject(projectId) {
  const setTrackedProjectId = useDebugStore((state) => state.setTrackedProjectId);
  useEffect5(() => {
    setTrackedProjectId(projectId);
    return () => setTrackedProjectId(null);
  }, [projectId, setTrackedProjectId]);
}

// src/capabilities/debug/DebugInitializer.tsx
import { useEffect as useEffect6 } from "react";
var DEBUG_GATE_KEY = "max_debug";
var DebugInitializer = () => {
  useEffect6(() => {
    const params = new URLSearchParams(window.location.search);
    if (params.get(DEBUG_GATE_KEY) === "true") {
      useDebugStore.getState().setGateEnabled(true);
    }
    if (params.get("debug") === "true" && useDebugStore.getState().gateEnabled) {
      useDebugStore.getState().toggleEnabled();
    }
    const isLocalhost = window.location.hostname === "localhost" || window.location.hostname === "127.0.0.1";
    const { debugFeaturesActivated, gateEnabled } = useDebugStore.getState();
    if (isLocalhost && !debugFeaturesActivated) {
      if (!gateEnabled) {
        const currentUrl = new URL(window.location.href);
        currentUrl.searchParams.set(DEBUG_GATE_KEY, "true");
        const enableUrl = currentUrl.toString();
        console.log(`
\u2554\u2550\u2550\u2550\u2550\u2550\u2550\u2550\u2550\u2550\u2550\u2550\u2550\u2550\u2550\u2550\u2550\u2550\u2550\u2550\u2550\u2550\u2550\u2550\u2550\u2550\u2550\u2550\u2550\u2550\u2550\u2550\u2550\u2550\u2550\u2550\u2550\u2550\u2550\u2550\u2550\u2550\u2550\u2550\u2550\u2550\u2550\u2550\u2550\u2550\u2550\u2550\u2550\u2550\u2550\u2550\u2550\u2550\u2550\u2550\u2557
\u2551                                                           \u2551
\u2551               \u{1F41B}  MAX DEBUG PANEL  \u{1F41B}                    \u2551
\u2551                                                           \u2551
\u2551  To enable the debug panel, add ?max_debug=true          \u2551
\u2551                                                           \u2551
\u2551  Click here to enable:                                    \u2551
\u2551  ${enableUrl}
\u2551                                                           \u2551
\u255A\u2550\u2550\u2550\u2550\u2550\u2550\u2550\u2550\u2550\u2550\u2550\u2550\u2550\u2550\u2550\u2550\u2550\u2550\u2550\u2550\u2550\u2550\u2550\u2550\u2550\u2550\u2550\u2550\u2550\u2550\u2550\u2550\u2550\u2550\u2550\u2550\u2550\u2550\u2550\u2550\u2550\u2550\u2550\u2550\u2550\u2550\u2550\u2550\u2550\u2550\u2550\u2550\u2550\u2550\u2550\u2550\u2550\u2550\u2550\u255D
        `);
      } else {
        console.log(`
\u2554\u2550\u2550\u2550\u2550\u2550\u2550\u2550\u2550\u2550\u2550\u2550\u2550\u2550\u2550\u2550\u2550\u2550\u2550\u2550\u2550\u2550\u2550\u2550\u2550\u2550\u2550\u2550\u2550\u2550\u2550\u2550\u2550\u2550\u2550\u2550\u2550\u2550\u2550\u2550\u2550\u2550\u2550\u2550\u2550\u2550\u2550\u2550\u2550\u2550\u2550\u2550\u2550\u2550\u2550\u2550\u2550\u2550\u2550\u2550\u2557
\u2551                                                           \u2551
\u2551               \u{1F41B}  MAX DEBUG PANEL AVAILABLE  \u{1F41B}          \u2551
\u2551                                                           \u2551
\u2551  Press Ctrl+Shift+B to open the Debug Panel              \u2551
\u2551                                                           \u2551
\u2551  Features:                                                \u2551
\u2551  \u{1F4CA} State Tab                                             \u2551
\u2551     \u2022 View current project state in real-time             \u2551
\u2551                                                           \u2551
\u2551  \u{1F4E6} Patches Tab                                           \u2551
\u2551     \u2022 Real-time SSE patch monitoring                      \u2551
\u2551     \u2022 Record/pause event capture                          \u2551
\u2551     \u2022 Tail mode (unlimited history)                       \u2551
\u2551     \u2022 Search and filter patches                           \u2551
\u2551     \u2022 Export patches to JSON                              \u2551
\u2551     \u2022 Clear patch history                                 \u2551
\u2551                                                           \u2551
\u2551  \u2699\uFE0F  Settings Tab                                         \u2551
\u2551     \u2022 Toggle debug messages                               \u2551
\u2551     \u2022 Enable dark mode                                    \u2551
\u2551     \u2022 Configure patch limits                              \u2551
\u2551                                                           \u2551
\u255A\u2550\u2550\u2550\u2550\u2550\u2550\u2550\u2550\u2550\u2550\u2550\u2550\u2550\u2550\u2550\u2550\u2550\u2550\u2550\u2550\u2550\u2550\u2550\u2550\u2550\u2550\u2550\u2550\u2550\u2550\u2550\u2550\u2550\u2550\u2550\u2550\u2550\u2550\u2550\u2550\u2550\u2550\u2550\u2550\u2550\u2550\u2550\u2550\u2550\u2550\u2550\u2550\u2550\u2550\u2550\u2550\u2550\u2550\u2550\u255D
        `);
      }
    }
    const handleKeyDown = (e) => {
      if (e.ctrlKey && e.shiftKey && e.key === "B") {
        e.preventDefault();
        const isGateEnabled = useDebugStore.getState().gateEnabled;
        if (isGateEnabled) {
          useDebugStore.getState().toggleEnabled();
        }
      }
    };
    window.addEventListener("keydown", handleKeyDown);
    return () => window.removeEventListener("keydown", handleKeyDown);
  }, []);
  return null;
};

// src/capabilities/services/MaxServiceClient.ts
function computeRetryDelayMs(base, attempt) {
  return base * 2 ** attempt + Math.floor(Math.random() * base);
}
var BOOTSTRAP_MINT_CALL_SITES = /* @__PURE__ */ new Set(["listProjects", "getProject"]);
var originGrantReturnedFromSignIn;
var originGrantRecoveryClosed = false;
function noteMcpCallForOriginGrantRecovery(toolName) {
  if (!BOOTSTRAP_MINT_CALL_SITES.has(toolName)) {
    originGrantRecoveryClosed = true;
  }
}
var MaxServiceClient = class _MaxServiceClient {
  static MIN_RECONNECTION_INTERVAL_MS = 1e4;
  /** listProjects page size: the schema maximum, so Home makes the fewest round trips. */
  static LIST_PROJECTS_PAGE_SIZE = 100;
  static THROTTLE_ERROR_CODES = /* @__PURE__ */ new Set([
    "REQUEST_RATE_LIMIT_EXCEEDED",
    "CONCURRENT_REQUEST_LIMIT_EXCEEDED",
    "PROJECT_CREATION_LIMIT_EXCEEDED",
    "AI_INFERENCE_RATE_LIMIT_EXCEEDED"
  ]);
  // The in-flight or settled MCP connection, created lazily and shared by every caller.
  // Null means "not connected and not connecting" — the next connect() builds a fresh one.
  // Holding a promise rather than a resolved McpClient is what keeps the handshake
  // (initialize + notifications/initialized) off the render path: construction returns
  // immediately and the wait is paid per call, by the callers that actually need the
  // connection, instead of by first paint.
  connection = null;
  sessionStore;
  locale;
  logger;
  lastReconnectionAttempt = 0;
  // Per-request Bearer suppression. When a request's nonce is in this set, the
  // transport fetch hook omits the Authorization header so the server resolves
  // to the SESSION identity even while signed in.
  //
  // This is scoped per-request (not a shared boolean) to avoid race conditions:
  // each suppressed request registers a unique nonce before the call and removes
  // it in `finally`. The fetch hook checks if the request's nonce is in the set.
  // This ensures concurrent/interleaved requests don't affect each other.
  suppressedRequestIds;
  // Federated artifact widget discovery, injected rather than read from a module singleton so
  // the client's tests can supply widgets without mocking @amzn/awsmp-max-data wholesale.
  // Kept as a thunk, not a promise, so construction stays free of discovery's start ordering.
  artifactWidgets;
  constructor(sessionStore, locale, logger, suppressedRequestIds, artifactWidgets) {
    this.sessionStore = sessionStore;
    this.locale = locale;
    this.logger = logger;
    this.suppressedRequestIds = suppressedRequestIds;
    this.artifactWidgets = artifactWidgets;
  }
  /**
   * Static factory method to create a Client instance.
   *
   * Synchronous by design. The MCP handshake is started here but NOT awaited, so the
   * caller (MaxServiceProvider) can render immediately instead of holding the whole
   * React tree behind a network round trip. Callers that need the connection await it
   * per call via connect().
   */
  static of(sessionStore, options, logger, artifactWidgets) {
    const suppressedRequestIds = /* @__PURE__ */ new Set();
    const client = new _MaxServiceClient(sessionStore, options.locale, logger, suppressedRequestIds, artifactWidgets);
    client.connect();
    return client;
  }
  /**
   * Read a cookie value from document.cookie by name, or undefined if absent.
   * Used by wit-continuity capture to read the non-HttpOnly aws-session-id cookie.
   */
  static readCookie(name) {
    if (typeof document === "undefined" || !document.cookie) {
      return void 0;
    }
    const match = document.cookie.match(new RegExp(`(?:^|;\\s*)${name}=([^;]*)`));
    return match ? decodeURIComponent(match[1]) : void 0;
  }
  static async createMcpClient(sessionStore, options, suppressedRequestIds, logger) {
    const mcpHostMeta = document.getElementById("mcp-host");
    const overrideMcpHost = mcpHostMeta && mcpHostMeta.getAttribute("content") !== "{{mcp-host}}";
    const mcpHost = mcpHostMeta?.getAttribute("content");
    const baseUrl = overrideMcpHost ? `${mcpHost}/mcp/` : "/mcp/";
    const additionalHeaders = {
      "awsmp-max-header": "ac5a197f-1304-4b2d-b0d4-1b73aff8a3e4"
    };
    const witCaptureMeta = document.getElementById("wit-capture-enabled");
    if (witCaptureMeta?.getAttribute("content") === "true") {
      const awsSessionId = _MaxServiceClient.readCookie("aws-session-id");
      if (awsSessionId) {
        additionalHeaders["x-aws-session-id"] = awsSessionId;
      }
    }
    const agentPreview = _MaxServiceClient.readCookie(AGENT_PREVIEW_COOKIE);
    if (agentPreview) {
      additionalHeaders[AGENT_PREVIEW_HEADER] = agentPreview;
    }
    const existingSessionId = new URLSearchParams(window.location.search).get("wit") || sessionStore.getSessionId();
    const transport = new StreamableHTTPClientTransport(new URL(baseUrl, window.location.origin), {
      requestInit: {
        headers: {
          [CLIENT_TYPE_HEADER_NAME]: CLIENT_TYPE_INTERNAL,
          // Identify as internal Amazon client
          "Accept-Language": options.locale,
          // Send user's locale preference
          ...additionalHeaders
          // Include production-specific headers
        }
      },
      // Per-request header injection — evaluated on every /mcp fetch, not frozen at
      // construction. This is where dynamic state (auth token, debug flags) is read so
      // it can be changed at any time and the next request picks it up.
      fetch: async (url, init) => {
        const tokenManager = getTokenManager();
        const token = tokenManager.getToken();
        let isSuppressed = false;
        if (typeof init?.body === "string") {
          try {
            const parsed = JSON.parse(init.body);
            const nonce = parsed?.params?._meta?.suppressBearerNonce;
            if (nonce) {
              if (suppressedRequestIds.has(nonce)) {
                isSuppressed = true;
              } else {
                logger.warn("suppressBearerNonce not found in registry \u2014 possible envelope mismatch", { nonce });
              }
            }
          } catch {
            logger.debug("Failed to parse request body for suppressBearerNonce check", { bodyLength: init.body.length });
          }
        }
        const needsBearer = !!token && !isSuppressed;
        const debugState = useDebugStore.getState();
        const needsTestSource = debugState.gateEnabled && debugState.settings.testTrafficMode;
        if (!needsBearer && !needsTestSource) {
          return fetch(url, init);
        }
        const headers = new Headers(init?.headers);
        if (needsBearer) {
          headers.set("Authorization", `Bearer ${token}`);
        }
        if (needsTestSource) {
          headers.set("x-amzn-request-source", "test-e2e");
        }
        return fetch(url, { ...init, headers });
      },
      sessionId: existingSessionId,
      // Pass existing session ID (or undefined for first connection)
      reconnectionOptions: {
        maxRetries: 5,
        // Finite retries to prevent retry storms during throttling
        initialReconnectionDelay: 2e3,
        // Start with 2s delay to reduce pressure on overloaded service
        maxReconnectionDelay: 3e4,
        // Cap delay at 30 seconds
        reconnectionDelayGrowFactor: 2
        // Exponential backoff: 2s, 4s, 8s, 16s, 30s
      }
    });
    const mcpClient = new McpClient(
      {
        name: "max-control-plane-client",
        version: "1.0.0"
      },
      {
        capabilities: {}
      }
    );
    await mcpClient.connect(transport);
    if (existingSessionId === void 0) {
      sessionStore.setSessionId(transport.sessionId);
      window.SESSION_ID_AGENTMODE = transport.sessionId;
    }
    return mcpClient;
  }
  /**
   * Create a new project
   */
  async createProject(options) {
    return this.callMcpTool("createProject", options);
  }
  /**
   * Get project current state
   */
  async getProject(projectId) {
    return this.callMcpTool("getProject", { projectId });
  }
  /**
   * Get project current state with streaming response
   * Returns an AbortController to cancel the stream
   */
  getProjectWithStreaming(projectId, handlers, webIdentityTokenOverride) {
    const abortController = new AbortController();
    void this.startMcpStreaming(
      "getProject",
      { projectId, enableStreaming: true, ...webIdentityTokenOverride && { webIdentityToken: webIdentityTokenOverride } },
      handlers,
      abortController
    );
    return abortController;
  }
  /**
   * Delete a project
   */
  async deleteProject(projectId, force = false) {
    return this.callMcpTool("deleteProject", { projectId, force });
  }
  /**
   * Interrupt active project processing
   */
  async interruptProject(projectId) {
    return this.callMcpTool("interruptProject", { projectId });
  }
  /**
   * Rollback project to a previous turn
   * - If turnId is provided: Restores to that specific turn
   * - If turnId is omitted: Restores to before the last user + assistant message pair
   */
  async rollbackProject(projectId, turnId) {
    return this.callMcpTool("rollbackProject", { projectId, turnId });
  }
  /**
   * Share project ownership with another web identity token
   */
  async shareProject(projectId, targetWebIdentityToken, webIdentityToken) {
    return this.callMcpTool("shareProject", {
      projectId,
      targetWebIdentityToken,
      ...webIdentityToken && { webIdentityToken }
    });
  }
  /**
   * Move a session-owned project to the caller's signed-in AWS account.
   * The Bearer token rides on the MCP transport; the destination account is
   * derived server-side. Ownership / EPO / signed-in guards are enforced by
   * the server's repository.moveProject.
   */
  async moveProject(projectId) {
    await getTokenManager(this.logger).ensureToken();
    try {
      return await this.callMcpTool("moveProject", {
        projectId
      });
    } catch (error) {
      const message = error instanceof Error ? error.message : String(error);
      if (/insufficient permissions|not found or insufficient/i.test(message)) {
        this.logger.warn(`moveProject no-op: project ${projectId} already moved (session no longer owns it)`);
        return { projectId, movedAt: "", movedTo: "" };
      }
      throw error;
    }
  }
  /**
   * List all projects with pagination support.
   *
   * When `suppressBearer` is true, the OAuth Bearer is omitted for this call so the
   * server resolves to the SESSION identity (returns browser/session projects)
   * even while signed in. Used to fetch the session side of the signed-in union.
   */
  async listProjects(nextToken, suppressBearer) {
    if (!suppressBearer) {
      await this.ensurePointOfUseBearer("listProjects");
      return this.callMcpTool("listProjects", {
        nextToken,
        limit: _MaxServiceClient.LIST_PROJECTS_PAGE_SIZE
      });
    }
    const suppressNonce = `suppress-${Date.now()}-${Math.random().toString(36).slice(2)}`;
    this.suppressedRequestIds.add(suppressNonce);
    try {
      return await this.callMcpTool(
        "listProjects",
        { nextToken, limit: _MaxServiceClient.LIST_PROJECTS_PAGE_SIZE },
        { suppressBearerNonce: suppressNonce }
      );
    } finally {
      this.suppressedRequestIds.delete(suppressNonce);
    }
  }
  /**
   * Send a message to a project
   */
  async sendMessage(projectId, contentOrBlocks) {
    const contentBlocks = typeof contentOrBlocks === "string" ? [{ text: contentOrBlocks }] : contentOrBlocks;
    return this.callMcpTool("sendMessage", {
      projectId,
      contentBlocks
    });
  }
  sendMessageWithStreaming(projectTurnId, contentOrBlocks, handlers, agent, webIdentityTokenOverride, metadata) {
    const abortController = new AbortController();
    const contentBlocks = typeof contentOrBlocks === "string" ? [{ text: contentOrBlocks }] : contentOrBlocks;
    noteMcpCallForOriginGrantRecovery("sendMessageWithStreaming");
    void (async () => {
      try {
        const artifactSchemas = await this.resolveArtifactSchemas();
        await this.startMcpStreaming(
          "sendMessageWithStreaming",
          {
            projectTurnId,
            contentBlocks,
            agent,
            ...metadata,
            ...webIdentityTokenOverride && { webIdentityToken: webIdentityTokenOverride },
            ...Object.keys(artifactSchemas).length > 0 && { artifactSchemas }
          },
          handlers,
          abortController
        );
      } catch (error) {
        this.reportStreamingFailure("sendMessageWithStreaming", error, handlers);
      }
    })();
    return abortController;
  }
  /**
   * Create a project with streaming response
   * Returns an AbortController to cancel the stream
   */
  createProjectWithStreaming(options, handlers) {
    const abortController = new AbortController();
    noteMcpCallForOriginGrantRecovery("createProject");
    void (async () => {
      try {
        const artifactSchemas = await this.resolveArtifactSchemas();
        await this.startMcpStreaming(
          "createProject",
          {
            ...options,
            ...Object.keys(artifactSchemas).length > 0 && { artifactSchemas }
          },
          handlers,
          abortController
        );
      } catch (error) {
        this.reportStreamingFailure("createProject", error, handlers);
      }
    })();
    return abortController;
  }
  /**
   * Send a tools request with content blocks
   */
  async sendToolsRequest(contentBlocks, projectId, agent, webIdentityTokenOverride) {
    return this.callMcpTool("sendMessageWithStreaming", {
      contentBlocks,
      projectId,
      agent,
      ...webIdentityTokenOverride && { webIdentityToken: webIdentityTokenOverride }
    });
  }
  /**
   * Check if the server is healthy
   */
  async checkHealth() {
    return this.callMcpTool("checkHealth", {});
  }
  /**
   * Upload a document to get a presigned S3 URL
   */
  async uploadDocument(projectId, fileName) {
    return this.callMcpTool("uploadDocument", { projectId, fileName });
  }
  /**
   * List documents for a project (triggers summary generation)
   */
  async listDocuments(projectId) {
    return this.callMcpTool("listDocuments", { projectId });
  }
  /**
   * Search AWS Marketplace listings
   * Uses MCP tool call for stateless execution
   */
  async searchListings(searchParams) {
    return this.callMcpTool("searchListings", searchParams);
  }
  /**
   * Get listing overview by listing IDs (max 10)
   * Uses MCP tool call for stateless execution
   */
  async getListingOverview(listingIds) {
    return this.callMcpTool("getListingOverview", { listingIds });
  }
  /**
   * Get full review content by listing ID and review ID
   * Uses MCP tool call for stateless execution
   */
  async getFullReview(listingId, reviewId) {
    return this.callMcpTool("getFullReview", {
      listingId,
      reviewId
    });
  }
  /**
   * Submit feedback for a message (thumbs up/down)
   * Uses dedicated MCP tool for direct persistence to project state
   */
  async submitFeedback(projectId, messageId, sentiment, categories, feedbackText, retried) {
    return this.callMcpTool("submitFeedback", { projectId, messageId, sentiment, categories, feedbackText, ...retried && { retried } });
  }
  /**
   * Set the project's tool-authorization behavior (the dangerously-skip-permissions toggle) by
   * invoking the generic `updateProjectSettings` control-plane op through the elicitation door.
   *
   * The server executes the op against durable project state with NO turn and NO conversation, and
   * returns the persisted `settings`. `enabled: true` maps to `"skip-tool-authorization"`; `false`
   * to `"enforce-tool-authorization"` (prompt again). This client wrapper keeps its narrow semantic
   * name — it is what the toggle handler calls — while the underlying tool is generic and can carry
   * other setting groups over time.
   *
   * Because a non-turn write is not streamed to an already-connected client, the caller updates its
   * store from the returned `settings`.
   */
  async setToolAuthorizationBehavior(projectId, enabled) {
    return this.callMcpTool("submitElicitationResponse", {
      // The door resolves a control-plane op by name AND gates on this reserved namespace — it marks
      // the submission as a platform action rather than a config namespace (shared with the server).
      elicitationNamespace: CONTROL_PLANE_ELICITATION_NAMESPACE,
      elicitationName: "updateProjectSettings",
      // projectId rides INSIDE the tool's input blob, not on the envelope — the envelope stays a pure
      // elicitation contract. The door reads it from `input.input` on the control-plane branch; the
      // tool itself ignores it and applies the `approvals` group.
      input: {
        projectId,
        approvals: { behavior: enabled ? ToolAuthorizationBehavior.Skip : ToolAuthorizationBehavior.Enforce }
      },
      fields: {}
    });
  }
  /**
   * Upload files to a project with progress tracking
   * Orchestrates the full upload workflow: get presigned URLs → upload to S3 → trigger processing
   */
  async uploadFilesToProject(projectId, files, callbacks) {
    await Promise.all(
      files.map(async (file) => {
        try {
          const result = await this.uploadDocument(projectId, file.name);
          if (!result || !result.uploadUrl) {
            throw new Error(`Failed to get upload URL for ${file.name}`);
          }
          const { uploadUrl } = result;
          await uploadFileToS3(file, uploadUrl, (percent) => {
            callbacks?.onProgress?.(file.name, percent);
          });
          callbacks?.onSuccess?.(file.name);
        } catch (error) {
          const errorMessage = error instanceof Error ? error.message : "Upload failed";
          callbacks?.onError?.(file.name, errorMessage);
          throw error;
        }
      })
    );
    callbacks?.onProcessing?.();
    await this.listDocuments(projectId);
    callbacks?.onComplete?.();
  }
  /**
   * Resolve the shared MCP connection, opening one if there isn't already an in-flight
   * or established connection.
   *
   * Failure is deliberately NOT sticky. A rejected promise stays rejected forever, so
   * caching one would poison the client for the life of the page and leave a reload as
   * the only recovery. Clearing the field on rejection lets the next call re-attempt —
   * the same self-healing reconnect() already relies on for session expiry.
   *
   * The same catch marks the rejection handled. connect() is called at construction but
   * may not be awaited for seconds (or ever, if the customer never acts), and without a
   * handler attached in that window a failure surfaces as an unhandled rejection. The
   * handler does not swallow anything: .catch() returns a new promise and leaves this
   * one untouched, so every awaiting caller still sees the original error.
   */
  connect() {
    if (!this.connection) {
      const connection = _MaxServiceClient.createMcpClient(this.sessionStore, { locale: this.locale }, this.suppressedRequestIds, this.logger);
      this.connection = connection;
      connection.catch((error) => {
        this.logger.warn("MCP handshake failed; will re-attempt on the next call", { error: String(error) });
        if (this.connection === connection) {
          this.connection = null;
        }
      });
    }
    return this.connection;
  }
  /**
   * Surface a pre-stream failure through the handler the caller already listens on.
   *
   * `startMcpStreaming` owns error reporting once it is running; anything that fails before it
   * starts has no other way out of a voided promise.
   */
  reportStreamingFailure(toolName, error, handlers) {
    const failure = error instanceof Error ? error : new Error(String(error));
    this.logger.error(`Failed to start ${toolName}`, failure, { toolName });
    handlers.onError?.(new ErrorEvent("error", { error: failure }));
  }
  /**
   * Artifact schemas for the wire payload: one per widget that loaded.
   *
   * A widget that failed to load is already logged and left out by discovery, so the send goes
   * ahead without its schema rather than failing for an agent the customer may not be using. That
   * is safe because the server's schema registry only ever adds: omitting a type removes nothing
   * it already holds.
   *
   * Deliberately NOT caught. Discovery rejects only when the pass itself throws, which is a
   * defect, so failing the send there is fail-fast at the point closest to the cause.
   */
  async resolveArtifactSchemas() {
    return getArtifactSchemas(await this.artifactWidgets());
  }
  /**
   * Standardized wrapper for MCP tool calls with strong typing and retry logic
   *
   * Handles two types of retries:
   * 1. Session invalidation (-99999): Reconnect with new session and retry ONCE
   * 2. Timeout errors: Exponential backoff up to maxRetries
   *
   * @param toolName - Name of the MCP tool to call
   * @param args - Arguments to pass to the tool (may include optional webIdentityToken)
   * @param extraMeta - Optional additional _meta fields to include in the request
   * @returns Typed response from the tool
   * @throws Error if the tool call fails after all retries
   */
  async callMcpTool(toolName, args, extraMeta) {
    noteMcpCallForOriginGrantRecovery(toolName);
    const maxRetries = 3;
    const baseDelayInMilliseconds = 2e3;
    const timeoutInMilliseconds = 9e5;
    let sessionRetryAttempted = false;
    for (let attempt = 0; attempt < maxRetries; attempt++) {
      let callRequestId;
      try {
        const mcpClient = await this.connect();
        const result = await mcpClient.callTool(
          {
            name: toolName,
            _meta: {
              locale: this.locale,
              ...extraMeta
            },
            arguments: args
            // webIdentityToken optional in args
          },
          void 0,
          // resultSchema parameter (optional)
          {
            timeout: timeoutInMilliseconds
          }
        );
        callRequestId = nonEmptyString(result._meta?.[MAX_REQUEST_ID_META_KEY]);
        if (result.isError) {
          const errorMessage = this.extractTextOrDefault(result, "Unknown error");
          throw new Error(errorMessage);
        }
        const responseText = this.extractTextOrDefault(result, "{}");
        return JSON.parse(responseText);
      } catch (error) {
        if (this.isThrottleError(error)) {
          withCallIds({ maxRequestId: callRequestId }, () => {
            this.logger.warn(`Throttled calling ${toolName}`, { toolName, attempt });
            this.logger.opsMetric({ metricName: CustomOpsMetricName.ClientSideThrottled, unit: "Count", value: 1 });
          });
          throw new ThrottleError(error instanceof Error ? error : void 0);
        }
        if (this.isSessionInvalidError(error) && !sessionRetryAttempted) {
          sessionRetryAttempted = true;
          withCallIds({ maxRequestId: callRequestId }, () => this.logger.warn(`Session invalid, reconnecting for ${toolName}`, { toolName }));
          await this.reconnectWithNewSession();
          continue;
        }
        if (this.isInvalidTokenError(error)) {
          withCallIds(
            { maxRequestId: callRequestId },
            () => this.logger.warn(`Bearer token rejected calling ${toolName}; clearing for re-mint`, { toolName, attempt })
          );
          getTokenManager(this.logger).clear();
          throw error;
        }
        if (error instanceof McpError && error.code === ErrorCode.RequestTimeout && attempt < maxRetries - 1) {
          const delay = computeRetryDelayMs(baseDelayInMilliseconds, attempt);
          withCallIds(
            { maxRequestId: callRequestId },
            () => this.logger.warn(`Timeout calling ${toolName}, retrying in ${delay}ms`, { toolName, attempt, delay })
          );
          await new Promise((resolve) => setTimeout(resolve, delay));
          continue;
        }
        withCallIds(
          { maxRequestId: callRequestId },
          () => this.logger.error(`Failed calling ${toolName}`, error instanceof Error ? error : new Error(String(error)), { toolName, attempt })
        );
        throw error;
      }
    }
    throw new Error(`Failed to call MCP tool ${toolName} after ${maxRetries} attempts`);
  }
  /**
   * Extract text content from a CallToolResult or return a default value
   * Follows the functional pattern of "get or default"
   *
   * @param result - The result from an MCP tool call (may not have content in error cases)
   * @param defaultValue - Fallback value if text extraction fails
   */
  extractTextOrDefault(result, defaultValue) {
    const r = result;
    if (r.content && r.content.length > 0) {
      const firstContent = r.content[0];
      if (firstContent.type === "text" && firstContent.text) {
        return firstContent.text;
      }
    }
    return defaultValue;
  }
  /**
   * Check if error indicates session invalidation
   * Server returns code -99999 for invalid/expired session IDs
   */
  isSessionInvalidError(error) {
    if (error instanceof McpError) {
      if (error.code === -99999) {
        return true;
      }
      const message = error.message?.toLowerCase() || "";
      return message.includes("invalid") && message.includes("session");
    }
    if (error instanceof Error) {
      const message = error.message?.toLowerCase() || "";
      return message.includes("invalid") && message.includes("session");
    }
    return false;
  }
  /**
   * Check if an error is a throttle/rate-limit response.
   *
   * Three cases from the MCP SDK when Lambda returns 429:
   * 1. POST path: Error("Error POSTing to endpoint (HTTP 429): ")
   * 2. SSE GET path: StreamableHTTPError("Streamable HTTP error: Failed to open SSE stream: Too Many Requests") with .code = 429
   * 3. Our server handler runs and returns a structured error with a code from error-classifier.ts.
   */
  isThrottleError(error) {
    if (!(error instanceof Error))
      return false;
    if (error.code === 429 || error.message.includes("HTTP 429") || error.message.includes("Too Many Requests")) {
      return true;
    }
    try {
      const parsed = JSON.parse(error.message);
      return _MaxServiceClient.THROTTLE_ERROR_CODES.has(parsed?.error?.code);
    } catch {
      return false;
    }
  }
  /**
   * Bearer token rejected by the server's ARPS gate (HTTP 401, RFC 6750 invalid_token):
   * expired/invalid/revoked. The token rides in a header (not the JSON-RPC body), so the
   * SDK surfaces this as a raw HTTP error — "HTTP 401" on the POST path, .code on the SSE path.
   */
  isInvalidTokenError(error) {
    if (!(error instanceof Error))
      return false;
    return error.code === 401 || error.message.includes("HTTP 401");
  }
  /**
   * Bearer token rejected by the server's ARPS gate (HTTP 403, RFC 6750 insufficient_scope):
   * the token is valid but lacks permission. Terminal — re-signing-in cannot fix it.
   */
  isPermissionError(error) {
    if (!(error instanceof Error))
      return false;
    return error.code === 403 || error.message.includes("HTTP 403");
  }
  /**
   * Reconnect with a new session after session invalidation
   * Clears the invalid session, closes the client, and creates a new connection
   * Rate-limited to prevent session multiplication storms
   */
  async reconnectWithNewSession() {
    const now = Date.now();
    const elapsed = now - this.lastReconnectionAttempt;
    if (elapsed < _MaxServiceClient.MIN_RECONNECTION_INTERVAL_MS) {
      this.logger.warn("Session reconnection rate-limited", { elapsed, minInterval: _MaxServiceClient.MIN_RECONNECTION_INTERVAL_MS });
      this.logger.opsMetric({ metricName: CustomOpsMetricName.ClientSideReconnectionRateLimited, unit: "Count", value: 1 });
      throw new Error("Session reconnection rate-limited");
    }
    this.lastReconnectionAttempt = now;
    this.sessionStore.setSessionId(void 0);
    try {
      await this.connection?.then((mcpClient) => mcpClient.close());
    } catch (error) {
      console.debug("Error closing MCP client during reconnection:", error);
    }
    this.connection = null;
    await this.connect();
  }
  /**
   * Parse and validate MCP patch notification (fail-fast)
   *
   * Throws errors immediately on invalid format instead of returning false.
   * This follows the fail-fast principle - expose problems early.
   *
   * @param message - JSON string from MCP notification
   * @returns Parsed and validated MCPPatchNotification
   * @throws Error if message is not valid JSON or missing required fields
   */
  parsePatchNotification(message) {
    let parsed;
    try {
      parsed = JSON.parse(message);
    } catch (error) {
      throw new Error(`Invalid JSON in MCP notification: ${error instanceof Error ? error.message : String(error)}`);
    }
    if (typeof parsed !== "object" || parsed === null) {
      throw new Error(`MCP notification must be an object, got ${typeof parsed}`);
    }
    const obj = parsed;
    if (!("patch" in obj)) {
      throw new Error("MCP notification missing required field: patch");
    }
    if (!("projectId" in obj)) {
      throw new Error("MCP notification missing required field: projectId");
    }
    return obj;
  }
  /**
   * Mint a bearer at the point of use. THE one gate, shared by every route that needs one.
   *
   * WHY POINT OF USE AT ALL. Nothing mints on page load, and the transport's fetch hook reads the token
   * store synchronously, so a mint must complete BEFORE the request or it is not attached. The other
   * mint sites are `moveProject` (unconditional, rare and customer-initiated) and the two authentication
   * prompt cards, which need a turn to have already asked. So a console session renewed out of band
   * leaves the binding clear having discarded the bearer with nothing to mint a replacement, and every
   * subsequent write is refused by a `sigv4: required` enricher.
   *
   * WHY BOTH HALVES OF THE GATE. Do NOT simplify the `!getToken()` half away as redundant with
   * `ensureToken`'s own check: the gate reads USABLE and `ensureToken` reads FRESH, so inside the
   * refresh lead they deliberately disagree, and the gate is the only thing keeping a background call
   * from firing a mint MAX already knows will be refused. That refused mint would also emit the
   * `MintRefused` signal, manufacturing the very datapoints the metric exists to count. The
   * `hasAwsSession()` half is independently load-bearing: it carries the `isOAuthMintEnabled()` rollout
   * gate that makes this fail closed, and it is what makes this correctly do NOTHING after a deliberate
   * sign-out, where continuing to act for the customer would be the defect.
   *
   * WHY FAILURE IS SWALLOWED. The mint is OPPORTUNISTIC, so its failure is not a failure of the
   * operation the caller asked for. A lifetime refusal is an expected end-of-session condition, and on
   * the streaming routes routing it to `handlers.onError` would unwind the turn and break requests
   * needing no bearer at all. `listProjects` lists as the session identity instead.
   *
   * NOT BOUNDED BY A DEADLINE, matching the behaviour this gate has already shipped with on
   * `listProjects`. `AwsRelayHandler` wraps a bare `new FetchHttpHandler()` with no `requestTimeout`, so
   * on the non-prod relay path a stalled mint can hold its caller open. That risk is not introduced
   * here: it is exactly what Home's project list has carried in Prod without incident, and the prod mint
   * handler sets its own `requestTimeout`. The right place to bound it is `AwsRelayHandler` itself, which
   * would cover every SDK call through the relay rather than these two callers, and is tracked
   * separately. Do not add a caller-side race here without revisiting that.
   *
   * Streaming callers still re-check their abort signal afterwards, since a mint is a network round trip
   * and `callTool` is never handed the signal.
   */
  async ensurePointOfUseBearer(toolName) {
    this.readPendingSignInOnce();
    const tokenManager = getTokenManager(this.logger);
    if (tokenManager.getToken()) {
      originGrantReturnedFromSignIn = false;
      return;
    }
    if (!tokenManager.hasAwsSession()) {
      return;
    }
    try {
      await tokenManager.ensureToken();
      originGrantReturnedFromSignIn = false;
    } catch (error) {
      this.logger.warn(`Point-of-use mint failed before ${toolName}; continuing without a bearer`, {
        error: error instanceof Error ? error.message : String(error)
      });
      this.recoverOriginGrant(toolName, error);
    }
  }
  /**
   * Consumes the pending-sign-in marker once per page load, so it cannot outlive the load. If storage is
   * blocked the loop guard is unreliable, so recovery is turned off rather than risking a loop.
   */
  readPendingSignInOnce() {
    if (originGrantReturnedFromSignIn !== void 0) {
      return;
    }
    try {
      originGrantReturnedFromSignIn = consumePendingSignIn() !== null;
    } catch (error) {
      originGrantReturnedFromSignIn = false;
      originGrantRecoveryClosed = true;
      this.logger.warn("Could not read the pending-sign-in marker; origin-grant recovery is off for this page", {
        error: error instanceof Error ? error.message : String(error)
      });
    }
  }
  /**
   * Navigates once through the same-origin login path to obtain the origin grant the mint needs (spec R2a; RCA on
   * P504954343). Without the grant the signer 302s the mint to itself, which `redirect: "manual"` surfaces as
   * `AuthenticationError`, and only a top-level navigation can deposit it.
   *
   * Only for page-open reads before any other call, never when the console session is signed out, once per load,
   * and not on the return from a sign-in. Uses `startSignIn` so no console session is ended. Never throws, so the
   * caller is never rejected.
   */
  recoverOriginGrant(toolName, error) {
    if (!(error instanceof AuthenticationError) || !BOOTSTRAP_MINT_CALL_SITES.has(toolName) || originGrantRecoveryClosed) {
      return;
    }
    if (!getTokenManager(this.logger).hasSignedInConsoleSession()) {
      return;
    }
    originGrantRecoveryClosed = true;
    if (originGrantReturnedFromSignIn) {
      this.logger.warn(`Origin grant still absent after a sign-in round trip; continuing without a bearer before ${toolName}`);
      this.logger.opsMetric({ metricName: CustomOpsMetricName.OriginGrantRecoveryExhausted, unit: "Count", value: 1 });
      return;
    }
    try {
      getTokenManager(this.logger).startSignIn();
    } catch (navigationError) {
      this.logger.warn("Could not navigate to sign-in to establish the origin grant; the request proceeds", {
        error: navigationError instanceof Error ? navigationError.message : String(navigationError)
      });
      return;
    }
    this.logger.log(`Navigating to sign-in to establish the origin grant before ${toolName}`);
    this.logger.opsMetric({ metricName: CustomOpsMetricName.OriginGrantRecoveryNavigated, unit: "Count", value: 1 });
  }
  /**
   * Consolidated streaming implementation for all MCP streaming operations
   * Handles SSE event parsing, error handling, session invalidation, and cleanup
   */
  async startMcpStreaming(toolName, toolArgs, handlers, abortController) {
    noteMcpCallForOriginGrantRecovery(toolName);
    await this.ensurePointOfUseBearer(toolName);
    if (abortController.signal.aborted) {
      return;
    }
    const maxAttempts = 2;
    let sessionRetryAttempted = false;
    for (let attempt = 0; attempt < maxAttempts; attempt++) {
      const startTime = Date.now();
      let callIds = {};
      try {
        const notificationHandler = (notification) => {
          if (abortController.signal.aborted || !notification.message || !handlers.onMessage) {
            return;
          }
          try {
            const patchNotification = this.parsePatchNotification(notification.message);
            callIds = { ...callIds, ...streamMessageCallIds(patchNotification) };
          } catch (error) {
            withCallIds(callIds, () => {
              this.logger.log("Skipping invalid MCP notification", {
                toolName,
                errorMessage: error instanceof Error ? error.message : String(error)
              });
              this.logger.opsMetric({
                metricName: CustomOpsMetricName.ClientSidePatchDropped,
                unit: "Count",
                value: 1,
                dimensions: { Stage: "validate" }
              });
            });
            return;
          }
          try {
            handlers.onMessage(new MessageEvent("message", { data: notification.message }));
          } catch (error) {
            console.error("Error in onMessage handler:", error);
          }
        };
        const mcpClient = await this.connect();
        if (handlers.onOpen) {
          handlers.onOpen();
        }
        const result = await mcpClient.callTool(
          {
            name: toolName,
            arguments: toolArgs,
            // webIdentityToken optional in args
            _meta: {
              locale: this.locale
            }
          },
          void 0,
          {
            onprogress: notificationHandler,
            resetTimeoutOnProgress: true
          }
        );
        const responseRequestId = nonEmptyString(result._meta?.[MAX_REQUEST_ID_META_KEY]);
        if (responseRequestId)
          callIds = { ...callIds, maxRequestId: responseRequestId };
        if (result.isError) {
          const errorMessage = this.extractTextOrDefault(result, `${toolName} streaming failed`);
          throw new Error(errorMessage);
        }
        if (handlers.onClose && !abortController.signal.aborted) {
          const content = result.structuredContent;
          const conversationLength = typeof content?.conversationLength === "number" ? content.conversationLength : Array.isArray(content?.conversation) ? content.conversation.length : void 0;
          const finalResult = conversationLength === void 0 ? void 0 : { conversationLength };
          handlers.onClose(finalResult);
        }
        return;
      } catch (error) {
        if (error instanceof Error && error.name === "AbortError") {
          return;
        }
        if (this.isThrottleError(error)) {
          withCallIds(callIds, () => {
            this.logger.warn(`Throttled during ${toolName} streaming`, { toolName });
            this.logger.opsMetric({ metricName: CustomOpsMetricName.ClientSideThrottled, unit: "Count", value: 1 });
          });
          if (handlers.onError) {
            handlers.onError(new ErrorEvent("error", { error: new ThrottleError(error instanceof Error ? error : void 0) }));
          }
          return;
        }
        if (this.isSessionInvalidError(error) && !sessionRetryAttempted) {
          sessionRetryAttempted = true;
          await this.reconnectWithNewSession();
          continue;
        }
        if (this.isPermissionError(error)) {
          withCallIds(callIds, () => this.logger.warn(`Permission denied during ${toolName} streaming`, { toolName }));
          if (handlers.onError) {
            handlers.onError(new ErrorEvent("error", { error }));
          }
          return;
        }
        if (this.isInvalidTokenError(error)) {
          withCallIds(callIds, () => this.logger.warn(`Bearer token rejected during ${toolName} streaming; clearing for re-mint`, { toolName }));
          getTokenManager().clear();
          if (handlers.onError) {
            handlers.onError(new ErrorEvent("error", { error }));
          }
          return;
        }
        const durationMs = Date.now() - startTime;
        const errorObj = error instanceof Error ? error : new Error("Streaming failed");
        withCallIds(
          callIds,
          () => this.logger.error("Streaming failed", errorObj, {
            toolName,
            durationMs,
            errorName: errorObj.name,
            errorMessage: errorObj.message
          })
        );
        if (handlers.onError) {
          handlers.onError(new ErrorEvent("error", { error: errorObj }));
        }
        return;
      }
    }
  }
};

// src/capabilities/services/MaxServiceContext.tsx
import { useAppTranslation as useAppTranslation2 } from "@amzn/awsmp-max-translations";

// src/capabilities/logging/LoggerContext.tsx
import * as React7 from "react";
import { jsx as jsx4 } from "react/jsx-runtime";
var LoggerContext = React7.createContext(void 0);
function LoggerProvider({ children, config }) {
  const { debug } = useDebug();
  const logger = React7.useMemo(() => createSafeLogger(debug, {}, config?.browserInfo), [debug, config?.browserInfo]);
  return /* @__PURE__ */ jsx4(LoggerContext.Provider, { value: logger, children });
}
function useLogger() {
  const logger = React7.useContext(LoggerContext);
  if (!logger) {
    throw new Error("useLogger must be used within LoggerProvider. Please wrap your application with <LoggerProvider>");
  }
  return logger;
}

// src/capabilities/logging/useLoggerManager.ts
import * as React8 from "react";
function wrapSafeLoggerAsLoggerManager(safeLogger) {
  return {
    log: safeLogger.log,
    error: safeLogger.error,
    warn: safeLogger.warn,
    info: safeLogger.log,
    // Info is a synonym for log
    debug: safeLogger.debug,
    opsMetric: safeLogger.opsMetric,
    biMetric: safeLogger.biMetric,
    updateContext: safeLogger.updateContext,
    pageHit: safeLogger.pageHit,
    subPageHit: safeLogger.subPageHit,
    setDimensions: (dimensions) => {
      const newLogger = safeLogger.setDimensions(dimensions);
      return wrapSafeLoggerAsLoggerManager(newLogger);
    }
  };
}
function useLoggerManager() {
  const logger = useLogger();
  return React8.useMemo(() => wrapSafeLoggerAsLoggerManager(logger), [logger]);
}

// src/capabilities/services/MaxServiceContext.tsx
import { jsx as jsx5 } from "react/jsx-runtime";
var MaxServiceContext = React9.createContext(void 0);
function captureWebIdentityTokenFromUrl() {
  const searchParams = new URLSearchParams(window.location.search);
  const hash = window.location.hash;
  const hashParts = hash.split("?");
  const hashPath = hashParts[0];
  const hashSearch = hashParts[1] || "";
  const hashParams = new URLSearchParams(hashSearch);
  const witFromUrl = searchParams.get("wit") || hashParams.get("wit");
  if (!witFromUrl) {
    return;
  }
  localStorage.setItem("web-identity-token", witFromUrl);
  searchParams.delete("wit");
  hashParams.delete("wit");
  const newSearch = searchParams.toString();
  const newHashSearch = hashParams.toString();
  const newHash = hashPath + (newHashSearch ? `?${newHashSearch}` : "");
  const cleanUrl = window.location.pathname + (newSearch ? `?${newSearch}` : "") + newHash;
  window.history.replaceState({}, "", cleanUrl);
}
function MaxServiceProvider({ children, discovery }) {
  const { currentLanguage } = useAppTranslation2();
  const logger = useLogger();
  const [client] = React9.useState(() => {
    captureWebIdentityTokenFromUrl();
    return MaxServiceClient.of(useMaxSessionStore, { locale: currentLanguage }, logger, () => discovery.artifactWidgets());
  });
  React9.useEffect(() => {
    return () => {
      cleanupProjectStore();
    };
  }, []);
  return /* @__PURE__ */ jsx5(MaxServiceContext.Provider, { value: client, children });
}
function useMaxServiceClient() {
  const client = React9.useContext(MaxServiceContext);
  if (!client) {
    throw new Error("useMaxServiceClient must be used within MaxServiceProvider. Please wrap your application with <MaxServiceProvider>");
  }
  return client;
}

// src/capabilities/navigation/NavigationContext.tsx
import * as React16 from "react";

// src/capabilities/navigation/RouteRegistry.ts
var RouteRegistry = class {
  routes;
  flatRoutes = /* @__PURE__ */ new Map();
  constructor(routes) {
    this.routes = routes;
    this.flatten();
  }
  // Get the raw route definitions
  getRoutes() {
    return this.routes;
  }
  // Get all paths for React Router
  getPaths() {
    const paths = {};
    this.flatRoutes.forEach((value, key) => {
      paths[key] = value.path;
    });
    return paths;
  }
  // Get link function for navigation
  getLink(name) {
    return this.flatRoutes.get(name)?.link;
  }
  // Match current pathname to a route
  matchRoute(pathname) {
    for (const [name, route] of this.flatRoutes.entries()) {
      const pattern = route.path.replace(/:[^/]+/g, "([^/]+)").replace(/\//g, "\\/");
      const regex = new RegExp(`^${pattern}$`);
      const match = pathname.match(regex);
      if (match) {
        const paramNames = (route.path.match(/:(\w+)/g) || []).map((p) => p.slice(1));
        const params = {};
        paramNames.forEach((paramName, index) => {
          params[paramName] = match[index + 1];
        });
        return { name, params };
      }
    }
    return null;
  }
  // Get breadcrumb route chain for current location
  // Returns the route chain info that can be used with hooks
  getBreadcrumbRoutes(pathname) {
    const matched = this.matchRoute(pathname);
    if (!matched)
      return [];
    const routeChain = [];
    let current2 = matched.name;
    while (current2) {
      const route = this.flatRoutes.get(current2);
      if (!route)
        break;
      const routeParams = {};
      const paramMatches = route.path?.match(/:(\w+)/g) || [];
      paramMatches.forEach((match) => {
        const paramName = match.slice(1);
        if (matched.params[paramName]) {
          routeParams[paramName] = matched.params[paramName];
        }
      });
      routeChain.unshift({ route, params: routeParams });
      current2 = route.parent;
    }
    return routeChain;
  }
  // Flatten nested structure while preserving parent relationships
  flatten(node = this.routes, parent = null) {
    for (const [key, value] of Object.entries(node)) {
      if (value.path && value.link && value.getBreadcrumbText) {
        this.flatRoutes.set(key, {
          path: value.path,
          link: value.link,
          getBreadcrumbText: value.getBreadcrumbText,
          useBreadcrumbs: value.useBreadcrumbs,
          parent
        });
      }
      if (value.children) {
        this.flatten(value.children, key);
      }
    }
  }
};

// src/capabilities/services/useProject.ts
import * as React10 from "react";
import { TurnStatus as TurnStatus3 } from "@amzn/awsmp-max-model";
function useProject({ projectId, forceRefresh = false }) {
  const client = useMaxServiceClient();
  const maxService = useMaxService();
  const projectData = useProjectStoreInternal((state) => state.currentProjectId === projectId ? state.currentProject : null);
  React10.useEffect(() => {
    useProjectStoreInternal.getState().getProject(client, projectId, forceRefresh);
  }, [client, projectId, forceRefresh]);
  const uploadFiles = React10.useCallback(
    async (files, callbacks) => {
      return maxService.uploadFilesToProject(projectId, files, callbacks);
    },
    [maxService, projectId]
  );
  const sendMessage = React10.useCallback(
    async (input) => {
      if (typeof input === "object" && input !== null && "contentBlocks" in input) {
        const { contentBlocks, files, uploadCallbacks, projectName, projectDescription, tags, agent } = input;
        if (files && files.length > 0) {
          const state = useProjectStoreInternal.getState();
          const current2 = state.currentProjectId === projectId ? state.currentProject : null;
          if (current2?.renderContext?.turnStatus === TurnStatus3.Processing) {
            return { status: "rejected" };
          }
          await maxService.uploadFilesToProject(projectId, files, uploadCallbacks);
        }
        if (projectName !== void 0 || projectDescription !== void 0 || tags !== void 0) {
          return maxService.sendMessageWithStreaming(projectId, { contentBlocks, projectName, projectDescription, tags }, void 0, agent);
        }
        return maxService.sendMessageWithStreaming(projectId, contentBlocks, void 0, agent);
      }
      return maxService.sendMessageWithStreaming(projectId, input);
    },
    [maxService, projectId]
  );
  const interruptProject = React10.useCallback(async () => {
    await maxService.interruptProject(projectId);
  }, [maxService, projectId]);
  if (!projectData) {
    return {
      id: projectId,
      renderContext: null,
      isLoading: true,
      error: null,
      sendMessage,
      uploadFiles,
      interruptProject
    };
  }
  return {
    id: projectId,
    renderContext: projectData.renderContext,
    isLoading: projectData.isLoading,
    error: projectData.error,
    sendMessage,
    uploadFiles,
    interruptProject
  };
}

// src/capabilities/services/useProjectCreation.ts
import * as React13 from "react";

// src/capabilities/navigation/useNavigation.ts
import * as React11 from "react";

// src/capabilities/navigation/breadcrumbStore.ts
import { create as create8 } from "zustand";
var useBreadcrumbStore = create8((set2) => ({
  breadcrumbs: [],
  setBreadcrumbs: (breadcrumbs) => set2({ breadcrumbs })
}));
var useBreadcrumbs = () => {
  const breadcrumbs = useBreadcrumbStore((state) => state.breadcrumbs);
  const setBreadcrumbs = useBreadcrumbStore((state) => state.setBreadcrumbs);
  return { breadcrumbs, setBreadcrumbs };
};

// src/capabilities/navigation/navigationStateStore.ts
import { create as create9 } from "zustand";
var useNavigationStateStore = create9((set2, get) => ({
  ephemeralStates: /* @__PURE__ */ new Map(),
  // Internal setter - not exported, only used by navigate()
  setEphemeralState: (routeName, ephemeralState) => {
    set2((state) => {
      const newStates = new Map(state.ephemeralStates);
      newStates.set(routeName, ephemeralState);
      return { ephemeralStates: newStates };
    });
  },
  // Retrieves and clears ephemeral state for a specific route
  consumeEphemeralState: (routeName) => {
    const ephemeralState = get().ephemeralStates.get(routeName) ?? null;
    set2((state) => {
      const newStates = new Map(state.ephemeralStates);
      newStates.delete(routeName);
      return { ephemeralStates: newStates };
    });
    return ephemeralState;
  }
}));

// src/capabilities/navigation/useNavigation.ts
function useNavigation() {
  const { navigate: navigateFn, registry } = useNavigationContext();
  const paths = React11.useMemo(() => registry.getPaths(), [registry]);
  const navigate = React11.useCallback(
    (name, params, options) => {
      if (!navigateFn) {
        console.warn(`Navigation not available for route: ${name}`);
        return;
      }
      const linkFn = registry.getLink(name);
      if (!linkFn)
        throw new Error(`Unknown route: ${name}`);
      if (options && "ephemeralState" in options && options.ephemeralState !== void 0) {
        useNavigationStateStore.getState().setEphemeralState(name, options.ephemeralState);
      }
      const path = linkFn(params || {});
      navigateFn(path);
    },
    [navigateFn, registry]
  );
  const consumeEphemeralState = React11.useCallback(
    (routeName) => {
      return useNavigationStateStore.getState().consumeEphemeralState(routeName);
    },
    []
  );
  const navigateByHref = React11.useCallback(
    (href) => {
      if (!navigateFn) {
        console.warn(`Navigation not available for href: ${href}`);
        return;
      }
      navigateFn(href);
    },
    [navigateFn]
  );
  const useBreadcrumbs2 = () => {
    const { breadcrumbs } = useBreadcrumbs();
    return breadcrumbs;
  };
  return {
    navigate,
    navigateByHref,
    consumeEphemeralState,
    paths,
    useBreadcrumbs: useBreadcrumbs2,
    registry
  };
}

// src/capabilities/navigation/withAsyncBreadcrumbs.tsx
import * as React12 from "react";
import { jsx as jsx6 } from "react/jsx-runtime";
function matchRoute(location, pattern) {
  const patternParts = pattern.split("/");
  const locationParts = location.split("/");
  if (patternParts.length !== locationParts.length)
    return false;
  return patternParts.every((part, i) => {
    return part.startsWith(":") || part === locationParts[i];
  });
}
function findRouteByLocation(routes, location) {
  for (const [, route] of Object.entries(routes)) {
    if (matchRoute(location, route.path)) {
      return route;
    }
    if (route.children) {
      const found = findRouteByLocation(route.children, location);
      if (found)
        return found;
    }
  }
  return void 0;
}
function getParentRoutes(routes, targetRoute, parents = []) {
  for (const [, route] of Object.entries(routes)) {
    if (route === targetRoute) {
      return parents;
    }
    if (route.children) {
      const found = getParentRoutes(route.children, targetRoute, [...parents, route]);
      if (found.length > parents.length)
        return found;
    }
  }
  return parents;
}
function withAsyncBreadcrumbs(Component6) {
  return (props) => {
    const location = props.location?.pathname || props.location;
    const params = props.params || {};
    const { setBreadcrumbs } = useBreadcrumbs();
    const { registry } = useNavigationContext();
    const routeDefinitions = registry.routes || {};
    const route = findRouteByLocation(routeDefinitions, location);
    const parentRoutes = route ? getParentRoutes(routeDefinitions, route) : [];
    const useBreadcrumbHook = route?.useBreadcrumbs || (() => void 0);
    const breadcrumbData = useBreadcrumbHook(params);
    const parentBreadcrumbData = parentRoutes.map((parentRoute) => {
      const useParentBreadcrumb = parentRoute.useBreadcrumbs || (() => void 0);
      return {
        route: parentRoute,
        data: useParentBreadcrumb(params)
      };
    });
    React12.useEffect(() => {
      const breadcrumbs = [];
      parentBreadcrumbData.forEach(({ route: parentRoute, data }) => {
        if (parentRoute) {
          const text = data || parentRoute.getBreadcrumbText(params);
          const href = parentRoute.link(params);
          breadcrumbs.push({
            text: typeof text === "string" ? text : text?.text || parentRoute.getBreadcrumbText(params),
            href
          });
        }
      });
      if (route) {
        const text = breadcrumbData || route.getBreadcrumbText(params);
        const href = route.link(params);
        breadcrumbs.push({
          text: typeof text === "string" ? text : text?.text || route.getBreadcrumbText(params),
          href
        });
      }
      setBreadcrumbs(breadcrumbs);
      return () => {
        setBreadcrumbs([]);
      };
    }, [location, params, breadcrumbData]);
    return /* @__PURE__ */ jsx6(Component6, { ...props });
  };
}

// src/capabilities/navigation/queryParamUtils.ts
function parseQueryParams(search) {
  if (!search)
    return {};
  const queryString = search.startsWith("?") ? search.slice(1) : search;
  if (!queryString)
    return {};
  const params = {};
  const searchParams = new URLSearchParams(queryString);
  searchParams.forEach((value, key) => {
    const bracketMatch = key.match(/^([^[]+)\[([^]]+)\]$/);
    if (bracketMatch) {
      const [, parentKey, childKey] = bracketMatch;
      if (!params[parentKey]) {
        params[parentKey] = {};
      }
      params[parentKey][childKey] = value;
      return;
    }
    if (value.includes(",")) {
      params[key] = value.split(",").map((v) => v.trim());
      return;
    }
    params[key] = value;
  });
  return params;
}
function buildQueryString3(params) {
  const searchParams = new URLSearchParams();
  Object.entries(params).forEach(([key, value]) => {
    if (value === void 0 || value === null) {
      return;
    }
    if (Array.isArray(value)) {
      searchParams.set(key, value.join(","));
    } else if (typeof value === "object" && !Array.isArray(value)) {
      Object.entries(value).forEach(([subKey, subValue]) => {
        if (subValue !== void 0 && subValue !== null) {
          searchParams.set(`${key}[${subKey}]`, String(subValue));
        }
      });
    } else {
      searchParams.set(key, String(value));
    }
  });
  return searchParams.toString();
}

// src/capabilities/services/useProjectCreation.ts
function useProjectCreation() {
  const maxService = useMaxService();
  const { navigate } = useNavigation();
  const [error, setError] = React13.useState(null);
  const createProjectWithStreaming = React13.useCallback(
    (options) => {
      setError(null);
      const { files, uploadCallbacks, contentBlocks, ...projectOptions } = options;
      const shouldDeferMessage = files && files.length > 0;
      maxService.createProjectWithStreaming(
        {
          ...projectOptions,
          // If uploading files, create project with empty contentBlocks
          // We'll send the message after file upload completes
          contentBlocks: shouldDeferMessage ? [] : contentBlocks
        },
        async (projectId) => {
          try {
            if (files && files.length > 0) {
              await maxService.uploadFilesToProject(projectId, files, uploadCallbacks);
              if (contentBlocks.length > 0) {
                let hasNavigated = false;
                maxService.sendMessageWithStreaming(
                  projectId,
                  contentBlocks,
                  {
                    onMessage: (_event) => {
                      if (!hasNavigated) {
                        hasNavigated = true;
                        navigate("project", { projectId });
                      }
                    },
                    onError: (error2) => {
                      reportStreamFailure("project-create", error2, { projectId });
                      if (!hasNavigated) {
                        hasNavigated = true;
                        setError(error2.message);
                        navigate("project", { projectId });
                      }
                    }
                  },
                  projectOptions.agent
                );
                return;
              }
            }
            navigate("project", { projectId });
          } catch (err) {
            const errorMessage = err instanceof Error ? err.message : "Failed to complete project creation";
            setError(errorMessage);
            reportStreamFailure("project-create-setup", err);
          }
        }
      );
    },
    [maxService, navigate]
  );
  return {
    createProjectWithStreaming,
    error
  };
}

// src/capabilities/services/useQueryParamProject.ts
import * as React14 from "react";
import {
  ContentBlockVisibility as ContentBlockVisibility2,
  AGENTS,
  AgentConfigSchema,
  detectStageFromHostname as detectStageFromHostname2,
  getAgentInputFields
} from "@amzn/awsmp-max-model";
var isValidAgent = (agentId, stage) => Object.values(AGENTS).some((a) => a.id === agentId && a.stages.includes(stage));
function parseAgentOverrideParam(value) {
  if (!value)
    return void 0;
  const pairs = Array.isArray(value) ? value : value.split(",");
  const overrides = {};
  for (const pair of pairs) {
    const [agentId, key] = pair.split(":");
    if (agentId && key)
      overrides[agentId.trim()] = key.trim();
  }
  return Object.keys(overrides).length > 0 ? overrides : void 0;
}
function queryParamsToAgentConfig(params, stage = detectStageFromHostname2(window.location.hostname)) {
  if (!params.agent)
    return null;
  if (params.agent === "comparison") {
    if (!Array.isArray(params.listingIds) || params.listingIds.length < 2)
      return null;
    const prompt2 = `Compare these products: ${params.listingIds.join(", ")}`;
    return {
      agent: { agentId: "comparison", listingIds: params.listingIds },
      projectName: `Compare ${params.listingIds.length} products`,
      projectDescription: `Product comparison for: ${params.listingIds.join(", ")}`,
      contentBlocks: [{ text: prompt2, visibility: ContentBlockVisibility2.INFERENCE_ONLY }]
    };
  }
  if (params.agent === "evaluation") {
    if (!params.listingId || !params.productName)
      return null;
    const prompt2 = `Help me evaluate product ${params.productName}. Please analyze the product features, pricing, reviews, and provide a comprehensive evaluation to help with my decision.`;
    return {
      agent: { agentId: "evaluation", listingId: params.listingId },
      projectName: `Proposal for ${params.productName}`,
      projectDescription: `Comprehensive evaluation of product ${params.productName}`,
      contentBlocks: [{ text: prompt2, visibility: ContentBlockVisibility2.INFERENCE_ONLY }]
    };
  }
  if (params.agent === "requirements" || params.agent === "search") {
    if (params.productName || params.listingId) {
      const label = params.productName || "product";
      const prompt3 = `Answer knowledge question about: ${label}`;
      return {
        agent: { agentId: "search", query: prompt3, ...params.listingId && { listingId: params.listingId } },
        projectName: `Research about ${label}`,
        projectDescription: `Product research for ${label}`,
        contentBlocks: [{ text: prompt3, visibility: ContentBlockVisibility2.INFERENCE_ONLY }]
      };
    }
    const prompt2 = "Help me analyze product requirements. I need assistance understanding key features, capabilities, and requirements for products I'm evaluating.";
    return {
      agent: { agentId: "search", query: prompt2 },
      projectName: "Requirements Analysis",
      projectDescription: "General product requirements analysis",
      contentBlocks: [{ text: prompt2 }]
    };
  }
  if (!isValidAgent(params.agent, stage))
    return null;
  const fields = getAgentInputFields(params.agent);
  const agentConfig = { agentId: params.agent };
  for (const field of fields) {
    if (params[field] !== void 0) {
      agentConfig[field] = params[field];
    }
  }
  const parsed = AgentConfigSchema.safeParse(agentConfig);
  if (!parsed.success)
    return null;
  const prompt = `Help me with ${JSON.stringify(agentConfig)}`;
  return {
    agent: parsed.data,
    projectName: `New ${params.agent} project`,
    projectDescription: `Project for ${params.agent} agent`,
    contentBlocks: [{ text: prompt, visibility: ContentBlockVisibility2.INFERENCE_ONLY }]
  };
}
function useQueryParamProject(queryString) {
  const { createProjectWithStreaming, error: creationError } = useProjectCreation();
  const [queryError, setQueryError] = React14.useState(null);
  const processedQueryRef = React14.useRef(null);
  React14.useEffect(() => {
    if (!queryString || processedQueryRef.current === queryString) {
      if (!queryString) {
        setQueryError(null);
      }
      return;
    }
    const params = parseQueryParams(queryString);
    if (Object.keys(params).length === 0) {
      setQueryError(null);
      processedQueryRef.current = queryString;
      return;
    }
    const projectConfig = queryParamsToAgentConfig(params);
    if (!projectConfig) {
      setQueryError(`Invalid query parameters: ${queryString}`);
      processedQueryRef.current = queryString;
      return;
    }
    const agentEndpointOverrides = parseAgentOverrideParam(params.agentOverride);
    processedQueryRef.current = queryString;
    setQueryError(null);
    createProjectWithStreaming({ ...projectConfig, agentEndpointOverrides });
  }, [queryString, createProjectWithStreaming]);
  return {
    error: queryError || creationError
  };
}

// src/capabilities/services/PromptInputActionStore.ts
import { create as create10 } from "zustand";
import * as React15 from "react";
var usePromptInputActionStore = create10()((set2, _get) => ({
  promptInputAction: null,
  queuePromptInputAction(action) {
    set2({
      promptInputAction: { ...action, timestamp: Date.now() }
    });
  },
  consumePromptInputAction() {
    set2({ promptInputAction: null });
  }
}));
function usePromptInputAction() {
  const action = usePromptInputActionStore((state) => state.promptInputAction);
  const consume = React15.useCallback(() => {
    usePromptInputActionStore.getState().consumePromptInputAction();
  }, []);
  return { action, consume };
}

// src/capabilities/navigation/createRouteDefinitions.ts
import { getArtifactLabel, resolveArtifactLabel, useArtifactWidgets } from "@amzn/awsmp-max-data";
function createRouteDefinitions(t) {
  return {
    home: {
      path: "/",
      link: () => "/",
      getBreadcrumbText: () => t("aiMode"),
      children: {
        project: {
          path: "/project/:projectId",
          link: (params) => `/project/${params.projectId}`,
          getBreadcrumbText: (params) => t("breadcrumbProject", { projectId: params.projectId }),
          useBreadcrumbs: (params) => {
            const project = useProject({ projectId: params.projectId });
            return project.renderContext?.projectName;
          },
          children: {
            artifact: {
              path: "/project/:projectId/artifact/:artifactType",
              link: (params) => `/project/${params.projectId}/artifact/${params.artifactType}`,
              getBreadcrumbText: (params) => t("breadcrumbArtifact", { artifactType: params.artifactType }),
              useBreadcrumbs: (params) => {
                const artifactWidgets = useArtifactWidgets();
                return resolveArtifactLabel(getArtifactLabel(params.artifactType, artifactWidgets), t);
              }
            }
          }
        },
        notFound: {
          path: "/404",
          link: () => "/404",
          getBreadcrumbText: () => t("breadcrumbPageNotFound")
        },
        compare: {
          path: "/compare",
          link: () => "/compare",
          getBreadcrumbText: () => t("compareProducts")
        },
        proposal: {
          path: "/proposal",
          link: () => "/proposal",
          getBreadcrumbText: () => t("breadcrumbCreateProposal")
        },
        epo: {
          path: "/epo",
          link: () => "/epo",
          getBreadcrumbText: () => "AWS Marketplace",
          children: {
            epoCreate: {
              path: "/epo/create/:productId?",
              link: (params) => params?.productId ? `/epo/create/${params.productId}` : "/epo/create",
              getBreadcrumbText: () => "Create proposal"
            },
            epoEdit: {
              path: "/epo/:productId/edit",
              link: (params) => `/epo/${params.productId}/edit`,
              getBreadcrumbText: () => "Edit configuration"
            },
            epoView: {
              path: "/epo/:productId",
              link: (params) => `/epo/${params.productId}`,
              getBreadcrumbText: (params) => params.productId
            },
            epoOffer: {
              path: "/epo/offer",
              link: () => "/epo/offer",
              getBreadcrumbText: () => "Get express private offer"
            }
          }
        }
      }
    }
  };
}

// src/capabilities/navigation/NavigationContext.tsx
import { useAppTranslation as useAppTranslation3 } from "@amzn/awsmp-max-translations";
import { jsx as jsx7 } from "react/jsx-runtime";
var NavigationContext = React16.createContext(void 0);
function NavigationProvider({ children, navigate }) {
  const { t } = useAppTranslation3();
  const routeDefinitions = React16.useMemo(() => createRouteDefinitions(t), [t]);
  const registry = React16.useMemo(() => new RouteRegistry(routeDefinitions), [routeDefinitions]);
  const value = React16.useMemo(() => ({ navigate, registry, t }), [navigate, registry, t]);
  return /* @__PURE__ */ jsx7(NavigationContext.Provider, { value, children });
}
function useNavigationContext() {
  const context = React16.useContext(NavigationContext);
  if (!context) {
    throw new Error("useNavigationContext must be used within NavigationProvider");
  }
  return context;
}

// src/capabilities/rendering/components/ApplicationErrorBoundary.tsx
import * as React17 from "react";
import { FatalErrorPage } from "@amzn/awsmp-max-ux-patterns/FatalErrorPage";
import { useAppTranslation as useAppTranslation4 } from "@amzn/awsmp-max-translations";
import { jsx as jsx8 } from "react/jsx-runtime";
function isAuthenticationError(error) {
  return typeof error === "object" && error !== null && "name" in error && error.name === "AuthenticationError";
}
function isExternalDomMutationError(error) {
  if (typeof error !== "object" || error === null)
    return false;
  const name = "name" in error ? String(error.name ?? "") : "";
  if (name !== "NotFoundError")
    return false;
  const message = "message" in error ? String(error.message ?? "") : "";
  return /'(?:removeChild|insertBefore)' on 'Node'/.test(message) || /not a child of this node/i.test(message);
}
function getSuppressionReasons(config) {
  return [
    { name: "NetworkError", test: (error) => isNetworkError(error) },
    { name: "AuthenticationError", test: isAuthenticationError },
    { name: "UnsupportedBrowser", test: () => !(config?.browserInfo?.isSupported ?? isSupportedBrowser()) },
    { name: "ExternalDomMutation", test: isExternalDomMutationError }
  ];
}
function getSuppressionReason(error, config) {
  return getSuppressionReasons(config).find((r) => r.test(error))?.name;
}
var ApplicationErrorBoundary = class extends React17.Component {
  logger;
  fatalEmitted = false;
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: void 0 };
    this.logger = createSafeLogger(false, {}, props.config?.browserInfo);
  }
  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }
  componentDidCatch(error, errorInfo) {
    this.logger.error("Fatal application error:", error, errorInfo);
    const suppressionReason = getSuppressionReason(error, this.props.config);
    if (suppressionReason) {
      this.logger.log("Fatal error suppressed", { suppressionReason });
      this.logger.opsMetric({
        metricName: CustomOpsMetricName.ClientSide500Ignored,
        unit: "Count",
        value: 1,
        dimensions: {
          SuppressionReason: suppressionReason
        }
      });
      return;
    }
    if (this.fatalEmitted) {
      this.logger.log("Fatal metric suppressed (duplicate for boundary instance)");
      return;
    }
    this.fatalEmitted = true;
    this.logger.opsMetric({
      metricName: CustomOpsMetricName.ClientSide500,
      unit: "Count",
      value: 1
    });
    this.logger.opsMetric({
      metricName: "ApplicationFatalErrorCount",
      unit: "Count",
      value: 1,
      dimensions: {
        Component: "ApplicationErrorBoundary"
      }
    });
  }
  render() {
    if (this.state.hasError) {
      this.logger.error("Fatal app boundary error", this.state.error);
      return /* @__PURE__ */ jsx8(FatalErrorPage, {});
    }
    return this.props.children;
  }
};

// src/AgenticRendererProvider.tsx
import { TranslationProvider } from "@amzn/awsmp-max-translations";

// src/ArtifactWidgetDiscoveryProvider.tsx
import * as React18 from "react";
import { AgentExperience, detectStageFromHostname as detectStageFromHostname3 } from "@amzn/awsmp-max-model";
import { ArtifactWidgetDiscovery, ArtifactWidgetsProvider } from "@amzn/awsmp-max-data";
import { jsx as jsx9 } from "react/jsx-runtime";
function ArtifactWidgetDiscoveryProvider({ config, children }) {
  const logger = useLogger();
  const [discovery] = React18.useState(
    () => ArtifactWidgetDiscovery.initializedInstance() ?? new ArtifactWidgetDiscovery({
      logger,
      stage: config?.stage ?? detectStageFromHostname3(window.location.hostname),
      experience: config?.experience ?? AgentExperience.None
    })
  );
  return /* @__PURE__ */ jsx9(ArtifactWidgetsProvider, { discovery, children: children(discovery) });
}

// src/AgenticRendererProvider.tsx
import { Fragment as Fragment2, jsx as jsx10, jsxs } from "react/jsx-runtime";
function AgenticRendererProvider({
  children,
  navigate,
  cloudscapeMessages,
  polarisMessages,
  maxService,
  config
}) {
  return /* @__PURE__ */ jsx10(ApplicationErrorBoundary, { config, children: /* @__PURE__ */ jsx10(TranslationProvider, { cloudscapeMessages, polarisMessages, children: /* @__PURE__ */ jsx10(LoggerProvider, { config, children: /* @__PURE__ */ jsx10(ArtifactWidgetDiscoveryProvider, { config, children: (discovery) => /* @__PURE__ */ jsx10(LayoutStateProvider, { children: /* @__PURE__ */ jsx10(NavigationProvider, { navigate, children: maxService ? /* @__PURE__ */ jsxs(Fragment2, { children: [
    /* @__PURE__ */ jsx10(DebugInitializer, {}),
    children
  ] }) : /* @__PURE__ */ jsxs(MaxServiceProvider, { discovery, children: [
    /* @__PURE__ */ jsx10(DebugInitializer, {}),
    children
  ] }) }) }) }) }) }) });
}

// src/capabilities/rendering/components/ProjectRenderer.tsx
import * as React27 from "react";
import Alert4 from "@cloudscape-design/components/alert";
import { LoadingSpinner } from "@amzn/awsmp-max-ux-patterns/LoadingSpinner";
import { StateProperties } from "@amzn/awsmp-max-model";
import {
  NotFoundError as NotFoundError3
} from "@amzn/awsmp-max-agentic-renderer-interface";
import { ArtifactWidgetStatus, useArtifactWidgets as useArtifactWidgets4 } from "@amzn/awsmp-max-data";

// src/capabilities/rendering/hooks/useProjectRendering.tsx
import * as React26 from "react";
import { useCallback as useCallback10, useEffect as useEffect14, useMemo as useMemo8 } from "react";
import { TurnStatus as TurnStatus7 } from "@amzn/awsmp-max-model";

// src/capabilities/rendering/hooks/useRenderMessages.tsx
import * as React24 from "react";
import { useCallback as useCallback9, useEffect as useEffect12, useRef as useRef2 } from "react";
import {
  createMaxWrappedError
} from "@amzn/awsmp-max-agentic-renderer-interface";
import {
  MessageStatus as MessageStatus2,
  TurnStatus as TurnStatus5,
  ProjectStatus
} from "@amzn/awsmp-max-model";

// src/capabilities/error-handling/withAsyncErrors.ts
import React20 from "react";

// src/capabilities/error-handling/useHandleSharedError.tsx
import * as React19 from "react";
import {
  NotFoundError as NotFoundError2
} from "@amzn/awsmp-max-agentic-renderer-interface";
import { useAppTranslation as useAppTranslation5 } from "@amzn/awsmp-max-translations";

// node_modules/serialize-error/error-constructors.js
var list = [
  // Native ES errors https://262.ecma-international.org/12.0/#sec-well-known-intrinsic-objects
  Error,
  EvalError,
  RangeError,
  ReferenceError,
  SyntaxError,
  TypeError,
  URIError,
  AggregateError,
  // Built-in errors
  globalThis.DOMException,
  // Node-specific errors
  // https://nodejs.org/api/errors.html
  globalThis.AssertionError,
  globalThis.SystemError
].filter(Boolean).map(
  (constructor) => [constructor.name, constructor]
);
var errorConstructors = new Map(list);

// node_modules/serialize-error/index.js
var errorProperties = [
  {
    property: "name",
    enumerable: false
  },
  {
    property: "message",
    enumerable: false
  },
  {
    property: "stack",
    enumerable: false
  },
  {
    property: "code",
    enumerable: true
  },
  {
    property: "cause",
    enumerable: false
  },
  {
    property: "errors",
    enumerable: false
  }
];
var toJsonWasCalled = /* @__PURE__ */ new WeakSet();
var toJSON = (from) => {
  toJsonWasCalled.add(from);
  const json = from.toJSON();
  toJsonWasCalled.delete(from);
  return json;
};
var newError = (name) => {
  const ErrorConstructor = errorConstructors.get(name) ?? Error;
  return ErrorConstructor === AggregateError ? new ErrorConstructor([]) : new ErrorConstructor();
};
var destroyCircular = ({
  from,
  seen,
  to,
  forceEnumerable,
  maxDepth,
  depth,
  useToJSON,
  serialize
}) => {
  if (!to) {
    if (Array.isArray(from)) {
      to = [];
    } else if (!serialize && isErrorLike(from)) {
      to = newError(from.name);
    } else {
      to = {};
    }
  }
  seen.push(from);
  if (depth >= maxDepth) {
    return to;
  }
  if (useToJSON && typeof from.toJSON === "function" && !toJsonWasCalled.has(from)) {
    return toJSON(from);
  }
  const continueDestroyCircular = (value) => destroyCircular({
    from: value,
    seen: [...seen],
    forceEnumerable,
    maxDepth,
    depth,
    useToJSON,
    serialize
  });
  for (const [key, value] of Object.entries(from)) {
    if (value && value instanceof Uint8Array && value.constructor.name === "Buffer") {
      to[key] = "[object Buffer]";
      continue;
    }
    if (value !== null && typeof value === "object" && typeof value.pipe === "function") {
      to[key] = "[object Stream]";
      continue;
    }
    if (typeof value === "function") {
      continue;
    }
    if (!value || typeof value !== "object") {
      try {
        to[key] = value;
      } catch {
      }
      continue;
    }
    if (!seen.includes(from[key])) {
      depth++;
      to[key] = continueDestroyCircular(from[key]);
      continue;
    }
    to[key] = "[Circular]";
  }
  if (serialize || to instanceof Error) {
    for (const { property, enumerable } of errorProperties) {
      if (from[property] !== void 0 && from[property] !== null) {
        Object.defineProperty(to, property, {
          value: isErrorLike(from[property]) || Array.isArray(from[property]) ? continueDestroyCircular(from[property]) : from[property],
          enumerable: forceEnumerable ? true : enumerable,
          configurable: true,
          writable: true
        });
      }
    }
  }
  return to;
};
function serializeError(value, options = {}) {
  const {
    maxDepth = Number.POSITIVE_INFINITY,
    useToJSON = true
  } = options;
  if (typeof value === "object" && value !== null) {
    return destroyCircular({
      from: value,
      seen: [],
      forceEnumerable: true,
      maxDepth,
      depth: 0,
      useToJSON,
      serialize: true
    });
  }
  if (typeof value === "function") {
    return `[Function: ${value.name || "anonymous"}]`;
  }
  return value;
}
function isErrorLike(value) {
  return Boolean(value) && typeof value === "object" && typeof value.name === "string" && typeof value.message === "string" && typeof value.stack === "string";
}

// src/capabilities/error-handling/useHandleSharedError.tsx
function isSilentError(_unwrappedError) {
  return false;
}
function isNonFatalError(unwrappedError, parsedError) {
  if (unwrappedError.isFatal === true)
    return false;
  if (unwrappedError.isFatal === false)
    return true;
  const sc = parsedError.parsedStatusCode;
  if (sc && sc >= 400 && sc < 500)
    return true;
  return false;
}
function tryParseError(error) {
  const result = { rawError: error };
  if (typeof error !== "object" || error === null) {
    return result;
  }
  if ("statusCode" in error && typeof error.statusCode === "number") {
    result.parsedStatusCode = error.statusCode;
  }
  if ("$metadata" in error && typeof error.$metadata === "object" && error.$metadata !== null && "httpStatusCode" in error.$metadata && typeof error.$metadata.httpStatusCode === "number") {
    result.parsedStatusCode = error.$metadata.httpStatusCode;
  }
  if ("exceptionName" in error && typeof error.exceptionName === "string") {
    result.parsedErrorName = error.exceptionName;
  }
  if ("name" in error && typeof error.name === "string") {
    result.parsedErrorName = error.name;
  }
  if ("message" in error && typeof error.message === "string") {
    result.parsedErrorMessage = error.message;
  }
  if ("Name" in error && typeof error.Name === "string") {
    result.parsedErrorName = error.Name;
  }
  if ("Message" in error && typeof error.Message === "string") {
    result.parsedErrorMessage = error.Message;
  }
  return result;
}
function isMaxWrappedError(error) {
  return typeof error === "object" && error !== null && "wrappedError" in error;
}
function unwrapError(error) {
  if (isMaxWrappedError(error)) {
    const { error: innerError, ...classification } = error.wrappedError;
    return { error: innerError, ...classification };
  }
  return { error };
}
function useHandleSharedError({ error: rawError, flashbarManager, logger, callbacks }) {
  const { t } = useAppTranslation5();
  React19.useEffect(() => {
    const unwrappedError = unwrapError(rawError);
    const { error } = unwrappedError;
    const maybeParsedError = tryParseError(error);
    if (error) {
      if (isSilentError(unwrappedError)) {
        logger.error("A silent error occurred", void 0, {
          error: serializeError(error)
        });
        callbacks?.onSilentError?.(maybeParsedError);
        return;
      }
      if (unwrappedError.isNotFound) {
        const sc = maybeParsedError.parsedStatusCode;
        const is4xx = sc !== void 0 && sc >= 400 && sc < 500;
        if (is4xx) {
          logger.error("A not-found error occurred", void 0, {
            error: serializeError(error)
          });
          if (unwrappedError.showFlashbar && flashbarManager) {
            const errorMessage = maybeParsedError?.parsedErrorMessage;
            flashbarManager.addItem({
              type: "error",
              header: t("errorValidationException"),
              content: errorMessage || t("errorUnknownValidationException"),
              dismissible: true
            });
          }
          callbacks?.onNotFoundError?.(maybeParsedError);
          throw new NotFoundError2(error);
        }
        logger.error("A not-found error escalated to fatal (5xx or no status code)", void 0, {
          error: serializeError(error)
        });
      }
      if (isNonFatalError(unwrappedError, maybeParsedError)) {
        logger.error("A non-fatal error occurred", void 0, {
          error: serializeError(error)
        });
        if (flashbarManager) {
          const statusCode = maybeParsedError?.parsedStatusCode;
          const is4xxError = statusCode && Math.floor(statusCode / 100) === 4;
          if (is4xxError) {
            const errorMessage = maybeParsedError?.parsedErrorMessage;
            flashbarManager.addItem({
              type: "error",
              header: t("errorValidationException"),
              content: errorMessage || t("errorUnknownValidationException"),
              dismissible: true
            });
          } else {
            flashbarManager.addItem({
              type: "error",
              header: t("errorSomethingWentWrong"),
              content: t("errorInternalError"),
              dismissible: true
            });
          }
        }
        callbacks?.onNonFatalError?.(maybeParsedError);
        return;
      }
      logger.error("A fatal error occurred", void 0, {
        error: serializeError(error)
      });
      callbacks?.onFatalError?.(maybeParsedError);
      throw error;
    }
  }, [rawError]);
}

// src/capabilities/error-handling/withAsyncErrors.ts
function withAsyncErrorsInternal(promise, setError, onSuccess) {
  return promise.then(() => {
    onSuccess?.();
  }).catch((error) => {
    setError(error);
  });
}
function useWithAsyncErrors(logger, callbacks) {
  const [error, setError] = React20.useState(null);
  const { flashbar } = useLayoutManager();
  useHandleSharedError({ error, flashbarManager: flashbar, callbacks, logger });
  const onSuccessRef = React20.useRef(callbacks?.onSuccess);
  onSuccessRef.current = callbacks?.onSuccess;
  const withAsyncErrors = React20.useCallback(
    (promise) => withAsyncErrorsInternal(promise, setError, () => onSuccessRef.current?.()),
    [setError]
  );
  return { withAsyncErrors };
}

// src/capabilities/error-handling/tool-request-error-metrics.ts
function emitZeroValueToolCallErrorMetric(logger) {
  logger.opsMetric({
    metricName: CustomOpsMetricName.ClientSideNonFatalToolCallError,
    unit: "Count",
    value: 0
  });
}
function emitToolCallErrorMetric(error, logger) {
  if (error.parsedStatusCode !== void 0 && (error.parsedStatusCode === 401 || error.parsedStatusCode === 403)) {
    return;
  }
  logger.opsMetric({
    metricName: CustomOpsMetricName.ClientSideNonFatalToolCallError,
    unit: "Count",
    value: 1
  });
}

// src/capabilities/rendering/components/ContentBlockErrorBoundary.tsx
import * as React21 from "react";
import Alert from "@cloudscape-design/components/alert";
import Box from "@cloudscape-design/components/box";
import SpaceBetween from "@cloudscape-design/components/space-between";
import { useAppTranslation as useAppTranslation6 } from "@amzn/awsmp-max-translations";
import { jsx as jsx11, jsxs as jsxs2 } from "react/jsx-runtime";
var ContentBlockErrorBoundary = class extends React21.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: void 0 };
  }
  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }
  componentDidCatch(error, errorInfo) {
    const { blockId, blockType, category, logger } = this.props;
    logger.error("ContentBlock rendering failed", error, {
      blockId,
      blockType,
      category: category || "none",
      componentStack: errorInfo.componentStack
    });
    logger.opsMetric({
      metricName: "ContentBlockRenderErrorCount",
      unit: "Count",
      value: 1,
      dimensions: {
        BlockType: blockType,
        Category: category || "none"
      }
    });
  }
  render() {
    if (this.state.hasError) {
      const t = this.props.t || ((_key) => _key);
      return /* @__PURE__ */ jsx11(Alert, { type: "warning", header: t("contentBlockFailedToRender", { blockType: this.props.blockType }), "data-testid": "content-block-error", children: /* @__PURE__ */ jsxs2(SpaceBetween, { size: "xs", children: [
        /* @__PURE__ */ jsxs2(Box, { variant: "small", children: [
          t("contentBlockId"),
          this.props.blockId,
          this.props.category && t("contentBlockCategory"),
          this.props.category
        ] }),
        this.state.error?.message && /* @__PURE__ */ jsx11(Box, { variant: "code", fontSize: "body-s", "data-testid": "error-message", children: this.state.error.message }),
        /* @__PURE__ */ jsx11(Box, { variant: "small", color: "text-label", children: t("contentBlockInvalidData") })
      ] }) });
    }
    return this.props.children;
  }
};

// src/capabilities/rendering/components/MessageErrorBoundary.tsx
import * as React22 from "react";
import Alert2 from "@cloudscape-design/components/alert";
import Box2 from "@cloudscape-design/components/box";
import { useAppTranslation as useAppTranslation7 } from "@amzn/awsmp-max-translations";
import { jsx as jsx12, jsxs as jsxs3 } from "react/jsx-runtime";
var MessageErrorBoundary = class extends React22.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: void 0 };
  }
  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }
  componentDidCatch(error, errorInfo) {
    const { messageId, authorRole, logger } = this.props;
    const role = authorRole || "unknown";
    logger.error("Message rendering failed", error, {
      messageId,
      authorRole: role,
      componentStack: errorInfo.componentStack
    });
    logger.opsMetric({
      metricName: "MessageRenderErrorCount",
      unit: "Count",
      value: 1,
      dimensions: {
        AuthorRole: role
      }
    });
  }
  render() {
    if (this.state.hasError) {
      const t = this.props.t || ((_key) => _key);
      return /* @__PURE__ */ jsxs3(Alert2, { type: "warning", header: t("messageFailedToRender"), "data-testid": "message-error", children: [
        /* @__PURE__ */ jsxs3(Box2, { variant: "small", children: [
          "Message ID: ",
          this.props.messageId,
          this.props.authorRole && ` | Author Role: ${this.props.authorRole}`
        ] }),
        this.state.error?.message && /* @__PURE__ */ jsxs3(Box2, { variant: "code", fontSize: "body-s", "data-testid": "error-message", children: [
          "Error: ",
          this.state.error.message
        ] })
      ] });
    }
    return this.props.children;
  }
};

// src/capabilities/rendering/utils/parseTextWithThinkTags.ts
function parseTextWithThinkTags(text) {
  if (!text || typeof text !== "string") {
    return [{ type: "text", content: "" }];
  }
  const segments = [];
  const closedThinkRegex = /<think>([\s\S]*?)<\/think>/g;
  let lastIndex = 0;
  let match;
  while ((match = closedThinkRegex.exec(text)) !== null) {
    const matchStart = match.index;
    const matchEnd = closedThinkRegex.lastIndex;
    const thinkContent = match[1];
    if (matchStart > lastIndex) {
      const beforeText = text.substring(lastIndex, matchStart);
      if (beforeText) {
        segments.push({ type: "text", content: beforeText });
      }
    }
    segments.push({ type: "think", content: thinkContent, isIncomplete: false });
    lastIndex = matchEnd;
  }
  const remainingText = text.substring(lastIndex);
  const openThinkIndex = remainingText.indexOf("<think>");
  if (openThinkIndex !== -1) {
    if (openThinkIndex > 0) {
      const beforeText = remainingText.substring(0, openThinkIndex);
      segments.push({ type: "text", content: beforeText });
    }
    const incompleteThinkContent = remainingText.substring(openThinkIndex + 7);
    segments.push({ type: "think", content: incompleteThinkContent, isIncomplete: true });
  } else if (remainingText) {
    segments.push({ type: "text", content: remainingText });
  }
  if (segments.length === 0) {
    segments.push({ type: "text", content: text });
  }
  return segments;
}

// src/capabilities/rendering/utils/tool-component-map.ts
var TOOL_COMPONENT_MAP = {
  askuser: "askuser",
  recommendunits: "recommendunits",
  annotate: "annotate",
  updateartifact: "linktoartifact"
};
var TOOL_RENDERING_CONFIG = {
  askuser: {
    renderOn: "input"
  },
  recommendunits: {
    renderOn: "input"
  },
  annotate: {
    renderOn: "input"
  },
  updateartifact: {
    renderOn: "output",
    deduplicatePerMessage: true
    // Renders on toolOutput so we have hasDisplayableContent to decide if thumbnail should show.
    // Empty artifacts (hasDisplayableContent: false) return null, no thumbnail rendered.
  }
};
function getToolComponent(toolName) {
  return TOOL_COMPONENT_MAP[toolName.toLowerCase()];
}
function shouldRenderToolBlock(toolName, blockType) {
  const config = TOOL_RENDERING_CONFIG[toolName.toLowerCase()];
  if (!config)
    return true;
  const expectedBlockType = config.renderOn === "input" ? "toolInput" : "toolOutput";
  return blockType === expectedBlockType;
}
function shouldDeduplicateTool(toolName) {
  const config = TOOL_RENDERING_CONFIG[toolName.toLowerCase()];
  return config?.deduplicatePerMessage ?? false;
}

// src/capabilities/rendering/utils/analysis-content.ts
function thinkStepItems(block) {
  return (block.content.thinkSteps || []).map((step, index) => ({ type: "thinkStep", step, index, timestamp: step.startTimestamp || "" }));
}
function parseAuthPrompt(block) {
  if (block.type !== "toolInput")
    return null;
  const askUserData = block.content.askUser;
  if (!askUserData)
    return null;
  const blockWithMeta = block;
  const contentBlockId = blockWithMeta.contentBlockId || "";
  const toolUseId = contentBlockId.split("/").at(-1) || "";
  const startTimestamp = blockWithMeta.startTimestamp || "";
  switch (askUserData.mode) {
    case "accessDenied":
      return {
        type: "accessDenied",
        block: {
          id: contentBlockId,
          // Absent kind ⇒ a legacy federated block (predates the discriminant); treat as aws-exception.
          kind: askUserData.kind === "mint-permission" ? "mint-permission" : "aws-exception",
          toolName: askUserData.toolName,
          errorMessage: askUserData.errorMessage,
          startTimestamp
        }
      };
    case "toolAuthorization":
      return {
        type: "toolAuth",
        toolUseId,
        data: askUserData,
        hasHeldTools: Boolean(askUserData.heldTools?.length),
        startTimestamp
      };
    case "authenticate":
      return {
        type: "authenticate",
        toolUseId,
        data: askUserData,
        hasAuthenticationType: Boolean(askUserData.authenticationType),
        startTimestamp
      };
    default:
      return null;
  }
}
function resolveAnalysisCandidate(candidate, context) {
  return candidate.type === "thinkStep" ? candidate : resolveAnalysisPrompt(candidate, context);
}
function resolveAnalysisPrompt(prompt, context) {
  if (prompt.type === "accessDenied") {
    return { type: "accessDenied", block: prompt.block, timestamp: prompt.block.startTimestamp };
  }
  if (!context.rendersAuthPrompts)
    return null;
  const output = context.toolBlocksByToolUseId.get(prompt.toolUseId)?.output;
  if (!output && !context.isLatestMessage)
    return null;
  if (prompt.type === "toolAuth") {
    if (!prompt.hasHeldTools)
      return null;
    const block2 = { toolUseId: prompt.toolUseId, data: prompt.data, output, startTimestamp: prompt.startTimestamp };
    return { type: "toolAuth", block: block2, timestamp: prompt.startTimestamp };
  }
  if (!prompt.hasAuthenticationType)
    return null;
  if (output?.responseFormat === "authenticate" && (output.outcome === "authenticated" || output.outcome === "permission-required")) {
    return null;
  }
  const block = { toolUseId: prompt.toolUseId, data: prompt.data, output, startTimestamp: prompt.startTimestamp };
  return { type: "authenticate", block, timestamp: prompt.startTimestamp };
}
function orderAnalysisTimeline(items) {
  return [...items].sort((a, b) => a.timestamp.localeCompare(b.timestamp));
}

// src/capabilities/rendering/hooks/useRenderContentBlock.tsx
import { useCallback as useCallback8, useMemo as useMemo7 } from "react";
import { MessageStatus, TurnStatus as TurnStatus4 } from "@amzn/awsmp-max-model";

// src/capabilities/rendering/components/FallbackContent.tsx
import ExpandableSection from "@cloudscape-design/components/expandable-section";
import React23 from "react";
import { Fragment as Fragment3, jsx as jsx13, jsxs as jsxs4 } from "react/jsx-runtime";
var FallbackContent = ({
  content,
  type,
  blockId,
  isStreaming,
  visibility,
  startTimestamp,
  endTimestamp
}) => {
  const renderCountRef = React23.useRef(0);
  renderCountRef.current += 1;
  const formatContent = (data) => {
    if (typeof data === "string") {
      return data;
    }
    try {
      return JSON.stringify(data, null, 2);
    } catch {
      return String(data);
    }
  };
  const formatTime = (isoTimestamp) => {
    try {
      const date = new Date(isoTimestamp);
      const hours = date.getHours().toString().padStart(2, "0");
      const minutes = date.getMinutes().toString().padStart(2, "0");
      const seconds = date.getSeconds().toString().padStart(2, "0");
      return `${hours}:${minutes}:${seconds}`;
    } catch {
      return "Invalid time";
    }
  };
  const calculateDuration = (start, end) => {
    try {
      const startDate = new Date(start);
      const endDate = new Date(end);
      const durationMs = endDate.getTime() - startDate.getTime();
      const durationSec = (durationMs / 1e3).toFixed(2);
      return `${durationSec}s`;
    } catch {
      return "N/A";
    }
  };
  const toolInfo = React23.useMemo(() => {
    if (content && typeof content === "object") {
      const obj = content;
      let toolName = null;
      let toolUseId = null;
      toolName = obj.tool || obj.name || null;
      toolUseId = obj.toolUseId || null;
      if (!toolName && obj && typeof obj === "object") {
        const keys = Object.keys(obj);
        if (keys.length === 1 && !["content", "type", "contentBlockId", "category"].includes(keys[0])) {
          toolName = keys[0];
        }
      }
      if (!toolName && obj.toolOutput) {
        toolName = obj.toolOutput.name || obj.toolOutput.tool || null;
        toolUseId = obj.toolOutput.toolUseId || toolUseId;
      }
      if (!toolName && obj.toolInput) {
        toolName = obj.toolInput.name || obj.toolInput.tool || null;
        toolUseId = obj.toolInput.toolUseId || toolUseId;
      }
      return { toolName, toolUseId };
    }
    return { toolName: null, toolUseId: null };
  }, [content]);
  const formattedContent = formatContent(content);
  const title = toolInfo.toolName ? `${toolInfo.toolName}` : type ? `${type}` : "Content";
  const subtitleParts = [];
  if (isStreaming !== void 0) {
    subtitleParts.push(isStreaming ? "\u26A1 streaming" : "\u2713 complete");
  }
  if (visibility) {
    subtitleParts.push(`\u{1F441}\uFE0F ${visibility}`);
  }
  if (toolInfo.toolName && type) {
    subtitleParts.push(`Type: ${type}`);
  }
  if (blockId) {
    subtitleParts.push(`ID: ${blockId}`);
  }
  if (toolInfo.toolUseId) {
    subtitleParts.push(`Tool: ${toolInfo.toolUseId}`);
  }
  if (startTimestamp) {
    subtitleParts.push(`\u23F1\uFE0F Start: ${formatTime(startTimestamp)}`);
    if (endTimestamp) {
      subtitleParts.push(`End: ${formatTime(endTimestamp)}`);
      subtitleParts.push(`Duration: ${calculateDuration(startTimestamp, endTimestamp)}`);
    } else if (isStreaming) {
      subtitleParts.push("End: (streaming...)");
      subtitleParts.push("Duration: (in progress)");
    }
  }
  const subtitle = subtitleParts.length > 0 ? subtitleParts.join(" | ") : void 0;
  const renderCount = renderCountRef.current;
  const debugBadge = /* @__PURE__ */ jsxs4(
    "div",
    {
      style: {
        display: "inline-block",
        padding: "4px 8px",
        marginBottom: "8px",
        backgroundColor: renderCount > 5 ? "#d91515" : "#037f0c",
        color: "white",
        borderRadius: "4px",
        fontSize: "11px",
        fontWeight: "bold"
      },
      children: [
        "\u{1F504} ",
        type,
        " Renders: ",
        renderCount,
        " ",
        renderCount > 5 ? "\u274C NOT OPTIMIZED" : "\u2705 OPTIMIZED"
      ]
    }
  );
  return /* @__PURE__ */ jsxs4(Fragment3, { children: [
    debugBadge,
    /* @__PURE__ */ jsx13(ExpandableSection, { headerText: title, headerDescription: subtitle, defaultExpanded: false, children: /* @__PURE__ */ jsx13(
      "pre",
      {
        style: {
          margin: 0,
          whiteSpace: "pre-wrap",
          wordBreak: "break-word",
          fontFamily: "monospace",
          fontSize: "12px"
        },
        children: formattedContent
      }
    ) })
  ] });
};

// src/capabilities/rendering/hooks/useRenderContentBlock.tsx
import { jsx as jsx14 } from "react/jsx-runtime";
function useRenderContentBlock(params) {
  const { renderContext, componentMap, rendererAPI } = params;
  const { debug, isToggled } = useDebug();
  const debugMessages = debug && isToggled("messages");
  const { layoutManager, navigationManager, sendMessage, uploadFiles, logger } = rendererAPI;
  const toolBlockMap = useMemo7(() => {
    const map = /* @__PURE__ */ new Map();
    renderContext.conversation?.forEach((msg) => {
      msg.contentBlocks?.forEach((block) => {
        if (block.type === "toolInput" || block.type === "toolOutput") {
          const contentBlockId = block.contentBlockId || "";
          const toolUseId = contentBlockId.split("/").at(-1) || "";
          if (!toolUseId)
            return;
          const existing = map.get(toolUseId) || {};
          const content = block.content;
          const toolName = Object.keys(content)[0];
          if (toolName) {
            if (block.type === "toolInput") {
              existing.input = content[toolName];
            } else {
              existing.output = content[toolName];
            }
            map.set(toolUseId, existing);
          }
        }
      });
    });
    return map;
  }, [renderContext.conversation]);
  const renderContentBlock = useCallback8(
    (block, blockId, isLatestMessage) => {
      if (block.type === "analysisSection") {
        const AnalysisStepsComponent = componentMap.analysissteps;
        if (!AnalysisStepsComponent)
          return null;
        const promptContext = { toolBlocksByToolUseId: toolBlockMap, isLatestMessage, rendersAuthPrompts: true };
        const items = orderAnalysisTimeline(block.candidates.flatMap((candidate) => resolveAnalysisCandidate(candidate, promptContext) ?? []));
        if (items.length === 0 && block.messageStatus !== MessageStatus.Streaming)
          return null;
        return /* @__PURE__ */ jsx14(
          AnalysisStepsComponent,
          {
            data: { items },
            status: block.messageStatus,
            isTurnProcessing: renderContext.turnStatus === TurnStatus4.Processing,
            layoutManager,
            navigationManager,
            agent: renderContext.agent,
            logger,
            rendererAPI: { ...rendererAPI, isLatestMessage }
          }
        );
      }
      if (debugMessages) {
        let debugType = block.type || "Unknown";
        let debugContent = block;
        if (block.type === "toolInput" || block.type === "toolOutput") {
          const content = block.content;
          const toolName = Object.keys(content)[0];
          if (toolName) {
            debugContent = content[toolName];
            debugType = `${toolName} (${block.type})`;
          }
        }
        const blockWithMetadata = block;
        const isStreaming = blockWithMetadata.status === MessageStatus.Streaming;
        return /* @__PURE__ */ jsx14(
          FallbackContent,
          {
            content: debugContent,
            type: debugType,
            blockId,
            isStreaming,
            visibility: blockWithMetadata.visibility,
            startTimestamp: blockWithMetadata.startTimestamp,
            endTimestamp: blockWithMetadata.endTimestamp
          }
        );
      }
      switch (block.type) {
        case "text": {
          return null;
        }
        case "thinkingSteps": {
          return null;
        }
        case "pricingAnnotation": {
          const pricingContent = block.content;
          if (!pricingContent.hasPricing)
            return null;
          const PricingAnnotationComponent = componentMap.pricingannotation;
          if (!PricingAnnotationComponent)
            return null;
          return /* @__PURE__ */ jsx14(PricingAnnotationComponent, { data: block, layoutManager, navigationManager });
        }
        case "provideRequirementsAnnotation": {
          const ProvideRequirementsAnnotationComponent = componentMap.providerequirementsannotation;
          if (!ProvideRequirementsAnnotationComponent)
            return null;
          return /* @__PURE__ */ jsx14(
            ProvideRequirementsAnnotationComponent,
            {
              data: block,
              uploadFiles,
              sendMessage,
              layoutManager,
              navigationManager
            }
          );
        }
        case "declaredElicitationForm": {
          const AskUserComponent = componentMap.askuser;
          if (!AskUserComponent)
            return null;
          const { toolUseId, form, submittedData } = block.content;
          const answer = toolBlockMap.get(toolUseId)?.output;
          const isSubmitted = typeof answer === "object" && answer !== null && "responseFormat" in answer && answer.responseFormat === "submitted";
          const shown2 = isSubmitted && submittedData !== void 0 ? { responseFormat: "accept", data: submittedData } : answer;
          return /* @__PURE__ */ jsx14(AskUserComponent, { data: { input: form, output: shown2 }, toolUseId, rendererAPI: { ...rendererAPI, isLatestMessage } });
        }
        case "interrupt":
        case "error": {
          const NotificationComponent = componentMap.notification;
          if (!NotificationComponent)
            return null;
          return /* @__PURE__ */ jsx14(NotificationComponent, { data: block, layoutManager, navigationManager, logger });
        }
        case "toolInput":
        case "toolOutput": {
          const content = block.content;
          const toolName = Object.keys(content)[0];
          if (!toolName)
            return null;
          if (!shouldRenderToolBlock(toolName, block.type))
            return null;
          const componentName = getToolComponent(toolName);
          if (!componentName)
            return null;
          const Component6 = componentMap[componentName];
          if (!Component6)
            return null;
          const blockWithMetadata = block;
          const contentBlockId = blockWithMetadata.contentBlockId || blockId;
          const toolUseId = contentBlockId.split("/").at(-1) || "";
          const pairedData = toolBlockMap.get(toolUseId) || { input: void 0, output: void 0 };
          const augmentedRendererAPI = { ...rendererAPI, isLatestMessage };
          return /* @__PURE__ */ jsx14(Component6, { data: pairedData, toolUseId, rendererAPI: augmentedRendererAPI });
        }
        default: {
          const blockWithMetadata = block;
          const unknownBlock = block;
          return /* @__PURE__ */ jsx14(
            FallbackContent,
            {
              content: unknownBlock,
              type: unknownBlock.type || "Unknown",
              blockId,
              isStreaming: blockWithMetadata.status === MessageStatus.Streaming,
              visibility: blockWithMetadata.visibility,
              startTimestamp: blockWithMetadata.startTimestamp,
              endTimestamp: blockWithMetadata.endTimestamp
            }
          );
        }
      }
    },
    [
      debugMessages,
      toolBlockMap,
      componentMap,
      rendererAPI,
      layoutManager,
      navigationManager,
      sendMessage,
      uploadFiles,
      logger,
      renderContext.agent,
      renderContext.turnStatus
    ]
  );
  return { renderContentBlock };
}

// src/capabilities/rendering/hooks/useRenderMessages.tsx
import { Fragment as Fragment4, jsx as jsx15 } from "react/jsx-runtime";
var MemoizedMessageRenderer = React24.memo(
  ({
    msg,
    msgIndex,
    isLatestMessage,
    componentMap,
    renderContentBlock,
    rendererAPI,
    debug,
    hasMultipleArtifactVersions,
    feedbackMap,
    isTurnActive
  }) => {
    const { layoutManager, navigationManager } = rendererAPI;
    const logger = useLoggerManager();
    const { withAsyncErrors } = useWithAsyncErrors(logger);
    const MessageComponent = componentMap.message;
    if (!MessageComponent)
      return null;
    const isAssistant = msg.role === "assistant";
    const isComplete = msg.status === MessageStatus2.Complete;
    const canShowUndo = isLatestMessage && isAssistant && isComplete && hasMultipleArtifactVersions;
    const { contentBlocks, ...msgProps } = msg;
    const renderedDeduplicatedTools = /* @__PURE__ */ new Set();
    const analysisCandidates = [];
    const categorizedBlocks = (contentBlocks || []).flatMap((block, blockIndex) => {
      const blocks = [];
      if (block.type === "text") {
        const blockId2 = block.contentBlockId || `${msgIndex}-${blockIndex}`;
        if (debug) {
          const innerContent2 = renderContentBlock(block, blockId2, isLatestMessage);
          if (innerContent2 === null) {
            return blocks;
          }
          const component2 = /* @__PURE__ */ jsx15(ContentBlockErrorBoundary, { blockId: blockId2, blockType: "text", logger, children: innerContent2 }, `block-${blockId2}`);
          blocks.push({
            category: "results",
            component: component2,
            blockType: "text",
            blockId: blockId2
          });
          return blocks;
        }
        const textBlock = block;
        const segments = parseTextWithThinkTags(textBlock.content.text);
        const TextComponent = componentMap.text;
        if (!TextComponent) {
          return blocks;
        }
        segments.forEach((segment, segmentIndex) => {
          if (segment.type === "text" && segment.content.trim()) {
            const baseBlockId = block.contentBlockId || `${msgIndex}-${blockIndex}`;
            const segmentBlockId = `${baseBlockId}-seg-${segmentIndex}`;
            const component2 = /* @__PURE__ */ jsx15(ContentBlockErrorBoundary, { blockId: segmentBlockId, blockType: "text", logger, children: /* @__PURE__ */ jsx15(
              TextComponent,
              {
                data: {
                  ...block,
                  content: { text: segment.content }
                },
                messageRole: msgProps.role,
                layoutManager,
                navigationManager
              }
            ) }, `block-${segmentBlockId}`);
            blocks.push({
              category: "results",
              component: component2,
              blockType: "text",
              blockId: segmentBlockId
            });
          }
        });
        return blocks;
      }
      const blockId = block.contentBlockId || `${msgIndex}-${blockIndex}`;
      if (block.category === "userToolResult" || block.category === "userToolUse") {
        return blocks;
      }
      if (block.type === "thinkingSteps" && !debug) {
        analysisCandidates.push(...thinkStepItems(block));
        return blocks;
      }
      const authPrompt = debug ? null : parseAuthPrompt(block);
      if (authPrompt) {
        analysisCandidates.push(authPrompt);
        if (authPrompt.type !== "accessDenied") {
          return blocks;
        }
      }
      if (!debug && (block.type === "toolInput" || block.type === "toolOutput")) {
        const content = block.content;
        const toolName = Object.keys(content)[0];
        if (toolName && shouldDeduplicateTool(toolName) && shouldRenderToolBlock(toolName, block.type)) {
          if (toolName.toLowerCase() === "updateartifact" && block.type === "toolOutput") {
            const toolData = content[toolName];
            const hasContent = toolData?.hasDisplayableContent ?? (toolData?.updatedSections && toolData.updatedSections.length > 0);
            if (!hasContent) {
              return blocks;
            } else if (renderedDeduplicatedTools.has(toolName)) {
              return blocks;
            } else {
              renderedDeduplicatedTools.add(toolName);
            }
          } else {
            if (renderedDeduplicatedTools.has(toolName)) {
              return blocks;
            }
            renderedDeduplicatedTools.add(toolName);
          }
        }
      }
      const innerContent = renderContentBlock(block, blockId, isLatestMessage);
      if (innerContent === null) {
        return blocks;
      }
      const category = block.type === "thinkingSteps" ? "analysis" : "results";
      const component = /* @__PURE__ */ jsx15(ContentBlockErrorBoundary, { blockId, blockType: block.type, logger, children: innerContent }, `block-${blockId}`);
      blocks.push({
        category,
        component,
        blockType: block.type,
        blockId
      });
      return blocks;
    });
    if (isAssistant && !debug) {
      const sectionId = `${msgProps.messageId || msgIndex}-analysis`;
      const analysisSection = renderContentBlock(
        { type: "analysisSection", candidates: analysisCandidates, messageStatus: msg.status },
        sectionId,
        isLatestMessage
      );
      if (analysisSection !== null) {
        categorizedBlocks.push({
          category: "analysis",
          component: /* @__PURE__ */ jsx15(ContentBlockErrorBoundary, { blockId: sectionId, blockType: "thinkingSteps", logger, children: analysisSection }, `block-${sectionId}`),
          blockType: "thinkingSteps",
          blockId: sectionId
        });
      }
    }
    if (categorizedBlocks.length === 0) {
      return null;
    }
    const handleUndo = () => {
      void withAsyncErrors(rendererAPI.maxService.rollbackProject(rendererAPI.projectId).then(() => void 0));
    };
    const FeedbackComponent = componentMap.feedback;
    const feedbackComponent = isAssistant && FeedbackComponent ? /* @__PURE__ */ jsx15(
      FeedbackComponent,
      {
        existingFeedback: feedbackMap?.[msgProps.messageId],
        onSubmitFeedback: async (payload) => {
          try {
            await rendererAPI.maxService.submitFeedback(rendererAPI.projectId, msgProps.messageId, payload);
          } catch (error) {
            const wrapped = createMaxWrappedError(error, { isFatal: false });
            void withAsyncErrors(Promise.reject(wrapped));
            throw wrapped;
          }
        },
        disabled: isTurnActive
      }
    ) : void 0;
    return /* @__PURE__ */ jsx15(MessageErrorBoundary, { messageId: msgProps.messageId || `${msgIndex}`, authorRole: msgProps.role, logger, children: /* @__PURE__ */ jsx15(
      MessageComponent,
      {
        data: msg,
        onInterrupt: rendererAPI.interruptProject,
        onUndo: canShowUndo ? handleUndo : void 0,
        feedbackComponent,
        isTurnActive,
        layoutManager,
        navigationManager,
        children: categorizedBlocks
      }
    ) }, `boundary-${msgIndex}`);
  },
  // Custom comparison: only re-render if message data actually changed
  (prevProps, nextProps) => {
    const msgSame = prevProps.msg === nextProps.msg;
    const componentMapSame = prevProps.componentMap === nextProps.componentMap;
    const debugSame = prevProps.debug === nextProps.debug;
    const rendererAPISame = prevProps.rendererAPI === nextProps.rendererAPI;
    const conversationLengthSame = prevProps.conversationLength === nextProps.conversationLength;
    const isLatestMessageSame = prevProps.isLatestMessage === nextProps.isLatestMessage;
    const hasMultipleArtifactVersionsSame = prevProps.hasMultipleArtifactVersions === nextProps.hasMultipleArtifactVersions;
    const feedbackSame = prevProps.feedbackMap?.[prevProps.msg.messageId] === nextProps.feedbackMap?.[nextProps.msg.messageId];
    const isTurnActiveSame = prevProps.isTurnActive === nextProps.isTurnActive;
    return msgSame && componentMapSame && debugSame && rendererAPISame && conversationLengthSame && isLatestMessageSame && hasMultipleArtifactVersionsSame && feedbackSame && isTurnActiveSame;
  }
);
function useRenderMessages(params) {
  const { renderContext, componentMap, rendererAPI, events } = params;
  const { debug, isToggled } = useDebug();
  const debugMessages = debug && isToggled("messages");
  const notifiedArtifactsRef = useRef2(/* @__PURE__ */ new Set());
  const { renderContentBlock } = useRenderContentBlock({
    renderContext,
    componentMap,
    rendererAPI
  });
  const lastMessage = renderContext.conversation?.[renderContext.conversation.length - 1];
  const contentBlocks = lastMessage?.contentBlocks;
  useEffect12(() => {
    if (!events?.onNewlyAvailableArtifact)
      return;
    if (!lastMessage || lastMessage.role !== "assistant")
      return;
    const updateArtifactBlocks = lastMessage.contentBlocks?.filter(
      (block) => block.type === "toolInput" && block.content && typeof block.content === "object" && "updateArtifact" in block.content
    ) || [];
    for (const updateArtifactBlock of updateArtifactBlocks) {
      const toolContent = updateArtifactBlock.content;
      const updateArtifactData = toolContent.updateArtifact;
      const artifactType = updateArtifactData?.artifactSection;
      if (!artifactType)
        continue;
      const notificationKey = `${lastMessage.messageId}:${artifactType}`;
      if (notifiedArtifactsRef.current.has(notificationKey)) {
        continue;
      }
      events.onNewlyAvailableArtifact(artifactType);
      notifiedArtifactsRef.current.add(notificationKey);
    }
  }, [events, contentBlocks]);
  const hasMultipleArtifactVersions = (() => {
    if (!lastMessage || lastMessage.role !== "assistant")
      return false;
    const updateArtifactBlocks = lastMessage.contentBlocks?.filter(
      (block) => block.type === "toolInput" && block.content && typeof block.content === "object" && "updateArtifact" in block.content
    ) || [];
    const artifactVersions = renderContext.artifactVersions;
    for (const updateArtifactBlock of updateArtifactBlocks) {
      const toolContent = updateArtifactBlock.content;
      const updateArtifactData = toolContent.updateArtifact;
      const artifactType = updateArtifactData?.artifactSection;
      if (artifactType && artifactVersions[artifactType]?.length > 1)
        return true;
    }
    return false;
  })();
  const feedbackMap = renderContext.feedbackMap;
  const isTurnActive = renderContext.turnStatus === TurnStatus5.Processing || renderContext.projectState === ProjectStatus.HumanRequest;
  const renderMessages = useCallback9(() => {
    const conversation = renderContext.conversation || [];
    if (conversation.length === 0) {
      return null;
    }
    const messageElements = conversation.map((msg, msgIndex) => {
      const isLatestMessage = msgIndex === conversation.length - 1;
      const displaySequence = msg.sequenceNumber ?? msgIndex;
      return /* @__PURE__ */ jsx15(
        MemoizedMessageRenderer,
        {
          msg,
          msgIndex,
          isLatestMessage,
          conversationLength: conversation.length,
          componentMap,
          renderContentBlock,
          rendererAPI,
          debug: debugMessages,
          hasMultipleArtifactVersions,
          feedbackMap,
          isTurnActive
        },
        `${msg.role}-${displaySequence}`
      );
    });
    return /* @__PURE__ */ jsx15(Fragment4, { children: messageElements });
  }, [
    renderContext.conversation,
    componentMap,
    renderContentBlock,
    rendererAPI,
    debugMessages,
    hasMultipleArtifactVersions,
    feedbackMap,
    isTurnActive
  ]);
  return { renderMessages };
}

// src/capabilities/rendering/functions/renderArtifactView.tsx
import {
  TurnStatus as TurnStatus6
} from "@amzn/awsmp-max-model";

// src/capabilities/rendering/components/ArtifactErrorBoundary.tsx
import * as React25 from "react";
import Alert3 from "@cloudscape-design/components/alert";
import Box3 from "@cloudscape-design/components/box";
import Container from "@cloudscape-design/components/container";
import SpaceBetween2 from "@cloudscape-design/components/space-between";
import { jsx as jsx16, jsxs as jsxs5 } from "react/jsx-runtime";
var ArtifactErrorBoundary = class extends React25.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: void 0 };
  }
  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }
  componentDidCatch(error, errorInfo) {
    console.error(`Artifact ${this.props.artifactId} (type: ${this.props.artifactType}) rendering failed:`, error, errorInfo);
  }
  render() {
    if (this.state.hasError) {
      return /* @__PURE__ */ jsx16(Container, { children: /* @__PURE__ */ jsx16(Alert3, { type: "warning", header: `${this.props.artifactType} artifact failed to render`, "data-testid": "artifact-error", children: /* @__PURE__ */ jsxs5(SpaceBetween2, { size: "xs", children: [
        /* @__PURE__ */ jsxs5(Box3, { variant: "small", children: [
          "Artifact ID: ",
          this.props.artifactId
        ] }),
        this.state.error?.message && /* @__PURE__ */ jsxs5(Box3, { variant: "code", fontSize: "body-s", "data-testid": "error-message", children: [
          "Error: ",
          this.state.error.message
        ] }),
        /* @__PURE__ */ jsx16(Box3, { variant: "small", color: "text-label", children: "This artifact could not be displayed due to invalid data." })
      ] }) }) });
    }
    return this.props.children;
  }
};

// src/capabilities/rendering/utils/complianceInsightsShaping.ts
import { hasNamedCertification } from "@amzn/awsmp-max-model";
var REMOVED_WHEN_CERTIFIED = ["securityCertifications"];
var REMOVED_WHEN_OFF = ["certificationInsights", "securityControls", "resiliency", "aiGovernance"];
var shapedProducts = { on: /* @__PURE__ */ new WeakMap(), off: /* @__PURE__ */ new WeakMap() };
var isObject = (value) => value !== null && typeof value === "object";
var removedKeys = (enabled, products) => {
  if (!enabled)
    return REMOVED_WHEN_OFF;
  return hasNamedCertification(products) ? REMOVED_WHEN_CERTIFIED : [];
};
var withoutKeys = (product, keys) => isObject(product) ? Object.fromEntries(Object.entries(product).filter(([key]) => !keys.includes(key))) : product;
function shapeComparisonForComplianceInsights(content, enabled) {
  if (!isObject(content) || !("products" in content))
    return content;
  const { products } = content;
  if (!isObject(products))
    return content;
  const list2 = Array.isArray(products) ? products : Object.values(products);
  const keys = removedKeys(enabled, list2);
  if (!list2.some((product) => isObject(product) && keys.some((key) => key in product)))
    return content;
  const cache = enabled ? shapedProducts.on : shapedProducts.off;
  if (!cache.has(products)) {
    cache.set(
      products,
      Array.isArray(products) ? products.map((product) => withoutKeys(product, keys)) : Object.fromEntries(Object.entries(products).map(([id, product]) => [id, withoutKeys(product, keys)]))
    );
  }
  return { ...content, products: cache.get(products) };
}

// src/capabilities/rendering/functions/renderArtifactView.tsx
import { jsx as jsx17 } from "react/jsx-runtime";
function renderArtifactView(artifact, componentMap, options) {
  const renderArtifactContent = (artifact2) => {
    const artifactStatus = options.turnStatus === TurnStatus6.Processing ? "streaming" : "complete";
    const commonProps = {
      helpPanel: options.layoutManager.helpPanel,
      layoutManager: options.layoutManager,
      navigationManager: options.navigationManager,
      projectId: options.projectId,
      artifactType: artifact2.artifactType,
      sendMessage: options.sendMessage,
      onExpand: options.onExpand,
      status: artifactStatus,
      logger: options.logger
    };
    let ArtifactComponent;
    let artifactData;
    switch (artifact2.artifactType) {
      case "search":
        ArtifactComponent = componentMap.search;
        artifactData = artifact2;
        break;
      case "comparison":
        ArtifactComponent = componentMap.comparison;
        artifactData = shapeComparisonForComplianceInsights(artifact2, options.complianceInsightsEnabled);
        break;
      case "evaluation":
        ArtifactComponent = componentMap.evaluation;
        artifactData = artifact2;
        break;
      case "epoSellerCreateConfiguration":
        ArtifactComponent = componentMap.epoSellerCreateConfiguration;
        artifactData = artifact2;
        break;
      case "epoBuyerRequest":
        ArtifactComponent = componentMap.epoBuyerRequest;
        artifactData = artifact2;
        break;
      case "epoDiscount":
        ArtifactComponent = componentMap.epoDiscount;
        artifactData = artifact2;
        break;
      default:
        ArtifactComponent = componentMap[artifact2.artifactType];
        artifactData = artifact2;
    }
    if (!ArtifactComponent || !artifactData) {
      if (!componentMap.fallback)
        return null;
      const FallbackComponent = componentMap.fallback;
      return /* @__PURE__ */ jsx17(
        FallbackComponent,
        {
          data: { artifact: artifact2, reason: `No component registered for type: ${artifact2.artifactType}` },
          ...commonProps
        }
      );
    }
    const getFullReview = options.getFullReview;
    const additionalProps = artifact2.artifactType === "evaluation" ? { comparisonData: shapeComparisonForComplianceInsights(options.artifactContext.comparison, options.complianceInsightsEnabled) } : artifact2.artifactType === "comparison" ? {
      complianceInsightsEnabled: options.complianceInsightsEnabled,
      ...getFullReview && {
        onGetFullReview: async (listingId, reviewId) => {
          const response = await getFullReview(listingId, reviewId);
          return response.output.getFullReview;
        }
      }
    } : {};
    return /* @__PURE__ */ jsx17(ArtifactComponent, { data: artifactData, ...commonProps, ...additionalProps });
  };
  return /* @__PURE__ */ jsx17(ArtifactErrorBoundary, { artifactId: artifact.artifactId, artifactType: artifact.artifactType, children: renderArtifactContent(artifact) });
}

// src/capabilities/rendering/functions/renderArtifacts.tsx
function renderArtifacts(artifacts, componentMap, options, filter) {
  const filteredArtifacts = filter ? artifacts.filter((artifact) => filter.includes(artifact.artifactType)) : artifacts;
  const result = {};
  filteredArtifacts.forEach((artifact) => {
    const element = renderArtifactView(artifact, componentMap, options);
    result[artifact.artifactType] = element;
  });
  return result;
}

// src/capabilities/rendering/hooks/useProjectRendering.tsx
import { getArtifactLabel as getArtifactLabel2, isAgentPreviewCookiePresent as isAgentPreviewCookiePresent2, resolveArtifactLabel as resolveArtifactLabel2, useArtifactWidgets as useArtifactWidgets2 } from "@amzn/awsmp-max-data";
import { useAppTranslation as useAppTranslation8 } from "@amzn/awsmp-max-translations";

// src/capabilities/services/createPromptInputActionManager.ts
import { ContentBlockVisibility as ContentBlockVisibility3 } from "@amzn/awsmp-max-model";
function findPlaceholder(template) {
  const start = template.indexOf("<");
  const end = template.indexOf(">", start);
  if (start === -1 || end === -1) {
    console.warn("Template missing placeholder markers < >");
    return null;
  }
  return {
    start,
    end: end + 1
    // Include closing >
  };
}
function createPromptInputActionManager() {
  return {
    insertTemplate: (template) => {
      const placeholder = findPlaceholder(template);
      usePromptInputActionStore.getState().queuePromptInputAction({
        type: "insert-text",
        text: template,
        selectionStart: placeholder?.start,
        selectionEnd: placeholder?.end,
        visibility: ContentBlockVisibility3.INFERENCE_ONLY
        // Default templates to inference-only for cleaner UX
      });
    }
  };
}

// src/capabilities/rendering/hooks/useStableNextSteps.ts
import { useState as useState6, useEffect as useEffect13 } from "react";
function useStableNextSteps(nextSteps, isMessageInFlight) {
  const [stableNextSteps, setStableNextSteps] = useState6(nextSteps);
  useEffect13(() => {
    if (isMessageInFlight) {
      setStableNextSteps(void 0);
    } else if (nextSteps && nextSteps.length > 0) {
      setStableNextSteps(nextSteps);
    }
  }, [isMessageInFlight, nextSteps]);
  return stableNextSteps;
}

// src/capabilities/rendering/hooks/useProjectRendering.tsx
import { Fragment as Fragment5, jsx as jsx18 } from "react/jsx-runtime";
var TURN_HELD_FLASHBAR_ID = "turn-held";
var turnHeldNoticeOwners = 0;
var MessagesRendererComponent = ({
  renderContext,
  messageComponents,
  layoutManager,
  navigationManager,
  renderArtifactInSplitPanel,
  sendMessage,
  uploadFiles,
  interruptProject,
  projectId,
  events,
  writeableArtifact
}) => {
  const maxService = useMaxService();
  const logger = useLoggerManager();
  const complianceInsightsEnabled = isAgentPreviewCookiePresent2();
  const getArtifact = useCallback10(
    (artifactType) => {
      const artifactSection = renderContext.artifact?.[artifactType];
      if (!artifactSection)
        return void 0;
      return { artifactType, ...artifactSection };
    },
    [renderContext.artifact]
  );
  const promptInputActions = useMemo8(() => createPromptInputActionManager(), []);
  const rendererAPI = {
    layoutManager,
    navigationManager,
    sendMessage,
    uploadFiles,
    interruptProject,
    projectId,
    windowSize: layoutManager.windowSize,
    renderArtifactInSplitPanel,
    getArtifact,
    renderArtifacts: (artifacts, componentMap) => renderArtifacts(artifacts, componentMap, {
      projectId,
      layoutManager,
      navigationManager,
      sendMessage,
      turnStatus: renderContext.turnStatus,
      artifactContext: renderContext.artifact,
      logger,
      complianceInsightsEnabled
    }),
    maxService,
    promptInputActions,
    logger,
    // Logger passed so the manager can emit its mint-refusal signal. This is the wiring point that
    // matters: the authentication prompts reach onAuthRequired through here, which is where a lifetime
    // refusal is observed.
    authManager: getTokenManager(logger),
    writeableArtifact
  };
  const { renderMessages } = useRenderMessages({
    renderContext,
    componentMap: messageComponents,
    rendererAPI,
    events
  });
  return /* @__PURE__ */ jsx18(Fragment5, { children: renderMessages() });
};
var MessagesRenderer = React26.memo(MessagesRendererComponent, (prevProps, nextProps) => {
  const conversationUnchanged = prevProps.renderContext.conversation === nextProps.renderContext.conversation;
  const artifactUnchanged = prevProps.renderContext.artifact === nextProps.renderContext.artifact;
  const renderContextUnchanged = prevProps.renderContext.projectId === nextProps.renderContext.projectId && conversationUnchanged && artifactUnchanged;
  const callbacksUnchanged = prevProps.renderArtifactInSplitPanel === nextProps.renderArtifactInSplitPanel && prevProps.sendMessage === nextProps.sendMessage && prevProps.layoutManager === nextProps.layoutManager && prevProps.navigationManager === nextProps.navigationManager;
  return renderContextUnchanged && callbacksUnchanged;
});
var SplitPanelArtifact = ({
  projectId,
  artifactType,
  onExpand,
  onMissingArtifact,
  missingArtifactBehavior,
  artifactComponents
}) => /* @__PURE__ */ jsx18(
  ProjectRenderer,
  {
    projectId,
    artifactType,
    onExpand,
    onMissingArtifact,
    missingArtifactBehavior,
    children: ({ renderArtifacts: renderArtifacts2 }) => {
      const rendered = renderArtifacts2(artifactComponents, [artifactType]);
      return rendered[artifactType] || null;
    }
  }
);
function useProjectRendering({
  renderContext,
  artifact,
  sendMessage,
  uploadFiles,
  interruptProject,
  navigationManager,
  layoutManager,
  onExpand,
  writeableArtifact
}) {
  const projectId = renderContext.projectId;
  const logger = useLoggerManager();
  const { getFullReview } = useMaxService();
  const complianceInsightsEnabled = isAgentPreviewCookiePresent2();
  const artifactWidgets = useArtifactWidgets2();
  const { t } = useAppTranslation8();
  const migrateArtifactType = (oldType) => {
    const migrationMap = {
      productSearch: "search",
      productComparison: "comparison",
      productEvaluation: "evaluation"
    };
    return migrationMap[oldType] || oldType;
  };
  const artifacts = useMemo8(() => {
    if (!renderContext.artifact)
      return [];
    return Object.entries(renderContext.artifact).filter(([_, value]) => value !== void 0).map(([key, value]) => ({ artifactType: migrateArtifactType(key), ...value }));
  }, [renderContext.artifact]);
  const extractedNextSteps = useMemo8(() => {
    const conversation = renderContext.conversation;
    if (!conversation || conversation.length === 0)
      return void 0;
    const lastMessage = conversation[conversation.length - 1];
    if (!lastMessage?.contentBlocks || lastMessage.contentBlocks.length === 0)
      return void 0;
    for (let i = lastMessage.contentBlocks.length - 1; i >= 0; i--) {
      const block = lastMessage.contentBlocks[i];
      if (block.type === "toolInput") {
        const content = block.content;
        const toolName = Object.keys(content)[0];
        if (toolName === "askUser") {
          const askUserData = content[toolName];
          if (askUserData?.nextSteps && Array.isArray(askUserData.nextSteps)) {
            return askUserData.nextSteps;
          }
        }
      }
    }
    return void 0;
  }, [renderContext.conversation]);
  const isMessageInFlight = renderContext.turnStatus === TurnStatus7.Processing;
  useEffect14(() => {
    if (!renderContext.turnHeld || !isMessageInFlight) {
      return;
    }
    turnHeldNoticeOwners += 1;
    useFlashbar.getState().addItem({
      id: TURN_HELD_FLASHBAR_ID,
      type: "in-progress",
      header: t("turnHeldNoticeHeader"),
      content: t("turnHeldNoticeContent"),
      dismissible: false
    });
    return () => {
      turnHeldNoticeOwners -= 1;
      if (turnHeldNoticeOwners === 0) {
        useFlashbar.getState().removeItem(TURN_HELD_FLASHBAR_ID);
      }
    };
  }, [renderContext.turnHeld, isMessageInFlight, t]);
  const nextSteps = useStableNextSteps(extractedNextSteps, isMessageInFlight);
  const renderArtifactsCallback = useCallback10(
    (componentMap, filter) => {
      const artifactsToRender = artifact ? [artifact] : artifacts;
      return renderArtifacts(
        artifactsToRender,
        componentMap,
        {
          projectId,
          layoutManager,
          navigationManager,
          sendMessage,
          onExpand,
          turnStatus: renderContext.turnStatus,
          artifactContext: renderContext.artifact,
          logger,
          getFullReview,
          complianceInsightsEnabled
        },
        filter
      );
    },
    [
      artifacts,
      artifact,
      navigationManager,
      layoutManager,
      projectId,
      sendMessage,
      onExpand,
      renderContext.turnStatus,
      renderContext.artifact,
      logger,
      getFullReview,
      complianceInsightsEnabled
    ]
  );
  const renderArtifactInSplitPanel = useCallback10(
    (artifactMap, options) => {
      const entries = Object.entries(artifactMap);
      if (entries.length !== 1) {
        throw new Error("renderArtifactInSplitPanel expects exactly one artifact type in the map");
      }
      const [artifactType, component] = entries[0];
      const artifactComponents = { [artifactType]: component };
      const artifactName = resolveArtifactLabel2(getArtifactLabel2(artifactType, artifactWidgets), t);
      const handleExpand = () => {
        navigationManager.navigate("artifact", { projectId, artifactType });
        layoutManager.splitPanel.hide();
      };
      const handleMissingArtifact = () => {
        layoutManager.splitPanel.hide();
      };
      const missingArtifactBehavior = options?.missingArtifactBehavior ?? "loading";
      layoutManager.splitPanel.setContent({
        header: artifactName,
        content: /* @__PURE__ */ jsx18(
          SplitPanelArtifact,
          {
            projectId,
            artifactType,
            onExpand: handleExpand,
            onMissingArtifact: handleMissingArtifact,
            missingArtifactBehavior,
            artifactComponents
          },
          `${projectId}:${artifactType}`
        )
      });
      layoutManager.splitPanel.updateMetadata({ artifactType });
    },
    [projectId, layoutManager, navigationManager, artifactWidgets, t]
  );
  const renderMessagesCallback = useCallback10(
    (componentMap, events) => {
      return /* @__PURE__ */ jsx18(
        MessagesRenderer,
        {
          renderContext,
          messageComponents: componentMap,
          layoutManager,
          navigationManager,
          renderArtifactInSplitPanel,
          sendMessage,
          uploadFiles,
          interruptProject,
          projectId,
          events,
          writeableArtifact
        }
      );
    },
    [
      renderContext,
      layoutManager,
      navigationManager,
      renderArtifactInSplitPanel,
      sendMessage,
      uploadFiles,
      interruptProject,
      projectId,
      writeableArtifact
    ]
  );
  return {
    renderMessages: renderMessagesCallback,
    renderArtifacts: renderArtifactsCallback,
    renderArtifactInSplitPanel,
    nextSteps,
    renderContext
  };
}

// src/capabilities/rendering/components/ProjectWithRenderingContext.tsx
import { getArtifactLabel as getArtifactLabel3, resolveArtifactLabel as resolveArtifactLabel3, useArtifactWidgets as useArtifactWidgets3 } from "@amzn/awsmp-max-data";
import { useAppTranslation as useAppTranslation9 } from "@amzn/awsmp-max-translations";
import { Fragment as Fragment6, jsx as jsx19 } from "react/jsx-runtime";
function ProjectWithRenderingContext(props) {
  const { renderMessages, renderArtifacts: renderArtifacts2, renderArtifactInSplitPanel, nextSteps, renderContext } = useProjectRendering(props);
  const artifactWidgets = useArtifactWidgets3();
  const { t } = useAppTranslation9();
  const baseProps = {
    projectName: props.renderContext.projectName,
    renderContext: { turnStatus: renderContext.turnStatus, tags: renderContext.tags },
    nextSteps,
    renderMessages,
    renderArtifacts: renderArtifacts2,
    renderArtifactInSplitPanel
  };
  return /* @__PURE__ */ jsx19(Fragment6, { children: props.artifact ? props.children({
    ...baseProps,
    artifactName: resolveArtifactLabel3(getArtifactLabel3(props.artifact.artifactType, artifactWidgets), t),
    sendMessage: props.sendMessage,
    uploadFiles: props.uploadFiles,
    renderContext,
    artifact: props.artifact
  }) : props.children(baseProps) });
}

// src/capabilities/rendering/components/ProjectRenderer.tsx
import { useAppTranslation as useAppTranslation10 } from "@amzn/awsmp-max-translations";
import { jsx as jsx20 } from "react/jsx-runtime";
function ProjectRenderer({
  projectId,
  artifactType,
  onExpand,
  missingArtifactBehavior = "error",
  onMissingArtifact,
  writeableArtifact,
  children
}) {
  const project = useProject({ projectId });
  const navigationManager = useNavigation();
  const layoutManager = useLayoutManager();
  const { t } = useAppTranslation10();
  const artifactWidgets = useArtifactWidgets4();
  const onMissingArtifactRef = React27.useRef(onMissingArtifact);
  React27.useEffect(() => {
    onMissingArtifactRef.current = onMissingArtifact;
  });
  const logger = useLoggerManager();
  const loggerRef = React27.useRef(logger);
  React27.useEffect(() => {
    loggerRef.current = logger;
  });
  const projectState = project.renderContext?.projectState;
  const artifactSection = artifactType ? project.renderContext?.artifact?.[artifactType] : void 0;
  const isTurnComplete = projectState ? StateProperties.isTurnComplete(projectState) : false;
  const shouldCallMissingArtifact = Boolean(artifactType && !artifactSection && isTurnComplete && onMissingArtifact);
  React27.useEffect(() => {
    if (shouldCallMissingArtifact) {
      onMissingArtifactRef.current?.();
    }
  }, [shouldCallMissingArtifact]);
  const projectTurnId = project.renderContext?.projectTurnId;
  React27.useEffect(() => {
    const alreadyShown = getMaxProjectContext();
    if (alreadyShown && alreadyShown.projectId !== projectId) {
      loggerRef.current.warn("ProjectRenderer mounted while another project is shown; records name whichever was shown last", {
        projectId,
        alreadyShownProjectId: alreadyShown.projectId
      });
    }
    const context = projectTurnId ? { projectId, projectTurnId } : { projectId };
    const release = showMaxProjectContext(context);
    return release;
  }, [projectId, projectTurnId]);
  if (project.error instanceof NotFoundError3) {
    throw project.error;
  }
  if (!project.renderContext || artifactWidgets.status === ArtifactWidgetStatus.Loading) {
    return /* @__PURE__ */ jsx20(LoadingSpinner, {});
  }
  const commonProps = {
    renderContext: project.renderContext,
    sendMessage: project.sendMessage,
    uploadFiles: project.uploadFiles,
    interruptProject: project.interruptProject,
    navigationManager,
    layoutManager,
    onExpand,
    writeableArtifact
  };
  if (artifactType) {
    if (!artifactSection) {
      if (missingArtifactBehavior === "loading" && !isTurnComplete) {
        return /* @__PURE__ */ jsx20(LoadingSpinner, {});
      }
      return /* @__PURE__ */ jsx20(Alert4, { type: "error", header: t("errorSomethingWentWrong"), children: t("errorOccurredTryAgain") });
    }
    const artifactWithType = { artifactType, ...artifactSection };
    return /* @__PURE__ */ jsx20(ProjectWithRenderingContext, { ...commonProps, artifact: artifactWithType, children });
  }
  return /* @__PURE__ */ jsx20(ProjectWithRenderingContext, { ...commonProps, children });
}

// src/capabilities/rendering/components/WriteableArtifactRenderer.ts
import { useState as useState7, useEffect as useEffect16, useCallback as useCallback11 } from "react";
import {
  TurnStatus as TurnStatus8
} from "@amzn/awsmp-max-model";
var WriteableArtifactRenderer = ({
  project,
  artifactTypePath,
  children,
  fallback
}) => {
  const serverArtifact = useProjectStoreInternal(
    (state) => state.currentProjectId === project.id ? state.currentProject?.renderContext?.artifact?.[artifactTypePath] : void 0
  );
  const [localArtifact, setLocalArtifact] = useState7(serverArtifact);
  const [isToolCallInFlight, setIsToolCallInFlight] = useState7(false);
  const { sendMessageWithStreaming, directToolCallWithStreaming, shareProject } = useMaxService();
  useEffect16(() => {
    setLocalArtifact(serverArtifact);
  }, [serverArtifact]);
  const isMessageInFlight = project?.renderContext?.turnStatus === void 0 || project?.renderContext?.turnStatus === TurnStatus8.Processing;
  const isArtifactLocked = project.isLoading || isMessageInFlight || isToolCallInFlight;
  const callMcpToolInternal = useCallback11(
    async (toolName, toolInput, webIdentityTokenOverride) => {
      try {
        setIsToolCallInFlight(true);
        return await directToolCallWithStreaming({
          projectId: project.id,
          toolName,
          toolInput,
          webIdentityTokenOverride
        });
      } finally {
        setIsToolCallInFlight(false);
      }
    },
    [directToolCallWithStreaming, project.id, setIsToolCallInFlight]
  );
  const commitArtifactUpdate = useCallback11(
    async (artifactOverride, webIdentityTokenOverride) => {
      try {
        const artifactToCommit = artifactOverride ?? localArtifact;
        await callMcpToolInternal(
          "updateArtifact",
          {
            artifactSection: artifactTypePath,
            patches: [
              {
                op: "replace",
                path: "",
                value: artifactToCommit
              }
            ]
          },
          webIdentityTokenOverride
        );
      } catch (error) {
        const epoError = {
          statusCode: 500,
          exceptionName: "InternalServiceException",
          message: error instanceof Error ? error.message : "Failed to update artifact"
        };
        throw epoError;
      }
    },
    [callMcpToolInternal, artifactTypePath, localArtifact]
  );
  const wrappedSendMessage = useCallback11(
    async (input, agent, artifactOverride, onStreamError) => {
      if (isArtifactLocked) {
        throw new Error("Cannot commit artifact update: artifact is locked");
      }
      await commitArtifactUpdate(artifactOverride);
      sendMessageWithStreaming(project.id, input, onStreamError ? { onError: onStreamError } : void 0, agent);
    },
    [isArtifactLocked, commitArtifactUpdate, sendMessageWithStreaming, project.id]
  );
  const callMcpTool = useCallback11(
    async (toolName, toolInput, webIdentityTokenOverride, artifactOverride) => {
      await commitArtifactUpdate(artifactOverride, webIdentityTokenOverride);
      return callMcpToolInternal(toolName, toolInput, webIdentityTokenOverride);
    },
    [commitArtifactUpdate, callMcpToolInternal]
  );
  if (!localArtifact) {
    return fallback;
  }
  const writeableArtifact = {
    artifactType: artifactTypePath,
    artifact: localArtifact,
    setArtifact: setLocalArtifact,
    sendMessage: wrappedSendMessage,
    callMcpTool,
    commitArtifactUpdate,
    isArtifactLocked,
    shareProject
  };
  return children(writeableArtifact);
};

// src/capabilities/rendering/components/NotFoundErrorBoundary.tsx
import * as React28 from "react";
import { NotFoundPage } from "@amzn/awsmp-max-ux-patterns/NotFoundPage";
import { NotFoundError as NotFoundError4 } from "@amzn/awsmp-max-agentic-renderer-interface";
import { jsx as jsx21 } from "react/jsx-runtime";
var NotFoundErrorBoundaryInternal = class extends React28.Component {
  constructor(props) {
    super(props);
    this.state = { isNotFound: false };
  }
  static getDerivedStateFromError(error) {
    if (error instanceof NotFoundError4) {
      return { isNotFound: true };
    }
    return null;
  }
  componentDidCatch(error, _errorInfo) {
    if (!(error instanceof NotFoundError4)) {
      throw error;
    }
  }
  render() {
    if (this.state.isNotFound) {
      return /* @__PURE__ */ jsx21(NotFoundPage, { logger: this.props.logger });
    }
    return this.props.children;
  }
};
function NotFoundErrorBoundary({ children }) {
  const logger = useLoggerManager();
  return /* @__PURE__ */ jsx21(NotFoundErrorBoundaryInternal, { logger, children });
}
export {
  AgenticRendererProvider,
  ApplicationErrorBoundary,
  DirectRenderingContainersProvider,
  LayoutHelpPanel,
  LayoutSplitPanel,
  MaxServiceProvider,
  NotFoundErrorBoundary,
  ProjectRenderer,
  WriteableArtifactRenderer,
  buildQueryString3 as buildQueryString,
  createRouteDefinitions,
  createSafeLogger,
  emitToolCallErrorMetric,
  emitZeroValueToolCallErrorMetric,
  getBrowserInfo,
  getClientLoggerInstance,
  getDebugSettings,
  getTokenManager,
  isOAuthMintDenial,
  isSupportedBrowser,
  parseQueryParams,
  useBreadcrumbStore,
  useDebug,
  useDebugPanel,
  useDirectRenderingStore,
  useFlashbar,
  useLayoutManager,
  useLogger,
  useLoggerManager,
  useMaxService,
  useMaxServiceClient,
  useNavigation,
  useProject,
  useProjectCreation,
  usePromptInputAction,
  useQueryParamProject,
  useTrackDebugProject,
  useWithAsyncErrors,
  withAsyncBreadcrumbs,
  withAsyncBreadcrumbs as withBreadcrumbData
};
/*! Bundled license information:

lodash/lodash.js:
  (**
   * @license
   * Lodash <https://lodash.com/>
   * Copyright OpenJS Foundation and other contributors <https://openjsf.org/>
   * Released under MIT license <https://lodash.com/license>
   * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
   * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
   *)

fast-json-patch/module/helpers.mjs:
  (*!
   * https://github.com/Starcounter-Jack/JSON-Patch
   * (c) 2017-2022 Joachim Wester
   * MIT licensed
   *)

fast-json-patch/module/duplex.mjs:
  (*!
   * https://github.com/Starcounter-Jack/JSON-Patch
   * (c) 2017-2021 Joachim Wester
   * MIT license
   *)
*/
//# sourceMappingURL=main.js.map
